export default [
  {
    'value': 110000000000,
    'text': '北京市',
    'level': 1,
    'pvalue': 0,
    'children': [
      {
        'value': 110100000000,
        'text': '市辖区',
        'level': 2,
        'pvalue': 110000000000,
        'children': [
          {
            'value': 110101000000,
            'text': '东城区',
            'level': 3,
            'pvalue': 110100000000
          },
          {
            'value': 110102000000,
            'text': '西城区',
            'level': 3,
            'pvalue': 110100000000
          },
          {
            'value': 110105000000,
            'text': '朝阳区',
            'level': 3,
            'pvalue': 110100000000
          },
          {
            'value': 110106000000,
            'text': '丰台区',
            'level': 3,
            'pvalue': 110100000000
          },
          {
            'value': 110107000000,
            'text': '石景山区',
            'level': 3,
            'pvalue': 110100000000
          },
          {
            'value': 110108000000,
            'text': '海淀区',
            'level': 3,
            'pvalue': 110100000000
          },
          {
            'value': 110109000000,
            'text': '门头沟区',
            'level': 3,
            'pvalue': 110100000000
          },
          {
            'value': 110111000000,
            'text': '房山区',
            'level': 3,
            'pvalue': 110100000000
          },
          {
            'value': 110112000000,
            'text': '通州区',
            'level': 3,
            'pvalue': 110100000000
          },
          {
            'value': 110113000000,
            'text': '顺义区',
            'level': 3,
            'pvalue': 110100000000
          },
          {
            'value': 110114000000,
            'text': '昌平区',
            'level': 3,
            'pvalue': 110100000000
          },
          {
            'value': 110115000000,
            'text': '大兴区',
            'level': 3,
            'pvalue': 110100000000
          },
          {
            'value': 110116000000,
            'text': '怀柔区',
            'level': 3,
            'pvalue': 110100000000
          },
          {
            'value': 110117000000,
            'text': '平谷区',
            'level': 3,
            'pvalue': 110100000000
          },
          {
            'value': 110118000000,
            'text': '密云区',
            'level': 3,
            'pvalue': 110100000000
          },
          {
            'value': 110119000000,
            'text': '延庆区',
            'level': 3,
            'pvalue': 110100000000
          }
        ]
      }
    ]
  },
  {
    'value': 120000000000,
    'text': '天津市',
    'level': 1,
    'pvalue': 0,
    'children': [
      {
        'value': 120100000000,
        'text': '市辖区',
        'level': 2,
        'pvalue': 120000000000,
        'children': [
          {
            'value': 120101000000,
            'text': '和平区',
            'level': 3,
            'pvalue': 120100000000
          },
          {
            'value': 120102000000,
            'text': '河东区',
            'level': 3,
            'pvalue': 120100000000
          },
          {
            'value': 120103000000,
            'text': '河西区',
            'level': 3,
            'pvalue': 120100000000
          },
          {
            'value': 120104000000,
            'text': '南开区',
            'level': 3,
            'pvalue': 120100000000
          },
          {
            'value': 120105000000,
            'text': '河北区',
            'level': 3,
            'pvalue': 120100000000
          },
          {
            'value': 120106000000,
            'text': '红桥区',
            'level': 3,
            'pvalue': 120100000000
          },
          {
            'value': 120110000000,
            'text': '东丽区',
            'level': 3,
            'pvalue': 120100000000
          },
          {
            'value': 120111000000,
            'text': '西青区',
            'level': 3,
            'pvalue': 120100000000
          },
          {
            'value': 120112000000,
            'text': '津南区',
            'level': 3,
            'pvalue': 120100000000
          },
          {
            'value': 120113000000,
            'text': '北辰区',
            'level': 3,
            'pvalue': 120100000000
          },
          {
            'value': 120114000000,
            'text': '武清区',
            'level': 3,
            'pvalue': 120100000000
          },
          {
            'value': 120115000000,
            'text': '宝坻区',
            'level': 3,
            'pvalue': 120100000000
          },
          {
            'value': 120116000000,
            'text': '滨海新区',
            'level': 3,
            'pvalue': 120100000000
          },
          {
            'value': 120117000000,
            'text': '宁河区',
            'level': 3,
            'pvalue': 120100000000
          },
          {
            'value': 120118000000,
            'text': '静海区',
            'level': 3,
            'pvalue': 120100000000
          },
          {
            'value': 120119000000,
            'text': '蓟州区',
            'level': 3,
            'pvalue': 120100000000
          }
        ]
      }
    ]
  },
  {
    'value': 130000000000,
    'text': '河北省',
    'level': 1,
    'pvalue': 0,
    'children': [
      {
        'value': 130100000000,
        'text': '石家庄市',
        'level': 2,
        'pvalue': 130000000000,
        'children': [
          {
            'value': 130101000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 130100000000
          },
          {
            'value': 130102000000,
            'text': '长安区',
            'level': 3,
            'pvalue': 130100000000
          },
          {
            'value': 130104000000,
            'text': '桥西区',
            'level': 3,
            'pvalue': 130100000000
          },
          {
            'value': 130105000000,
            'text': '新华区',
            'level': 3,
            'pvalue': 130100000000
          },
          {
            'value': 130107000000,
            'text': '井陉矿区',
            'level': 3,
            'pvalue': 130100000000
          },
          {
            'value': 130108000000,
            'text': '裕华区',
            'level': 3,
            'pvalue': 130100000000
          },
          {
            'value': 130109000000,
            'text': '藁城区',
            'level': 3,
            'pvalue': 130100000000
          },
          {
            'value': 130110000000,
            'text': '鹿泉区',
            'level': 3,
            'pvalue': 130100000000
          },
          {
            'value': 130111000000,
            'text': '栾城区',
            'level': 3,
            'pvalue': 130100000000
          },
          {
            'value': 130121000000,
            'text': '井陉县',
            'level': 3,
            'pvalue': 130100000000
          },
          {
            'value': 130123000000,
            'text': '正定县',
            'level': 3,
            'pvalue': 130100000000
          },
          {
            'value': 130125000000,
            'text': '行唐县',
            'level': 3,
            'pvalue': 130100000000
          },
          {
            'value': 130126000000,
            'text': '灵寿县',
            'level': 3,
            'pvalue': 130100000000
          },
          {
            'value': 130127000000,
            'text': '高邑县',
            'level': 3,
            'pvalue': 130100000000
          },
          {
            'value': 130128000000,
            'text': '深泽县',
            'level': 3,
            'pvalue': 130100000000
          },
          {
            'value': 130129000000,
            'text': '赞皇县',
            'level': 3,
            'pvalue': 130100000000
          },
          {
            'value': 130130000000,
            'text': '无极县',
            'level': 3,
            'pvalue': 130100000000
          },
          {
            'value': 130131000000,
            'text': '平山县',
            'level': 3,
            'pvalue': 130100000000
          },
          {
            'value': 130132000000,
            'text': '元氏县',
            'level': 3,
            'pvalue': 130100000000
          },
          {
            'value': 130133000000,
            'text': '赵县',
            'level': 3,
            'pvalue': 130100000000
          },
          {
            'value': 130171000000,
            'text': '石家庄高新技术产业开发区',
            'level': 3,
            'pvalue': 130100000000
          },
          {
            'value': 130172000000,
            'text': '石家庄循环化工园区',
            'level': 3,
            'pvalue': 130100000000
          },
          {
            'value': 130181000000,
            'text': '辛集市',
            'level': 3,
            'pvalue': 130100000000
          },
          {
            'value': 130183000000,
            'text': '晋州市',
            'level': 3,
            'pvalue': 130100000000
          },
          {
            'value': 130184000000,
            'text': '新乐市',
            'level': 3,
            'pvalue': 130100000000
          }
        ]
      },
      {
        'value': 130200000000,
        'text': '唐山市',
        'level': 2,
        'pvalue': 130000000000,
        'children': [
          {
            'value': 130201000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 130200000000
          },
          {
            'value': 130202000000,
            'text': '路南区',
            'level': 3,
            'pvalue': 130200000000
          },
          {
            'value': 130203000000,
            'text': '路北区',
            'level': 3,
            'pvalue': 130200000000
          },
          {
            'value': 130204000000,
            'text': '古冶区',
            'level': 3,
            'pvalue': 130200000000
          },
          {
            'value': 130205000000,
            'text': '开平区',
            'level': 3,
            'pvalue': 130200000000
          },
          {
            'value': 130207000000,
            'text': '丰南区',
            'level': 3,
            'pvalue': 130200000000
          },
          {
            'value': 130208000000,
            'text': '丰润区',
            'level': 3,
            'pvalue': 130200000000
          },
          {
            'value': 130209000000,
            'text': '曹妃甸区',
            'level': 3,
            'pvalue': 130200000000
          },
          {
            'value': 130224000000,
            'text': '滦南县',
            'level': 3,
            'pvalue': 130200000000
          },
          {
            'value': 130225000000,
            'text': '乐亭县',
            'level': 3,
            'pvalue': 130200000000
          },
          {
            'value': 130227000000,
            'text': '迁西县',
            'level': 3,
            'pvalue': 130200000000
          },
          {
            'value': 130229000000,
            'text': '玉田县',
            'level': 3,
            'pvalue': 130200000000
          },
          {
            'value': 130271000000,
            'text': '河北唐山芦台经济开发区',
            'level': 3,
            'pvalue': 130200000000
          },
          {
            'value': 130272000000,
            'text': '唐山市汉沽管理区',
            'level': 3,
            'pvalue': 130200000000
          },
          {
            'value': 130273000000,
            'text': '唐山高新技术产业开发区',
            'level': 3,
            'pvalue': 130200000000
          },
          {
            'value': 130274000000,
            'text': '河北唐山海港经济开发区',
            'level': 3,
            'pvalue': 130200000000
          },
          {
            'value': 130281000000,
            'text': '遵化市',
            'level': 3,
            'pvalue': 130200000000
          },
          {
            'value': 130283000000,
            'text': '迁安市',
            'level': 3,
            'pvalue': 130200000000
          },
          {
            'value': 130284000000,
            'text': '滦州市',
            'level': 3,
            'pvalue': 130200000000
          }
        ]
      },
      {
        'value': 130300000000,
        'text': '秦皇岛市',
        'level': 2,
        'pvalue': 130000000000,
        'children': [
          {
            'value': 130301000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 130300000000
          },
          {
            'value': 130302000000,
            'text': '海港区',
            'level': 3,
            'pvalue': 130300000000
          },
          {
            'value': 130303000000,
            'text': '山海关区',
            'level': 3,
            'pvalue': 130300000000
          },
          {
            'value': 130304000000,
            'text': '北戴河区',
            'level': 3,
            'pvalue': 130300000000
          },
          {
            'value': 130306000000,
            'text': '抚宁区',
            'level': 3,
            'pvalue': 130300000000
          },
          {
            'value': 130321000000,
            'text': '青龙满族自治县',
            'level': 3,
            'pvalue': 130300000000
          },
          {
            'value': 130322000000,
            'text': '昌黎县',
            'level': 3,
            'pvalue': 130300000000
          },
          {
            'value': 130324000000,
            'text': '卢龙县',
            'level': 3,
            'pvalue': 130300000000
          },
          {
            'value': 130371000000,
            'text': '秦皇岛市经济技术开发区',
            'level': 3,
            'pvalue': 130300000000
          },
          {
            'value': 130372000000,
            'text': '北戴河新区',
            'level': 3,
            'pvalue': 130300000000
          }
        ]
      },
      {
        'value': 130400000000,
        'text': '邯郸市',
        'level': 2,
        'pvalue': 130000000000,
        'children': [
          {
            'value': 130401000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 130400000000
          },
          {
            'value': 130402000000,
            'text': '邯山区',
            'level': 3,
            'pvalue': 130400000000
          },
          {
            'value': 130403000000,
            'text': '丛台区',
            'level': 3,
            'pvalue': 130400000000
          },
          {
            'value': 130404000000,
            'text': '复兴区',
            'level': 3,
            'pvalue': 130400000000
          },
          {
            'value': 130406000000,
            'text': '峰峰矿区',
            'level': 3,
            'pvalue': 130400000000
          },
          {
            'value': 130407000000,
            'text': '肥乡区',
            'level': 3,
            'pvalue': 130400000000
          },
          {
            'value': 130408000000,
            'text': '永年区',
            'level': 3,
            'pvalue': 130400000000
          },
          {
            'value': 130423000000,
            'text': '临漳县',
            'level': 3,
            'pvalue': 130400000000
          },
          {
            'value': 130424000000,
            'text': '成安县',
            'level': 3,
            'pvalue': 130400000000
          },
          {
            'value': 130425000000,
            'text': '大名县',
            'level': 3,
            'pvalue': 130400000000
          },
          {
            'value': 130426000000,
            'text': '涉县',
            'level': 3,
            'pvalue': 130400000000
          },
          {
            'value': 130427000000,
            'text': '磁县',
            'level': 3,
            'pvalue': 130400000000
          },
          {
            'value': 130430000000,
            'text': '邱县',
            'level': 3,
            'pvalue': 130400000000
          },
          {
            'value': 130431000000,
            'text': '鸡泽县',
            'level': 3,
            'pvalue': 130400000000
          },
          {
            'value': 130432000000,
            'text': '广平县',
            'level': 3,
            'pvalue': 130400000000
          },
          {
            'value': 130433000000,
            'text': '馆陶县',
            'level': 3,
            'pvalue': 130400000000
          },
          {
            'value': 130434000000,
            'text': '魏县',
            'level': 3,
            'pvalue': 130400000000
          },
          {
            'value': 130435000000,
            'text': '曲周县',
            'level': 3,
            'pvalue': 130400000000
          },
          {
            'value': 130471000000,
            'text': '邯郸经济技术开发区',
            'level': 3,
            'pvalue': 130400000000
          },
          {
            'value': 130473000000,
            'text': '邯郸冀南新区',
            'level': 3,
            'pvalue': 130400000000
          },
          {
            'value': 130481000000,
            'text': '武安市',
            'level': 3,
            'pvalue': 130400000000
          }
        ]
      },
      {
        'value': 130500000000,
        'text': '邢台市',
        'level': 2,
        'pvalue': 130000000000,
        'children': [
          {
            'value': 130501000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 130500000000
          },
          {
            'value': 130502000000,
            'text': '襄都区',
            'level': 3,
            'pvalue': 130500000000
          },
          {
            'value': 130503000000,
            'text': '信都区',
            'level': 3,
            'pvalue': 130500000000
          },
          {
            'value': 130505000000,
            'text': '任泽区',
            'level': 3,
            'pvalue': 130500000000
          },
          {
            'value': 130506000000,
            'text': '南和区',
            'level': 3,
            'pvalue': 130500000000
          },
          {
            'value': 130522000000,
            'text': '临城县',
            'level': 3,
            'pvalue': 130500000000
          },
          {
            'value': 130523000000,
            'text': '内丘县',
            'level': 3,
            'pvalue': 130500000000
          },
          {
            'value': 130524000000,
            'text': '柏乡县',
            'level': 3,
            'pvalue': 130500000000
          },
          {
            'value': 130525000000,
            'text': '隆尧县',
            'level': 3,
            'pvalue': 130500000000
          },
          {
            'value': 130528000000,
            'text': '宁晋县',
            'level': 3,
            'pvalue': 130500000000
          },
          {
            'value': 130529000000,
            'text': '巨鹿县',
            'level': 3,
            'pvalue': 130500000000
          },
          {
            'value': 130530000000,
            'text': '新河县',
            'level': 3,
            'pvalue': 130500000000
          },
          {
            'value': 130531000000,
            'text': '广宗县',
            'level': 3,
            'pvalue': 130500000000
          },
          {
            'value': 130532000000,
            'text': '平乡县',
            'level': 3,
            'pvalue': 130500000000
          },
          {
            'value': 130533000000,
            'text': '威县',
            'level': 3,
            'pvalue': 130500000000
          },
          {
            'value': 130534000000,
            'text': '清河县',
            'level': 3,
            'pvalue': 130500000000
          },
          {
            'value': 130535000000,
            'text': '临西县',
            'level': 3,
            'pvalue': 130500000000
          },
          {
            'value': 130571000000,
            'text': '河北邢台经济开发区',
            'level': 3,
            'pvalue': 130500000000
          },
          {
            'value': 130581000000,
            'text': '南宫市',
            'level': 3,
            'pvalue': 130500000000
          },
          {
            'value': 130582000000,
            'text': '沙河市',
            'level': 3,
            'pvalue': 130500000000
          }
        ]
      },
      {
        'value': 130600000000,
        'text': '保定市',
        'level': 2,
        'pvalue': 130000000000,
        'children': [
          {
            'value': 130601000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 130600000000
          },
          {
            'value': 130602000000,
            'text': '竞秀区',
            'level': 3,
            'pvalue': 130600000000
          },
          {
            'value': 130606000000,
            'text': '莲池区',
            'level': 3,
            'pvalue': 130600000000
          },
          {
            'value': 130607000000,
            'text': '满城区',
            'level': 3,
            'pvalue': 130600000000
          },
          {
            'value': 130608000000,
            'text': '清苑区',
            'level': 3,
            'pvalue': 130600000000
          },
          {
            'value': 130609000000,
            'text': '徐水区',
            'level': 3,
            'pvalue': 130600000000
          },
          {
            'value': 130623000000,
            'text': '涞水县',
            'level': 3,
            'pvalue': 130600000000
          },
          {
            'value': 130624000000,
            'text': '阜平县',
            'level': 3,
            'pvalue': 130600000000
          },
          {
            'value': 130626000000,
            'text': '定兴县',
            'level': 3,
            'pvalue': 130600000000
          },
          {
            'value': 130627000000,
            'text': '唐县',
            'level': 3,
            'pvalue': 130600000000
          },
          {
            'value': 130628000000,
            'text': '高阳县',
            'level': 3,
            'pvalue': 130600000000
          },
          {
            'value': 130629000000,
            'text': '容城县',
            'level': 3,
            'pvalue': 130600000000
          },
          {
            'value': 130630000000,
            'text': '涞源县',
            'level': 3,
            'pvalue': 130600000000
          },
          {
            'value': 130631000000,
            'text': '望都县',
            'level': 3,
            'pvalue': 130600000000
          },
          {
            'value': 130632000000,
            'text': '安新县',
            'level': 3,
            'pvalue': 130600000000
          },
          {
            'value': 130633000000,
            'text': '易县',
            'level': 3,
            'pvalue': 130600000000
          },
          {
            'value': 130634000000,
            'text': '曲阳县',
            'level': 3,
            'pvalue': 130600000000
          },
          {
            'value': 130635000000,
            'text': '蠡县',
            'level': 3,
            'pvalue': 130600000000
          },
          {
            'value': 130636000000,
            'text': '顺平县',
            'level': 3,
            'pvalue': 130600000000
          },
          {
            'value': 130637000000,
            'text': '博野县',
            'level': 3,
            'pvalue': 130600000000
          },
          {
            'value': 130638000000,
            'text': '雄县',
            'level': 3,
            'pvalue': 130600000000
          },
          {
            'value': 130671000000,
            'text': '保定高新技术产业开发区',
            'level': 3,
            'pvalue': 130600000000
          },
          {
            'value': 130672000000,
            'text': '保定白沟新城',
            'level': 3,
            'pvalue': 130600000000
          },
          {
            'value': 130681000000,
            'text': '涿州市',
            'level': 3,
            'pvalue': 130600000000
          },
          {
            'value': 130682000000,
            'text': '定州市',
            'level': 3,
            'pvalue': 130600000000
          },
          {
            'value': 130683000000,
            'text': '安国市',
            'level': 3,
            'pvalue': 130600000000
          },
          {
            'value': 130684000000,
            'text': '高碑店市',
            'level': 3,
            'pvalue': 130600000000
          }
        ]
      },
      {
        'value': 130700000000,
        'text': '张家口市',
        'level': 2,
        'pvalue': 130000000000,
        'children': [
          {
            'value': 130701000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 130700000000
          },
          {
            'value': 130702000000,
            'text': '桥东区',
            'level': 3,
            'pvalue': 130700000000
          },
          {
            'value': 130703000000,
            'text': '桥西区',
            'level': 3,
            'pvalue': 130700000000
          },
          {
            'value': 130705000000,
            'text': '宣化区',
            'level': 3,
            'pvalue': 130700000000
          },
          {
            'value': 130706000000,
            'text': '下花园区',
            'level': 3,
            'pvalue': 130700000000
          },
          {
            'value': 130708000000,
            'text': '万全区',
            'level': 3,
            'pvalue': 130700000000
          },
          {
            'value': 130709000000,
            'text': '崇礼区',
            'level': 3,
            'pvalue': 130700000000
          },
          {
            'value': 130722000000,
            'text': '张北县',
            'level': 3,
            'pvalue': 130700000000
          },
          {
            'value': 130723000000,
            'text': '康保县',
            'level': 3,
            'pvalue': 130700000000
          },
          {
            'value': 130724000000,
            'text': '沽源县',
            'level': 3,
            'pvalue': 130700000000
          },
          {
            'value': 130725000000,
            'text': '尚义县',
            'level': 3,
            'pvalue': 130700000000
          },
          {
            'value': 130726000000,
            'text': '蔚县',
            'level': 3,
            'pvalue': 130700000000
          },
          {
            'value': 130727000000,
            'text': '阳原县',
            'level': 3,
            'pvalue': 130700000000
          },
          {
            'value': 130728000000,
            'text': '怀安县',
            'level': 3,
            'pvalue': 130700000000
          },
          {
            'value': 130730000000,
            'text': '怀来县',
            'level': 3,
            'pvalue': 130700000000
          },
          {
            'value': 130731000000,
            'text': '涿鹿县',
            'level': 3,
            'pvalue': 130700000000
          },
          {
            'value': 130732000000,
            'text': '赤城县',
            'level': 3,
            'pvalue': 130700000000
          },
          {
            'value': 130771000000,
            'text': '张家口经济开发区',
            'level': 3,
            'pvalue': 130700000000
          },
          {
            'value': 130772000000,
            'text': '张家口市察北管理区',
            'level': 3,
            'pvalue': 130700000000
          },
          {
            'value': 130773000000,
            'text': '张家口市塞北管理区',
            'level': 3,
            'pvalue': 130700000000
          }
        ]
      },
      {
        'value': 130800000000,
        'text': '承德市',
        'level': 2,
        'pvalue': 130000000000,
        'children': [
          {
            'value': 130801000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 130800000000
          },
          {
            'value': 130802000000,
            'text': '双桥区',
            'level': 3,
            'pvalue': 130800000000
          },
          {
            'value': 130803000000,
            'text': '双滦区',
            'level': 3,
            'pvalue': 130800000000
          },
          {
            'value': 130804000000,
            'text': '鹰手营子矿区',
            'level': 3,
            'pvalue': 130800000000
          },
          {
            'value': 130821000000,
            'text': '承德县',
            'level': 3,
            'pvalue': 130800000000
          },
          {
            'value': 130822000000,
            'text': '兴隆县',
            'level': 3,
            'pvalue': 130800000000
          },
          {
            'value': 130824000000,
            'text': '滦平县',
            'level': 3,
            'pvalue': 130800000000
          },
          {
            'value': 130825000000,
            'text': '隆化县',
            'level': 3,
            'pvalue': 130800000000
          },
          {
            'value': 130826000000,
            'text': '丰宁满族自治县',
            'level': 3,
            'pvalue': 130800000000
          },
          {
            'value': 130827000000,
            'text': '宽城满族自治县',
            'level': 3,
            'pvalue': 130800000000
          },
          {
            'value': 130828000000,
            'text': '围场满族蒙古族自治县',
            'level': 3,
            'pvalue': 130800000000
          },
          {
            'value': 130871000000,
            'text': '承德高新技术产业开发区',
            'level': 3,
            'pvalue': 130800000000
          },
          {
            'value': 130881000000,
            'text': '平泉市',
            'level': 3,
            'pvalue': 130800000000
          }
        ]
      },
      {
        'value': 130900000000,
        'text': '沧州市',
        'level': 2,
        'pvalue': 130000000000,
        'children': [
          {
            'value': 130901000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 130900000000
          },
          {
            'value': 130902000000,
            'text': '新华区',
            'level': 3,
            'pvalue': 130900000000
          },
          {
            'value': 130903000000,
            'text': '运河区',
            'level': 3,
            'pvalue': 130900000000
          },
          {
            'value': 130921000000,
            'text': '沧县',
            'level': 3,
            'pvalue': 130900000000
          },
          {
            'value': 130922000000,
            'text': '青县',
            'level': 3,
            'pvalue': 130900000000
          },
          {
            'value': 130923000000,
            'text': '东光县',
            'level': 3,
            'pvalue': 130900000000
          },
          {
            'value': 130924000000,
            'text': '海兴县',
            'level': 3,
            'pvalue': 130900000000
          },
          {
            'value': 130925000000,
            'text': '盐山县',
            'level': 3,
            'pvalue': 130900000000
          },
          {
            'value': 130926000000,
            'text': '肃宁县',
            'level': 3,
            'pvalue': 130900000000
          },
          {
            'value': 130927000000,
            'text': '南皮县',
            'level': 3,
            'pvalue': 130900000000
          },
          {
            'value': 130928000000,
            'text': '吴桥县',
            'level': 3,
            'pvalue': 130900000000
          },
          {
            'value': 130929000000,
            'text': '献县',
            'level': 3,
            'pvalue': 130900000000
          },
          {
            'value': 130930000000,
            'text': '孟村回族自治县',
            'level': 3,
            'pvalue': 130900000000
          },
          {
            'value': 130971000000,
            'text': '河北沧州经济开发区',
            'level': 3,
            'pvalue': 130900000000
          },
          {
            'value': 130972000000,
            'text': '沧州高新技术产业开发区',
            'level': 3,
            'pvalue': 130900000000
          },
          {
            'value': 130973000000,
            'text': '沧州渤海新区',
            'level': 3,
            'pvalue': 130900000000
          },
          {
            'value': 130981000000,
            'text': '泊头市',
            'level': 3,
            'pvalue': 130900000000
          },
          {
            'value': 130982000000,
            'text': '任丘市',
            'level': 3,
            'pvalue': 130900000000
          },
          {
            'value': 130983000000,
            'text': '黄骅市',
            'level': 3,
            'pvalue': 130900000000
          },
          {
            'value': 130984000000,
            'text': '河间市',
            'level': 3,
            'pvalue': 130900000000
          }
        ]
      },
      {
        'value': 131000000000,
        'text': '廊坊市',
        'level': 2,
        'pvalue': 130000000000,
        'children': [
          {
            'value': 131001000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 131000000000
          },
          {
            'value': 131002000000,
            'text': '安次区',
            'level': 3,
            'pvalue': 131000000000
          },
          {
            'value': 131003000000,
            'text': '广阳区',
            'level': 3,
            'pvalue': 131000000000
          },
          {
            'value': 131022000000,
            'text': '固安县',
            'level': 3,
            'pvalue': 131000000000
          },
          {
            'value': 131023000000,
            'text': '永清县',
            'level': 3,
            'pvalue': 131000000000
          },
          {
            'value': 131024000000,
            'text': '香河县',
            'level': 3,
            'pvalue': 131000000000
          },
          {
            'value': 131025000000,
            'text': '大城县',
            'level': 3,
            'pvalue': 131000000000
          },
          {
            'value': 131026000000,
            'text': '文安县',
            'level': 3,
            'pvalue': 131000000000
          },
          {
            'value': 131028000000,
            'text': '大厂回族自治县',
            'level': 3,
            'pvalue': 131000000000
          },
          {
            'value': 131071000000,
            'text': '廊坊经济技术开发区',
            'level': 3,
            'pvalue': 131000000000
          },
          {
            'value': 131081000000,
            'text': '霸州市',
            'level': 3,
            'pvalue': 131000000000
          },
          {
            'value': 131082000000,
            'text': '三河市',
            'level': 3,
            'pvalue': 131000000000
          }
        ]
      },
      {
        'value': 131100000000,
        'text': '衡水市',
        'level': 2,
        'pvalue': 130000000000,
        'children': [
          {
            'value': 131101000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 131100000000
          },
          {
            'value': 131102000000,
            'text': '桃城区',
            'level': 3,
            'pvalue': 131100000000
          },
          {
            'value': 131103000000,
            'text': '冀州区',
            'level': 3,
            'pvalue': 131100000000
          },
          {
            'value': 131121000000,
            'text': '枣强县',
            'level': 3,
            'pvalue': 131100000000
          },
          {
            'value': 131122000000,
            'text': '武邑县',
            'level': 3,
            'pvalue': 131100000000
          },
          {
            'value': 131123000000,
            'text': '武强县',
            'level': 3,
            'pvalue': 131100000000
          },
          {
            'value': 131124000000,
            'text': '饶阳县',
            'level': 3,
            'pvalue': 131100000000
          },
          {
            'value': 131125000000,
            'text': '安平县',
            'level': 3,
            'pvalue': 131100000000
          },
          {
            'value': 131126000000,
            'text': '故城县',
            'level': 3,
            'pvalue': 131100000000
          },
          {
            'value': 131127000000,
            'text': '景县',
            'level': 3,
            'pvalue': 131100000000
          },
          {
            'value': 131128000000,
            'text': '阜城县',
            'level': 3,
            'pvalue': 131100000000
          },
          {
            'value': 131171000000,
            'text': '河北衡水高新技术产业开发区',
            'level': 3,
            'pvalue': 131100000000
          },
          {
            'value': 131172000000,
            'text': '衡水滨湖新区',
            'level': 3,
            'pvalue': 131100000000
          },
          {
            'value': 131182000000,
            'text': '深州市',
            'level': 3,
            'pvalue': 131100000000
          }
        ]
      }
    ]
  },
  {
    'value': 140000000000,
    'text': '山西省',
    'level': 1,
    'pvalue': 0,
    'children': [
      {
        'value': 140100000000,
        'text': '太原市',
        'level': 2,
        'pvalue': 140000000000,
        'children': [
          {
            'value': 140101000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 140100000000
          },
          {
            'value': 140105000000,
            'text': '小店区',
            'level': 3,
            'pvalue': 140100000000
          },
          {
            'value': 140106000000,
            'text': '迎泽区',
            'level': 3,
            'pvalue': 140100000000
          },
          {
            'value': 140107000000,
            'text': '杏花岭区',
            'level': 3,
            'pvalue': 140100000000
          },
          {
            'value': 140108000000,
            'text': '尖草坪区',
            'level': 3,
            'pvalue': 140100000000
          },
          {
            'value': 140109000000,
            'text': '万柏林区',
            'level': 3,
            'pvalue': 140100000000
          },
          {
            'value': 140110000000,
            'text': '晋源区',
            'level': 3,
            'pvalue': 140100000000
          },
          {
            'value': 140121000000,
            'text': '清徐县',
            'level': 3,
            'pvalue': 140100000000
          },
          {
            'value': 140122000000,
            'text': '阳曲县',
            'level': 3,
            'pvalue': 140100000000
          },
          {
            'value': 140123000000,
            'text': '娄烦县',
            'level': 3,
            'pvalue': 140100000000
          },
          {
            'value': 140171000000,
            'text': '山西转型综合改革示范区',
            'level': 3,
            'pvalue': 140100000000
          },
          {
            'value': 140181000000,
            'text': '古交市',
            'level': 3,
            'pvalue': 140100000000
          }
        ]
      },
      {
        'value': 140200000000,
        'text': '大同市',
        'level': 2,
        'pvalue': 140000000000,
        'children': [
          {
            'value': 140201000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 140200000000
          },
          {
            'value': 140212000000,
            'text': '新荣区',
            'level': 3,
            'pvalue': 140200000000
          },
          {
            'value': 140213000000,
            'text': '平城区',
            'level': 3,
            'pvalue': 140200000000
          },
          {
            'value': 140214000000,
            'text': '云冈区',
            'level': 3,
            'pvalue': 140200000000
          },
          {
            'value': 140215000000,
            'text': '云州区',
            'level': 3,
            'pvalue': 140200000000
          },
          {
            'value': 140221000000,
            'text': '阳高县',
            'level': 3,
            'pvalue': 140200000000
          },
          {
            'value': 140222000000,
            'text': '天镇县',
            'level': 3,
            'pvalue': 140200000000
          },
          {
            'value': 140223000000,
            'text': '广灵县',
            'level': 3,
            'pvalue': 140200000000
          },
          {
            'value': 140224000000,
            'text': '灵丘县',
            'level': 3,
            'pvalue': 140200000000
          },
          {
            'value': 140225000000,
            'text': '浑源县',
            'level': 3,
            'pvalue': 140200000000
          },
          {
            'value': 140226000000,
            'text': '左云县',
            'level': 3,
            'pvalue': 140200000000
          },
          {
            'value': 140271000000,
            'text': '山西大同经济开发区',
            'level': 3,
            'pvalue': 140200000000
          }
        ]
      },
      {
        'value': 140300000000,
        'text': '阳泉市',
        'level': 2,
        'pvalue': 140000000000,
        'children': [
          {
            'value': 140301000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 140300000000
          },
          {
            'value': 140302000000,
            'text': '城区',
            'level': 3,
            'pvalue': 140300000000
          },
          {
            'value': 140303000000,
            'text': '矿区',
            'level': 3,
            'pvalue': 140300000000
          },
          {
            'value': 140311000000,
            'text': '郊区',
            'level': 3,
            'pvalue': 140300000000
          },
          {
            'value': 140321000000,
            'text': '平定县',
            'level': 3,
            'pvalue': 140300000000
          },
          {
            'value': 140322000000,
            'text': '盂县',
            'level': 3,
            'pvalue': 140300000000
          }
        ]
      },
      {
        'value': 140400000000,
        'text': '长治市',
        'level': 2,
        'pvalue': 140000000000,
        'children': [
          {
            'value': 140401000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 140400000000
          },
          {
            'value': 140403000000,
            'text': '潞州区',
            'level': 3,
            'pvalue': 140400000000
          },
          {
            'value': 140404000000,
            'text': '上党区',
            'level': 3,
            'pvalue': 140400000000
          },
          {
            'value': 140405000000,
            'text': '屯留区',
            'level': 3,
            'pvalue': 140400000000
          },
          {
            'value': 140406000000,
            'text': '潞城区',
            'level': 3,
            'pvalue': 140400000000
          },
          {
            'value': 140423000000,
            'text': '襄垣县',
            'level': 3,
            'pvalue': 140400000000
          },
          {
            'value': 140425000000,
            'text': '平顺县',
            'level': 3,
            'pvalue': 140400000000
          },
          {
            'value': 140426000000,
            'text': '黎城县',
            'level': 3,
            'pvalue': 140400000000
          },
          {
            'value': 140427000000,
            'text': '壶关县',
            'level': 3,
            'pvalue': 140400000000
          },
          {
            'value': 140428000000,
            'text': '长子县',
            'level': 3,
            'pvalue': 140400000000
          },
          {
            'value': 140429000000,
            'text': '武乡县',
            'level': 3,
            'pvalue': 140400000000
          },
          {
            'value': 140430000000,
            'text': '沁县',
            'level': 3,
            'pvalue': 140400000000
          },
          {
            'value': 140431000000,
            'text': '沁源县',
            'level': 3,
            'pvalue': 140400000000
          },
          {
            'value': 140471000000,
            'text': '山西长治高新技术产业园区',
            'level': 3,
            'pvalue': 140400000000
          }
        ]
      },
      {
        'value': 140500000000,
        'text': '晋城市',
        'level': 2,
        'pvalue': 140000000000,
        'children': [
          {
            'value': 140501000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 140500000000
          },
          {
            'value': 140502000000,
            'text': '城区',
            'level': 3,
            'pvalue': 140500000000
          },
          {
            'value': 140521000000,
            'text': '沁水县',
            'level': 3,
            'pvalue': 140500000000
          },
          {
            'value': 140522000000,
            'text': '阳城县',
            'level': 3,
            'pvalue': 140500000000
          },
          {
            'value': 140524000000,
            'text': '陵川县',
            'level': 3,
            'pvalue': 140500000000
          },
          {
            'value': 140525000000,
            'text': '泽州县',
            'level': 3,
            'pvalue': 140500000000
          },
          {
            'value': 140581000000,
            'text': '高平市',
            'level': 3,
            'pvalue': 140500000000
          }
        ]
      },
      {
        'value': 140600000000,
        'text': '朔州市',
        'level': 2,
        'pvalue': 140000000000,
        'children': [
          {
            'value': 140601000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 140600000000
          },
          {
            'value': 140602000000,
            'text': '朔城区',
            'level': 3,
            'pvalue': 140600000000
          },
          {
            'value': 140603000000,
            'text': '平鲁区',
            'level': 3,
            'pvalue': 140600000000
          },
          {
            'value': 140621000000,
            'text': '山阴县',
            'level': 3,
            'pvalue': 140600000000
          },
          {
            'value': 140622000000,
            'text': '应县',
            'level': 3,
            'pvalue': 140600000000
          },
          {
            'value': 140623000000,
            'text': '右玉县',
            'level': 3,
            'pvalue': 140600000000
          },
          {
            'value': 140671000000,
            'text': '山西朔州经济开发区',
            'level': 3,
            'pvalue': 140600000000
          },
          {
            'value': 140681000000,
            'text': '怀仁市',
            'level': 3,
            'pvalue': 140600000000
          }
        ]
      },
      {
        'value': 140700000000,
        'text': '晋中市',
        'level': 2,
        'pvalue': 140000000000,
        'children': [
          {
            'value': 140701000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 140700000000
          },
          {
            'value': 140702000000,
            'text': '榆次区',
            'level': 3,
            'pvalue': 140700000000
          },
          {
            'value': 140703000000,
            'text': '太谷区',
            'level': 3,
            'pvalue': 140700000000
          },
          {
            'value': 140721000000,
            'text': '榆社县',
            'level': 3,
            'pvalue': 140700000000
          },
          {
            'value': 140722000000,
            'text': '左权县',
            'level': 3,
            'pvalue': 140700000000
          },
          {
            'value': 140723000000,
            'text': '和顺县',
            'level': 3,
            'pvalue': 140700000000
          },
          {
            'value': 140724000000,
            'text': '昔阳县',
            'level': 3,
            'pvalue': 140700000000
          },
          {
            'value': 140725000000,
            'text': '寿阳县',
            'level': 3,
            'pvalue': 140700000000
          },
          {
            'value': 140727000000,
            'text': '祁县',
            'level': 3,
            'pvalue': 140700000000
          },
          {
            'value': 140728000000,
            'text': '平遥县',
            'level': 3,
            'pvalue': 140700000000
          },
          {
            'value': 140729000000,
            'text': '灵石县',
            'level': 3,
            'pvalue': 140700000000
          },
          {
            'value': 140781000000,
            'text': '介休市',
            'level': 3,
            'pvalue': 140700000000
          }
        ]
      },
      {
        'value': 140800000000,
        'text': '运城市',
        'level': 2,
        'pvalue': 140000000000,
        'children': [
          {
            'value': 140801000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 140800000000
          },
          {
            'value': 140802000000,
            'text': '盐湖区',
            'level': 3,
            'pvalue': 140800000000
          },
          {
            'value': 140821000000,
            'text': '临猗县',
            'level': 3,
            'pvalue': 140800000000
          },
          {
            'value': 140822000000,
            'text': '万荣县',
            'level': 3,
            'pvalue': 140800000000
          },
          {
            'value': 140823000000,
            'text': '闻喜县',
            'level': 3,
            'pvalue': 140800000000
          },
          {
            'value': 140824000000,
            'text': '稷山县',
            'level': 3,
            'pvalue': 140800000000
          },
          {
            'value': 140825000000,
            'text': '新绛县',
            'level': 3,
            'pvalue': 140800000000
          },
          {
            'value': 140826000000,
            'text': '绛县',
            'level': 3,
            'pvalue': 140800000000
          },
          {
            'value': 140827000000,
            'text': '垣曲县',
            'level': 3,
            'pvalue': 140800000000
          },
          {
            'value': 140828000000,
            'text': '夏县',
            'level': 3,
            'pvalue': 140800000000
          },
          {
            'value': 140829000000,
            'text': '平陆县',
            'level': 3,
            'pvalue': 140800000000
          },
          {
            'value': 140830000000,
            'text': '芮城县',
            'level': 3,
            'pvalue': 140800000000
          },
          {
            'value': 140881000000,
            'text': '永济市',
            'level': 3,
            'pvalue': 140800000000
          },
          {
            'value': 140882000000,
            'text': '河津市',
            'level': 3,
            'pvalue': 140800000000
          }
        ]
      },
      {
        'value': 140900000000,
        'text': '忻州市',
        'level': 2,
        'pvalue': 140000000000,
        'children': [
          {
            'value': 140901000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 140900000000
          },
          {
            'value': 140902000000,
            'text': '忻府区',
            'level': 3,
            'pvalue': 140900000000
          },
          {
            'value': 140921000000,
            'text': '定襄县',
            'level': 3,
            'pvalue': 140900000000
          },
          {
            'value': 140922000000,
            'text': '五台县',
            'level': 3,
            'pvalue': 140900000000
          },
          {
            'value': 140923000000,
            'text': '代县',
            'level': 3,
            'pvalue': 140900000000
          },
          {
            'value': 140924000000,
            'text': '繁峙县',
            'level': 3,
            'pvalue': 140900000000
          },
          {
            'value': 140925000000,
            'text': '宁武县',
            'level': 3,
            'pvalue': 140900000000
          },
          {
            'value': 140926000000,
            'text': '静乐县',
            'level': 3,
            'pvalue': 140900000000
          },
          {
            'value': 140927000000,
            'text': '神池县',
            'level': 3,
            'pvalue': 140900000000
          },
          {
            'value': 140928000000,
            'text': '五寨县',
            'level': 3,
            'pvalue': 140900000000
          },
          {
            'value': 140929000000,
            'text': '岢岚县',
            'level': 3,
            'pvalue': 140900000000
          },
          {
            'value': 140930000000,
            'text': '河曲县',
            'level': 3,
            'pvalue': 140900000000
          },
          {
            'value': 140931000000,
            'text': '保德县',
            'level': 3,
            'pvalue': 140900000000
          },
          {
            'value': 140932000000,
            'text': '偏关县',
            'level': 3,
            'pvalue': 140900000000
          },
          {
            'value': 140971000000,
            'text': '五台山风景名胜区',
            'level': 3,
            'pvalue': 140900000000
          },
          {
            'value': 140981000000,
            'text': '原平市',
            'level': 3,
            'pvalue': 140900000000
          }
        ]
      },
      {
        'value': 141000000000,
        'text': '临汾市',
        'level': 2,
        'pvalue': 140000000000,
        'children': [
          {
            'value': 141001000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 141000000000
          },
          {
            'value': 141002000000,
            'text': '尧都区',
            'level': 3,
            'pvalue': 141000000000
          },
          {
            'value': 141021000000,
            'text': '曲沃县',
            'level': 3,
            'pvalue': 141000000000
          },
          {
            'value': 141022000000,
            'text': '翼城县',
            'level': 3,
            'pvalue': 141000000000
          },
          {
            'value': 141023000000,
            'text': '襄汾县',
            'level': 3,
            'pvalue': 141000000000
          },
          {
            'value': 141024000000,
            'text': '洪洞县',
            'level': 3,
            'pvalue': 141000000000
          },
          {
            'value': 141025000000,
            'text': '古县',
            'level': 3,
            'pvalue': 141000000000
          },
          {
            'value': 141026000000,
            'text': '安泽县',
            'level': 3,
            'pvalue': 141000000000
          },
          {
            'value': 141027000000,
            'text': '浮山县',
            'level': 3,
            'pvalue': 141000000000
          },
          {
            'value': 141028000000,
            'text': '吉县',
            'level': 3,
            'pvalue': 141000000000
          },
          {
            'value': 141029000000,
            'text': '乡宁县',
            'level': 3,
            'pvalue': 141000000000
          },
          {
            'value': 141030000000,
            'text': '大宁县',
            'level': 3,
            'pvalue': 141000000000
          },
          {
            'value': 141031000000,
            'text': '隰县',
            'level': 3,
            'pvalue': 141000000000
          },
          {
            'value': 141032000000,
            'text': '永和县',
            'level': 3,
            'pvalue': 141000000000
          },
          {
            'value': 141033000000,
            'text': '蒲县',
            'level': 3,
            'pvalue': 141000000000
          },
          {
            'value': 141034000000,
            'text': '汾西县',
            'level': 3,
            'pvalue': 141000000000
          },
          {
            'value': 141081000000,
            'text': '侯马市',
            'level': 3,
            'pvalue': 141000000000
          },
          {
            'value': 141082000000,
            'text': '霍州市',
            'level': 3,
            'pvalue': 141000000000
          }
        ]
      },
      {
        'value': 141100000000,
        'text': '吕梁市',
        'level': 2,
        'pvalue': 140000000000,
        'children': [
          {
            'value': 141101000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 141100000000
          },
          {
            'value': 141102000000,
            'text': '离石区',
            'level': 3,
            'pvalue': 141100000000
          },
          {
            'value': 141121000000,
            'text': '文水县',
            'level': 3,
            'pvalue': 141100000000
          },
          {
            'value': 141122000000,
            'text': '交城县',
            'level': 3,
            'pvalue': 141100000000
          },
          {
            'value': 141123000000,
            'text': '兴县',
            'level': 3,
            'pvalue': 141100000000
          },
          {
            'value': 141124000000,
            'text': '临县',
            'level': 3,
            'pvalue': 141100000000
          },
          {
            'value': 141125000000,
            'text': '柳林县',
            'level': 3,
            'pvalue': 141100000000
          },
          {
            'value': 141126000000,
            'text': '石楼县',
            'level': 3,
            'pvalue': 141100000000
          },
          {
            'value': 141127000000,
            'text': '岚县',
            'level': 3,
            'pvalue': 141100000000
          },
          {
            'value': 141128000000,
            'text': '方山县',
            'level': 3,
            'pvalue': 141100000000
          },
          {
            'value': 141129000000,
            'text': '中阳县',
            'level': 3,
            'pvalue': 141100000000
          },
          {
            'value': 141130000000,
            'text': '交口县',
            'level': 3,
            'pvalue': 141100000000
          },
          {
            'value': 141181000000,
            'text': '孝义市',
            'level': 3,
            'pvalue': 141100000000
          },
          {
            'value': 141182000000,
            'text': '汾阳市',
            'level': 3,
            'pvalue': 141100000000
          }
        ]
      }
    ]
  },
  {
    'value': 150000000000,
    'text': '内蒙古自治区',
    'level': 1,
    'pvalue': 0,
    'children': [
      {
        'value': 150100000000,
        'text': '呼和浩特市',
        'level': 2,
        'pvalue': 150000000000,
        'children': [
          {
            'value': 150101000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 150100000000
          },
          {
            'value': 150102000000,
            'text': '新城区',
            'level': 3,
            'pvalue': 150100000000
          },
          {
            'value': 150103000000,
            'text': '回民区',
            'level': 3,
            'pvalue': 150100000000
          },
          {
            'value': 150104000000,
            'text': '玉泉区',
            'level': 3,
            'pvalue': 150100000000
          },
          {
            'value': 150105000000,
            'text': '赛罕区',
            'level': 3,
            'pvalue': 150100000000
          },
          {
            'value': 150121000000,
            'text': '土默特左旗',
            'level': 3,
            'pvalue': 150100000000
          },
          {
            'value': 150122000000,
            'text': '托克托县',
            'level': 3,
            'pvalue': 150100000000
          },
          {
            'value': 150123000000,
            'text': '和林格尔县',
            'level': 3,
            'pvalue': 150100000000
          },
          {
            'value': 150124000000,
            'text': '清水河县',
            'level': 3,
            'pvalue': 150100000000
          },
          {
            'value': 150125000000,
            'text': '武川县',
            'level': 3,
            'pvalue': 150100000000
          },
          {
            'value': 150172000000,
            'text': '呼和浩特经济技术开发区',
            'level': 3,
            'pvalue': 150100000000
          }
        ]
      },
      {
        'value': 150200000000,
        'text': '包头市',
        'level': 2,
        'pvalue': 150000000000,
        'children': [
          {
            'value': 150201000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 150200000000
          },
          {
            'value': 150202000000,
            'text': '东河区',
            'level': 3,
            'pvalue': 150200000000
          },
          {
            'value': 150203000000,
            'text': '昆都仑区',
            'level': 3,
            'pvalue': 150200000000
          },
          {
            'value': 150204000000,
            'text': '青山区',
            'level': 3,
            'pvalue': 150200000000
          },
          {
            'value': 150205000000,
            'text': '石拐区',
            'level': 3,
            'pvalue': 150200000000
          },
          {
            'value': 150206000000,
            'text': '白云鄂博矿区',
            'level': 3,
            'pvalue': 150200000000
          },
          {
            'value': 150207000000,
            'text': '九原区',
            'level': 3,
            'pvalue': 150200000000
          },
          {
            'value': 150221000000,
            'text': '土默特右旗',
            'level': 3,
            'pvalue': 150200000000
          },
          {
            'value': 150222000000,
            'text': '固阳县',
            'level': 3,
            'pvalue': 150200000000
          },
          {
            'value': 150223000000,
            'text': '达尔罕茂明安联合旗',
            'level': 3,
            'pvalue': 150200000000
          },
          {
            'value': 150271000000,
            'text': '包头稀土高新技术产业开发区',
            'level': 3,
            'pvalue': 150200000000
          }
        ]
      },
      {
        'value': 150300000000,
        'text': '乌海市',
        'level': 2,
        'pvalue': 150000000000,
        'children': [
          {
            'value': 150301000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 150300000000
          },
          {
            'value': 150302000000,
            'text': '海勃湾区',
            'level': 3,
            'pvalue': 150300000000
          },
          {
            'value': 150303000000,
            'text': '海南区',
            'level': 3,
            'pvalue': 150300000000
          },
          {
            'value': 150304000000,
            'text': '乌达区',
            'level': 3,
            'pvalue': 150300000000
          }
        ]
      },
      {
        'value': 150400000000,
        'text': '赤峰市',
        'level': 2,
        'pvalue': 150000000000,
        'children': [
          {
            'value': 150401000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 150400000000
          },
          {
            'value': 150402000000,
            'text': '红山区',
            'level': 3,
            'pvalue': 150400000000
          },
          {
            'value': 150403000000,
            'text': '元宝山区',
            'level': 3,
            'pvalue': 150400000000
          },
          {
            'value': 150404000000,
            'text': '松山区',
            'level': 3,
            'pvalue': 150400000000
          },
          {
            'value': 150421000000,
            'text': '阿鲁科尔沁旗',
            'level': 3,
            'pvalue': 150400000000
          },
          {
            'value': 150422000000,
            'text': '巴林左旗',
            'level': 3,
            'pvalue': 150400000000
          },
          {
            'value': 150423000000,
            'text': '巴林右旗',
            'level': 3,
            'pvalue': 150400000000
          },
          {
            'value': 150424000000,
            'text': '林西县',
            'level': 3,
            'pvalue': 150400000000
          },
          {
            'value': 150425000000,
            'text': '克什克腾旗',
            'level': 3,
            'pvalue': 150400000000
          },
          {
            'value': 150426000000,
            'text': '翁牛特旗',
            'level': 3,
            'pvalue': 150400000000
          },
          {
            'value': 150428000000,
            'text': '喀喇沁旗',
            'level': 3,
            'pvalue': 150400000000
          },
          {
            'value': 150429000000,
            'text': '宁城县',
            'level': 3,
            'pvalue': 150400000000
          },
          {
            'value': 150430000000,
            'text': '敖汉旗',
            'level': 3,
            'pvalue': 150400000000
          }
        ]
      },
      {
        'value': 150500000000,
        'text': '通辽市',
        'level': 2,
        'pvalue': 150000000000,
        'children': [
          {
            'value': 150501000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 150500000000
          },
          {
            'value': 150502000000,
            'text': '科尔沁区',
            'level': 3,
            'pvalue': 150500000000
          },
          {
            'value': 150521000000,
            'text': '科尔沁左翼中旗',
            'level': 3,
            'pvalue': 150500000000
          },
          {
            'value': 150522000000,
            'text': '科尔沁左翼后旗',
            'level': 3,
            'pvalue': 150500000000
          },
          {
            'value': 150523000000,
            'text': '开鲁县',
            'level': 3,
            'pvalue': 150500000000
          },
          {
            'value': 150524000000,
            'text': '库伦旗',
            'level': 3,
            'pvalue': 150500000000
          },
          {
            'value': 150525000000,
            'text': '奈曼旗',
            'level': 3,
            'pvalue': 150500000000
          },
          {
            'value': 150526000000,
            'text': '扎鲁特旗',
            'level': 3,
            'pvalue': 150500000000
          },
          {
            'value': 150571000000,
            'text': '通辽经济技术开发区',
            'level': 3,
            'pvalue': 150500000000
          },
          {
            'value': 150581000000,
            'text': '霍林郭勒市',
            'level': 3,
            'pvalue': 150500000000
          }
        ]
      },
      {
        'value': 150600000000,
        'text': '鄂尔多斯市',
        'level': 2,
        'pvalue': 150000000000,
        'children': [
          {
            'value': 150601000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 150600000000
          },
          {
            'value': 150602000000,
            'text': '东胜区',
            'level': 3,
            'pvalue': 150600000000
          },
          {
            'value': 150603000000,
            'text': '康巴什区',
            'level': 3,
            'pvalue': 150600000000
          },
          {
            'value': 150621000000,
            'text': '达拉特旗',
            'level': 3,
            'pvalue': 150600000000
          },
          {
            'value': 150622000000,
            'text': '准格尔旗',
            'level': 3,
            'pvalue': 150600000000
          },
          {
            'value': 150623000000,
            'text': '鄂托克前旗',
            'level': 3,
            'pvalue': 150600000000
          },
          {
            'value': 150624000000,
            'text': '鄂托克旗',
            'level': 3,
            'pvalue': 150600000000
          },
          {
            'value': 150625000000,
            'text': '杭锦旗',
            'level': 3,
            'pvalue': 150600000000
          },
          {
            'value': 150626000000,
            'text': '乌审旗',
            'level': 3,
            'pvalue': 150600000000
          },
          {
            'value': 150627000000,
            'text': '伊金霍洛旗',
            'level': 3,
            'pvalue': 150600000000
          }
        ]
      },
      {
        'value': 150700000000,
        'text': '呼伦贝尔市',
        'level': 2,
        'pvalue': 150000000000,
        'children': [
          {
            'value': 150701000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 150700000000
          },
          {
            'value': 150702000000,
            'text': '海拉尔区',
            'level': 3,
            'pvalue': 150700000000
          },
          {
            'value': 150703000000,
            'text': '扎赉诺尔区',
            'level': 3,
            'pvalue': 150700000000
          },
          {
            'value': 150721000000,
            'text': '阿荣旗',
            'level': 3,
            'pvalue': 150700000000
          },
          {
            'value': 150722000000,
            'text': '莫力达瓦达斡尔族自治旗',
            'level': 3,
            'pvalue': 150700000000
          },
          {
            'value': 150723000000,
            'text': '鄂伦春自治旗',
            'level': 3,
            'pvalue': 150700000000
          },
          {
            'value': 150724000000,
            'text': '鄂温克族自治旗',
            'level': 3,
            'pvalue': 150700000000
          },
          {
            'value': 150725000000,
            'text': '陈巴尔虎旗',
            'level': 3,
            'pvalue': 150700000000
          },
          {
            'value': 150726000000,
            'text': '新巴尔虎左旗',
            'level': 3,
            'pvalue': 150700000000
          },
          {
            'value': 150727000000,
            'text': '新巴尔虎右旗',
            'level': 3,
            'pvalue': 150700000000
          },
          {
            'value': 150781000000,
            'text': '满洲里市',
            'level': 3,
            'pvalue': 150700000000
          },
          {
            'value': 150782000000,
            'text': '牙克石市',
            'level': 3,
            'pvalue': 150700000000
          },
          {
            'value': 150783000000,
            'text': '扎兰屯市',
            'level': 3,
            'pvalue': 150700000000
          },
          {
            'value': 150784000000,
            'text': '额尔古纳市',
            'level': 3,
            'pvalue': 150700000000
          },
          {
            'value': 150785000000,
            'text': '根河市',
            'level': 3,
            'pvalue': 150700000000
          }
        ]
      },
      {
        'value': 150800000000,
        'text': '巴彦淖尔市',
        'level': 2,
        'pvalue': 150000000000,
        'children': [
          {
            'value': 150801000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 150800000000
          },
          {
            'value': 150802000000,
            'text': '临河区',
            'level': 3,
            'pvalue': 150800000000
          },
          {
            'value': 150821000000,
            'text': '五原县',
            'level': 3,
            'pvalue': 150800000000
          },
          {
            'value': 150822000000,
            'text': '磴口县',
            'level': 3,
            'pvalue': 150800000000
          },
          {
            'value': 150823000000,
            'text': '乌拉特前旗',
            'level': 3,
            'pvalue': 150800000000
          },
          {
            'value': 150824000000,
            'text': '乌拉特中旗',
            'level': 3,
            'pvalue': 150800000000
          },
          {
            'value': 150825000000,
            'text': '乌拉特后旗',
            'level': 3,
            'pvalue': 150800000000
          },
          {
            'value': 150826000000,
            'text': '杭锦后旗',
            'level': 3,
            'pvalue': 150800000000
          }
        ]
      },
      {
        'value': 150900000000,
        'text': '乌兰察布市',
        'level': 2,
        'pvalue': 150000000000,
        'children': [
          {
            'value': 150901000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 150900000000
          },
          {
            'value': 150902000000,
            'text': '集宁区',
            'level': 3,
            'pvalue': 150900000000
          },
          {
            'value': 150921000000,
            'text': '卓资县',
            'level': 3,
            'pvalue': 150900000000
          },
          {
            'value': 150922000000,
            'text': '化德县',
            'level': 3,
            'pvalue': 150900000000
          },
          {
            'value': 150923000000,
            'text': '商都县',
            'level': 3,
            'pvalue': 150900000000
          },
          {
            'value': 150924000000,
            'text': '兴和县',
            'level': 3,
            'pvalue': 150900000000
          },
          {
            'value': 150925000000,
            'text': '凉城县',
            'level': 3,
            'pvalue': 150900000000
          },
          {
            'value': 150926000000,
            'text': '察哈尔右翼前旗',
            'level': 3,
            'pvalue': 150900000000
          },
          {
            'value': 150927000000,
            'text': '察哈尔右翼中旗',
            'level': 3,
            'pvalue': 150900000000
          },
          {
            'value': 150928000000,
            'text': '察哈尔右翼后旗',
            'level': 3,
            'pvalue': 150900000000
          },
          {
            'value': 150929000000,
            'text': '四子王旗',
            'level': 3,
            'pvalue': 150900000000
          },
          {
            'value': 150981000000,
            'text': '丰镇市',
            'level': 3,
            'pvalue': 150900000000
          }
        ]
      },
      {
        'value': 152200000000,
        'text': '兴安盟',
        'level': 2,
        'pvalue': 150000000000,
        'children': [
          {
            'value': 152201000000,
            'text': '乌兰浩特市',
            'level': 3,
            'pvalue': 152200000000
          },
          {
            'value': 152202000000,
            'text': '阿尔山市',
            'level': 3,
            'pvalue': 152200000000
          },
          {
            'value': 152221000000,
            'text': '科尔沁右翼前旗',
            'level': 3,
            'pvalue': 152200000000
          },
          {
            'value': 152222000000,
            'text': '科尔沁右翼中旗',
            'level': 3,
            'pvalue': 152200000000
          },
          {
            'value': 152223000000,
            'text': '扎赉特旗',
            'level': 3,
            'pvalue': 152200000000
          },
          {
            'value': 152224000000,
            'text': '突泉县',
            'level': 3,
            'pvalue': 152200000000
          }
        ]
      },
      {
        'value': 152500000000,
        'text': '锡林郭勒盟',
        'level': 2,
        'pvalue': 150000000000,
        'children': [
          {
            'value': 152501000000,
            'text': '二连浩特市',
            'level': 3,
            'pvalue': 152500000000
          },
          {
            'value': 152502000000,
            'text': '锡林浩特市',
            'level': 3,
            'pvalue': 152500000000
          },
          {
            'value': 152522000000,
            'text': '阿巴嘎旗',
            'level': 3,
            'pvalue': 152500000000
          },
          {
            'value': 152523000000,
            'text': '苏尼特左旗',
            'level': 3,
            'pvalue': 152500000000
          },
          {
            'value': 152524000000,
            'text': '苏尼特右旗',
            'level': 3,
            'pvalue': 152500000000
          },
          {
            'value': 152525000000,
            'text': '东乌珠穆沁旗',
            'level': 3,
            'pvalue': 152500000000
          },
          {
            'value': 152526000000,
            'text': '西乌珠穆沁旗',
            'level': 3,
            'pvalue': 152500000000
          },
          {
            'value': 152527000000,
            'text': '太仆寺旗',
            'level': 3,
            'pvalue': 152500000000
          },
          {
            'value': 152528000000,
            'text': '镶黄旗',
            'level': 3,
            'pvalue': 152500000000
          },
          {
            'value': 152529000000,
            'text': '正镶白旗',
            'level': 3,
            'pvalue': 152500000000
          },
          {
            'value': 152530000000,
            'text': '正蓝旗',
            'level': 3,
            'pvalue': 152500000000
          },
          {
            'value': 152531000000,
            'text': '多伦县',
            'level': 3,
            'pvalue': 152500000000
          },
          {
            'value': 152571000000,
            'text': '乌拉盖管委会',
            'level': 3,
            'pvalue': 152500000000
          }
        ]
      },
      {
        'value': 152900000000,
        'text': '阿拉善盟',
        'level': 2,
        'pvalue': 150000000000,
        'children': [
          {
            'value': 152921000000,
            'text': '阿拉善左旗',
            'level': 3,
            'pvalue': 152900000000
          },
          {
            'value': 152922000000,
            'text': '阿拉善右旗',
            'level': 3,
            'pvalue': 152900000000
          },
          {
            'value': 152923000000,
            'text': '额济纳旗',
            'level': 3,
            'pvalue': 152900000000
          },
          {
            'value': 152971000000,
            'text': '内蒙古阿拉善高新技术产业开发区',
            'level': 3,
            'pvalue': 152900000000
          }
        ]
      }
    ]
  },
  {
    'value': 210000000000,
    'text': '辽宁省',
    'level': 1,
    'pvalue': 0,
    'children': [
      {
        'value': 210100000000,
        'text': '沈阳市',
        'level': 2,
        'pvalue': 210000000000,
        'children': [
          {
            'value': 210101000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 210100000000
          },
          {
            'value': 210102000000,
            'text': '和平区',
            'level': 3,
            'pvalue': 210100000000
          },
          {
            'value': 210103000000,
            'text': '沈河区',
            'level': 3,
            'pvalue': 210100000000
          },
          {
            'value': 210104000000,
            'text': '大东区',
            'level': 3,
            'pvalue': 210100000000
          },
          {
            'value': 210105000000,
            'text': '皇姑区',
            'level': 3,
            'pvalue': 210100000000
          },
          {
            'value': 210106000000,
            'text': '铁西区',
            'level': 3,
            'pvalue': 210100000000
          },
          {
            'value': 210111000000,
            'text': '苏家屯区',
            'level': 3,
            'pvalue': 210100000000
          },
          {
            'value': 210112000000,
            'text': '浑南区',
            'level': 3,
            'pvalue': 210100000000
          },
          {
            'value': 210113000000,
            'text': '沈北新区',
            'level': 3,
            'pvalue': 210100000000
          },
          {
            'value': 210114000000,
            'text': '于洪区',
            'level': 3,
            'pvalue': 210100000000
          },
          {
            'value': 210115000000,
            'text': '辽中区',
            'level': 3,
            'pvalue': 210100000000
          },
          {
            'value': 210123000000,
            'text': '康平县',
            'level': 3,
            'pvalue': 210100000000
          },
          {
            'value': 210124000000,
            'text': '法库县',
            'level': 3,
            'pvalue': 210100000000
          },
          {
            'value': 210181000000,
            'text': '新民市',
            'level': 3,
            'pvalue': 210100000000
          }
        ]
      },
      {
        'value': 210200000000,
        'text': '大连市',
        'level': 2,
        'pvalue': 210000000000,
        'children': [
          {
            'value': 210201000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 210200000000
          },
          {
            'value': 210202000000,
            'text': '中山区',
            'level': 3,
            'pvalue': 210200000000
          },
          {
            'value': 210203000000,
            'text': '西岗区',
            'level': 3,
            'pvalue': 210200000000
          },
          {
            'value': 210204000000,
            'text': '沙河口区',
            'level': 3,
            'pvalue': 210200000000
          },
          {
            'value': 210211000000,
            'text': '甘井子区',
            'level': 3,
            'pvalue': 210200000000
          },
          {
            'value': 210212000000,
            'text': '旅顺口区',
            'level': 3,
            'pvalue': 210200000000
          },
          {
            'value': 210213000000,
            'text': '金州区',
            'level': 3,
            'pvalue': 210200000000
          },
          {
            'value': 210214000000,
            'text': '普兰店区',
            'level': 3,
            'pvalue': 210200000000
          },
          {
            'value': 210224000000,
            'text': '长海县',
            'level': 3,
            'pvalue': 210200000000
          },
          {
            'value': 210281000000,
            'text': '瓦房店市',
            'level': 3,
            'pvalue': 210200000000
          },
          {
            'value': 210283000000,
            'text': '庄河市',
            'level': 3,
            'pvalue': 210200000000
          }
        ]
      },
      {
        'value': 210300000000,
        'text': '鞍山市',
        'level': 2,
        'pvalue': 210000000000,
        'children': [
          {
            'value': 210301000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 210300000000
          },
          {
            'value': 210302000000,
            'text': '铁东区',
            'level': 3,
            'pvalue': 210300000000
          },
          {
            'value': 210303000000,
            'text': '铁西区',
            'level': 3,
            'pvalue': 210300000000
          },
          {
            'value': 210304000000,
            'text': '立山区',
            'level': 3,
            'pvalue': 210300000000
          },
          {
            'value': 210311000000,
            'text': '千山区',
            'level': 3,
            'pvalue': 210300000000
          },
          {
            'value': 210321000000,
            'text': '台安县',
            'level': 3,
            'pvalue': 210300000000
          },
          {
            'value': 210323000000,
            'text': '岫岩满族自治县',
            'level': 3,
            'pvalue': 210300000000
          },
          {
            'value': 210381000000,
            'text': '海城市',
            'level': 3,
            'pvalue': 210300000000
          }
        ]
      },
      {
        'value': 210400000000,
        'text': '抚顺市',
        'level': 2,
        'pvalue': 210000000000,
        'children': [
          {
            'value': 210401000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 210400000000
          },
          {
            'value': 210402000000,
            'text': '新抚区',
            'level': 3,
            'pvalue': 210400000000
          },
          {
            'value': 210403000000,
            'text': '东洲区',
            'level': 3,
            'pvalue': 210400000000
          },
          {
            'value': 210404000000,
            'text': '望花区',
            'level': 3,
            'pvalue': 210400000000
          },
          {
            'value': 210411000000,
            'text': '顺城区',
            'level': 3,
            'pvalue': 210400000000
          },
          {
            'value': 210421000000,
            'text': '抚顺县',
            'level': 3,
            'pvalue': 210400000000
          },
          {
            'value': 210422000000,
            'text': '新宾满族自治县',
            'level': 3,
            'pvalue': 210400000000
          },
          {
            'value': 210423000000,
            'text': '清原满族自治县',
            'level': 3,
            'pvalue': 210400000000
          }
        ]
      },
      {
        'value': 210500000000,
        'text': '本溪市',
        'level': 2,
        'pvalue': 210000000000,
        'children': [
          {
            'value': 210501000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 210500000000
          },
          {
            'value': 210502000000,
            'text': '平山区',
            'level': 3,
            'pvalue': 210500000000
          },
          {
            'value': 210503000000,
            'text': '溪湖区',
            'level': 3,
            'pvalue': 210500000000
          },
          {
            'value': 210504000000,
            'text': '明山区',
            'level': 3,
            'pvalue': 210500000000
          },
          {
            'value': 210505000000,
            'text': '南芬区',
            'level': 3,
            'pvalue': 210500000000
          },
          {
            'value': 210521000000,
            'text': '本溪满族自治县',
            'level': 3,
            'pvalue': 210500000000
          },
          {
            'value': 210522000000,
            'text': '桓仁满族自治县',
            'level': 3,
            'pvalue': 210500000000
          }
        ]
      },
      {
        'value': 210600000000,
        'text': '丹东市',
        'level': 2,
        'pvalue': 210000000000,
        'children': [
          {
            'value': 210601000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 210600000000
          },
          {
            'value': 210602000000,
            'text': '元宝区',
            'level': 3,
            'pvalue': 210600000000
          },
          {
            'value': 210603000000,
            'text': '振兴区',
            'level': 3,
            'pvalue': 210600000000
          },
          {
            'value': 210604000000,
            'text': '振安区',
            'level': 3,
            'pvalue': 210600000000
          },
          {
            'value': 210624000000,
            'text': '宽甸满族自治县',
            'level': 3,
            'pvalue': 210600000000
          },
          {
            'value': 210681000000,
            'text': '东港市',
            'level': 3,
            'pvalue': 210600000000
          },
          {
            'value': 210682000000,
            'text': '凤城市',
            'level': 3,
            'pvalue': 210600000000
          }
        ]
      },
      {
        'value': 210700000000,
        'text': '锦州市',
        'level': 2,
        'pvalue': 210000000000,
        'children': [
          {
            'value': 210701000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 210700000000
          },
          {
            'value': 210702000000,
            'text': '古塔区',
            'level': 3,
            'pvalue': 210700000000
          },
          {
            'value': 210703000000,
            'text': '凌河区',
            'level': 3,
            'pvalue': 210700000000
          },
          {
            'value': 210711000000,
            'text': '太和区',
            'level': 3,
            'pvalue': 210700000000
          },
          {
            'value': 210726000000,
            'text': '黑山县',
            'level': 3,
            'pvalue': 210700000000
          },
          {
            'value': 210727000000,
            'text': '义县',
            'level': 3,
            'pvalue': 210700000000
          },
          {
            'value': 210781000000,
            'text': '凌海市',
            'level': 3,
            'pvalue': 210700000000
          },
          {
            'value': 210782000000,
            'text': '北镇市',
            'level': 3,
            'pvalue': 210700000000
          }
        ]
      },
      {
        'value': 210800000000,
        'text': '营口市',
        'level': 2,
        'pvalue': 210000000000,
        'children': [
          {
            'value': 210801000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 210800000000
          },
          {
            'value': 210802000000,
            'text': '站前区',
            'level': 3,
            'pvalue': 210800000000
          },
          {
            'value': 210803000000,
            'text': '西市区',
            'level': 3,
            'pvalue': 210800000000
          },
          {
            'value': 210804000000,
            'text': '鲅鱼圈区',
            'level': 3,
            'pvalue': 210800000000
          },
          {
            'value': 210811000000,
            'text': '老边区',
            'level': 3,
            'pvalue': 210800000000
          },
          {
            'value': 210881000000,
            'text': '盖州市',
            'level': 3,
            'pvalue': 210800000000
          },
          {
            'value': 210882000000,
            'text': '大石桥市',
            'level': 3,
            'pvalue': 210800000000
          }
        ]
      },
      {
        'value': 210900000000,
        'text': '阜新市',
        'level': 2,
        'pvalue': 210000000000,
        'children': [
          {
            'value': 210901000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 210900000000
          },
          {
            'value': 210902000000,
            'text': '海州区',
            'level': 3,
            'pvalue': 210900000000
          },
          {
            'value': 210903000000,
            'text': '新邱区',
            'level': 3,
            'pvalue': 210900000000
          },
          {
            'value': 210904000000,
            'text': '太平区',
            'level': 3,
            'pvalue': 210900000000
          },
          {
            'value': 210905000000,
            'text': '清河门区',
            'level': 3,
            'pvalue': 210900000000
          },
          {
            'value': 210911000000,
            'text': '细河区',
            'level': 3,
            'pvalue': 210900000000
          },
          {
            'value': 210921000000,
            'text': '阜新蒙古族自治县',
            'level': 3,
            'pvalue': 210900000000
          },
          {
            'value': 210922000000,
            'text': '彰武县',
            'level': 3,
            'pvalue': 210900000000
          }
        ]
      },
      {
        'value': 211000000000,
        'text': '辽阳市',
        'level': 2,
        'pvalue': 210000000000,
        'children': [
          {
            'value': 211001000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 211000000000
          },
          {
            'value': 211002000000,
            'text': '白塔区',
            'level': 3,
            'pvalue': 211000000000
          },
          {
            'value': 211003000000,
            'text': '文圣区',
            'level': 3,
            'pvalue': 211000000000
          },
          {
            'value': 211004000000,
            'text': '宏伟区',
            'level': 3,
            'pvalue': 211000000000
          },
          {
            'value': 211005000000,
            'text': '弓长岭区',
            'level': 3,
            'pvalue': 211000000000
          },
          {
            'value': 211011000000,
            'text': '太子河区',
            'level': 3,
            'pvalue': 211000000000
          },
          {
            'value': 211021000000,
            'text': '辽阳县',
            'level': 3,
            'pvalue': 211000000000
          },
          {
            'value': 211081000000,
            'text': '灯塔市',
            'level': 3,
            'pvalue': 211000000000
          }
        ]
      },
      {
        'value': 211100000000,
        'text': '盘锦市',
        'level': 2,
        'pvalue': 210000000000,
        'children': [
          {
            'value': 211101000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 211100000000
          },
          {
            'value': 211102000000,
            'text': '双台子区',
            'level': 3,
            'pvalue': 211100000000
          },
          {
            'value': 211103000000,
            'text': '兴隆台区',
            'level': 3,
            'pvalue': 211100000000
          },
          {
            'value': 211104000000,
            'text': '大洼区',
            'level': 3,
            'pvalue': 211100000000
          },
          {
            'value': 211122000000,
            'text': '盘山县',
            'level': 3,
            'pvalue': 211100000000
          }
        ]
      },
      {
        'value': 211200000000,
        'text': '铁岭市',
        'level': 2,
        'pvalue': 210000000000,
        'children': [
          {
            'value': 211201000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 211200000000
          },
          {
            'value': 211202000000,
            'text': '银州区',
            'level': 3,
            'pvalue': 211200000000
          },
          {
            'value': 211204000000,
            'text': '清河区',
            'level': 3,
            'pvalue': 211200000000
          },
          {
            'value': 211221000000,
            'text': '铁岭县',
            'level': 3,
            'pvalue': 211200000000
          },
          {
            'value': 211223000000,
            'text': '西丰县',
            'level': 3,
            'pvalue': 211200000000
          },
          {
            'value': 211224000000,
            'text': '昌图县',
            'level': 3,
            'pvalue': 211200000000
          },
          {
            'value': 211281000000,
            'text': '调兵山市',
            'level': 3,
            'pvalue': 211200000000
          },
          {
            'value': 211282000000,
            'text': '开原市',
            'level': 3,
            'pvalue': 211200000000
          }
        ]
      },
      {
        'value': 211300000000,
        'text': '朝阳市',
        'level': 2,
        'pvalue': 210000000000,
        'children': [
          {
            'value': 211301000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 211300000000
          },
          {
            'value': 211302000000,
            'text': '双塔区',
            'level': 3,
            'pvalue': 211300000000
          },
          {
            'value': 211303000000,
            'text': '龙城区',
            'level': 3,
            'pvalue': 211300000000
          },
          {
            'value': 211321000000,
            'text': '朝阳县',
            'level': 3,
            'pvalue': 211300000000
          },
          {
            'value': 211322000000,
            'text': '建平县',
            'level': 3,
            'pvalue': 211300000000
          },
          {
            'value': 211324000000,
            'text': '喀喇沁左翼蒙古族自治县',
            'level': 3,
            'pvalue': 211300000000
          },
          {
            'value': 211381000000,
            'text': '北票市',
            'level': 3,
            'pvalue': 211300000000
          },
          {
            'value': 211382000000,
            'text': '凌源市',
            'level': 3,
            'pvalue': 211300000000
          }
        ]
      },
      {
        'value': 211400000000,
        'text': '葫芦岛市',
        'level': 2,
        'pvalue': 210000000000,
        'children': [
          {
            'value': 211401000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 211400000000
          },
          {
            'value': 211402000000,
            'text': '连山区',
            'level': 3,
            'pvalue': 211400000000
          },
          {
            'value': 211403000000,
            'text': '龙港区',
            'level': 3,
            'pvalue': 211400000000
          },
          {
            'value': 211404000000,
            'text': '南票区',
            'level': 3,
            'pvalue': 211400000000
          },
          {
            'value': 211421000000,
            'text': '绥中县',
            'level': 3,
            'pvalue': 211400000000
          },
          {
            'value': 211422000000,
            'text': '建昌县',
            'level': 3,
            'pvalue': 211400000000
          },
          {
            'value': 211481000000,
            'text': '兴城市',
            'level': 3,
            'pvalue': 211400000000
          }
        ]
      }
    ]
  },
  {
    'value': 220000000000,
    'text': '吉林省',
    'level': 1,
    'pvalue': 0,
    'children': [
      {
        'value': 220100000000,
        'text': '长春市',
        'level': 2,
        'pvalue': 220000000000,
        'children': [
          {
            'value': 220101000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 220100000000
          },
          {
            'value': 220102000000,
            'text': '南关区',
            'level': 3,
            'pvalue': 220100000000
          },
          {
            'value': 220103000000,
            'text': '宽城区',
            'level': 3,
            'pvalue': 220100000000
          },
          {
            'value': 220104000000,
            'text': '朝阳区',
            'level': 3,
            'pvalue': 220100000000
          },
          {
            'value': 220105000000,
            'text': '二道区',
            'level': 3,
            'pvalue': 220100000000
          },
          {
            'value': 220106000000,
            'text': '绿园区',
            'level': 3,
            'pvalue': 220100000000
          },
          {
            'value': 220112000000,
            'text': '双阳区',
            'level': 3,
            'pvalue': 220100000000
          },
          {
            'value': 220113000000,
            'text': '九台区',
            'level': 3,
            'pvalue': 220100000000
          },
          {
            'value': 220122000000,
            'text': '农安县',
            'level': 3,
            'pvalue': 220100000000
          },
          {
            'value': 220171000000,
            'text': '长春经济技术开发区',
            'level': 3,
            'pvalue': 220100000000
          },
          {
            'value': 220172000000,
            'text': '长春净月高新技术产业开发区',
            'level': 3,
            'pvalue': 220100000000
          },
          {
            'value': 220173000000,
            'text': '长春高新技术产业开发区',
            'level': 3,
            'pvalue': 220100000000
          },
          {
            'value': 220174000000,
            'text': '长春汽车经济技术开发区',
            'level': 3,
            'pvalue': 220100000000
          },
          {
            'value': 220182000000,
            'text': '榆树市',
            'level': 3,
            'pvalue': 220100000000
          },
          {
            'value': 220183000000,
            'text': '德惠市',
            'level': 3,
            'pvalue': 220100000000
          },
          {
            'value': 220184000000,
            'text': '公主岭市',
            'level': 3,
            'pvalue': 220100000000
          }
        ]
      },
      {
        'value': 220200000000,
        'text': '吉林市',
        'level': 2,
        'pvalue': 220000000000,
        'children': [
          {
            'value': 220201000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 220200000000
          },
          {
            'value': 220202000000,
            'text': '昌邑区',
            'level': 3,
            'pvalue': 220200000000
          },
          {
            'value': 220203000000,
            'text': '龙潭区',
            'level': 3,
            'pvalue': 220200000000
          },
          {
            'value': 220204000000,
            'text': '船营区',
            'level': 3,
            'pvalue': 220200000000
          },
          {
            'value': 220211000000,
            'text': '丰满区',
            'level': 3,
            'pvalue': 220200000000
          },
          {
            'value': 220221000000,
            'text': '永吉县',
            'level': 3,
            'pvalue': 220200000000
          },
          {
            'value': 220271000000,
            'text': '吉林经济开发区',
            'level': 3,
            'pvalue': 220200000000
          },
          {
            'value': 220272000000,
            'text': '吉林高新技术产业开发区',
            'level': 3,
            'pvalue': 220200000000
          },
          {
            'value': 220273000000,
            'text': '吉林中国新加坡食品区',
            'level': 3,
            'pvalue': 220200000000
          },
          {
            'value': 220281000000,
            'text': '蛟河市',
            'level': 3,
            'pvalue': 220200000000
          },
          {
            'value': 220282000000,
            'text': '桦甸市',
            'level': 3,
            'pvalue': 220200000000
          },
          {
            'value': 220283000000,
            'text': '舒兰市',
            'level': 3,
            'pvalue': 220200000000
          },
          {
            'value': 220284000000,
            'text': '磐石市',
            'level': 3,
            'pvalue': 220200000000
          }
        ]
      },
      {
        'value': 220300000000,
        'text': '四平市',
        'level': 2,
        'pvalue': 220000000000,
        'children': [
          {
            'value': 220301000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 220300000000
          },
          {
            'value': 220302000000,
            'text': '铁西区',
            'level': 3,
            'pvalue': 220300000000
          },
          {
            'value': 220303000000,
            'text': '铁东区',
            'level': 3,
            'pvalue': 220300000000
          },
          {
            'value': 220322000000,
            'text': '梨树县',
            'level': 3,
            'pvalue': 220300000000
          },
          {
            'value': 220323000000,
            'text': '伊通满族自治县',
            'level': 3,
            'pvalue': 220300000000
          },
          {
            'value': 220382000000,
            'text': '双辽市',
            'level': 3,
            'pvalue': 220300000000
          }
        ]
      },
      {
        'value': 220400000000,
        'text': '辽源市',
        'level': 2,
        'pvalue': 220000000000,
        'children': [
          {
            'value': 220401000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 220400000000
          },
          {
            'value': 220402000000,
            'text': '龙山区',
            'level': 3,
            'pvalue': 220400000000
          },
          {
            'value': 220403000000,
            'text': '西安区',
            'level': 3,
            'pvalue': 220400000000
          },
          {
            'value': 220421000000,
            'text': '东丰县',
            'level': 3,
            'pvalue': 220400000000
          },
          {
            'value': 220422000000,
            'text': '东辽县',
            'level': 3,
            'pvalue': 220400000000
          }
        ]
      },
      {
        'value': 220500000000,
        'text': '通化市',
        'level': 2,
        'pvalue': 220000000000,
        'children': [
          {
            'value': 220501000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 220500000000
          },
          {
            'value': 220502000000,
            'text': '东昌区',
            'level': 3,
            'pvalue': 220500000000
          },
          {
            'value': 220503000000,
            'text': '二道江区',
            'level': 3,
            'pvalue': 220500000000
          },
          {
            'value': 220521000000,
            'text': '通化县',
            'level': 3,
            'pvalue': 220500000000
          },
          {
            'value': 220523000000,
            'text': '辉南县',
            'level': 3,
            'pvalue': 220500000000
          },
          {
            'value': 220524000000,
            'text': '柳河县',
            'level': 3,
            'pvalue': 220500000000
          },
          {
            'value': 220581000000,
            'text': '梅河口市',
            'level': 3,
            'pvalue': 220500000000
          },
          {
            'value': 220582000000,
            'text': '集安市',
            'level': 3,
            'pvalue': 220500000000
          }
        ]
      },
      {
        'value': 220600000000,
        'text': '白山市',
        'level': 2,
        'pvalue': 220000000000,
        'children': [
          {
            'value': 220601000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 220600000000
          },
          {
            'value': 220602000000,
            'text': '浑江区',
            'level': 3,
            'pvalue': 220600000000
          },
          {
            'value': 220605000000,
            'text': '江源区',
            'level': 3,
            'pvalue': 220600000000
          },
          {
            'value': 220621000000,
            'text': '抚松县',
            'level': 3,
            'pvalue': 220600000000
          },
          {
            'value': 220622000000,
            'text': '靖宇县',
            'level': 3,
            'pvalue': 220600000000
          },
          {
            'value': 220623000000,
            'text': '长白朝鲜族自治县',
            'level': 3,
            'pvalue': 220600000000
          },
          {
            'value': 220681000000,
            'text': '临江市',
            'level': 3,
            'pvalue': 220600000000
          }
        ]
      },
      {
        'value': 220700000000,
        'text': '松原市',
        'level': 2,
        'pvalue': 220000000000,
        'children': [
          {
            'value': 220701000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 220700000000
          },
          {
            'value': 220702000000,
            'text': '宁江区',
            'level': 3,
            'pvalue': 220700000000
          },
          {
            'value': 220721000000,
            'text': '前郭尔罗斯蒙古族自治县',
            'level': 3,
            'pvalue': 220700000000
          },
          {
            'value': 220722000000,
            'text': '长岭县',
            'level': 3,
            'pvalue': 220700000000
          },
          {
            'value': 220723000000,
            'text': '乾安县',
            'level': 3,
            'pvalue': 220700000000
          },
          {
            'value': 220771000000,
            'text': '吉林松原经济开发区',
            'level': 3,
            'pvalue': 220700000000
          },
          {
            'value': 220781000000,
            'text': '扶余市',
            'level': 3,
            'pvalue': 220700000000
          }
        ]
      },
      {
        'value': 220800000000,
        'text': '白城市',
        'level': 2,
        'pvalue': 220000000000,
        'children': [
          {
            'value': 220801000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 220800000000
          },
          {
            'value': 220802000000,
            'text': '洮北区',
            'level': 3,
            'pvalue': 220800000000
          },
          {
            'value': 220821000000,
            'text': '镇赉县',
            'level': 3,
            'pvalue': 220800000000
          },
          {
            'value': 220822000000,
            'text': '通榆县',
            'level': 3,
            'pvalue': 220800000000
          },
          {
            'value': 220871000000,
            'text': '吉林白城经济开发区',
            'level': 3,
            'pvalue': 220800000000
          },
          {
            'value': 220881000000,
            'text': '洮南市',
            'level': 3,
            'pvalue': 220800000000
          },
          {
            'value': 220882000000,
            'text': '大安市',
            'level': 3,
            'pvalue': 220800000000
          }
        ]
      },
      {
        'value': 222400000000,
        'text': '延边朝鲜族自治州',
        'level': 2,
        'pvalue': 220000000000,
        'children': [
          {
            'value': 222401000000,
            'text': '延吉市',
            'level': 3,
            'pvalue': 222400000000
          },
          {
            'value': 222402000000,
            'text': '图们市',
            'level': 3,
            'pvalue': 222400000000
          },
          {
            'value': 222403000000,
            'text': '敦化市',
            'level': 3,
            'pvalue': 222400000000
          },
          {
            'value': 222404000000,
            'text': '珲春市',
            'level': 3,
            'pvalue': 222400000000
          },
          {
            'value': 222405000000,
            'text': '龙井市',
            'level': 3,
            'pvalue': 222400000000
          },
          {
            'value': 222406000000,
            'text': '和龙市',
            'level': 3,
            'pvalue': 222400000000
          },
          {
            'value': 222424000000,
            'text': '汪清县',
            'level': 3,
            'pvalue': 222400000000
          },
          {
            'value': 222426000000,
            'text': '安图县',
            'level': 3,
            'pvalue': 222400000000
          }
        ]
      }
    ]
  },
  {
    'value': 230000000000,
    'text': '黑龙江省',
    'level': 1,
    'pvalue': 0,
    'children': [
      {
        'value': 230100000000,
        'text': '哈尔滨市',
        'level': 2,
        'pvalue': 230000000000,
        'children': [
          {
            'value': 230101000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 230100000000
          },
          {
            'value': 230102000000,
            'text': '道里区',
            'level': 3,
            'pvalue': 230100000000
          },
          {
            'value': 230103000000,
            'text': '南岗区',
            'level': 3,
            'pvalue': 230100000000
          },
          {
            'value': 230104000000,
            'text': '道外区',
            'level': 3,
            'pvalue': 230100000000
          },
          {
            'value': 230108000000,
            'text': '平房区',
            'level': 3,
            'pvalue': 230100000000
          },
          {
            'value': 230109000000,
            'text': '松北区',
            'level': 3,
            'pvalue': 230100000000
          },
          {
            'value': 230110000000,
            'text': '香坊区',
            'level': 3,
            'pvalue': 230100000000
          },
          {
            'value': 230111000000,
            'text': '呼兰区',
            'level': 3,
            'pvalue': 230100000000
          },
          {
            'value': 230112000000,
            'text': '阿城区',
            'level': 3,
            'pvalue': 230100000000
          },
          {
            'value': 230113000000,
            'text': '双城区',
            'level': 3,
            'pvalue': 230100000000
          },
          {
            'value': 230123000000,
            'text': '依兰县',
            'level': 3,
            'pvalue': 230100000000
          },
          {
            'value': 230124000000,
            'text': '方正县',
            'level': 3,
            'pvalue': 230100000000
          },
          {
            'value': 230125000000,
            'text': '宾县',
            'level': 3,
            'pvalue': 230100000000
          },
          {
            'value': 230126000000,
            'text': '巴彦县',
            'level': 3,
            'pvalue': 230100000000
          },
          {
            'value': 230127000000,
            'text': '木兰县',
            'level': 3,
            'pvalue': 230100000000
          },
          {
            'value': 230128000000,
            'text': '通河县',
            'level': 3,
            'pvalue': 230100000000
          },
          {
            'value': 230129000000,
            'text': '延寿县',
            'level': 3,
            'pvalue': 230100000000
          },
          {
            'value': 230183000000,
            'text': '尚志市',
            'level': 3,
            'pvalue': 230100000000
          },
          {
            'value': 230184000000,
            'text': '五常市',
            'level': 3,
            'pvalue': 230100000000
          }
        ]
      },
      {
        'value': 230200000000,
        'text': '齐齐哈尔市',
        'level': 2,
        'pvalue': 230000000000,
        'children': [
          {
            'value': 230201000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 230200000000
          },
          {
            'value': 230202000000,
            'text': '龙沙区',
            'level': 3,
            'pvalue': 230200000000
          },
          {
            'value': 230203000000,
            'text': '建华区',
            'level': 3,
            'pvalue': 230200000000
          },
          {
            'value': 230204000000,
            'text': '铁锋区',
            'level': 3,
            'pvalue': 230200000000
          },
          {
            'value': 230205000000,
            'text': '昂昂溪区',
            'level': 3,
            'pvalue': 230200000000
          },
          {
            'value': 230206000000,
            'text': '富拉尔基区',
            'level': 3,
            'pvalue': 230200000000
          },
          {
            'value': 230207000000,
            'text': '碾子山区',
            'level': 3,
            'pvalue': 230200000000
          },
          {
            'value': 230208000000,
            'text': '梅里斯达斡尔族区',
            'level': 3,
            'pvalue': 230200000000
          },
          {
            'value': 230221000000,
            'text': '龙江县',
            'level': 3,
            'pvalue': 230200000000
          },
          {
            'value': 230223000000,
            'text': '依安县',
            'level': 3,
            'pvalue': 230200000000
          },
          {
            'value': 230224000000,
            'text': '泰来县',
            'level': 3,
            'pvalue': 230200000000
          },
          {
            'value': 230225000000,
            'text': '甘南县',
            'level': 3,
            'pvalue': 230200000000
          },
          {
            'value': 230227000000,
            'text': '富裕县',
            'level': 3,
            'pvalue': 230200000000
          },
          {
            'value': 230229000000,
            'text': '克山县',
            'level': 3,
            'pvalue': 230200000000
          },
          {
            'value': 230230000000,
            'text': '克东县',
            'level': 3,
            'pvalue': 230200000000
          },
          {
            'value': 230231000000,
            'text': '拜泉县',
            'level': 3,
            'pvalue': 230200000000
          },
          {
            'value': 230281000000,
            'text': '讷河市',
            'level': 3,
            'pvalue': 230200000000
          }
        ]
      },
      {
        'value': 230300000000,
        'text': '鸡西市',
        'level': 2,
        'pvalue': 230000000000,
        'children': [
          {
            'value': 230301000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 230300000000
          },
          {
            'value': 230302000000,
            'text': '鸡冠区',
            'level': 3,
            'pvalue': 230300000000
          },
          {
            'value': 230303000000,
            'text': '恒山区',
            'level': 3,
            'pvalue': 230300000000
          },
          {
            'value': 230304000000,
            'text': '滴道区',
            'level': 3,
            'pvalue': 230300000000
          },
          {
            'value': 230305000000,
            'text': '梨树区',
            'level': 3,
            'pvalue': 230300000000
          },
          {
            'value': 230306000000,
            'text': '城子河区',
            'level': 3,
            'pvalue': 230300000000
          },
          {
            'value': 230307000000,
            'text': '麻山区',
            'level': 3,
            'pvalue': 230300000000
          },
          {
            'value': 230321000000,
            'text': '鸡东县',
            'level': 3,
            'pvalue': 230300000000
          },
          {
            'value': 230381000000,
            'text': '虎林市',
            'level': 3,
            'pvalue': 230300000000
          },
          {
            'value': 230382000000,
            'text': '密山市',
            'level': 3,
            'pvalue': 230300000000
          }
        ]
      },
      {
        'value': 230400000000,
        'text': '鹤岗市',
        'level': 2,
        'pvalue': 230000000000,
        'children': [
          {
            'value': 230401000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 230400000000
          },
          {
            'value': 230402000000,
            'text': '向阳区',
            'level': 3,
            'pvalue': 230400000000
          },
          {
            'value': 230403000000,
            'text': '工农区',
            'level': 3,
            'pvalue': 230400000000
          },
          {
            'value': 230404000000,
            'text': '南山区',
            'level': 3,
            'pvalue': 230400000000
          },
          {
            'value': 230405000000,
            'text': '兴安区',
            'level': 3,
            'pvalue': 230400000000
          },
          {
            'value': 230406000000,
            'text': '东山区',
            'level': 3,
            'pvalue': 230400000000
          },
          {
            'value': 230407000000,
            'text': '兴山区',
            'level': 3,
            'pvalue': 230400000000
          },
          {
            'value': 230421000000,
            'text': '萝北县',
            'level': 3,
            'pvalue': 230400000000
          },
          {
            'value': 230422000000,
            'text': '绥滨县',
            'level': 3,
            'pvalue': 230400000000
          }
        ]
      },
      {
        'value': 230500000000,
        'text': '双鸭山市',
        'level': 2,
        'pvalue': 230000000000,
        'children': [
          {
            'value': 230501000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 230500000000
          },
          {
            'value': 230502000000,
            'text': '尖山区',
            'level': 3,
            'pvalue': 230500000000
          },
          {
            'value': 230503000000,
            'text': '岭东区',
            'level': 3,
            'pvalue': 230500000000
          },
          {
            'value': 230505000000,
            'text': '四方台区',
            'level': 3,
            'pvalue': 230500000000
          },
          {
            'value': 230506000000,
            'text': '宝山区',
            'level': 3,
            'pvalue': 230500000000
          },
          {
            'value': 230521000000,
            'text': '集贤县',
            'level': 3,
            'pvalue': 230500000000
          },
          {
            'value': 230522000000,
            'text': '友谊县',
            'level': 3,
            'pvalue': 230500000000
          },
          {
            'value': 230523000000,
            'text': '宝清县',
            'level': 3,
            'pvalue': 230500000000
          },
          {
            'value': 230524000000,
            'text': '饶河县',
            'level': 3,
            'pvalue': 230500000000
          }
        ]
      },
      {
        'value': 230600000000,
        'text': '大庆市',
        'level': 2,
        'pvalue': 230000000000,
        'children': [
          {
            'value': 230601000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 230600000000
          },
          {
            'value': 230602000000,
            'text': '萨尔图区',
            'level': 3,
            'pvalue': 230600000000
          },
          {
            'value': 230603000000,
            'text': '龙凤区',
            'level': 3,
            'pvalue': 230600000000
          },
          {
            'value': 230604000000,
            'text': '让胡路区',
            'level': 3,
            'pvalue': 230600000000
          },
          {
            'value': 230605000000,
            'text': '红岗区',
            'level': 3,
            'pvalue': 230600000000
          },
          {
            'value': 230606000000,
            'text': '大同区',
            'level': 3,
            'pvalue': 230600000000
          },
          {
            'value': 230621000000,
            'text': '肇州县',
            'level': 3,
            'pvalue': 230600000000
          },
          {
            'value': 230622000000,
            'text': '肇源县',
            'level': 3,
            'pvalue': 230600000000
          },
          {
            'value': 230623000000,
            'text': '林甸县',
            'level': 3,
            'pvalue': 230600000000
          },
          {
            'value': 230624000000,
            'text': '杜尔伯特蒙古族自治县',
            'level': 3,
            'pvalue': 230600000000
          },
          {
            'value': 230671000000,
            'text': '大庆高新技术产业开发区',
            'level': 3,
            'pvalue': 230600000000
          }
        ]
      },
      {
        'value': 230700000000,
        'text': '伊春市',
        'level': 2,
        'pvalue': 230000000000,
        'children': [
          {
            'value': 230701000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 230700000000
          },
          {
            'value': 230717000000,
            'text': '伊美区',
            'level': 3,
            'pvalue': 230700000000
          },
          {
            'value': 230718000000,
            'text': '乌翠区',
            'level': 3,
            'pvalue': 230700000000
          },
          {
            'value': 230719000000,
            'text': '友好区',
            'level': 3,
            'pvalue': 230700000000
          },
          {
            'value': 230722000000,
            'text': '嘉荫县',
            'level': 3,
            'pvalue': 230700000000
          },
          {
            'value': 230723000000,
            'text': '汤旺县',
            'level': 3,
            'pvalue': 230700000000
          },
          {
            'value': 230724000000,
            'text': '丰林县',
            'level': 3,
            'pvalue': 230700000000
          },
          {
            'value': 230725000000,
            'text': '大箐山县',
            'level': 3,
            'pvalue': 230700000000
          },
          {
            'value': 230726000000,
            'text': '南岔县',
            'level': 3,
            'pvalue': 230700000000
          },
          {
            'value': 230751000000,
            'text': '金林区',
            'level': 3,
            'pvalue': 230700000000
          },
          {
            'value': 230781000000,
            'text': '铁力市',
            'level': 3,
            'pvalue': 230700000000
          }
        ]
      },
      {
        'value': 230800000000,
        'text': '佳木斯市',
        'level': 2,
        'pvalue': 230000000000,
        'children': [
          {
            'value': 230801000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 230800000000
          },
          {
            'value': 230803000000,
            'text': '向阳区',
            'level': 3,
            'pvalue': 230800000000
          },
          {
            'value': 230804000000,
            'text': '前进区',
            'level': 3,
            'pvalue': 230800000000
          },
          {
            'value': 230805000000,
            'text': '东风区',
            'level': 3,
            'pvalue': 230800000000
          },
          {
            'value': 230811000000,
            'text': '郊区',
            'level': 3,
            'pvalue': 230800000000
          },
          {
            'value': 230822000000,
            'text': '桦南县',
            'level': 3,
            'pvalue': 230800000000
          },
          {
            'value': 230826000000,
            'text': '桦川县',
            'level': 3,
            'pvalue': 230800000000
          },
          {
            'value': 230828000000,
            'text': '汤原县',
            'level': 3,
            'pvalue': 230800000000
          },
          {
            'value': 230881000000,
            'text': '同江市',
            'level': 3,
            'pvalue': 230800000000
          },
          {
            'value': 230882000000,
            'text': '富锦市',
            'level': 3,
            'pvalue': 230800000000
          },
          {
            'value': 230883000000,
            'text': '抚远市',
            'level': 3,
            'pvalue': 230800000000
          }
        ]
      },
      {
        'value': 230900000000,
        'text': '七台河市',
        'level': 2,
        'pvalue': 230000000000,
        'children': [
          {
            'value': 230901000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 230900000000
          },
          {
            'value': 230902000000,
            'text': '新兴区',
            'level': 3,
            'pvalue': 230900000000
          },
          {
            'value': 230903000000,
            'text': '桃山区',
            'level': 3,
            'pvalue': 230900000000
          },
          {
            'value': 230904000000,
            'text': '茄子河区',
            'level': 3,
            'pvalue': 230900000000
          },
          {
            'value': 230921000000,
            'text': '勃利县',
            'level': 3,
            'pvalue': 230900000000
          }
        ]
      },
      {
        'value': 231000000000,
        'text': '牡丹江市',
        'level': 2,
        'pvalue': 230000000000,
        'children': [
          {
            'value': 231001000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 231000000000
          },
          {
            'value': 231002000000,
            'text': '东安区',
            'level': 3,
            'pvalue': 231000000000
          },
          {
            'value': 231003000000,
            'text': '阳明区',
            'level': 3,
            'pvalue': 231000000000
          },
          {
            'value': 231004000000,
            'text': '爱民区',
            'level': 3,
            'pvalue': 231000000000
          },
          {
            'value': 231005000000,
            'text': '西安区',
            'level': 3,
            'pvalue': 231000000000
          },
          {
            'value': 231025000000,
            'text': '林口县',
            'level': 3,
            'pvalue': 231000000000
          },
          {
            'value': 231071000000,
            'text': '牡丹江经济技术开发区',
            'level': 3,
            'pvalue': 231000000000
          },
          {
            'value': 231081000000,
            'text': '绥芬河市',
            'level': 3,
            'pvalue': 231000000000
          },
          {
            'value': 231083000000,
            'text': '海林市',
            'level': 3,
            'pvalue': 231000000000
          },
          {
            'value': 231084000000,
            'text': '宁安市',
            'level': 3,
            'pvalue': 231000000000
          },
          {
            'value': 231085000000,
            'text': '穆棱市',
            'level': 3,
            'pvalue': 231000000000
          },
          {
            'value': 231086000000,
            'text': '东宁市',
            'level': 3,
            'pvalue': 231000000000
          }
        ]
      },
      {
        'value': 231100000000,
        'text': '黑河市',
        'level': 2,
        'pvalue': 230000000000,
        'children': [
          {
            'value': 231101000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 231100000000
          },
          {
            'value': 231102000000,
            'text': '爱辉区',
            'level': 3,
            'pvalue': 231100000000
          },
          {
            'value': 231123000000,
            'text': '逊克县',
            'level': 3,
            'pvalue': 231100000000
          },
          {
            'value': 231124000000,
            'text': '孙吴县',
            'level': 3,
            'pvalue': 231100000000
          },
          {
            'value': 231181000000,
            'text': '北安市',
            'level': 3,
            'pvalue': 231100000000
          },
          {
            'value': 231182000000,
            'text': '五大连池市',
            'level': 3,
            'pvalue': 231100000000
          },
          {
            'value': 231183000000,
            'text': '嫩江市',
            'level': 3,
            'pvalue': 231100000000
          }
        ]
      },
      {
        'value': 231200000000,
        'text': '绥化市',
        'level': 2,
        'pvalue': 230000000000,
        'children': [
          {
            'value': 231201000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 231200000000
          },
          {
            'value': 231202000000,
            'text': '北林区',
            'level': 3,
            'pvalue': 231200000000
          },
          {
            'value': 231221000000,
            'text': '望奎县',
            'level': 3,
            'pvalue': 231200000000
          },
          {
            'value': 231222000000,
            'text': '兰西县',
            'level': 3,
            'pvalue': 231200000000
          },
          {
            'value': 231223000000,
            'text': '青冈县',
            'level': 3,
            'pvalue': 231200000000
          },
          {
            'value': 231224000000,
            'text': '庆安县',
            'level': 3,
            'pvalue': 231200000000
          },
          {
            'value': 231225000000,
            'text': '明水县',
            'level': 3,
            'pvalue': 231200000000
          },
          {
            'value': 231226000000,
            'text': '绥棱县',
            'level': 3,
            'pvalue': 231200000000
          },
          {
            'value': 231281000000,
            'text': '安达市',
            'level': 3,
            'pvalue': 231200000000
          },
          {
            'value': 231282000000,
            'text': '肇东市',
            'level': 3,
            'pvalue': 231200000000
          },
          {
            'value': 231283000000,
            'text': '海伦市',
            'level': 3,
            'pvalue': 231200000000
          }
        ]
      },
      {
        'value': 232700000000,
        'text': '大兴安岭地区',
        'level': 2,
        'pvalue': 230000000000,
        'children': [
          {
            'value': 232701000000,
            'text': '漠河市',
            'level': 3,
            'pvalue': 232700000000
          },
          {
            'value': 232721000000,
            'text': '呼玛县',
            'level': 3,
            'pvalue': 232700000000
          },
          {
            'value': 232722000000,
            'text': '塔河县',
            'level': 3,
            'pvalue': 232700000000
          },
          {
            'value': 232761000000,
            'text': '加格达奇区',
            'level': 3,
            'pvalue': 232700000000
          },
          {
            'value': 232762000000,
            'text': '松岭区',
            'level': 3,
            'pvalue': 232700000000
          },
          {
            'value': 232763000000,
            'text': '新林区',
            'level': 3,
            'pvalue': 232700000000
          },
          {
            'value': 232764000000,
            'text': '呼中区',
            'level': 3,
            'pvalue': 232700000000
          }
        ]
      }
    ]
  },
  {
    'value': 310000000000,
    'text': '上海市',
    'level': 1,
    'pvalue': 0,
    'children': [
      {
        'value': 310100000000,
        'text': '市辖区',
        'level': 2,
        'pvalue': 310000000000,
        'children': [
          {
            'value': 310101000000,
            'text': '黄浦区',
            'level': 3,
            'pvalue': 310100000000
          },
          {
            'value': 310104000000,
            'text': '徐汇区',
            'level': 3,
            'pvalue': 310100000000
          },
          {
            'value': 310105000000,
            'text': '长宁区',
            'level': 3,
            'pvalue': 310100000000
          },
          {
            'value': 310106000000,
            'text': '静安区',
            'level': 3,
            'pvalue': 310100000000
          },
          {
            'value': 310107000000,
            'text': '普陀区',
            'level': 3,
            'pvalue': 310100000000
          },
          {
            'value': 310109000000,
            'text': '虹口区',
            'level': 3,
            'pvalue': 310100000000
          },
          {
            'value': 310110000000,
            'text': '杨浦区',
            'level': 3,
            'pvalue': 310100000000
          },
          {
            'value': 310112000000,
            'text': '闵行区',
            'level': 3,
            'pvalue': 310100000000
          },
          {
            'value': 310113000000,
            'text': '宝山区',
            'level': 3,
            'pvalue': 310100000000
          },
          {
            'value': 310114000000,
            'text': '嘉定区',
            'level': 3,
            'pvalue': 310100000000
          },
          {
            'value': 310115000000,
            'text': '浦东新区',
            'level': 3,
            'pvalue': 310100000000
          },
          {
            'value': 310116000000,
            'text': '金山区',
            'level': 3,
            'pvalue': 310100000000
          },
          {
            'value': 310117000000,
            'text': '松江区',
            'level': 3,
            'pvalue': 310100000000
          },
          {
            'value': 310118000000,
            'text': '青浦区',
            'level': 3,
            'pvalue': 310100000000
          },
          {
            'value': 310120000000,
            'text': '奉贤区',
            'level': 3,
            'pvalue': 310100000000
          },
          {
            'value': 310151000000,
            'text': '崇明区',
            'level': 3,
            'pvalue': 310100000000
          }
        ]
      }
    ]
  },
  {
    'value': 320000000000,
    'text': '江苏省',
    'level': 1,
    'pvalue': 0,
    'children': [
      {
        'value': 320100000000,
        'text': '南京市',
        'level': 2,
        'pvalue': 320000000000,
        'children': [
          {
            'value': 320101000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 320100000000
          },
          {
            'value': 320102000000,
            'text': '玄武区',
            'level': 3,
            'pvalue': 320100000000
          },
          {
            'value': 320104000000,
            'text': '秦淮区',
            'level': 3,
            'pvalue': 320100000000
          },
          {
            'value': 320105000000,
            'text': '建邺区',
            'level': 3,
            'pvalue': 320100000000
          },
          {
            'value': 320106000000,
            'text': '鼓楼区',
            'level': 3,
            'pvalue': 320100000000
          },
          {
            'value': 320111000000,
            'text': '浦口区',
            'level': 3,
            'pvalue': 320100000000
          },
          {
            'value': 320113000000,
            'text': '栖霞区',
            'level': 3,
            'pvalue': 320100000000
          },
          {
            'value': 320114000000,
            'text': '雨花台区',
            'level': 3,
            'pvalue': 320100000000
          },
          {
            'value': 320115000000,
            'text': '江宁区',
            'level': 3,
            'pvalue': 320100000000
          },
          {
            'value': 320116000000,
            'text': '六合区',
            'level': 3,
            'pvalue': 320100000000
          },
          {
            'value': 320117000000,
            'text': '溧水区',
            'level': 3,
            'pvalue': 320100000000
          },
          {
            'value': 320118000000,
            'text': '高淳区',
            'level': 3,
            'pvalue': 320100000000
          }
        ]
      },
      {
        'value': 320200000000,
        'text': '无锡市',
        'level': 2,
        'pvalue': 320000000000,
        'children': [
          {
            'value': 320201000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 320200000000
          },
          {
            'value': 320205000000,
            'text': '锡山区',
            'level': 3,
            'pvalue': 320200000000
          },
          {
            'value': 320206000000,
            'text': '惠山区',
            'level': 3,
            'pvalue': 320200000000
          },
          {
            'value': 320211000000,
            'text': '滨湖区',
            'level': 3,
            'pvalue': 320200000000
          },
          {
            'value': 320213000000,
            'text': '梁溪区',
            'level': 3,
            'pvalue': 320200000000
          },
          {
            'value': 320214000000,
            'text': '新吴区',
            'level': 3,
            'pvalue': 320200000000
          },
          {
            'value': 320281000000,
            'text': '江阴市',
            'level': 3,
            'pvalue': 320200000000
          },
          {
            'value': 320282000000,
            'text': '宜兴市',
            'level': 3,
            'pvalue': 320200000000
          }
        ]
      },
      {
        'value': 320300000000,
        'text': '徐州市',
        'level': 2,
        'pvalue': 320000000000,
        'children': [
          {
            'value': 320301000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 320300000000
          },
          {
            'value': 320302000000,
            'text': '鼓楼区',
            'level': 3,
            'pvalue': 320300000000
          },
          {
            'value': 320303000000,
            'text': '云龙区',
            'level': 3,
            'pvalue': 320300000000
          },
          {
            'value': 320305000000,
            'text': '贾汪区',
            'level': 3,
            'pvalue': 320300000000
          },
          {
            'value': 320311000000,
            'text': '泉山区',
            'level': 3,
            'pvalue': 320300000000
          },
          {
            'value': 320312000000,
            'text': '铜山区',
            'level': 3,
            'pvalue': 320300000000
          },
          {
            'value': 320321000000,
            'text': '丰县',
            'level': 3,
            'pvalue': 320300000000
          },
          {
            'value': 320322000000,
            'text': '沛县',
            'level': 3,
            'pvalue': 320300000000
          },
          {
            'value': 320324000000,
            'text': '睢宁县',
            'level': 3,
            'pvalue': 320300000000
          },
          {
            'value': 320371000000,
            'text': '徐州经济技术开发区',
            'level': 3,
            'pvalue': 320300000000
          },
          {
            'value': 320381000000,
            'text': '新沂市',
            'level': 3,
            'pvalue': 320300000000
          },
          {
            'value': 320382000000,
            'text': '邳州市',
            'level': 3,
            'pvalue': 320300000000
          }
        ]
      },
      {
        'value': 320400000000,
        'text': '常州市',
        'level': 2,
        'pvalue': 320000000000,
        'children': [
          {
            'value': 320401000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 320400000000
          },
          {
            'value': 320402000000,
            'text': '天宁区',
            'level': 3,
            'pvalue': 320400000000
          },
          {
            'value': 320404000000,
            'text': '钟楼区',
            'level': 3,
            'pvalue': 320400000000
          },
          {
            'value': 320411000000,
            'text': '新北区',
            'level': 3,
            'pvalue': 320400000000
          },
          {
            'value': 320412000000,
            'text': '武进区',
            'level': 3,
            'pvalue': 320400000000
          },
          {
            'value': 320413000000,
            'text': '金坛区',
            'level': 3,
            'pvalue': 320400000000
          },
          {
            'value': 320481000000,
            'text': '溧阳市',
            'level': 3,
            'pvalue': 320400000000
          }
        ]
      },
      {
        'value': 320500000000,
        'text': '苏州市',
        'level': 2,
        'pvalue': 320000000000,
        'children': [
          {
            'value': 320501000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 320500000000
          },
          {
            'value': 320505000000,
            'text': '虎丘区',
            'level': 3,
            'pvalue': 320500000000
          },
          {
            'value': 320506000000,
            'text': '吴中区',
            'level': 3,
            'pvalue': 320500000000
          },
          {
            'value': 320507000000,
            'text': '相城区',
            'level': 3,
            'pvalue': 320500000000
          },
          {
            'value': 320508000000,
            'text': '姑苏区',
            'level': 3,
            'pvalue': 320500000000
          },
          {
            'value': 320509000000,
            'text': '吴江区',
            'level': 3,
            'pvalue': 320500000000
          },
          {
            'value': 320571000000,
            'text': '苏州工业园区',
            'level': 3,
            'pvalue': 320500000000
          },
          {
            'value': 320581000000,
            'text': '常熟市',
            'level': 3,
            'pvalue': 320500000000
          },
          {
            'value': 320582000000,
            'text': '张家港市',
            'level': 3,
            'pvalue': 320500000000
          },
          {
            'value': 320583000000,
            'text': '昆山市',
            'level': 3,
            'pvalue': 320500000000
          },
          {
            'value': 320585000000,
            'text': '太仓市',
            'level': 3,
            'pvalue': 320500000000
          }
        ]
      },
      {
        'value': 320600000000,
        'text': '南通市',
        'level': 2,
        'pvalue': 320000000000,
        'children': [
          {
            'value': 320601000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 320600000000
          },
          {
            'value': 320612000000,
            'text': '通州区',
            'level': 3,
            'pvalue': 320600000000
          },
          {
            'value': 320613000000,
            'text': '崇川区',
            'level': 3,
            'pvalue': 320600000000
          },
          {
            'value': 320614000000,
            'text': '海门区',
            'level': 3,
            'pvalue': 320600000000
          },
          {
            'value': 320623000000,
            'text': '如东县',
            'level': 3,
            'pvalue': 320600000000
          },
          {
            'value': 320671000000,
            'text': '南通经济技术开发区',
            'level': 3,
            'pvalue': 320600000000
          },
          {
            'value': 320681000000,
            'text': '启东市',
            'level': 3,
            'pvalue': 320600000000
          },
          {
            'value': 320682000000,
            'text': '如皋市',
            'level': 3,
            'pvalue': 320600000000
          },
          {
            'value': 320685000000,
            'text': '海安市',
            'level': 3,
            'pvalue': 320600000000
          }
        ]
      },
      {
        'value': 320700000000,
        'text': '连云港市',
        'level': 2,
        'pvalue': 320000000000,
        'children': [
          {
            'value': 320701000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 320700000000
          },
          {
            'value': 320703000000,
            'text': '连云区',
            'level': 3,
            'pvalue': 320700000000
          },
          {
            'value': 320706000000,
            'text': '海州区',
            'level': 3,
            'pvalue': 320700000000
          },
          {
            'value': 320707000000,
            'text': '赣榆区',
            'level': 3,
            'pvalue': 320700000000
          },
          {
            'value': 320722000000,
            'text': '东海县',
            'level': 3,
            'pvalue': 320700000000
          },
          {
            'value': 320723000000,
            'text': '灌云县',
            'level': 3,
            'pvalue': 320700000000
          },
          {
            'value': 320724000000,
            'text': '灌南县',
            'level': 3,
            'pvalue': 320700000000
          },
          {
            'value': 320771000000,
            'text': '连云港经济技术开发区',
            'level': 3,
            'pvalue': 320700000000
          },
          {
            'value': 320772000000,
            'text': '连云港高新技术产业开发区',
            'level': 3,
            'pvalue': 320700000000
          }
        ]
      },
      {
        'value': 320800000000,
        'text': '淮安市',
        'level': 2,
        'pvalue': 320000000000,
        'children': [
          {
            'value': 320801000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 320800000000
          },
          {
            'value': 320803000000,
            'text': '淮安区',
            'level': 3,
            'pvalue': 320800000000
          },
          {
            'value': 320804000000,
            'text': '淮阴区',
            'level': 3,
            'pvalue': 320800000000
          },
          {
            'value': 320812000000,
            'text': '清江浦区',
            'level': 3,
            'pvalue': 320800000000
          },
          {
            'value': 320813000000,
            'text': '洪泽区',
            'level': 3,
            'pvalue': 320800000000
          },
          {
            'value': 320826000000,
            'text': '涟水县',
            'level': 3,
            'pvalue': 320800000000
          },
          {
            'value': 320830000000,
            'text': '盱眙县',
            'level': 3,
            'pvalue': 320800000000
          },
          {
            'value': 320831000000,
            'text': '金湖县',
            'level': 3,
            'pvalue': 320800000000
          },
          {
            'value': 320871000000,
            'text': '淮安经济技术开发区',
            'level': 3,
            'pvalue': 320800000000
          }
        ]
      },
      {
        'value': 320900000000,
        'text': '盐城市',
        'level': 2,
        'pvalue': 320000000000,
        'children': [
          {
            'value': 320901000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 320900000000
          },
          {
            'value': 320902000000,
            'text': '亭湖区',
            'level': 3,
            'pvalue': 320900000000
          },
          {
            'value': 320903000000,
            'text': '盐都区',
            'level': 3,
            'pvalue': 320900000000
          },
          {
            'value': 320904000000,
            'text': '大丰区',
            'level': 3,
            'pvalue': 320900000000
          },
          {
            'value': 320921000000,
            'text': '响水县',
            'level': 3,
            'pvalue': 320900000000
          },
          {
            'value': 320922000000,
            'text': '滨海县',
            'level': 3,
            'pvalue': 320900000000
          },
          {
            'value': 320923000000,
            'text': '阜宁县',
            'level': 3,
            'pvalue': 320900000000
          },
          {
            'value': 320924000000,
            'text': '射阳县',
            'level': 3,
            'pvalue': 320900000000
          },
          {
            'value': 320925000000,
            'text': '建湖县',
            'level': 3,
            'pvalue': 320900000000
          },
          {
            'value': 320971000000,
            'text': '盐城经济技术开发区',
            'level': 3,
            'pvalue': 320900000000
          },
          {
            'value': 320981000000,
            'text': '东台市',
            'level': 3,
            'pvalue': 320900000000
          }
        ]
      },
      {
        'value': 321000000000,
        'text': '扬州市',
        'level': 2,
        'pvalue': 320000000000,
        'children': [
          {
            'value': 321001000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 321000000000
          },
          {
            'value': 321002000000,
            'text': '广陵区',
            'level': 3,
            'pvalue': 321000000000
          },
          {
            'value': 321003000000,
            'text': '邗江区',
            'level': 3,
            'pvalue': 321000000000
          },
          {
            'value': 321012000000,
            'text': '江都区',
            'level': 3,
            'pvalue': 321000000000
          },
          {
            'value': 321023000000,
            'text': '宝应县',
            'level': 3,
            'pvalue': 321000000000
          },
          {
            'value': 321071000000,
            'text': '扬州经济技术开发区',
            'level': 3,
            'pvalue': 321000000000
          },
          {
            'value': 321081000000,
            'text': '仪征市',
            'level': 3,
            'pvalue': 321000000000
          },
          {
            'value': 321084000000,
            'text': '高邮市',
            'level': 3,
            'pvalue': 321000000000
          }
        ]
      },
      {
        'value': 321100000000,
        'text': '镇江市',
        'level': 2,
        'pvalue': 320000000000,
        'children': [
          {
            'value': 321101000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 321100000000
          },
          {
            'value': 321102000000,
            'text': '京口区',
            'level': 3,
            'pvalue': 321100000000
          },
          {
            'value': 321111000000,
            'text': '润州区',
            'level': 3,
            'pvalue': 321100000000
          },
          {
            'value': 321112000000,
            'text': '丹徒区',
            'level': 3,
            'pvalue': 321100000000
          },
          {
            'value': 321171000000,
            'text': '镇江新区',
            'level': 3,
            'pvalue': 321100000000
          },
          {
            'value': 321181000000,
            'text': '丹阳市',
            'level': 3,
            'pvalue': 321100000000
          },
          {
            'value': 321182000000,
            'text': '扬中市',
            'level': 3,
            'pvalue': 321100000000
          },
          {
            'value': 321183000000,
            'text': '句容市',
            'level': 3,
            'pvalue': 321100000000
          }
        ]
      },
      {
        'value': 321200000000,
        'text': '泰州市',
        'level': 2,
        'pvalue': 320000000000,
        'children': [
          {
            'value': 321201000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 321200000000
          },
          {
            'value': 321202000000,
            'text': '海陵区',
            'level': 3,
            'pvalue': 321200000000
          },
          {
            'value': 321203000000,
            'text': '高港区',
            'level': 3,
            'pvalue': 321200000000
          },
          {
            'value': 321204000000,
            'text': '姜堰区',
            'level': 3,
            'pvalue': 321200000000
          },
          {
            'value': 321271000000,
            'text': '泰州医药高新技术产业开发区',
            'level': 3,
            'pvalue': 321200000000
          },
          {
            'value': 321281000000,
            'text': '兴化市',
            'level': 3,
            'pvalue': 321200000000
          },
          {
            'value': 321282000000,
            'text': '靖江市',
            'level': 3,
            'pvalue': 321200000000
          },
          {
            'value': 321283000000,
            'text': '泰兴市',
            'level': 3,
            'pvalue': 321200000000
          }
        ]
      },
      {
        'value': 321300000000,
        'text': '宿迁市',
        'level': 2,
        'pvalue': 320000000000,
        'children': [
          {
            'value': 321301000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 321300000000
          },
          {
            'value': 321302000000,
            'text': '宿城区',
            'level': 3,
            'pvalue': 321300000000
          },
          {
            'value': 321311000000,
            'text': '宿豫区',
            'level': 3,
            'pvalue': 321300000000
          },
          {
            'value': 321322000000,
            'text': '沭阳县',
            'level': 3,
            'pvalue': 321300000000
          },
          {
            'value': 321323000000,
            'text': '泗阳县',
            'level': 3,
            'pvalue': 321300000000
          },
          {
            'value': 321324000000,
            'text': '泗洪县',
            'level': 3,
            'pvalue': 321300000000
          },
          {
            'value': 321371000000,
            'text': '宿迁经济技术开发区',
            'level': 3,
            'pvalue': 321300000000
          }
        ]
      }
    ]
  },
  {
    'value': 330000000000,
    'text': '浙江省',
    'level': 1,
    'pvalue': 0,
    'children': [
      {
        'value': 330100000000,
        'text': '杭州市',
        'level': 2,
        'pvalue': 330000000000,
        'children': [
          {
            'value': 330101000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 330100000000
          },
          {
            'value': 330102000000,
            'text': '上城区',
            'level': 3,
            'pvalue': 330100000000
          },
          {
            'value': 330105000000,
            'text': '拱墅区',
            'level': 3,
            'pvalue': 330100000000
          },
          {
            'value': 330106000000,
            'text': '西湖区',
            'level': 3,
            'pvalue': 330100000000
          },
          {
            'value': 330108000000,
            'text': '滨江区',
            'level': 3,
            'pvalue': 330100000000
          },
          {
            'value': 330109000000,
            'text': '萧山区',
            'level': 3,
            'pvalue': 330100000000
          },
          {
            'value': 330110000000,
            'text': '余杭区',
            'level': 3,
            'pvalue': 330100000000
          },
          {
            'value': 330111000000,
            'text': '富阳区',
            'level': 3,
            'pvalue': 330100000000
          },
          {
            'value': 330112000000,
            'text': '临安区',
            'level': 3,
            'pvalue': 330100000000
          },
          {
            'value': 330113000000,
            'text': '临平区',
            'level': 3,
            'pvalue': 330100000000
          },
          {
            'value': 330114000000,
            'text': '钱塘区',
            'level': 3,
            'pvalue': 330100000000
          },
          {
            'value': 330122000000,
            'text': '桐庐县',
            'level': 3,
            'pvalue': 330100000000
          },
          {
            'value': 330127000000,
            'text': '淳安县',
            'level': 3,
            'pvalue': 330100000000
          },
          {
            'value': 330182000000,
            'text': '建德市',
            'level': 3,
            'pvalue': 330100000000
          }
        ]
      },
      {
        'value': 330200000000,
        'text': '宁波市',
        'level': 2,
        'pvalue': 330000000000,
        'children': [
          {
            'value': 330201000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 330200000000
          },
          {
            'value': 330203000000,
            'text': '海曙区',
            'level': 3,
            'pvalue': 330200000000
          },
          {
            'value': 330205000000,
            'text': '江北区',
            'level': 3,
            'pvalue': 330200000000
          },
          {
            'value': 330206000000,
            'text': '北仑区',
            'level': 3,
            'pvalue': 330200000000
          },
          {
            'value': 330211000000,
            'text': '镇海区',
            'level': 3,
            'pvalue': 330200000000
          },
          {
            'value': 330212000000,
            'text': '鄞州区',
            'level': 3,
            'pvalue': 330200000000
          },
          {
            'value': 330213000000,
            'text': '奉化区',
            'level': 3,
            'pvalue': 330200000000
          },
          {
            'value': 330225000000,
            'text': '象山县',
            'level': 3,
            'pvalue': 330200000000
          },
          {
            'value': 330226000000,
            'text': '宁海县',
            'level': 3,
            'pvalue': 330200000000
          },
          {
            'value': 330281000000,
            'text': '余姚市',
            'level': 3,
            'pvalue': 330200000000
          },
          {
            'value': 330282000000,
            'text': '慈溪市',
            'level': 3,
            'pvalue': 330200000000
          }
        ]
      },
      {
        'value': 330300000000,
        'text': '温州市',
        'level': 2,
        'pvalue': 330000000000,
        'children': [
          {
            'value': 330301000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 330300000000
          },
          {
            'value': 330302000000,
            'text': '鹿城区',
            'level': 3,
            'pvalue': 330300000000
          },
          {
            'value': 330303000000,
            'text': '龙湾区',
            'level': 3,
            'pvalue': 330300000000
          },
          {
            'value': 330304000000,
            'text': '瓯海区',
            'level': 3,
            'pvalue': 330300000000
          },
          {
            'value': 330305000000,
            'text': '洞头区',
            'level': 3,
            'pvalue': 330300000000
          },
          {
            'value': 330324000000,
            'text': '永嘉县',
            'level': 3,
            'pvalue': 330300000000
          },
          {
            'value': 330326000000,
            'text': '平阳县',
            'level': 3,
            'pvalue': 330300000000
          },
          {
            'value': 330327000000,
            'text': '苍南县',
            'level': 3,
            'pvalue': 330300000000
          },
          {
            'value': 330328000000,
            'text': '文成县',
            'level': 3,
            'pvalue': 330300000000
          },
          {
            'value': 330329000000,
            'text': '泰顺县',
            'level': 3,
            'pvalue': 330300000000
          },
          {
            'value': 330371000000,
            'text': '温州经济技术开发区',
            'level': 3,
            'pvalue': 330300000000
          },
          {
            'value': 330381000000,
            'text': '瑞安市',
            'level': 3,
            'pvalue': 330300000000
          },
          {
            'value': 330382000000,
            'text': '乐清市',
            'level': 3,
            'pvalue': 330300000000
          },
          {
            'value': 330383000000,
            'text': '龙港市',
            'level': 3,
            'pvalue': 330300000000
          }
        ]
      },
      {
        'value': 330400000000,
        'text': '嘉兴市',
        'level': 2,
        'pvalue': 330000000000,
        'children': [
          {
            'value': 330401000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 330400000000
          },
          {
            'value': 330402000000,
            'text': '南湖区',
            'level': 3,
            'pvalue': 330400000000
          },
          {
            'value': 330411000000,
            'text': '秀洲区',
            'level': 3,
            'pvalue': 330400000000
          },
          {
            'value': 330421000000,
            'text': '嘉善县',
            'level': 3,
            'pvalue': 330400000000
          },
          {
            'value': 330424000000,
            'text': '海盐县',
            'level': 3,
            'pvalue': 330400000000
          },
          {
            'value': 330481000000,
            'text': '海宁市',
            'level': 3,
            'pvalue': 330400000000
          },
          {
            'value': 330482000000,
            'text': '平湖市',
            'level': 3,
            'pvalue': 330400000000
          },
          {
            'value': 330483000000,
            'text': '桐乡市',
            'level': 3,
            'pvalue': 330400000000
          }
        ]
      },
      {
        'value': 330500000000,
        'text': '湖州市',
        'level': 2,
        'pvalue': 330000000000,
        'children': [
          {
            'value': 330501000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 330500000000
          },
          {
            'value': 330502000000,
            'text': '吴兴区',
            'level': 3,
            'pvalue': 330500000000
          },
          {
            'value': 330503000000,
            'text': '南浔区',
            'level': 3,
            'pvalue': 330500000000
          },
          {
            'value': 330521000000,
            'text': '德清县',
            'level': 3,
            'pvalue': 330500000000
          },
          {
            'value': 330522000000,
            'text': '长兴县',
            'level': 3,
            'pvalue': 330500000000
          },
          {
            'value': 330523000000,
            'text': '安吉县',
            'level': 3,
            'pvalue': 330500000000
          }
        ]
      },
      {
        'value': 330600000000,
        'text': '绍兴市',
        'level': 2,
        'pvalue': 330000000000,
        'children': [
          {
            'value': 330601000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 330600000000
          },
          {
            'value': 330602000000,
            'text': '越城区',
            'level': 3,
            'pvalue': 330600000000
          },
          {
            'value': 330603000000,
            'text': '柯桥区',
            'level': 3,
            'pvalue': 330600000000
          },
          {
            'value': 330604000000,
            'text': '上虞区',
            'level': 3,
            'pvalue': 330600000000
          },
          {
            'value': 330624000000,
            'text': '新昌县',
            'level': 3,
            'pvalue': 330600000000
          },
          {
            'value': 330681000000,
            'text': '诸暨市',
            'level': 3,
            'pvalue': 330600000000
          },
          {
            'value': 330683000000,
            'text': '嵊州市',
            'level': 3,
            'pvalue': 330600000000
          }
        ]
      },
      {
        'value': 330700000000,
        'text': '金华市',
        'level': 2,
        'pvalue': 330000000000,
        'children': [
          {
            'value': 330701000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 330700000000
          },
          {
            'value': 330702000000,
            'text': '婺城区',
            'level': 3,
            'pvalue': 330700000000
          },
          {
            'value': 330703000000,
            'text': '金东区',
            'level': 3,
            'pvalue': 330700000000
          },
          {
            'value': 330723000000,
            'text': '武义县',
            'level': 3,
            'pvalue': 330700000000
          },
          {
            'value': 330726000000,
            'text': '浦江县',
            'level': 3,
            'pvalue': 330700000000
          },
          {
            'value': 330727000000,
            'text': '磐安县',
            'level': 3,
            'pvalue': 330700000000
          },
          {
            'value': 330781000000,
            'text': '兰溪市',
            'level': 3,
            'pvalue': 330700000000
          },
          {
            'value': 330782000000,
            'text': '义乌市',
            'level': 3,
            'pvalue': 330700000000
          },
          {
            'value': 330783000000,
            'text': '东阳市',
            'level': 3,
            'pvalue': 330700000000
          },
          {
            'value': 330784000000,
            'text': '永康市',
            'level': 3,
            'pvalue': 330700000000
          }
        ]
      },
      {
        'value': 330800000000,
        'text': '衢州市',
        'level': 2,
        'pvalue': 330000000000,
        'children': [
          {
            'value': 330801000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 330800000000
          },
          {
            'value': 330802000000,
            'text': '柯城区',
            'level': 3,
            'pvalue': 330800000000
          },
          {
            'value': 330803000000,
            'text': '衢江区',
            'level': 3,
            'pvalue': 330800000000
          },
          {
            'value': 330822000000,
            'text': '常山县',
            'level': 3,
            'pvalue': 330800000000
          },
          {
            'value': 330824000000,
            'text': '开化县',
            'level': 3,
            'pvalue': 330800000000
          },
          {
            'value': 330825000000,
            'text': '龙游县',
            'level': 3,
            'pvalue': 330800000000
          },
          {
            'value': 330881000000,
            'text': '江山市',
            'level': 3,
            'pvalue': 330800000000
          }
        ]
      },
      {
        'value': 330900000000,
        'text': '舟山市',
        'level': 2,
        'pvalue': 330000000000,
        'children': [
          {
            'value': 330901000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 330900000000
          },
          {
            'value': 330902000000,
            'text': '定海区',
            'level': 3,
            'pvalue': 330900000000
          },
          {
            'value': 330903000000,
            'text': '普陀区',
            'level': 3,
            'pvalue': 330900000000
          },
          {
            'value': 330921000000,
            'text': '岱山县',
            'level': 3,
            'pvalue': 330900000000
          },
          {
            'value': 330922000000,
            'text': '嵊泗县',
            'level': 3,
            'pvalue': 330900000000
          }
        ]
      },
      {
        'value': 331000000000,
        'text': '台州市',
        'level': 2,
        'pvalue': 330000000000,
        'children': [
          {
            'value': 331001000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 331000000000
          },
          {
            'value': 331002000000,
            'text': '椒江区',
            'level': 3,
            'pvalue': 331000000000
          },
          {
            'value': 331003000000,
            'text': '黄岩区',
            'level': 3,
            'pvalue': 331000000000
          },
          {
            'value': 331004000000,
            'text': '路桥区',
            'level': 3,
            'pvalue': 331000000000
          },
          {
            'value': 331022000000,
            'text': '三门县',
            'level': 3,
            'pvalue': 331000000000
          },
          {
            'value': 331023000000,
            'text': '天台县',
            'level': 3,
            'pvalue': 331000000000
          },
          {
            'value': 331024000000,
            'text': '仙居县',
            'level': 3,
            'pvalue': 331000000000
          },
          {
            'value': 331081000000,
            'text': '温岭市',
            'level': 3,
            'pvalue': 331000000000
          },
          {
            'value': 331082000000,
            'text': '临海市',
            'level': 3,
            'pvalue': 331000000000
          },
          {
            'value': 331083000000,
            'text': '玉环市',
            'level': 3,
            'pvalue': 331000000000
          }
        ]
      },
      {
        'value': 331100000000,
        'text': '丽水市',
        'level': 2,
        'pvalue': 330000000000,
        'children': [
          {
            'value': 331101000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 331100000000
          },
          {
            'value': 331102000000,
            'text': '莲都区',
            'level': 3,
            'pvalue': 331100000000
          },
          {
            'value': 331121000000,
            'text': '青田县',
            'level': 3,
            'pvalue': 331100000000
          },
          {
            'value': 331122000000,
            'text': '缙云县',
            'level': 3,
            'pvalue': 331100000000
          },
          {
            'value': 331123000000,
            'text': '遂昌县',
            'level': 3,
            'pvalue': 331100000000
          },
          {
            'value': 331124000000,
            'text': '松阳县',
            'level': 3,
            'pvalue': 331100000000
          },
          {
            'value': 331125000000,
            'text': '云和县',
            'level': 3,
            'pvalue': 331100000000
          },
          {
            'value': 331126000000,
            'text': '庆元县',
            'level': 3,
            'pvalue': 331100000000
          },
          {
            'value': 331127000000,
            'text': '景宁畲族自治县',
            'level': 3,
            'pvalue': 331100000000
          },
          {
            'value': 331181000000,
            'text': '龙泉市',
            'level': 3,
            'pvalue': 331100000000
          }
        ]
      }
    ]
  },
  {
    'value': 340000000000,
    'text': '安徽省',
    'level': 1,
    'pvalue': 0,
    'children': [
      {
        'value': 340100000000,
        'text': '合肥市',
        'level': 2,
        'pvalue': 340000000000,
        'children': [
          {
            'value': 340101000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 340100000000
          },
          {
            'value': 340102000000,
            'text': '瑶海区',
            'level': 3,
            'pvalue': 340100000000
          },
          {
            'value': 340103000000,
            'text': '庐阳区',
            'level': 3,
            'pvalue': 340100000000
          },
          {
            'value': 340104000000,
            'text': '蜀山区',
            'level': 3,
            'pvalue': 340100000000
          },
          {
            'value': 340111000000,
            'text': '包河区',
            'level': 3,
            'pvalue': 340100000000
          },
          {
            'value': 340121000000,
            'text': '长丰县',
            'level': 3,
            'pvalue': 340100000000
          },
          {
            'value': 340122000000,
            'text': '肥东县',
            'level': 3,
            'pvalue': 340100000000
          },
          {
            'value': 340123000000,
            'text': '肥西县',
            'level': 3,
            'pvalue': 340100000000
          },
          {
            'value': 340124000000,
            'text': '庐江县',
            'level': 3,
            'pvalue': 340100000000
          },
          {
            'value': 340171000000,
            'text': '合肥高新技术产业开发区',
            'level': 3,
            'pvalue': 340100000000
          },
          {
            'value': 340172000000,
            'text': '合肥经济技术开发区',
            'level': 3,
            'pvalue': 340100000000
          },
          {
            'value': 340173000000,
            'text': '合肥新站高新技术产业开发区',
            'level': 3,
            'pvalue': 340100000000
          },
          {
            'value': 340181000000,
            'text': '巢湖市',
            'level': 3,
            'pvalue': 340100000000
          }
        ]
      },
      {
        'value': 340200000000,
        'text': '芜湖市',
        'level': 2,
        'pvalue': 340000000000,
        'children': [
          {
            'value': 340201000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 340200000000
          },
          {
            'value': 340202000000,
            'text': '镜湖区',
            'level': 3,
            'pvalue': 340200000000
          },
          {
            'value': 340207000000,
            'text': '鸠江区',
            'level': 3,
            'pvalue': 340200000000
          },
          {
            'value': 340209000000,
            'text': '弋江区',
            'level': 3,
            'pvalue': 340200000000
          },
          {
            'value': 340210000000,
            'text': '湾沚区',
            'level': 3,
            'pvalue': 340200000000
          },
          {
            'value': 340212000000,
            'text': '繁昌区',
            'level': 3,
            'pvalue': 340200000000
          },
          {
            'value': 340223000000,
            'text': '南陵县',
            'level': 3,
            'pvalue': 340200000000
          },
          {
            'value': 340271000000,
            'text': '芜湖经济技术开发区',
            'level': 3,
            'pvalue': 340200000000
          },
          {
            'value': 340272000000,
            'text': '安徽芜湖三山经济开发区',
            'level': 3,
            'pvalue': 340200000000
          },
          {
            'value': 340281000000,
            'text': '无为市',
            'level': 3,
            'pvalue': 340200000000
          }
        ]
      },
      {
        'value': 340300000000,
        'text': '蚌埠市',
        'level': 2,
        'pvalue': 340000000000,
        'children': [
          {
            'value': 340301000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 340300000000
          },
          {
            'value': 340302000000,
            'text': '龙子湖区',
            'level': 3,
            'pvalue': 340300000000
          },
          {
            'value': 340303000000,
            'text': '蚌山区',
            'level': 3,
            'pvalue': 340300000000
          },
          {
            'value': 340304000000,
            'text': '禹会区',
            'level': 3,
            'pvalue': 340300000000
          },
          {
            'value': 340311000000,
            'text': '淮上区',
            'level': 3,
            'pvalue': 340300000000
          },
          {
            'value': 340321000000,
            'text': '怀远县',
            'level': 3,
            'pvalue': 340300000000
          },
          {
            'value': 340322000000,
            'text': '五河县',
            'level': 3,
            'pvalue': 340300000000
          },
          {
            'value': 340323000000,
            'text': '固镇县',
            'level': 3,
            'pvalue': 340300000000
          },
          {
            'value': 340371000000,
            'text': '蚌埠市高新技术开发区',
            'level': 3,
            'pvalue': 340300000000
          },
          {
            'value': 340372000000,
            'text': '蚌埠市经济开发区',
            'level': 3,
            'pvalue': 340300000000
          }
        ]
      },
      {
        'value': 340400000000,
        'text': '淮南市',
        'level': 2,
        'pvalue': 340000000000,
        'children': [
          {
            'value': 340401000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 340400000000
          },
          {
            'value': 340402000000,
            'text': '大通区',
            'level': 3,
            'pvalue': 340400000000
          },
          {
            'value': 340403000000,
            'text': '田家庵区',
            'level': 3,
            'pvalue': 340400000000
          },
          {
            'value': 340404000000,
            'text': '谢家集区',
            'level': 3,
            'pvalue': 340400000000
          },
          {
            'value': 340405000000,
            'text': '八公山区',
            'level': 3,
            'pvalue': 340400000000
          },
          {
            'value': 340406000000,
            'text': '潘集区',
            'level': 3,
            'pvalue': 340400000000
          },
          {
            'value': 340421000000,
            'text': '凤台县',
            'level': 3,
            'pvalue': 340400000000
          },
          {
            'value': 340422000000,
            'text': '寿县',
            'level': 3,
            'pvalue': 340400000000
          }
        ]
      },
      {
        'value': 340500000000,
        'text': '马鞍山市',
        'level': 2,
        'pvalue': 340000000000,
        'children': [
          {
            'value': 340501000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 340500000000
          },
          {
            'value': 340503000000,
            'text': '花山区',
            'level': 3,
            'pvalue': 340500000000
          },
          {
            'value': 340504000000,
            'text': '雨山区',
            'level': 3,
            'pvalue': 340500000000
          },
          {
            'value': 340506000000,
            'text': '博望区',
            'level': 3,
            'pvalue': 340500000000
          },
          {
            'value': 340521000000,
            'text': '当涂县',
            'level': 3,
            'pvalue': 340500000000
          },
          {
            'value': 340522000000,
            'text': '含山县',
            'level': 3,
            'pvalue': 340500000000
          },
          {
            'value': 340523000000,
            'text': '和县',
            'level': 3,
            'pvalue': 340500000000
          }
        ]
      },
      {
        'value': 340600000000,
        'text': '淮北市',
        'level': 2,
        'pvalue': 340000000000,
        'children': [
          {
            'value': 340601000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 340600000000
          },
          {
            'value': 340602000000,
            'text': '杜集区',
            'level': 3,
            'pvalue': 340600000000
          },
          {
            'value': 340603000000,
            'text': '相山区',
            'level': 3,
            'pvalue': 340600000000
          },
          {
            'value': 340604000000,
            'text': '烈山区',
            'level': 3,
            'pvalue': 340600000000
          },
          {
            'value': 340621000000,
            'text': '濉溪县',
            'level': 3,
            'pvalue': 340600000000
          }
        ]
      },
      {
        'value': 340700000000,
        'text': '铜陵市',
        'level': 2,
        'pvalue': 340000000000,
        'children': [
          {
            'value': 340701000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 340700000000
          },
          {
            'value': 340705000000,
            'text': '铜官区',
            'level': 3,
            'pvalue': 340700000000
          },
          {
            'value': 340706000000,
            'text': '义安区',
            'level': 3,
            'pvalue': 340700000000
          },
          {
            'value': 340711000000,
            'text': '郊区',
            'level': 3,
            'pvalue': 340700000000
          },
          {
            'value': 340722000000,
            'text': '枞阳县',
            'level': 3,
            'pvalue': 340700000000
          }
        ]
      },
      {
        'value': 340800000000,
        'text': '安庆市',
        'level': 2,
        'pvalue': 340000000000,
        'children': [
          {
            'value': 340801000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 340800000000
          },
          {
            'value': 340802000000,
            'text': '迎江区',
            'level': 3,
            'pvalue': 340800000000
          },
          {
            'value': 340803000000,
            'text': '大观区',
            'level': 3,
            'pvalue': 340800000000
          },
          {
            'value': 340811000000,
            'text': '宜秀区',
            'level': 3,
            'pvalue': 340800000000
          },
          {
            'value': 340822000000,
            'text': '怀宁县',
            'level': 3,
            'pvalue': 340800000000
          },
          {
            'value': 340825000000,
            'text': '太湖县',
            'level': 3,
            'pvalue': 340800000000
          },
          {
            'value': 340826000000,
            'text': '宿松县',
            'level': 3,
            'pvalue': 340800000000
          },
          {
            'value': 340827000000,
            'text': '望江县',
            'level': 3,
            'pvalue': 340800000000
          },
          {
            'value': 340828000000,
            'text': '岳西县',
            'level': 3,
            'pvalue': 340800000000
          },
          {
            'value': 340871000000,
            'text': '安徽安庆经济开发区',
            'level': 3,
            'pvalue': 340800000000
          },
          {
            'value': 340881000000,
            'text': '桐城市',
            'level': 3,
            'pvalue': 340800000000
          },
          {
            'value': 340882000000,
            'text': '潜山市',
            'level': 3,
            'pvalue': 340800000000
          }
        ]
      },
      {
        'value': 341000000000,
        'text': '黄山市',
        'level': 2,
        'pvalue': 340000000000,
        'children': [
          {
            'value': 341001000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 341000000000
          },
          {
            'value': 341002000000,
            'text': '屯溪区',
            'level': 3,
            'pvalue': 341000000000
          },
          {
            'value': 341003000000,
            'text': '黄山区',
            'level': 3,
            'pvalue': 341000000000
          },
          {
            'value': 341004000000,
            'text': '徽州区',
            'level': 3,
            'pvalue': 341000000000
          },
          {
            'value': 341021000000,
            'text': '歙县',
            'level': 3,
            'pvalue': 341000000000
          },
          {
            'value': 341022000000,
            'text': '休宁县',
            'level': 3,
            'pvalue': 341000000000
          },
          {
            'value': 341023000000,
            'text': '黟县',
            'level': 3,
            'pvalue': 341000000000
          },
          {
            'value': 341024000000,
            'text': '祁门县',
            'level': 3,
            'pvalue': 341000000000
          }
        ]
      },
      {
        'value': 341100000000,
        'text': '滁州市',
        'level': 2,
        'pvalue': 340000000000,
        'children': [
          {
            'value': 341101000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 341100000000
          },
          {
            'value': 341102000000,
            'text': '琅琊区',
            'level': 3,
            'pvalue': 341100000000
          },
          {
            'value': 341103000000,
            'text': '南谯区',
            'level': 3,
            'pvalue': 341100000000
          },
          {
            'value': 341122000000,
            'text': '来安县',
            'level': 3,
            'pvalue': 341100000000
          },
          {
            'value': 341124000000,
            'text': '全椒县',
            'level': 3,
            'pvalue': 341100000000
          },
          {
            'value': 341125000000,
            'text': '定远县',
            'level': 3,
            'pvalue': 341100000000
          },
          {
            'value': 341126000000,
            'text': '凤阳县',
            'level': 3,
            'pvalue': 341100000000
          },
          {
            'value': 341171000000,
            'text': '中新苏滁高新技术产业开发区',
            'level': 3,
            'pvalue': 341100000000
          },
          {
            'value': 341172000000,
            'text': '滁州经济技术开发区',
            'level': 3,
            'pvalue': 341100000000
          },
          {
            'value': 341181000000,
            'text': '天长市',
            'level': 3,
            'pvalue': 341100000000
          },
          {
            'value': 341182000000,
            'text': '明光市',
            'level': 3,
            'pvalue': 341100000000
          }
        ]
      },
      {
        'value': 341200000000,
        'text': '阜阳市',
        'level': 2,
        'pvalue': 340000000000,
        'children': [
          {
            'value': 341201000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 341200000000
          },
          {
            'value': 341202000000,
            'text': '颍州区',
            'level': 3,
            'pvalue': 341200000000
          },
          {
            'value': 341203000000,
            'text': '颍东区',
            'level': 3,
            'pvalue': 341200000000
          },
          {
            'value': 341204000000,
            'text': '颍泉区',
            'level': 3,
            'pvalue': 341200000000
          },
          {
            'value': 341221000000,
            'text': '临泉县',
            'level': 3,
            'pvalue': 341200000000
          },
          {
            'value': 341222000000,
            'text': '太和县',
            'level': 3,
            'pvalue': 341200000000
          },
          {
            'value': 341225000000,
            'text': '阜南县',
            'level': 3,
            'pvalue': 341200000000
          },
          {
            'value': 341226000000,
            'text': '颍上县',
            'level': 3,
            'pvalue': 341200000000
          },
          {
            'value': 341271000000,
            'text': '阜阳合肥现代产业园区',
            'level': 3,
            'pvalue': 341200000000
          },
          {
            'value': 341272000000,
            'text': '阜阳经济技术开发区',
            'level': 3,
            'pvalue': 341200000000
          },
          {
            'value': 341282000000,
            'text': '界首市',
            'level': 3,
            'pvalue': 341200000000
          }
        ]
      },
      {
        'value': 341300000000,
        'text': '宿州市',
        'level': 2,
        'pvalue': 340000000000,
        'children': [
          {
            'value': 341301000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 341300000000
          },
          {
            'value': 341302000000,
            'text': '埇桥区',
            'level': 3,
            'pvalue': 341300000000
          },
          {
            'value': 341321000000,
            'text': '砀山县',
            'level': 3,
            'pvalue': 341300000000
          },
          {
            'value': 341322000000,
            'text': '萧县',
            'level': 3,
            'pvalue': 341300000000
          },
          {
            'value': 341323000000,
            'text': '灵璧县',
            'level': 3,
            'pvalue': 341300000000
          },
          {
            'value': 341324000000,
            'text': '泗县',
            'level': 3,
            'pvalue': 341300000000
          },
          {
            'value': 341371000000,
            'text': '宿州马鞍山现代产业园区',
            'level': 3,
            'pvalue': 341300000000
          },
          {
            'value': 341372000000,
            'text': '宿州经济技术开发区',
            'level': 3,
            'pvalue': 341300000000
          }
        ]
      },
      {
        'value': 341500000000,
        'text': '六安市',
        'level': 2,
        'pvalue': 340000000000,
        'children': [
          {
            'value': 341501000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 341500000000
          },
          {
            'value': 341502000000,
            'text': '金安区',
            'level': 3,
            'pvalue': 341500000000
          },
          {
            'value': 341503000000,
            'text': '裕安区',
            'level': 3,
            'pvalue': 341500000000
          },
          {
            'value': 341504000000,
            'text': '叶集区',
            'level': 3,
            'pvalue': 341500000000
          },
          {
            'value': 341522000000,
            'text': '霍邱县',
            'level': 3,
            'pvalue': 341500000000
          },
          {
            'value': 341523000000,
            'text': '舒城县',
            'level': 3,
            'pvalue': 341500000000
          },
          {
            'value': 341524000000,
            'text': '金寨县',
            'level': 3,
            'pvalue': 341500000000
          },
          {
            'value': 341525000000,
            'text': '霍山县',
            'level': 3,
            'pvalue': 341500000000
          }
        ]
      },
      {
        'value': 341600000000,
        'text': '亳州市',
        'level': 2,
        'pvalue': 340000000000,
        'children': [
          {
            'value': 341601000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 341600000000
          },
          {
            'value': 341602000000,
            'text': '谯城区',
            'level': 3,
            'pvalue': 341600000000
          },
          {
            'value': 341621000000,
            'text': '涡阳县',
            'level': 3,
            'pvalue': 341600000000
          },
          {
            'value': 341622000000,
            'text': '蒙城县',
            'level': 3,
            'pvalue': 341600000000
          },
          {
            'value': 341623000000,
            'text': '利辛县',
            'level': 3,
            'pvalue': 341600000000
          }
        ]
      },
      {
        'value': 341700000000,
        'text': '池州市',
        'level': 2,
        'pvalue': 340000000000,
        'children': [
          {
            'value': 341701000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 341700000000
          },
          {
            'value': 341702000000,
            'text': '贵池区',
            'level': 3,
            'pvalue': 341700000000
          },
          {
            'value': 341721000000,
            'text': '东至县',
            'level': 3,
            'pvalue': 341700000000
          },
          {
            'value': 341722000000,
            'text': '石台县',
            'level': 3,
            'pvalue': 341700000000
          },
          {
            'value': 341723000000,
            'text': '青阳县',
            'level': 3,
            'pvalue': 341700000000
          }
        ]
      },
      {
        'value': 341800000000,
        'text': '宣城市',
        'level': 2,
        'pvalue': 340000000000,
        'children': [
          {
            'value': 341801000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 341800000000
          },
          {
            'value': 341802000000,
            'text': '宣州区',
            'level': 3,
            'pvalue': 341800000000
          },
          {
            'value': 341821000000,
            'text': '郎溪县',
            'level': 3,
            'pvalue': 341800000000
          },
          {
            'value': 341823000000,
            'text': '泾县',
            'level': 3,
            'pvalue': 341800000000
          },
          {
            'value': 341824000000,
            'text': '绩溪县',
            'level': 3,
            'pvalue': 341800000000
          },
          {
            'value': 341825000000,
            'text': '旌德县',
            'level': 3,
            'pvalue': 341800000000
          },
          {
            'value': 341871000000,
            'text': '宣城市经济开发区',
            'level': 3,
            'pvalue': 341800000000
          },
          {
            'value': 341881000000,
            'text': '宁国市',
            'level': 3,
            'pvalue': 341800000000
          },
          {
            'value': 341882000000,
            'text': '广德市',
            'level': 3,
            'pvalue': 341800000000
          }
        ]
      }
    ]
  },
  {
    'value': 350000000000,
    'text': '福建省',
    'level': 1,
    'pvalue': 0,
    'children': [
      {
        'value': 350100000000,
        'text': '福州市',
        'level': 2,
        'pvalue': 350000000000,
        'children': [
          {
            'value': 350101000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 350100000000
          },
          {
            'value': 350102000000,
            'text': '鼓楼区',
            'level': 3,
            'pvalue': 350100000000
          },
          {
            'value': 350103000000,
            'text': '台江区',
            'level': 3,
            'pvalue': 350100000000
          },
          {
            'value': 350104000000,
            'text': '仓山区',
            'level': 3,
            'pvalue': 350100000000
          },
          {
            'value': 350105000000,
            'text': '马尾区',
            'level': 3,
            'pvalue': 350100000000
          },
          {
            'value': 350111000000,
            'text': '晋安区',
            'level': 3,
            'pvalue': 350100000000
          },
          {
            'value': 350112000000,
            'text': '长乐区',
            'level': 3,
            'pvalue': 350100000000
          },
          {
            'value': 350121000000,
            'text': '闽侯县',
            'level': 3,
            'pvalue': 350100000000
          },
          {
            'value': 350122000000,
            'text': '连江县',
            'level': 3,
            'pvalue': 350100000000
          },
          {
            'value': 350123000000,
            'text': '罗源县',
            'level': 3,
            'pvalue': 350100000000
          },
          {
            'value': 350124000000,
            'text': '闽清县',
            'level': 3,
            'pvalue': 350100000000
          },
          {
            'value': 350125000000,
            'text': '永泰县',
            'level': 3,
            'pvalue': 350100000000
          },
          {
            'value': 350128000000,
            'text': '平潭县',
            'level': 3,
            'pvalue': 350100000000
          },
          {
            'value': 350181000000,
            'text': '福清市',
            'level': 3,
            'pvalue': 350100000000
          }
        ]
      },
      {
        'value': 350200000000,
        'text': '厦门市',
        'level': 2,
        'pvalue': 350000000000,
        'children': [
          {
            'value': 350201000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 350200000000
          },
          {
            'value': 350203000000,
            'text': '思明区',
            'level': 3,
            'pvalue': 350200000000
          },
          {
            'value': 350205000000,
            'text': '海沧区',
            'level': 3,
            'pvalue': 350200000000
          },
          {
            'value': 350206000000,
            'text': '湖里区',
            'level': 3,
            'pvalue': 350200000000
          },
          {
            'value': 350211000000,
            'text': '集美区',
            'level': 3,
            'pvalue': 350200000000
          },
          {
            'value': 350212000000,
            'text': '同安区',
            'level': 3,
            'pvalue': 350200000000
          },
          {
            'value': 350213000000,
            'text': '翔安区',
            'level': 3,
            'pvalue': 350200000000
          }
        ]
      },
      {
        'value': 350300000000,
        'text': '莆田市',
        'level': 2,
        'pvalue': 350000000000,
        'children': [
          {
            'value': 350301000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 350300000000
          },
          {
            'value': 350302000000,
            'text': '城厢区',
            'level': 3,
            'pvalue': 350300000000
          },
          {
            'value': 350303000000,
            'text': '涵江区',
            'level': 3,
            'pvalue': 350300000000
          },
          {
            'value': 350304000000,
            'text': '荔城区',
            'level': 3,
            'pvalue': 350300000000
          },
          {
            'value': 350305000000,
            'text': '秀屿区',
            'level': 3,
            'pvalue': 350300000000
          },
          {
            'value': 350322000000,
            'text': '仙游县',
            'level': 3,
            'pvalue': 350300000000
          }
        ]
      },
      {
        'value': 350400000000,
        'text': '三明市',
        'level': 2,
        'pvalue': 350000000000,
        'children': [
          {
            'value': 350401000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 350400000000
          },
          {
            'value': 350404000000,
            'text': '三元区',
            'level': 3,
            'pvalue': 350400000000
          },
          {
            'value': 350405000000,
            'text': '沙县区',
            'level': 3,
            'pvalue': 350400000000
          },
          {
            'value': 350421000000,
            'text': '明溪县',
            'level': 3,
            'pvalue': 350400000000
          },
          {
            'value': 350423000000,
            'text': '清流县',
            'level': 3,
            'pvalue': 350400000000
          },
          {
            'value': 350424000000,
            'text': '宁化县',
            'level': 3,
            'pvalue': 350400000000
          },
          {
            'value': 350425000000,
            'text': '大田县',
            'level': 3,
            'pvalue': 350400000000
          },
          {
            'value': 350426000000,
            'text': '尤溪县',
            'level': 3,
            'pvalue': 350400000000
          },
          {
            'value': 350428000000,
            'text': '将乐县',
            'level': 3,
            'pvalue': 350400000000
          },
          {
            'value': 350429000000,
            'text': '泰宁县',
            'level': 3,
            'pvalue': 350400000000
          },
          {
            'value': 350430000000,
            'text': '建宁县',
            'level': 3,
            'pvalue': 350400000000
          },
          {
            'value': 350481000000,
            'text': '永安市',
            'level': 3,
            'pvalue': 350400000000
          }
        ]
      },
      {
        'value': 350500000000,
        'text': '泉州市',
        'level': 2,
        'pvalue': 350000000000,
        'children': [
          {
            'value': 350501000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 350500000000
          },
          {
            'value': 350502000000,
            'text': '鲤城区',
            'level': 3,
            'pvalue': 350500000000
          },
          {
            'value': 350503000000,
            'text': '丰泽区',
            'level': 3,
            'pvalue': 350500000000
          },
          {
            'value': 350504000000,
            'text': '洛江区',
            'level': 3,
            'pvalue': 350500000000
          },
          {
            'value': 350505000000,
            'text': '泉港区',
            'level': 3,
            'pvalue': 350500000000
          },
          {
            'value': 350521000000,
            'text': '惠安县',
            'level': 3,
            'pvalue': 350500000000
          },
          {
            'value': 350524000000,
            'text': '安溪县',
            'level': 3,
            'pvalue': 350500000000
          },
          {
            'value': 350525000000,
            'text': '永春县',
            'level': 3,
            'pvalue': 350500000000
          },
          {
            'value': 350526000000,
            'text': '德化县',
            'level': 3,
            'pvalue': 350500000000
          },
          {
            'value': 350527000000,
            'text': '金门县',
            'level': 3,
            'pvalue': 350500000000
          },
          {
            'value': 350581000000,
            'text': '石狮市',
            'level': 3,
            'pvalue': 350500000000
          },
          {
            'value': 350582000000,
            'text': '晋江市',
            'level': 3,
            'pvalue': 350500000000
          },
          {
            'value': 350583000000,
            'text': '南安市',
            'level': 3,
            'pvalue': 350500000000
          }
        ]
      },
      {
        'value': 350600000000,
        'text': '漳州市',
        'level': 2,
        'pvalue': 350000000000,
        'children': [
          {
            'value': 350601000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 350600000000
          },
          {
            'value': 350602000000,
            'text': '芗城区',
            'level': 3,
            'pvalue': 350600000000
          },
          {
            'value': 350603000000,
            'text': '龙文区',
            'level': 3,
            'pvalue': 350600000000
          },
          {
            'value': 350604000000,
            'text': '龙海区',
            'level': 3,
            'pvalue': 350600000000
          },
          {
            'value': 350605000000,
            'text': '长泰区',
            'level': 3,
            'pvalue': 350600000000
          },
          {
            'value': 350622000000,
            'text': '云霄县',
            'level': 3,
            'pvalue': 350600000000
          },
          {
            'value': 350623000000,
            'text': '漳浦县',
            'level': 3,
            'pvalue': 350600000000
          },
          {
            'value': 350624000000,
            'text': '诏安县',
            'level': 3,
            'pvalue': 350600000000
          },
          {
            'value': 350626000000,
            'text': '东山县',
            'level': 3,
            'pvalue': 350600000000
          },
          {
            'value': 350627000000,
            'text': '南靖县',
            'level': 3,
            'pvalue': 350600000000
          },
          {
            'value': 350628000000,
            'text': '平和县',
            'level': 3,
            'pvalue': 350600000000
          },
          {
            'value': 350629000000,
            'text': '华安县',
            'level': 3,
            'pvalue': 350600000000
          }
        ]
      },
      {
        'value': 350700000000,
        'text': '南平市',
        'level': 2,
        'pvalue': 350000000000,
        'children': [
          {
            'value': 350701000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 350700000000
          },
          {
            'value': 350702000000,
            'text': '延平区',
            'level': 3,
            'pvalue': 350700000000
          },
          {
            'value': 350703000000,
            'text': '建阳区',
            'level': 3,
            'pvalue': 350700000000
          },
          {
            'value': 350721000000,
            'text': '顺昌县',
            'level': 3,
            'pvalue': 350700000000
          },
          {
            'value': 350722000000,
            'text': '浦城县',
            'level': 3,
            'pvalue': 350700000000
          },
          {
            'value': 350723000000,
            'text': '光泽县',
            'level': 3,
            'pvalue': 350700000000
          },
          {
            'value': 350724000000,
            'text': '松溪县',
            'level': 3,
            'pvalue': 350700000000
          },
          {
            'value': 350725000000,
            'text': '政和县',
            'level': 3,
            'pvalue': 350700000000
          },
          {
            'value': 350781000000,
            'text': '邵武市',
            'level': 3,
            'pvalue': 350700000000
          },
          {
            'value': 350782000000,
            'text': '武夷山市',
            'level': 3,
            'pvalue': 350700000000
          },
          {
            'value': 350783000000,
            'text': '建瓯市',
            'level': 3,
            'pvalue': 350700000000
          }
        ]
      },
      {
        'value': 350800000000,
        'text': '龙岩市',
        'level': 2,
        'pvalue': 350000000000,
        'children': [
          {
            'value': 350801000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 350800000000
          },
          {
            'value': 350802000000,
            'text': '新罗区',
            'level': 3,
            'pvalue': 350800000000
          },
          {
            'value': 350803000000,
            'text': '永定区',
            'level': 3,
            'pvalue': 350800000000
          },
          {
            'value': 350821000000,
            'text': '长汀县',
            'level': 3,
            'pvalue': 350800000000
          },
          {
            'value': 350823000000,
            'text': '上杭县',
            'level': 3,
            'pvalue': 350800000000
          },
          {
            'value': 350824000000,
            'text': '武平县',
            'level': 3,
            'pvalue': 350800000000
          },
          {
            'value': 350825000000,
            'text': '连城县',
            'level': 3,
            'pvalue': 350800000000
          },
          {
            'value': 350881000000,
            'text': '漳平市',
            'level': 3,
            'pvalue': 350800000000
          }
        ]
      },
      {
        'value': 350900000000,
        'text': '宁德市',
        'level': 2,
        'pvalue': 350000000000,
        'children': [
          {
            'value': 350901000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 350900000000
          },
          {
            'value': 350902000000,
            'text': '蕉城区',
            'level': 3,
            'pvalue': 350900000000
          },
          {
            'value': 350921000000,
            'text': '霞浦县',
            'level': 3,
            'pvalue': 350900000000
          },
          {
            'value': 350922000000,
            'text': '古田县',
            'level': 3,
            'pvalue': 350900000000
          },
          {
            'value': 350923000000,
            'text': '屏南县',
            'level': 3,
            'pvalue': 350900000000
          },
          {
            'value': 350924000000,
            'text': '寿宁县',
            'level': 3,
            'pvalue': 350900000000
          },
          {
            'value': 350925000000,
            'text': '周宁县',
            'level': 3,
            'pvalue': 350900000000
          },
          {
            'value': 350926000000,
            'text': '柘荣县',
            'level': 3,
            'pvalue': 350900000000
          },
          {
            'value': 350981000000,
            'text': '福安市',
            'level': 3,
            'pvalue': 350900000000
          },
          {
            'value': 350982000000,
            'text': '福鼎市',
            'level': 3,
            'pvalue': 350900000000
          }
        ]
      }
    ]
  },
  {
    'value': 360000000000,
    'text': '江西省',
    'level': 1,
    'pvalue': 0,
    'children': [
      {
        'value': 360100000000,
        'text': '南昌市',
        'level': 2,
        'pvalue': 360000000000,
        'children': [
          {
            'value': 360101000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 360100000000
          },
          {
            'value': 360102000000,
            'text': '东湖区',
            'level': 3,
            'pvalue': 360100000000
          },
          {
            'value': 360103000000,
            'text': '西湖区',
            'level': 3,
            'pvalue': 360100000000
          },
          {
            'value': 360104000000,
            'text': '青云谱区',
            'level': 3,
            'pvalue': 360100000000
          },
          {
            'value': 360111000000,
            'text': '青山湖区',
            'level': 3,
            'pvalue': 360100000000
          },
          {
            'value': 360112000000,
            'text': '新建区',
            'level': 3,
            'pvalue': 360100000000
          },
          {
            'value': 360113000000,
            'text': '红谷滩区',
            'level': 3,
            'pvalue': 360100000000
          },
          {
            'value': 360121000000,
            'text': '南昌县',
            'level': 3,
            'pvalue': 360100000000
          },
          {
            'value': 360123000000,
            'text': '安义县',
            'level': 3,
            'pvalue': 360100000000
          },
          {
            'value': 360124000000,
            'text': '进贤县',
            'level': 3,
            'pvalue': 360100000000
          }
        ]
      },
      {
        'value': 360200000000,
        'text': '景德镇市',
        'level': 2,
        'pvalue': 360000000000,
        'children': [
          {
            'value': 360201000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 360200000000
          },
          {
            'value': 360202000000,
            'text': '昌江区',
            'level': 3,
            'pvalue': 360200000000
          },
          {
            'value': 360203000000,
            'text': '珠山区',
            'level': 3,
            'pvalue': 360200000000
          },
          {
            'value': 360222000000,
            'text': '浮梁县',
            'level': 3,
            'pvalue': 360200000000
          },
          {
            'value': 360281000000,
            'text': '乐平市',
            'level': 3,
            'pvalue': 360200000000
          }
        ]
      },
      {
        'value': 360300000000,
        'text': '萍乡市',
        'level': 2,
        'pvalue': 360000000000,
        'children': [
          {
            'value': 360301000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 360300000000
          },
          {
            'value': 360302000000,
            'text': '安源区',
            'level': 3,
            'pvalue': 360300000000
          },
          {
            'value': 360313000000,
            'text': '湘东区',
            'level': 3,
            'pvalue': 360300000000
          },
          {
            'value': 360321000000,
            'text': '莲花县',
            'level': 3,
            'pvalue': 360300000000
          },
          {
            'value': 360322000000,
            'text': '上栗县',
            'level': 3,
            'pvalue': 360300000000
          },
          {
            'value': 360323000000,
            'text': '芦溪县',
            'level': 3,
            'pvalue': 360300000000
          }
        ]
      },
      {
        'value': 360400000000,
        'text': '九江市',
        'level': 2,
        'pvalue': 360000000000,
        'children': [
          {
            'value': 360401000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 360400000000
          },
          {
            'value': 360402000000,
            'text': '濂溪区',
            'level': 3,
            'pvalue': 360400000000
          },
          {
            'value': 360403000000,
            'text': '浔阳区',
            'level': 3,
            'pvalue': 360400000000
          },
          {
            'value': 360404000000,
            'text': '柴桑区',
            'level': 3,
            'pvalue': 360400000000
          },
          {
            'value': 360423000000,
            'text': '武宁县',
            'level': 3,
            'pvalue': 360400000000
          },
          {
            'value': 360424000000,
            'text': '修水县',
            'level': 3,
            'pvalue': 360400000000
          },
          {
            'value': 360425000000,
            'text': '永修县',
            'level': 3,
            'pvalue': 360400000000
          },
          {
            'value': 360426000000,
            'text': '德安县',
            'level': 3,
            'pvalue': 360400000000
          },
          {
            'value': 360428000000,
            'text': '都昌县',
            'level': 3,
            'pvalue': 360400000000
          },
          {
            'value': 360429000000,
            'text': '湖口县',
            'level': 3,
            'pvalue': 360400000000
          },
          {
            'value': 360430000000,
            'text': '彭泽县',
            'level': 3,
            'pvalue': 360400000000
          },
          {
            'value': 360481000000,
            'text': '瑞昌市',
            'level': 3,
            'pvalue': 360400000000
          },
          {
            'value': 360482000000,
            'text': '共青城市',
            'level': 3,
            'pvalue': 360400000000
          },
          {
            'value': 360483000000,
            'text': '庐山市',
            'level': 3,
            'pvalue': 360400000000
          }
        ]
      },
      {
        'value': 360500000000,
        'text': '新余市',
        'level': 2,
        'pvalue': 360000000000,
        'children': [
          {
            'value': 360501000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 360500000000
          },
          {
            'value': 360502000000,
            'text': '渝水区',
            'level': 3,
            'pvalue': 360500000000
          },
          {
            'value': 360521000000,
            'text': '分宜县',
            'level': 3,
            'pvalue': 360500000000
          }
        ]
      },
      {
        'value': 360600000000,
        'text': '鹰潭市',
        'level': 2,
        'pvalue': 360000000000,
        'children': [
          {
            'value': 360601000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 360600000000
          },
          {
            'value': 360602000000,
            'text': '月湖区',
            'level': 3,
            'pvalue': 360600000000
          },
          {
            'value': 360603000000,
            'text': '余江区',
            'level': 3,
            'pvalue': 360600000000
          },
          {
            'value': 360681000000,
            'text': '贵溪市',
            'level': 3,
            'pvalue': 360600000000
          }
        ]
      },
      {
        'value': 360700000000,
        'text': '赣州市',
        'level': 2,
        'pvalue': 360000000000,
        'children': [
          {
            'value': 360701000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 360700000000
          },
          {
            'value': 360702000000,
            'text': '章贡区',
            'level': 3,
            'pvalue': 360700000000
          },
          {
            'value': 360703000000,
            'text': '南康区',
            'level': 3,
            'pvalue': 360700000000
          },
          {
            'value': 360704000000,
            'text': '赣县区',
            'level': 3,
            'pvalue': 360700000000
          },
          {
            'value': 360722000000,
            'text': '信丰县',
            'level': 3,
            'pvalue': 360700000000
          },
          {
            'value': 360723000000,
            'text': '大余县',
            'level': 3,
            'pvalue': 360700000000
          },
          {
            'value': 360724000000,
            'text': '上犹县',
            'level': 3,
            'pvalue': 360700000000
          },
          {
            'value': 360725000000,
            'text': '崇义县',
            'level': 3,
            'pvalue': 360700000000
          },
          {
            'value': 360726000000,
            'text': '安远县',
            'level': 3,
            'pvalue': 360700000000
          },
          {
            'value': 360728000000,
            'text': '定南县',
            'level': 3,
            'pvalue': 360700000000
          },
          {
            'value': 360729000000,
            'text': '全南县',
            'level': 3,
            'pvalue': 360700000000
          },
          {
            'value': 360730000000,
            'text': '宁都县',
            'level': 3,
            'pvalue': 360700000000
          },
          {
            'value': 360731000000,
            'text': '于都县',
            'level': 3,
            'pvalue': 360700000000
          },
          {
            'value': 360732000000,
            'text': '兴国县',
            'level': 3,
            'pvalue': 360700000000
          },
          {
            'value': 360733000000,
            'text': '会昌县',
            'level': 3,
            'pvalue': 360700000000
          },
          {
            'value': 360734000000,
            'text': '寻乌县',
            'level': 3,
            'pvalue': 360700000000
          },
          {
            'value': 360735000000,
            'text': '石城县',
            'level': 3,
            'pvalue': 360700000000
          },
          {
            'value': 360781000000,
            'text': '瑞金市',
            'level': 3,
            'pvalue': 360700000000
          },
          {
            'value': 360783000000,
            'text': '龙南市',
            'level': 3,
            'pvalue': 360700000000
          }
        ]
      },
      {
        'value': 360800000000,
        'text': '吉安市',
        'level': 2,
        'pvalue': 360000000000,
        'children': [
          {
            'value': 360801000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 360800000000
          },
          {
            'value': 360802000000,
            'text': '吉州区',
            'level': 3,
            'pvalue': 360800000000
          },
          {
            'value': 360803000000,
            'text': '青原区',
            'level': 3,
            'pvalue': 360800000000
          },
          {
            'value': 360821000000,
            'text': '吉安县',
            'level': 3,
            'pvalue': 360800000000
          },
          {
            'value': 360822000000,
            'text': '吉水县',
            'level': 3,
            'pvalue': 360800000000
          },
          {
            'value': 360823000000,
            'text': '峡江县',
            'level': 3,
            'pvalue': 360800000000
          },
          {
            'value': 360824000000,
            'text': '新干县',
            'level': 3,
            'pvalue': 360800000000
          },
          {
            'value': 360825000000,
            'text': '永丰县',
            'level': 3,
            'pvalue': 360800000000
          },
          {
            'value': 360826000000,
            'text': '泰和县',
            'level': 3,
            'pvalue': 360800000000
          },
          {
            'value': 360827000000,
            'text': '遂川县',
            'level': 3,
            'pvalue': 360800000000
          },
          {
            'value': 360828000000,
            'text': '万安县',
            'level': 3,
            'pvalue': 360800000000
          },
          {
            'value': 360829000000,
            'text': '安福县',
            'level': 3,
            'pvalue': 360800000000
          },
          {
            'value': 360830000000,
            'text': '永新县',
            'level': 3,
            'pvalue': 360800000000
          },
          {
            'value': 360881000000,
            'text': '井冈山市',
            'level': 3,
            'pvalue': 360800000000
          }
        ]
      },
      {
        'value': 360900000000,
        'text': '宜春市',
        'level': 2,
        'pvalue': 360000000000,
        'children': [
          {
            'value': 360901000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 360900000000
          },
          {
            'value': 360902000000,
            'text': '袁州区',
            'level': 3,
            'pvalue': 360900000000
          },
          {
            'value': 360921000000,
            'text': '奉新县',
            'level': 3,
            'pvalue': 360900000000
          },
          {
            'value': 360922000000,
            'text': '万载县',
            'level': 3,
            'pvalue': 360900000000
          },
          {
            'value': 360923000000,
            'text': '上高县',
            'level': 3,
            'pvalue': 360900000000
          },
          {
            'value': 360924000000,
            'text': '宜丰县',
            'level': 3,
            'pvalue': 360900000000
          },
          {
            'value': 360925000000,
            'text': '靖安县',
            'level': 3,
            'pvalue': 360900000000
          },
          {
            'value': 360926000000,
            'text': '铜鼓县',
            'level': 3,
            'pvalue': 360900000000
          },
          {
            'value': 360981000000,
            'text': '丰城市',
            'level': 3,
            'pvalue': 360900000000
          },
          {
            'value': 360982000000,
            'text': '樟树市',
            'level': 3,
            'pvalue': 360900000000
          },
          {
            'value': 360983000000,
            'text': '高安市',
            'level': 3,
            'pvalue': 360900000000
          }
        ]
      },
      {
        'value': 361000000000,
        'text': '抚州市',
        'level': 2,
        'pvalue': 360000000000,
        'children': [
          {
            'value': 361001000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 361000000000
          },
          {
            'value': 361002000000,
            'text': '临川区',
            'level': 3,
            'pvalue': 361000000000
          },
          {
            'value': 361003000000,
            'text': '东乡区',
            'level': 3,
            'pvalue': 361000000000
          },
          {
            'value': 361021000000,
            'text': '南城县',
            'level': 3,
            'pvalue': 361000000000
          },
          {
            'value': 361022000000,
            'text': '黎川县',
            'level': 3,
            'pvalue': 361000000000
          },
          {
            'value': 361023000000,
            'text': '南丰县',
            'level': 3,
            'pvalue': 361000000000
          },
          {
            'value': 361024000000,
            'text': '崇仁县',
            'level': 3,
            'pvalue': 361000000000
          },
          {
            'value': 361025000000,
            'text': '乐安县',
            'level': 3,
            'pvalue': 361000000000
          },
          {
            'value': 361026000000,
            'text': '宜黄县',
            'level': 3,
            'pvalue': 361000000000
          },
          {
            'value': 361027000000,
            'text': '金溪县',
            'level': 3,
            'pvalue': 361000000000
          },
          {
            'value': 361028000000,
            'text': '资溪县',
            'level': 3,
            'pvalue': 361000000000
          },
          {
            'value': 361030000000,
            'text': '广昌县',
            'level': 3,
            'pvalue': 361000000000
          }
        ]
      },
      {
        'value': 361100000000,
        'text': '上饶市',
        'level': 2,
        'pvalue': 360000000000,
        'children': [
          {
            'value': 361101000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 361100000000
          },
          {
            'value': 361102000000,
            'text': '信州区',
            'level': 3,
            'pvalue': 361100000000
          },
          {
            'value': 361103000000,
            'text': '广丰区',
            'level': 3,
            'pvalue': 361100000000
          },
          {
            'value': 361104000000,
            'text': '广信区',
            'level': 3,
            'pvalue': 361100000000
          },
          {
            'value': 361123000000,
            'text': '玉山县',
            'level': 3,
            'pvalue': 361100000000
          },
          {
            'value': 361124000000,
            'text': '铅山县',
            'level': 3,
            'pvalue': 361100000000
          },
          {
            'value': 361125000000,
            'text': '横峰县',
            'level': 3,
            'pvalue': 361100000000
          },
          {
            'value': 361126000000,
            'text': '弋阳县',
            'level': 3,
            'pvalue': 361100000000
          },
          {
            'value': 361127000000,
            'text': '余干县',
            'level': 3,
            'pvalue': 361100000000
          },
          {
            'value': 361128000000,
            'text': '鄱阳县',
            'level': 3,
            'pvalue': 361100000000
          },
          {
            'value': 361129000000,
            'text': '万年县',
            'level': 3,
            'pvalue': 361100000000
          },
          {
            'value': 361130000000,
            'text': '婺源县',
            'level': 3,
            'pvalue': 361100000000
          },
          {
            'value': 361181000000,
            'text': '德兴市',
            'level': 3,
            'pvalue': 361100000000
          }
        ]
      }
    ]
  },
  {
    'value': 370000000000,
    'text': '山东省',
    'level': 1,
    'pvalue': 0,
    'children': [
      {
        'value': 370100000000,
        'text': '济南市',
        'level': 2,
        'pvalue': 370000000000,
        'children': [
          {
            'value': 370101000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 370100000000
          },
          {
            'value': 370102000000,
            'text': '历下区',
            'level': 3,
            'pvalue': 370100000000
          },
          {
            'value': 370103000000,
            'text': '市中区',
            'level': 3,
            'pvalue': 370100000000
          },
          {
            'value': 370104000000,
            'text': '槐荫区',
            'level': 3,
            'pvalue': 370100000000
          },
          {
            'value': 370105000000,
            'text': '天桥区',
            'level': 3,
            'pvalue': 370100000000
          },
          {
            'value': 370112000000,
            'text': '历城区',
            'level': 3,
            'pvalue': 370100000000
          },
          {
            'value': 370113000000,
            'text': '长清区',
            'level': 3,
            'pvalue': 370100000000
          },
          {
            'value': 370114000000,
            'text': '章丘区',
            'level': 3,
            'pvalue': 370100000000
          },
          {
            'value': 370115000000,
            'text': '济阳区',
            'level': 3,
            'pvalue': 370100000000
          },
          {
            'value': 370116000000,
            'text': '莱芜区',
            'level': 3,
            'pvalue': 370100000000
          },
          {
            'value': 370117000000,
            'text': '钢城区',
            'level': 3,
            'pvalue': 370100000000
          },
          {
            'value': 370124000000,
            'text': '平阴县',
            'level': 3,
            'pvalue': 370100000000
          },
          {
            'value': 370126000000,
            'text': '商河县',
            'level': 3,
            'pvalue': 370100000000
          },
          {
            'value': 370171000000,
            'text': '济南高新技术产业开发区',
            'level': 3,
            'pvalue': 370100000000
          }
        ]
      },
      {
        'value': 370200000000,
        'text': '青岛市',
        'level': 2,
        'pvalue': 370000000000,
        'children': [
          {
            'value': 370201000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 370200000000
          },
          {
            'value': 370202000000,
            'text': '市南区',
            'level': 3,
            'pvalue': 370200000000
          },
          {
            'value': 370203000000,
            'text': '市北区',
            'level': 3,
            'pvalue': 370200000000
          },
          {
            'value': 370211000000,
            'text': '黄岛区',
            'level': 3,
            'pvalue': 370200000000
          },
          {
            'value': 370212000000,
            'text': '崂山区',
            'level': 3,
            'pvalue': 370200000000
          },
          {
            'value': 370213000000,
            'text': '李沧区',
            'level': 3,
            'pvalue': 370200000000
          },
          {
            'value': 370214000000,
            'text': '城阳区',
            'level': 3,
            'pvalue': 370200000000
          },
          {
            'value': 370215000000,
            'text': '即墨区',
            'level': 3,
            'pvalue': 370200000000
          },
          {
            'value': 370271000000,
            'text': '青岛高新技术产业开发区',
            'level': 3,
            'pvalue': 370200000000
          },
          {
            'value': 370281000000,
            'text': '胶州市',
            'level': 3,
            'pvalue': 370200000000
          },
          {
            'value': 370283000000,
            'text': '平度市',
            'level': 3,
            'pvalue': 370200000000
          },
          {
            'value': 370285000000,
            'text': '莱西市',
            'level': 3,
            'pvalue': 370200000000
          }
        ]
      },
      {
        'value': 370300000000,
        'text': '淄博市',
        'level': 2,
        'pvalue': 370000000000,
        'children': [
          {
            'value': 370301000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 370300000000
          },
          {
            'value': 370302000000,
            'text': '淄川区',
            'level': 3,
            'pvalue': 370300000000
          },
          {
            'value': 370303000000,
            'text': '张店区',
            'level': 3,
            'pvalue': 370300000000
          },
          {
            'value': 370304000000,
            'text': '博山区',
            'level': 3,
            'pvalue': 370300000000
          },
          {
            'value': 370305000000,
            'text': '临淄区',
            'level': 3,
            'pvalue': 370300000000
          },
          {
            'value': 370306000000,
            'text': '周村区',
            'level': 3,
            'pvalue': 370300000000
          },
          {
            'value': 370321000000,
            'text': '桓台县',
            'level': 3,
            'pvalue': 370300000000
          },
          {
            'value': 370322000000,
            'text': '高青县',
            'level': 3,
            'pvalue': 370300000000
          },
          {
            'value': 370323000000,
            'text': '沂源县',
            'level': 3,
            'pvalue': 370300000000
          }
        ]
      },
      {
        'value': 370400000000,
        'text': '枣庄市',
        'level': 2,
        'pvalue': 370000000000,
        'children': [
          {
            'value': 370401000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 370400000000
          },
          {
            'value': 370402000000,
            'text': '市中区',
            'level': 3,
            'pvalue': 370400000000
          },
          {
            'value': 370403000000,
            'text': '薛城区',
            'level': 3,
            'pvalue': 370400000000
          },
          {
            'value': 370404000000,
            'text': '峄城区',
            'level': 3,
            'pvalue': 370400000000
          },
          {
            'value': 370405000000,
            'text': '台儿庄区',
            'level': 3,
            'pvalue': 370400000000
          },
          {
            'value': 370406000000,
            'text': '山亭区',
            'level': 3,
            'pvalue': 370400000000
          },
          {
            'value': 370481000000,
            'text': '滕州市',
            'level': 3,
            'pvalue': 370400000000
          }
        ]
      },
      {
        'value': 370500000000,
        'text': '东营市',
        'level': 2,
        'pvalue': 370000000000,
        'children': [
          {
            'value': 370501000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 370500000000
          },
          {
            'value': 370502000000,
            'text': '东营区',
            'level': 3,
            'pvalue': 370500000000
          },
          {
            'value': 370503000000,
            'text': '河口区',
            'level': 3,
            'pvalue': 370500000000
          },
          {
            'value': 370505000000,
            'text': '垦利区',
            'level': 3,
            'pvalue': 370500000000
          },
          {
            'value': 370522000000,
            'text': '利津县',
            'level': 3,
            'pvalue': 370500000000
          },
          {
            'value': 370523000000,
            'text': '广饶县',
            'level': 3,
            'pvalue': 370500000000
          },
          {
            'value': 370571000000,
            'text': '东营经济技术开发区',
            'level': 3,
            'pvalue': 370500000000
          },
          {
            'value': 370572000000,
            'text': '东营港经济开发区',
            'level': 3,
            'pvalue': 370500000000
          }
        ]
      },
      {
        'value': 370600000000,
        'text': '烟台市',
        'level': 2,
        'pvalue': 370000000000,
        'children': [
          {
            'value': 370601000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 370600000000
          },
          {
            'value': 370602000000,
            'text': '芝罘区',
            'level': 3,
            'pvalue': 370600000000
          },
          {
            'value': 370611000000,
            'text': '福山区',
            'level': 3,
            'pvalue': 370600000000
          },
          {
            'value': 370612000000,
            'text': '牟平区',
            'level': 3,
            'pvalue': 370600000000
          },
          {
            'value': 370613000000,
            'text': '莱山区',
            'level': 3,
            'pvalue': 370600000000
          },
          {
            'value': 370614000000,
            'text': '蓬莱区',
            'level': 3,
            'pvalue': 370600000000
          },
          {
            'value': 370671000000,
            'text': '烟台高新技术产业开发区',
            'level': 3,
            'pvalue': 370600000000
          },
          {
            'value': 370672000000,
            'text': '烟台经济技术开发区',
            'level': 3,
            'pvalue': 370600000000
          },
          {
            'value': 370681000000,
            'text': '龙口市',
            'level': 3,
            'pvalue': 370600000000
          },
          {
            'value': 370682000000,
            'text': '莱阳市',
            'level': 3,
            'pvalue': 370600000000
          },
          {
            'value': 370683000000,
            'text': '莱州市',
            'level': 3,
            'pvalue': 370600000000
          },
          {
            'value': 370685000000,
            'text': '招远市',
            'level': 3,
            'pvalue': 370600000000
          },
          {
            'value': 370686000000,
            'text': '栖霞市',
            'level': 3,
            'pvalue': 370600000000
          },
          {
            'value': 370687000000,
            'text': '海阳市',
            'level': 3,
            'pvalue': 370600000000
          }
        ]
      },
      {
        'value': 370700000000,
        'text': '潍坊市',
        'level': 2,
        'pvalue': 370000000000,
        'children': [
          {
            'value': 370701000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 370700000000
          },
          {
            'value': 370702000000,
            'text': '潍城区',
            'level': 3,
            'pvalue': 370700000000
          },
          {
            'value': 370703000000,
            'text': '寒亭区',
            'level': 3,
            'pvalue': 370700000000
          },
          {
            'value': 370704000000,
            'text': '坊子区',
            'level': 3,
            'pvalue': 370700000000
          },
          {
            'value': 370705000000,
            'text': '奎文区',
            'level': 3,
            'pvalue': 370700000000
          },
          {
            'value': 370724000000,
            'text': '临朐县',
            'level': 3,
            'pvalue': 370700000000
          },
          {
            'value': 370725000000,
            'text': '昌乐县',
            'level': 3,
            'pvalue': 370700000000
          },
          {
            'value': 370772000000,
            'text': '潍坊滨海经济技术开发区',
            'level': 3,
            'pvalue': 370700000000
          },
          {
            'value': 370781000000,
            'text': '青州市',
            'level': 3,
            'pvalue': 370700000000
          },
          {
            'value': 370782000000,
            'text': '诸城市',
            'level': 3,
            'pvalue': 370700000000
          },
          {
            'value': 370783000000,
            'text': '寿光市',
            'level': 3,
            'pvalue': 370700000000
          },
          {
            'value': 370784000000,
            'text': '安丘市',
            'level': 3,
            'pvalue': 370700000000
          },
          {
            'value': 370785000000,
            'text': '高密市',
            'level': 3,
            'pvalue': 370700000000
          },
          {
            'value': 370786000000,
            'text': '昌邑市',
            'level': 3,
            'pvalue': 370700000000
          }
        ]
      },
      {
        'value': 370800000000,
        'text': '济宁市',
        'level': 2,
        'pvalue': 370000000000,
        'children': [
          {
            'value': 370801000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 370800000000
          },
          {
            'value': 370811000000,
            'text': '任城区',
            'level': 3,
            'pvalue': 370800000000
          },
          {
            'value': 370812000000,
            'text': '兖州区',
            'level': 3,
            'pvalue': 370800000000
          },
          {
            'value': 370826000000,
            'text': '微山县',
            'level': 3,
            'pvalue': 370800000000
          },
          {
            'value': 370827000000,
            'text': '鱼台县',
            'level': 3,
            'pvalue': 370800000000
          },
          {
            'value': 370828000000,
            'text': '金乡县',
            'level': 3,
            'pvalue': 370800000000
          },
          {
            'value': 370829000000,
            'text': '嘉祥县',
            'level': 3,
            'pvalue': 370800000000
          },
          {
            'value': 370830000000,
            'text': '汶上县',
            'level': 3,
            'pvalue': 370800000000
          },
          {
            'value': 370831000000,
            'text': '泗水县',
            'level': 3,
            'pvalue': 370800000000
          },
          {
            'value': 370832000000,
            'text': '梁山县',
            'level': 3,
            'pvalue': 370800000000
          },
          {
            'value': 370871000000,
            'text': '济宁高新技术产业开发区',
            'level': 3,
            'pvalue': 370800000000
          },
          {
            'value': 370881000000,
            'text': '曲阜市',
            'level': 3,
            'pvalue': 370800000000
          },
          {
            'value': 370883000000,
            'text': '邹城市',
            'level': 3,
            'pvalue': 370800000000
          }
        ]
      },
      {
        'value': 370900000000,
        'text': '泰安市',
        'level': 2,
        'pvalue': 370000000000,
        'children': [
          {
            'value': 370901000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 370900000000
          },
          {
            'value': 370902000000,
            'text': '泰山区',
            'level': 3,
            'pvalue': 370900000000
          },
          {
            'value': 370911000000,
            'text': '岱岳区',
            'level': 3,
            'pvalue': 370900000000
          },
          {
            'value': 370921000000,
            'text': '宁阳县',
            'level': 3,
            'pvalue': 370900000000
          },
          {
            'value': 370923000000,
            'text': '东平县',
            'level': 3,
            'pvalue': 370900000000
          },
          {
            'value': 370982000000,
            'text': '新泰市',
            'level': 3,
            'pvalue': 370900000000
          },
          {
            'value': 370983000000,
            'text': '肥城市',
            'level': 3,
            'pvalue': 370900000000
          }
        ]
      },
      {
        'value': 371000000000,
        'text': '威海市',
        'level': 2,
        'pvalue': 370000000000,
        'children': [
          {
            'value': 371001000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 371000000000
          },
          {
            'value': 371002000000,
            'text': '环翠区',
            'level': 3,
            'pvalue': 371000000000
          },
          {
            'value': 371003000000,
            'text': '文登区',
            'level': 3,
            'pvalue': 371000000000
          },
          {
            'value': 371071000000,
            'text': '威海火炬高技术产业开发区',
            'level': 3,
            'pvalue': 371000000000
          },
          {
            'value': 371072000000,
            'text': '威海经济技术开发区',
            'level': 3,
            'pvalue': 371000000000
          },
          {
            'value': 371073000000,
            'text': '威海临港经济技术开发区',
            'level': 3,
            'pvalue': 371000000000
          },
          {
            'value': 371082000000,
            'text': '荣成市',
            'level': 3,
            'pvalue': 371000000000
          },
          {
            'value': 371083000000,
            'text': '乳山市',
            'level': 3,
            'pvalue': 371000000000
          }
        ]
      },
      {
        'value': 371100000000,
        'text': '日照市',
        'level': 2,
        'pvalue': 370000000000,
        'children': [
          {
            'value': 371101000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 371100000000
          },
          {
            'value': 371102000000,
            'text': '东港区',
            'level': 3,
            'pvalue': 371100000000
          },
          {
            'value': 371103000000,
            'text': '岚山区',
            'level': 3,
            'pvalue': 371100000000
          },
          {
            'value': 371121000000,
            'text': '五莲县',
            'level': 3,
            'pvalue': 371100000000
          },
          {
            'value': 371122000000,
            'text': '莒县',
            'level': 3,
            'pvalue': 371100000000
          },
          {
            'value': 371171000000,
            'text': '日照经济技术开发区',
            'level': 3,
            'pvalue': 371100000000
          }
        ]
      },
      {
        'value': 371300000000,
        'text': '临沂市',
        'level': 2,
        'pvalue': 370000000000,
        'children': [
          {
            'value': 371301000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 371300000000
          },
          {
            'value': 371302000000,
            'text': '兰山区',
            'level': 3,
            'pvalue': 371300000000
          },
          {
            'value': 371311000000,
            'text': '罗庄区',
            'level': 3,
            'pvalue': 371300000000
          },
          {
            'value': 371312000000,
            'text': '河东区',
            'level': 3,
            'pvalue': 371300000000
          },
          {
            'value': 371321000000,
            'text': '沂南县',
            'level': 3,
            'pvalue': 371300000000
          },
          {
            'value': 371322000000,
            'text': '郯城县',
            'level': 3,
            'pvalue': 371300000000
          },
          {
            'value': 371323000000,
            'text': '沂水县',
            'level': 3,
            'pvalue': 371300000000
          },
          {
            'value': 371324000000,
            'text': '兰陵县',
            'level': 3,
            'pvalue': 371300000000
          },
          {
            'value': 371325000000,
            'text': '费县',
            'level': 3,
            'pvalue': 371300000000
          },
          {
            'value': 371326000000,
            'text': '平邑县',
            'level': 3,
            'pvalue': 371300000000
          },
          {
            'value': 371327000000,
            'text': '莒南县',
            'level': 3,
            'pvalue': 371300000000
          },
          {
            'value': 371328000000,
            'text': '蒙阴县',
            'level': 3,
            'pvalue': 371300000000
          },
          {
            'value': 371329000000,
            'text': '临沭县',
            'level': 3,
            'pvalue': 371300000000
          },
          {
            'value': 371371000000,
            'text': '临沂高新技术产业开发区',
            'level': 3,
            'pvalue': 371300000000
          }
        ]
      },
      {
        'value': 371400000000,
        'text': '德州市',
        'level': 2,
        'pvalue': 370000000000,
        'children': [
          {
            'value': 371401000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 371400000000
          },
          {
            'value': 371402000000,
            'text': '德城区',
            'level': 3,
            'pvalue': 371400000000
          },
          {
            'value': 371403000000,
            'text': '陵城区',
            'level': 3,
            'pvalue': 371400000000
          },
          {
            'value': 371422000000,
            'text': '宁津县',
            'level': 3,
            'pvalue': 371400000000
          },
          {
            'value': 371423000000,
            'text': '庆云县',
            'level': 3,
            'pvalue': 371400000000
          },
          {
            'value': 371424000000,
            'text': '临邑县',
            'level': 3,
            'pvalue': 371400000000
          },
          {
            'value': 371425000000,
            'text': '齐河县',
            'level': 3,
            'pvalue': 371400000000
          },
          {
            'value': 371426000000,
            'text': '平原县',
            'level': 3,
            'pvalue': 371400000000
          },
          {
            'value': 371427000000,
            'text': '夏津县',
            'level': 3,
            'pvalue': 371400000000
          },
          {
            'value': 371428000000,
            'text': '武城县',
            'level': 3,
            'pvalue': 371400000000
          },
          {
            'value': 371471000000,
            'text': '德州经济技术开发区',
            'level': 3,
            'pvalue': 371400000000
          },
          {
            'value': 371472000000,
            'text': '德州运河经济开发区',
            'level': 3,
            'pvalue': 371400000000
          },
          {
            'value': 371481000000,
            'text': '乐陵市',
            'level': 3,
            'pvalue': 371400000000
          },
          {
            'value': 371482000000,
            'text': '禹城市',
            'level': 3,
            'pvalue': 371400000000
          }
        ]
      },
      {
        'value': 371500000000,
        'text': '聊城市',
        'level': 2,
        'pvalue': 370000000000,
        'children': [
          {
            'value': 371501000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 371500000000
          },
          {
            'value': 371502000000,
            'text': '东昌府区',
            'level': 3,
            'pvalue': 371500000000
          },
          {
            'value': 371503000000,
            'text': '茌平区',
            'level': 3,
            'pvalue': 371500000000
          },
          {
            'value': 371521000000,
            'text': '阳谷县',
            'level': 3,
            'pvalue': 371500000000
          },
          {
            'value': 371522000000,
            'text': '莘县',
            'level': 3,
            'pvalue': 371500000000
          },
          {
            'value': 371524000000,
            'text': '东阿县',
            'level': 3,
            'pvalue': 371500000000
          },
          {
            'value': 371525000000,
            'text': '冠县',
            'level': 3,
            'pvalue': 371500000000
          },
          {
            'value': 371526000000,
            'text': '高唐县',
            'level': 3,
            'pvalue': 371500000000
          },
          {
            'value': 371581000000,
            'text': '临清市',
            'level': 3,
            'pvalue': 371500000000
          }
        ]
      },
      {
        'value': 371600000000,
        'text': '滨州市',
        'level': 2,
        'pvalue': 370000000000,
        'children': [
          {
            'value': 371601000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 371600000000
          },
          {
            'value': 371602000000,
            'text': '滨城区',
            'level': 3,
            'pvalue': 371600000000
          },
          {
            'value': 371603000000,
            'text': '沾化区',
            'level': 3,
            'pvalue': 371600000000
          },
          {
            'value': 371621000000,
            'text': '惠民县',
            'level': 3,
            'pvalue': 371600000000
          },
          {
            'value': 371622000000,
            'text': '阳信县',
            'level': 3,
            'pvalue': 371600000000
          },
          {
            'value': 371623000000,
            'text': '无棣县',
            'level': 3,
            'pvalue': 371600000000
          },
          {
            'value': 371625000000,
            'text': '博兴县',
            'level': 3,
            'pvalue': 371600000000
          },
          {
            'value': 371681000000,
            'text': '邹平市',
            'level': 3,
            'pvalue': 371600000000
          }
        ]
      },
      {
        'value': 371700000000,
        'text': '菏泽市',
        'level': 2,
        'pvalue': 370000000000,
        'children': [
          {
            'value': 371701000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 371700000000
          },
          {
            'value': 371702000000,
            'text': '牡丹区',
            'level': 3,
            'pvalue': 371700000000
          },
          {
            'value': 371703000000,
            'text': '定陶区',
            'level': 3,
            'pvalue': 371700000000
          },
          {
            'value': 371721000000,
            'text': '曹县',
            'level': 3,
            'pvalue': 371700000000
          },
          {
            'value': 371722000000,
            'text': '单县',
            'level': 3,
            'pvalue': 371700000000
          },
          {
            'value': 371723000000,
            'text': '成武县',
            'level': 3,
            'pvalue': 371700000000
          },
          {
            'value': 371724000000,
            'text': '巨野县',
            'level': 3,
            'pvalue': 371700000000
          },
          {
            'value': 371725000000,
            'text': '郓城县',
            'level': 3,
            'pvalue': 371700000000
          },
          {
            'value': 371726000000,
            'text': '鄄城县',
            'level': 3,
            'pvalue': 371700000000
          },
          {
            'value': 371728000000,
            'text': '东明县',
            'level': 3,
            'pvalue': 371700000000
          },
          {
            'value': 371771000000,
            'text': '菏泽经济技术开发区',
            'level': 3,
            'pvalue': 371700000000
          },
          {
            'value': 371772000000,
            'text': '菏泽高新技术开发区',
            'level': 3,
            'pvalue': 371700000000
          }
        ]
      }
    ]
  },
  {
    'value': 410000000000,
    'text': '河南省',
    'level': 1,
    'pvalue': 0,
    'children': [
      {
        'value': 410100000000,
        'text': '郑州市',
        'level': 2,
        'pvalue': 410000000000,
        'children': [
          {
            'value': 410101000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 410100000000
          },
          {
            'value': 410102000000,
            'text': '中原区',
            'level': 3,
            'pvalue': 410100000000
          },
          {
            'value': 410103000000,
            'text': '二七区',
            'level': 3,
            'pvalue': 410100000000
          },
          {
            'value': 410104000000,
            'text': '管城回族区',
            'level': 3,
            'pvalue': 410100000000
          },
          {
            'value': 410105000000,
            'text': '金水区',
            'level': 3,
            'pvalue': 410100000000
          },
          {
            'value': 410106000000,
            'text': '上街区',
            'level': 3,
            'pvalue': 410100000000
          },
          {
            'value': 410108000000,
            'text': '惠济区',
            'level': 3,
            'pvalue': 410100000000
          },
          {
            'value': 410122000000,
            'text': '中牟县',
            'level': 3,
            'pvalue': 410100000000
          },
          {
            'value': 410171000000,
            'text': '郑州经济技术开发区',
            'level': 3,
            'pvalue': 410100000000
          },
          {
            'value': 410172000000,
            'text': '郑州高新技术产业开发区',
            'level': 3,
            'pvalue': 410100000000
          },
          {
            'value': 410173000000,
            'text': '郑州航空港经济综合实验区',
            'level': 3,
            'pvalue': 410100000000
          },
          {
            'value': 410181000000,
            'text': '巩义市',
            'level': 3,
            'pvalue': 410100000000
          },
          {
            'value': 410182000000,
            'text': '荥阳市',
            'level': 3,
            'pvalue': 410100000000
          },
          {
            'value': 410183000000,
            'text': '新密市',
            'level': 3,
            'pvalue': 410100000000
          },
          {
            'value': 410184000000,
            'text': '新郑市',
            'level': 3,
            'pvalue': 410100000000
          },
          {
            'value': 410185000000,
            'text': '登封市',
            'level': 3,
            'pvalue': 410100000000
          }
        ]
      },
      {
        'value': 410200000000,
        'text': '开封市',
        'level': 2,
        'pvalue': 410000000000,
        'children': [
          {
            'value': 410201000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 410200000000
          },
          {
            'value': 410202000000,
            'text': '龙亭区',
            'level': 3,
            'pvalue': 410200000000
          },
          {
            'value': 410203000000,
            'text': '顺河回族区',
            'level': 3,
            'pvalue': 410200000000
          },
          {
            'value': 410204000000,
            'text': '鼓楼区',
            'level': 3,
            'pvalue': 410200000000
          },
          {
            'value': 410205000000,
            'text': '禹王台区',
            'level': 3,
            'pvalue': 410200000000
          },
          {
            'value': 410212000000,
            'text': '祥符区',
            'level': 3,
            'pvalue': 410200000000
          },
          {
            'value': 410221000000,
            'text': '杞县',
            'level': 3,
            'pvalue': 410200000000
          },
          {
            'value': 410222000000,
            'text': '通许县',
            'level': 3,
            'pvalue': 410200000000
          },
          {
            'value': 410223000000,
            'text': '尉氏县',
            'level': 3,
            'pvalue': 410200000000
          },
          {
            'value': 410225000000,
            'text': '兰考县',
            'level': 3,
            'pvalue': 410200000000
          }
        ]
      },
      {
        'value': 410300000000,
        'text': '洛阳市',
        'level': 2,
        'pvalue': 410000000000,
        'children': [
          {
            'value': 410301000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 410300000000
          },
          {
            'value': 410302000000,
            'text': '老城区',
            'level': 3,
            'pvalue': 410300000000
          },
          {
            'value': 410303000000,
            'text': '西工区',
            'level': 3,
            'pvalue': 410300000000
          },
          {
            'value': 410304000000,
            'text': '瀍河回族区',
            'level': 3,
            'pvalue': 410300000000
          },
          {
            'value': 410305000000,
            'text': '涧西区',
            'level': 3,
            'pvalue': 410300000000
          },
          {
            'value': 410307000000,
            'text': '偃师区',
            'level': 3,
            'pvalue': 410300000000
          },
          {
            'value': 410308000000,
            'text': '孟津区',
            'level': 3,
            'pvalue': 410300000000
          },
          {
            'value': 410311000000,
            'text': '洛龙区',
            'level': 3,
            'pvalue': 410300000000
          },
          {
            'value': 410323000000,
            'text': '新安县',
            'level': 3,
            'pvalue': 410300000000
          },
          {
            'value': 410324000000,
            'text': '栾川县',
            'level': 3,
            'pvalue': 410300000000
          },
          {
            'value': 410325000000,
            'text': '嵩县',
            'level': 3,
            'pvalue': 410300000000
          },
          {
            'value': 410326000000,
            'text': '汝阳县',
            'level': 3,
            'pvalue': 410300000000
          },
          {
            'value': 410327000000,
            'text': '宜阳县',
            'level': 3,
            'pvalue': 410300000000
          },
          {
            'value': 410328000000,
            'text': '洛宁县',
            'level': 3,
            'pvalue': 410300000000
          },
          {
            'value': 410329000000,
            'text': '伊川县',
            'level': 3,
            'pvalue': 410300000000
          },
          {
            'value': 410371000000,
            'text': '洛阳高新技术产业开发区',
            'level': 3,
            'pvalue': 410300000000
          }
        ]
      },
      {
        'value': 410400000000,
        'text': '平顶山市',
        'level': 2,
        'pvalue': 410000000000,
        'children': [
          {
            'value': 410401000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 410400000000
          },
          {
            'value': 410402000000,
            'text': '新华区',
            'level': 3,
            'pvalue': 410400000000
          },
          {
            'value': 410403000000,
            'text': '卫东区',
            'level': 3,
            'pvalue': 410400000000
          },
          {
            'value': 410404000000,
            'text': '石龙区',
            'level': 3,
            'pvalue': 410400000000
          },
          {
            'value': 410411000000,
            'text': '湛河区',
            'level': 3,
            'pvalue': 410400000000
          },
          {
            'value': 410421000000,
            'text': '宝丰县',
            'level': 3,
            'pvalue': 410400000000
          },
          {
            'value': 410422000000,
            'text': '叶县',
            'level': 3,
            'pvalue': 410400000000
          },
          {
            'value': 410423000000,
            'text': '鲁山县',
            'level': 3,
            'pvalue': 410400000000
          },
          {
            'value': 410425000000,
            'text': '郏县',
            'level': 3,
            'pvalue': 410400000000
          },
          {
            'value': 410471000000,
            'text': '平顶山高新技术产业开发区',
            'level': 3,
            'pvalue': 410400000000
          },
          {
            'value': 410472000000,
            'text': '平顶山市城乡一体化示范区',
            'level': 3,
            'pvalue': 410400000000
          },
          {
            'value': 410481000000,
            'text': '舞钢市',
            'level': 3,
            'pvalue': 410400000000
          },
          {
            'value': 410482000000,
            'text': '汝州市',
            'level': 3,
            'pvalue': 410400000000
          }
        ]
      },
      {
        'value': 410500000000,
        'text': '安阳市',
        'level': 2,
        'pvalue': 410000000000,
        'children': [
          {
            'value': 410501000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 410500000000
          },
          {
            'value': 410502000000,
            'text': '文峰区',
            'level': 3,
            'pvalue': 410500000000
          },
          {
            'value': 410503000000,
            'text': '北关区',
            'level': 3,
            'pvalue': 410500000000
          },
          {
            'value': 410505000000,
            'text': '殷都区',
            'level': 3,
            'pvalue': 410500000000
          },
          {
            'value': 410506000000,
            'text': '龙安区',
            'level': 3,
            'pvalue': 410500000000
          },
          {
            'value': 410522000000,
            'text': '安阳县',
            'level': 3,
            'pvalue': 410500000000
          },
          {
            'value': 410523000000,
            'text': '汤阴县',
            'level': 3,
            'pvalue': 410500000000
          },
          {
            'value': 410526000000,
            'text': '滑县',
            'level': 3,
            'pvalue': 410500000000
          },
          {
            'value': 410527000000,
            'text': '内黄县',
            'level': 3,
            'pvalue': 410500000000
          },
          {
            'value': 410571000000,
            'text': '安阳高新技术产业开发区',
            'level': 3,
            'pvalue': 410500000000
          },
          {
            'value': 410581000000,
            'text': '林州市',
            'level': 3,
            'pvalue': 410500000000
          }
        ]
      },
      {
        'value': 410600000000,
        'text': '鹤壁市',
        'level': 2,
        'pvalue': 410000000000,
        'children': [
          {
            'value': 410601000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 410600000000
          },
          {
            'value': 410602000000,
            'text': '鹤山区',
            'level': 3,
            'pvalue': 410600000000
          },
          {
            'value': 410603000000,
            'text': '山城区',
            'level': 3,
            'pvalue': 410600000000
          },
          {
            'value': 410611000000,
            'text': '淇滨区',
            'level': 3,
            'pvalue': 410600000000
          },
          {
            'value': 410621000000,
            'text': '浚县',
            'level': 3,
            'pvalue': 410600000000
          },
          {
            'value': 410622000000,
            'text': '淇县',
            'level': 3,
            'pvalue': 410600000000
          },
          {
            'value': 410671000000,
            'text': '鹤壁经济技术开发区',
            'level': 3,
            'pvalue': 410600000000
          }
        ]
      },
      {
        'value': 410700000000,
        'text': '新乡市',
        'level': 2,
        'pvalue': 410000000000,
        'children': [
          {
            'value': 410701000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 410700000000
          },
          {
            'value': 410702000000,
            'text': '红旗区',
            'level': 3,
            'pvalue': 410700000000
          },
          {
            'value': 410703000000,
            'text': '卫滨区',
            'level': 3,
            'pvalue': 410700000000
          },
          {
            'value': 410704000000,
            'text': '凤泉区',
            'level': 3,
            'pvalue': 410700000000
          },
          {
            'value': 410711000000,
            'text': '牧野区',
            'level': 3,
            'pvalue': 410700000000
          },
          {
            'value': 410721000000,
            'text': '新乡县',
            'level': 3,
            'pvalue': 410700000000
          },
          {
            'value': 410724000000,
            'text': '获嘉县',
            'level': 3,
            'pvalue': 410700000000
          },
          {
            'value': 410725000000,
            'text': '原阳县',
            'level': 3,
            'pvalue': 410700000000
          },
          {
            'value': 410726000000,
            'text': '延津县',
            'level': 3,
            'pvalue': 410700000000
          },
          {
            'value': 410727000000,
            'text': '封丘县',
            'level': 3,
            'pvalue': 410700000000
          },
          {
            'value': 410771000000,
            'text': '新乡高新技术产业开发区',
            'level': 3,
            'pvalue': 410700000000
          },
          {
            'value': 410772000000,
            'text': '新乡经济技术开发区',
            'level': 3,
            'pvalue': 410700000000
          },
          {
            'value': 410773000000,
            'text': '新乡市平原城乡一体化示范区',
            'level': 3,
            'pvalue': 410700000000
          },
          {
            'value': 410781000000,
            'text': '卫辉市',
            'level': 3,
            'pvalue': 410700000000
          },
          {
            'value': 410782000000,
            'text': '辉县市',
            'level': 3,
            'pvalue': 410700000000
          },
          {
            'value': 410783000000,
            'text': '长垣市',
            'level': 3,
            'pvalue': 410700000000
          }
        ]
      },
      {
        'value': 410800000000,
        'text': '焦作市',
        'level': 2,
        'pvalue': 410000000000,
        'children': [
          {
            'value': 410801000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 410800000000
          },
          {
            'value': 410802000000,
            'text': '解放区',
            'level': 3,
            'pvalue': 410800000000
          },
          {
            'value': 410803000000,
            'text': '中站区',
            'level': 3,
            'pvalue': 410800000000
          },
          {
            'value': 410804000000,
            'text': '马村区',
            'level': 3,
            'pvalue': 410800000000
          },
          {
            'value': 410811000000,
            'text': '山阳区',
            'level': 3,
            'pvalue': 410800000000
          },
          {
            'value': 410821000000,
            'text': '修武县',
            'level': 3,
            'pvalue': 410800000000
          },
          {
            'value': 410822000000,
            'text': '博爱县',
            'level': 3,
            'pvalue': 410800000000
          },
          {
            'value': 410823000000,
            'text': '武陟县',
            'level': 3,
            'pvalue': 410800000000
          },
          {
            'value': 410825000000,
            'text': '温县',
            'level': 3,
            'pvalue': 410800000000
          },
          {
            'value': 410871000000,
            'text': '焦作城乡一体化示范区',
            'level': 3,
            'pvalue': 410800000000
          },
          {
            'value': 410882000000,
            'text': '沁阳市',
            'level': 3,
            'pvalue': 410800000000
          },
          {
            'value': 410883000000,
            'text': '孟州市',
            'level': 3,
            'pvalue': 410800000000
          }
        ]
      },
      {
        'value': 410900000000,
        'text': '濮阳市',
        'level': 2,
        'pvalue': 410000000000,
        'children': [
          {
            'value': 410901000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 410900000000
          },
          {
            'value': 410902000000,
            'text': '华龙区',
            'level': 3,
            'pvalue': 410900000000
          },
          {
            'value': 410922000000,
            'text': '清丰县',
            'level': 3,
            'pvalue': 410900000000
          },
          {
            'value': 410923000000,
            'text': '南乐县',
            'level': 3,
            'pvalue': 410900000000
          },
          {
            'value': 410926000000,
            'text': '范县',
            'level': 3,
            'pvalue': 410900000000
          },
          {
            'value': 410927000000,
            'text': '台前县',
            'level': 3,
            'pvalue': 410900000000
          },
          {
            'value': 410928000000,
            'text': '濮阳县',
            'level': 3,
            'pvalue': 410900000000
          },
          {
            'value': 410971000000,
            'text': '河南濮阳工业园区',
            'level': 3,
            'pvalue': 410900000000
          },
          {
            'value': 410972000000,
            'text': '濮阳经济技术开发区',
            'level': 3,
            'pvalue': 410900000000
          }
        ]
      },
      {
        'value': 411000000000,
        'text': '许昌市',
        'level': 2,
        'pvalue': 410000000000,
        'children': [
          {
            'value': 411001000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 411000000000
          },
          {
            'value': 411002000000,
            'text': '魏都区',
            'level': 3,
            'pvalue': 411000000000
          },
          {
            'value': 411003000000,
            'text': '建安区',
            'level': 3,
            'pvalue': 411000000000
          },
          {
            'value': 411024000000,
            'text': '鄢陵县',
            'level': 3,
            'pvalue': 411000000000
          },
          {
            'value': 411025000000,
            'text': '襄城县',
            'level': 3,
            'pvalue': 411000000000
          },
          {
            'value': 411071000000,
            'text': '许昌经济技术开发区',
            'level': 3,
            'pvalue': 411000000000
          },
          {
            'value': 411081000000,
            'text': '禹州市',
            'level': 3,
            'pvalue': 411000000000
          },
          {
            'value': 411082000000,
            'text': '长葛市',
            'level': 3,
            'pvalue': 411000000000
          }
        ]
      },
      {
        'value': 411100000000,
        'text': '漯河市',
        'level': 2,
        'pvalue': 410000000000,
        'children': [
          {
            'value': 411101000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 411100000000
          },
          {
            'value': 411102000000,
            'text': '源汇区',
            'level': 3,
            'pvalue': 411100000000
          },
          {
            'value': 411103000000,
            'text': '郾城区',
            'level': 3,
            'pvalue': 411100000000
          },
          {
            'value': 411104000000,
            'text': '召陵区',
            'level': 3,
            'pvalue': 411100000000
          },
          {
            'value': 411121000000,
            'text': '舞阳县',
            'level': 3,
            'pvalue': 411100000000
          },
          {
            'value': 411122000000,
            'text': '临颍县',
            'level': 3,
            'pvalue': 411100000000
          },
          {
            'value': 411171000000,
            'text': '漯河经济技术开发区',
            'level': 3,
            'pvalue': 411100000000
          }
        ]
      },
      {
        'value': 411200000000,
        'text': '三门峡市',
        'level': 2,
        'pvalue': 410000000000,
        'children': [
          {
            'value': 411201000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 411200000000
          },
          {
            'value': 411202000000,
            'text': '湖滨区',
            'level': 3,
            'pvalue': 411200000000
          },
          {
            'value': 411203000000,
            'text': '陕州区',
            'level': 3,
            'pvalue': 411200000000
          },
          {
            'value': 411221000000,
            'text': '渑池县',
            'level': 3,
            'pvalue': 411200000000
          },
          {
            'value': 411224000000,
            'text': '卢氏县',
            'level': 3,
            'pvalue': 411200000000
          },
          {
            'value': 411271000000,
            'text': '河南三门峡经济开发区',
            'level': 3,
            'pvalue': 411200000000
          },
          {
            'value': 411281000000,
            'text': '义马市',
            'level': 3,
            'pvalue': 411200000000
          },
          {
            'value': 411282000000,
            'text': '灵宝市',
            'level': 3,
            'pvalue': 411200000000
          }
        ]
      },
      {
        'value': 411300000000,
        'text': '南阳市',
        'level': 2,
        'pvalue': 410000000000,
        'children': [
          {
            'value': 411301000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 411300000000
          },
          {
            'value': 411302000000,
            'text': '宛城区',
            'level': 3,
            'pvalue': 411300000000
          },
          {
            'value': 411303000000,
            'text': '卧龙区',
            'level': 3,
            'pvalue': 411300000000
          },
          {
            'value': 411321000000,
            'text': '南召县',
            'level': 3,
            'pvalue': 411300000000
          },
          {
            'value': 411322000000,
            'text': '方城县',
            'level': 3,
            'pvalue': 411300000000
          },
          {
            'value': 411323000000,
            'text': '西峡县',
            'level': 3,
            'pvalue': 411300000000
          },
          {
            'value': 411324000000,
            'text': '镇平县',
            'level': 3,
            'pvalue': 411300000000
          },
          {
            'value': 411325000000,
            'text': '内乡县',
            'level': 3,
            'pvalue': 411300000000
          },
          {
            'value': 411326000000,
            'text': '淅川县',
            'level': 3,
            'pvalue': 411300000000
          },
          {
            'value': 411327000000,
            'text': '社旗县',
            'level': 3,
            'pvalue': 411300000000
          },
          {
            'value': 411328000000,
            'text': '唐河县',
            'level': 3,
            'pvalue': 411300000000
          },
          {
            'value': 411329000000,
            'text': '新野县',
            'level': 3,
            'pvalue': 411300000000
          },
          {
            'value': 411330000000,
            'text': '桐柏县',
            'level': 3,
            'pvalue': 411300000000
          },
          {
            'value': 411371000000,
            'text': '南阳高新技术产业开发区',
            'level': 3,
            'pvalue': 411300000000
          },
          {
            'value': 411372000000,
            'text': '南阳市城乡一体化示范区',
            'level': 3,
            'pvalue': 411300000000
          },
          {
            'value': 411381000000,
            'text': '邓州市',
            'level': 3,
            'pvalue': 411300000000
          }
        ]
      },
      {
        'value': 411400000000,
        'text': '商丘市',
        'level': 2,
        'pvalue': 410000000000,
        'children': [
          {
            'value': 411401000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 411400000000
          },
          {
            'value': 411402000000,
            'text': '梁园区',
            'level': 3,
            'pvalue': 411400000000
          },
          {
            'value': 411403000000,
            'text': '睢阳区',
            'level': 3,
            'pvalue': 411400000000
          },
          {
            'value': 411421000000,
            'text': '民权县',
            'level': 3,
            'pvalue': 411400000000
          },
          {
            'value': 411422000000,
            'text': '睢县',
            'level': 3,
            'pvalue': 411400000000
          },
          {
            'value': 411423000000,
            'text': '宁陵县',
            'level': 3,
            'pvalue': 411400000000
          },
          {
            'value': 411424000000,
            'text': '柘城县',
            'level': 3,
            'pvalue': 411400000000
          },
          {
            'value': 411425000000,
            'text': '虞城县',
            'level': 3,
            'pvalue': 411400000000
          },
          {
            'value': 411426000000,
            'text': '夏邑县',
            'level': 3,
            'pvalue': 411400000000
          },
          {
            'value': 411471000000,
            'text': '豫东综合物流产业聚集区',
            'level': 3,
            'pvalue': 411400000000
          },
          {
            'value': 411472000000,
            'text': '河南商丘经济开发区',
            'level': 3,
            'pvalue': 411400000000
          },
          {
            'value': 411481000000,
            'text': '永城市',
            'level': 3,
            'pvalue': 411400000000
          }
        ]
      },
      {
        'value': 411500000000,
        'text': '信阳市',
        'level': 2,
        'pvalue': 410000000000,
        'children': [
          {
            'value': 411501000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 411500000000
          },
          {
            'value': 411502000000,
            'text': '浉河区',
            'level': 3,
            'pvalue': 411500000000
          },
          {
            'value': 411503000000,
            'text': '平桥区',
            'level': 3,
            'pvalue': 411500000000
          },
          {
            'value': 411521000000,
            'text': '罗山县',
            'level': 3,
            'pvalue': 411500000000
          },
          {
            'value': 411522000000,
            'text': '光山县',
            'level': 3,
            'pvalue': 411500000000
          },
          {
            'value': 411523000000,
            'text': '新县',
            'level': 3,
            'pvalue': 411500000000
          },
          {
            'value': 411524000000,
            'text': '商城县',
            'level': 3,
            'pvalue': 411500000000
          },
          {
            'value': 411525000000,
            'text': '固始县',
            'level': 3,
            'pvalue': 411500000000
          },
          {
            'value': 411526000000,
            'text': '潢川县',
            'level': 3,
            'pvalue': 411500000000
          },
          {
            'value': 411527000000,
            'text': '淮滨县',
            'level': 3,
            'pvalue': 411500000000
          },
          {
            'value': 411528000000,
            'text': '息县',
            'level': 3,
            'pvalue': 411500000000
          },
          {
            'value': 411571000000,
            'text': '信阳高新技术产业开发区',
            'level': 3,
            'pvalue': 411500000000
          }
        ]
      },
      {
        'value': 411600000000,
        'text': '周口市',
        'level': 2,
        'pvalue': 410000000000,
        'children': [
          {
            'value': 411601000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 411600000000
          },
          {
            'value': 411602000000,
            'text': '川汇区',
            'level': 3,
            'pvalue': 411600000000
          },
          {
            'value': 411603000000,
            'text': '淮阳区',
            'level': 3,
            'pvalue': 411600000000
          },
          {
            'value': 411621000000,
            'text': '扶沟县',
            'level': 3,
            'pvalue': 411600000000
          },
          {
            'value': 411622000000,
            'text': '西华县',
            'level': 3,
            'pvalue': 411600000000
          },
          {
            'value': 411623000000,
            'text': '商水县',
            'level': 3,
            'pvalue': 411600000000
          },
          {
            'value': 411624000000,
            'text': '沈丘县',
            'level': 3,
            'pvalue': 411600000000
          },
          {
            'value': 411625000000,
            'text': '郸城县',
            'level': 3,
            'pvalue': 411600000000
          },
          {
            'value': 411627000000,
            'text': '太康县',
            'level': 3,
            'pvalue': 411600000000
          },
          {
            'value': 411628000000,
            'text': '鹿邑县',
            'level': 3,
            'pvalue': 411600000000
          },
          {
            'value': 411671000000,
            'text': '河南周口经济开发区',
            'level': 3,
            'pvalue': 411600000000
          },
          {
            'value': 411681000000,
            'text': '项城市',
            'level': 3,
            'pvalue': 411600000000
          }
        ]
      },
      {
        'value': 411700000000,
        'text': '驻马店市',
        'level': 2,
        'pvalue': 410000000000,
        'children': [
          {
            'value': 411701000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 411700000000
          },
          {
            'value': 411702000000,
            'text': '驿城区',
            'level': 3,
            'pvalue': 411700000000
          },
          {
            'value': 411721000000,
            'text': '西平县',
            'level': 3,
            'pvalue': 411700000000
          },
          {
            'value': 411722000000,
            'text': '上蔡县',
            'level': 3,
            'pvalue': 411700000000
          },
          {
            'value': 411723000000,
            'text': '平舆县',
            'level': 3,
            'pvalue': 411700000000
          },
          {
            'value': 411724000000,
            'text': '正阳县',
            'level': 3,
            'pvalue': 411700000000
          },
          {
            'value': 411725000000,
            'text': '确山县',
            'level': 3,
            'pvalue': 411700000000
          },
          {
            'value': 411726000000,
            'text': '泌阳县',
            'level': 3,
            'pvalue': 411700000000
          },
          {
            'value': 411727000000,
            'text': '汝南县',
            'level': 3,
            'pvalue': 411700000000
          },
          {
            'value': 411728000000,
            'text': '遂平县',
            'level': 3,
            'pvalue': 411700000000
          },
          {
            'value': 411729000000,
            'text': '新蔡县',
            'level': 3,
            'pvalue': 411700000000
          },
          {
            'value': 411771000000,
            'text': '河南驻马店经济开发区',
            'level': 3,
            'pvalue': 411700000000
          }
        ]
      },
      {
        'value': 419000000000,
        'text': '省直辖县级行政区划',
        'level': 2,
        'pvalue': 410000000000,
        'children': [
          {
            'value': 419001000000,
            'text': '济源市',
            'level': 3,
            'pvalue': 419000000000
          }
        ]
      }
    ]
  },
  {
    'value': 420000000000,
    'text': '湖北省',
    'level': 1,
    'pvalue': 0,
    'children': [
      {
        'value': 420100000000,
        'text': '武汉市',
        'level': 2,
        'pvalue': 420000000000,
        'children': [
          {
            'value': 420101000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 420100000000
          },
          {
            'value': 420102000000,
            'text': '江岸区',
            'level': 3,
            'pvalue': 420100000000
          },
          {
            'value': 420103000000,
            'text': '江汉区',
            'level': 3,
            'pvalue': 420100000000
          },
          {
            'value': 420104000000,
            'text': '硚口区',
            'level': 3,
            'pvalue': 420100000000
          },
          {
            'value': 420105000000,
            'text': '汉阳区',
            'level': 3,
            'pvalue': 420100000000
          },
          {
            'value': 420106000000,
            'text': '武昌区',
            'level': 3,
            'pvalue': 420100000000
          },
          {
            'value': 420107000000,
            'text': '青山区',
            'level': 3,
            'pvalue': 420100000000
          },
          {
            'value': 420111000000,
            'text': '洪山区',
            'level': 3,
            'pvalue': 420100000000
          },
          {
            'value': 420112000000,
            'text': '东西湖区',
            'level': 3,
            'pvalue': 420100000000
          },
          {
            'value': 420113000000,
            'text': '汉南区',
            'level': 3,
            'pvalue': 420100000000
          },
          {
            'value': 420114000000,
            'text': '蔡甸区',
            'level': 3,
            'pvalue': 420100000000
          },
          {
            'value': 420115000000,
            'text': '江夏区',
            'level': 3,
            'pvalue': 420100000000
          },
          {
            'value': 420116000000,
            'text': '黄陂区',
            'level': 3,
            'pvalue': 420100000000
          },
          {
            'value': 420117000000,
            'text': '新洲区',
            'level': 3,
            'pvalue': 420100000000
          }
        ]
      },
      {
        'value': 420200000000,
        'text': '黄石市',
        'level': 2,
        'pvalue': 420000000000,
        'children': [
          {
            'value': 420201000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 420200000000
          },
          {
            'value': 420202000000,
            'text': '黄石港区',
            'level': 3,
            'pvalue': 420200000000
          },
          {
            'value': 420203000000,
            'text': '西塞山区',
            'level': 3,
            'pvalue': 420200000000
          },
          {
            'value': 420204000000,
            'text': '下陆区',
            'level': 3,
            'pvalue': 420200000000
          },
          {
            'value': 420205000000,
            'text': '铁山区',
            'level': 3,
            'pvalue': 420200000000
          },
          {
            'value': 420222000000,
            'text': '阳新县',
            'level': 3,
            'pvalue': 420200000000
          },
          {
            'value': 420281000000,
            'text': '大冶市',
            'level': 3,
            'pvalue': 420200000000
          }
        ]
      },
      {
        'value': 420300000000,
        'text': '十堰市',
        'level': 2,
        'pvalue': 420000000000,
        'children': [
          {
            'value': 420301000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 420300000000
          },
          {
            'value': 420302000000,
            'text': '茅箭区',
            'level': 3,
            'pvalue': 420300000000
          },
          {
            'value': 420303000000,
            'text': '张湾区',
            'level': 3,
            'pvalue': 420300000000
          },
          {
            'value': 420304000000,
            'text': '郧阳区',
            'level': 3,
            'pvalue': 420300000000
          },
          {
            'value': 420322000000,
            'text': '郧西县',
            'level': 3,
            'pvalue': 420300000000
          },
          {
            'value': 420323000000,
            'text': '竹山县',
            'level': 3,
            'pvalue': 420300000000
          },
          {
            'value': 420324000000,
            'text': '竹溪县',
            'level': 3,
            'pvalue': 420300000000
          },
          {
            'value': 420325000000,
            'text': '房县',
            'level': 3,
            'pvalue': 420300000000
          },
          {
            'value': 420381000000,
            'text': '丹江口市',
            'level': 3,
            'pvalue': 420300000000
          }
        ]
      },
      {
        'value': 420500000000,
        'text': '宜昌市',
        'level': 2,
        'pvalue': 420000000000,
        'children': [
          {
            'value': 420501000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 420500000000
          },
          {
            'value': 420502000000,
            'text': '西陵区',
            'level': 3,
            'pvalue': 420500000000
          },
          {
            'value': 420503000000,
            'text': '伍家岗区',
            'level': 3,
            'pvalue': 420500000000
          },
          {
            'value': 420504000000,
            'text': '点军区',
            'level': 3,
            'pvalue': 420500000000
          },
          {
            'value': 420505000000,
            'text': '猇亭区',
            'level': 3,
            'pvalue': 420500000000
          },
          {
            'value': 420506000000,
            'text': '夷陵区',
            'level': 3,
            'pvalue': 420500000000
          },
          {
            'value': 420525000000,
            'text': '远安县',
            'level': 3,
            'pvalue': 420500000000
          },
          {
            'value': 420526000000,
            'text': '兴山县',
            'level': 3,
            'pvalue': 420500000000
          },
          {
            'value': 420527000000,
            'text': '秭归县',
            'level': 3,
            'pvalue': 420500000000
          },
          {
            'value': 420528000000,
            'text': '长阳土家族自治县',
            'level': 3,
            'pvalue': 420500000000
          },
          {
            'value': 420529000000,
            'text': '五峰土家族自治县',
            'level': 3,
            'pvalue': 420500000000
          },
          {
            'value': 420581000000,
            'text': '宜都市',
            'level': 3,
            'pvalue': 420500000000
          },
          {
            'value': 420582000000,
            'text': '当阳市',
            'level': 3,
            'pvalue': 420500000000
          },
          {
            'value': 420583000000,
            'text': '枝江市',
            'level': 3,
            'pvalue': 420500000000
          }
        ]
      },
      {
        'value': 420600000000,
        'text': '襄阳市',
        'level': 2,
        'pvalue': 420000000000,
        'children': [
          {
            'value': 420601000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 420600000000
          },
          {
            'value': 420602000000,
            'text': '襄城区',
            'level': 3,
            'pvalue': 420600000000
          },
          {
            'value': 420606000000,
            'text': '樊城区',
            'level': 3,
            'pvalue': 420600000000
          },
          {
            'value': 420607000000,
            'text': '襄州区',
            'level': 3,
            'pvalue': 420600000000
          },
          {
            'value': 420624000000,
            'text': '南漳县',
            'level': 3,
            'pvalue': 420600000000
          },
          {
            'value': 420625000000,
            'text': '谷城县',
            'level': 3,
            'pvalue': 420600000000
          },
          {
            'value': 420626000000,
            'text': '保康县',
            'level': 3,
            'pvalue': 420600000000
          },
          {
            'value': 420682000000,
            'text': '老河口市',
            'level': 3,
            'pvalue': 420600000000
          },
          {
            'value': 420683000000,
            'text': '枣阳市',
            'level': 3,
            'pvalue': 420600000000
          },
          {
            'value': 420684000000,
            'text': '宜城市',
            'level': 3,
            'pvalue': 420600000000
          }
        ]
      },
      {
        'value': 420700000000,
        'text': '鄂州市',
        'level': 2,
        'pvalue': 420000000000,
        'children': [
          {
            'value': 420701000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 420700000000
          },
          {
            'value': 420702000000,
            'text': '梁子湖区',
            'level': 3,
            'pvalue': 420700000000
          },
          {
            'value': 420703000000,
            'text': '华容区',
            'level': 3,
            'pvalue': 420700000000
          },
          {
            'value': 420704000000,
            'text': '鄂城区',
            'level': 3,
            'pvalue': 420700000000
          }
        ]
      },
      {
        'value': 420800000000,
        'text': '荆门市',
        'level': 2,
        'pvalue': 420000000000,
        'children': [
          {
            'value': 420801000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 420800000000
          },
          {
            'value': 420802000000,
            'text': '东宝区',
            'level': 3,
            'pvalue': 420800000000
          },
          {
            'value': 420804000000,
            'text': '掇刀区',
            'level': 3,
            'pvalue': 420800000000
          },
          {
            'value': 420822000000,
            'text': '沙洋县',
            'level': 3,
            'pvalue': 420800000000
          },
          {
            'value': 420881000000,
            'text': '钟祥市',
            'level': 3,
            'pvalue': 420800000000
          },
          {
            'value': 420882000000,
            'text': '京山市',
            'level': 3,
            'pvalue': 420800000000
          }
        ]
      },
      {
        'value': 420900000000,
        'text': '孝感市',
        'level': 2,
        'pvalue': 420000000000,
        'children': [
          {
            'value': 420901000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 420900000000
          },
          {
            'value': 420902000000,
            'text': '孝南区',
            'level': 3,
            'pvalue': 420900000000
          },
          {
            'value': 420921000000,
            'text': '孝昌县',
            'level': 3,
            'pvalue': 420900000000
          },
          {
            'value': 420922000000,
            'text': '大悟县',
            'level': 3,
            'pvalue': 420900000000
          },
          {
            'value': 420923000000,
            'text': '云梦县',
            'level': 3,
            'pvalue': 420900000000
          },
          {
            'value': 420981000000,
            'text': '应城市',
            'level': 3,
            'pvalue': 420900000000
          },
          {
            'value': 420982000000,
            'text': '安陆市',
            'level': 3,
            'pvalue': 420900000000
          },
          {
            'value': 420984000000,
            'text': '汉川市',
            'level': 3,
            'pvalue': 420900000000
          }
        ]
      },
      {
        'value': 421000000000,
        'text': '荆州市',
        'level': 2,
        'pvalue': 420000000000,
        'children': [
          {
            'value': 421001000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 421000000000
          },
          {
            'value': 421002000000,
            'text': '沙市区',
            'level': 3,
            'pvalue': 421000000000
          },
          {
            'value': 421003000000,
            'text': '荆州区',
            'level': 3,
            'pvalue': 421000000000
          },
          {
            'value': 421022000000,
            'text': '公安县',
            'level': 3,
            'pvalue': 421000000000
          },
          {
            'value': 421024000000,
            'text': '江陵县',
            'level': 3,
            'pvalue': 421000000000
          },
          {
            'value': 421071000000,
            'text': '荆州经济技术开发区',
            'level': 3,
            'pvalue': 421000000000
          },
          {
            'value': 421081000000,
            'text': '石首市',
            'level': 3,
            'pvalue': 421000000000
          },
          {
            'value': 421083000000,
            'text': '洪湖市',
            'level': 3,
            'pvalue': 421000000000
          },
          {
            'value': 421087000000,
            'text': '松滋市',
            'level': 3,
            'pvalue': 421000000000
          },
          {
            'value': 421088000000,
            'text': '监利市',
            'level': 3,
            'pvalue': 421000000000
          }
        ]
      },
      {
        'value': 421100000000,
        'text': '黄冈市',
        'level': 2,
        'pvalue': 420000000000,
        'children': [
          {
            'value': 421101000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 421100000000
          },
          {
            'value': 421102000000,
            'text': '黄州区',
            'level': 3,
            'pvalue': 421100000000
          },
          {
            'value': 421121000000,
            'text': '团风县',
            'level': 3,
            'pvalue': 421100000000
          },
          {
            'value': 421122000000,
            'text': '红安县',
            'level': 3,
            'pvalue': 421100000000
          },
          {
            'value': 421123000000,
            'text': '罗田县',
            'level': 3,
            'pvalue': 421100000000
          },
          {
            'value': 421124000000,
            'text': '英山县',
            'level': 3,
            'pvalue': 421100000000
          },
          {
            'value': 421125000000,
            'text': '浠水县',
            'level': 3,
            'pvalue': 421100000000
          },
          {
            'value': 421126000000,
            'text': '蕲春县',
            'level': 3,
            'pvalue': 421100000000
          },
          {
            'value': 421127000000,
            'text': '黄梅县',
            'level': 3,
            'pvalue': 421100000000
          },
          {
            'value': 421171000000,
            'text': '龙感湖管理区',
            'level': 3,
            'pvalue': 421100000000
          },
          {
            'value': 421181000000,
            'text': '麻城市',
            'level': 3,
            'pvalue': 421100000000
          },
          {
            'value': 421182000000,
            'text': '武穴市',
            'level': 3,
            'pvalue': 421100000000
          }
        ]
      },
      {
        'value': 421200000000,
        'text': '咸宁市',
        'level': 2,
        'pvalue': 420000000000,
        'children': [
          {
            'value': 421201000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 421200000000
          },
          {
            'value': 421202000000,
            'text': '咸安区',
            'level': 3,
            'pvalue': 421200000000
          },
          {
            'value': 421221000000,
            'text': '嘉鱼县',
            'level': 3,
            'pvalue': 421200000000
          },
          {
            'value': 421222000000,
            'text': '通城县',
            'level': 3,
            'pvalue': 421200000000
          },
          {
            'value': 421223000000,
            'text': '崇阳县',
            'level': 3,
            'pvalue': 421200000000
          },
          {
            'value': 421224000000,
            'text': '通山县',
            'level': 3,
            'pvalue': 421200000000
          },
          {
            'value': 421281000000,
            'text': '赤壁市',
            'level': 3,
            'pvalue': 421200000000
          }
        ]
      },
      {
        'value': 421300000000,
        'text': '随州市',
        'level': 2,
        'pvalue': 420000000000,
        'children': [
          {
            'value': 421301000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 421300000000
          },
          {
            'value': 421303000000,
            'text': '曾都区',
            'level': 3,
            'pvalue': 421300000000
          },
          {
            'value': 421321000000,
            'text': '随县',
            'level': 3,
            'pvalue': 421300000000
          },
          {
            'value': 421381000000,
            'text': '广水市',
            'level': 3,
            'pvalue': 421300000000
          }
        ]
      },
      {
        'value': 422800000000,
        'text': '恩施土家族苗族自治州',
        'level': 2,
        'pvalue': 420000000000,
        'children': [
          {
            'value': 422801000000,
            'text': '恩施市',
            'level': 3,
            'pvalue': 422800000000
          },
          {
            'value': 422802000000,
            'text': '利川市',
            'level': 3,
            'pvalue': 422800000000
          },
          {
            'value': 422822000000,
            'text': '建始县',
            'level': 3,
            'pvalue': 422800000000
          },
          {
            'value': 422823000000,
            'text': '巴东县',
            'level': 3,
            'pvalue': 422800000000
          },
          {
            'value': 422825000000,
            'text': '宣恩县',
            'level': 3,
            'pvalue': 422800000000
          },
          {
            'value': 422826000000,
            'text': '咸丰县',
            'level': 3,
            'pvalue': 422800000000
          },
          {
            'value': 422827000000,
            'text': '来凤县',
            'level': 3,
            'pvalue': 422800000000
          },
          {
            'value': 422828000000,
            'text': '鹤峰县',
            'level': 3,
            'pvalue': 422800000000
          }
        ]
      },
      {
        'value': 429000000000,
        'text': '省直辖县级行政区划',
        'level': 2,
        'pvalue': 420000000000,
        'children': [
          {
            'value': 429004000000,
            'text': '仙桃市',
            'level': 3,
            'pvalue': 429000000000
          },
          {
            'value': 429005000000,
            'text': '潜江市',
            'level': 3,
            'pvalue': 429000000000
          },
          {
            'value': 429006000000,
            'text': '天门市',
            'level': 3,
            'pvalue': 429000000000
          },
          {
            'value': 429021000000,
            'text': '神农架林区',
            'level': 3,
            'pvalue': 429000000000
          }
        ]
      }
    ]
  },
  {
    'value': 430000000000,
    'text': '湖南省',
    'level': 1,
    'pvalue': 0,
    'children': [
      {
        'value': 430100000000,
        'text': '长沙市',
        'level': 2,
        'pvalue': 430000000000,
        'children': [
          {
            'value': 430101000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 430100000000
          },
          {
            'value': 430102000000,
            'text': '芙蓉区',
            'level': 3,
            'pvalue': 430100000000
          },
          {
            'value': 430103000000,
            'text': '天心区',
            'level': 3,
            'pvalue': 430100000000
          },
          {
            'value': 430104000000,
            'text': '岳麓区',
            'level': 3,
            'pvalue': 430100000000
          },
          {
            'value': 430105000000,
            'text': '开福区',
            'level': 3,
            'pvalue': 430100000000
          },
          {
            'value': 430111000000,
            'text': '雨花区',
            'level': 3,
            'pvalue': 430100000000
          },
          {
            'value': 430112000000,
            'text': '望城区',
            'level': 3,
            'pvalue': 430100000000
          },
          {
            'value': 430121000000,
            'text': '长沙县',
            'level': 3,
            'pvalue': 430100000000
          },
          {
            'value': 430181000000,
            'text': '浏阳市',
            'level': 3,
            'pvalue': 430100000000
          },
          {
            'value': 430182000000,
            'text': '宁乡市',
            'level': 3,
            'pvalue': 430100000000
          }
        ]
      },
      {
        'value': 430200000000,
        'text': '株洲市',
        'level': 2,
        'pvalue': 430000000000,
        'children': [
          {
            'value': 430201000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 430200000000
          },
          {
            'value': 430202000000,
            'text': '荷塘区',
            'level': 3,
            'pvalue': 430200000000
          },
          {
            'value': 430203000000,
            'text': '芦淞区',
            'level': 3,
            'pvalue': 430200000000
          },
          {
            'value': 430204000000,
            'text': '石峰区',
            'level': 3,
            'pvalue': 430200000000
          },
          {
            'value': 430211000000,
            'text': '天元区',
            'level': 3,
            'pvalue': 430200000000
          },
          {
            'value': 430212000000,
            'text': '渌口区',
            'level': 3,
            'pvalue': 430200000000
          },
          {
            'value': 430223000000,
            'text': '攸县',
            'level': 3,
            'pvalue': 430200000000
          },
          {
            'value': 430224000000,
            'text': '茶陵县',
            'level': 3,
            'pvalue': 430200000000
          },
          {
            'value': 430225000000,
            'text': '炎陵县',
            'level': 3,
            'pvalue': 430200000000
          },
          {
            'value': 430271000000,
            'text': '云龙示范区',
            'level': 3,
            'pvalue': 430200000000
          },
          {
            'value': 430281000000,
            'text': '醴陵市',
            'level': 3,
            'pvalue': 430200000000
          }
        ]
      },
      {
        'value': 430300000000,
        'text': '湘潭市',
        'level': 2,
        'pvalue': 430000000000,
        'children': [
          {
            'value': 430301000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 430300000000
          },
          {
            'value': 430302000000,
            'text': '雨湖区',
            'level': 3,
            'pvalue': 430300000000
          },
          {
            'value': 430304000000,
            'text': '岳塘区',
            'level': 3,
            'pvalue': 430300000000
          },
          {
            'value': 430321000000,
            'text': '湘潭县',
            'level': 3,
            'pvalue': 430300000000
          },
          {
            'value': 430371000000,
            'text': '湖南湘潭高新技术产业园区',
            'level': 3,
            'pvalue': 430300000000
          },
          {
            'value': 430372000000,
            'text': '湘潭昭山示范区',
            'level': 3,
            'pvalue': 430300000000
          },
          {
            'value': 430373000000,
            'text': '湘潭九华示范区',
            'level': 3,
            'pvalue': 430300000000
          },
          {
            'value': 430381000000,
            'text': '湘乡市',
            'level': 3,
            'pvalue': 430300000000
          },
          {
            'value': 430382000000,
            'text': '韶山市',
            'level': 3,
            'pvalue': 430300000000
          }
        ]
      },
      {
        'value': 430400000000,
        'text': '衡阳市',
        'level': 2,
        'pvalue': 430000000000,
        'children': [
          {
            'value': 430401000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 430400000000
          },
          {
            'value': 430405000000,
            'text': '珠晖区',
            'level': 3,
            'pvalue': 430400000000
          },
          {
            'value': 430406000000,
            'text': '雁峰区',
            'level': 3,
            'pvalue': 430400000000
          },
          {
            'value': 430407000000,
            'text': '石鼓区',
            'level': 3,
            'pvalue': 430400000000
          },
          {
            'value': 430408000000,
            'text': '蒸湘区',
            'level': 3,
            'pvalue': 430400000000
          },
          {
            'value': 430412000000,
            'text': '南岳区',
            'level': 3,
            'pvalue': 430400000000
          },
          {
            'value': 430421000000,
            'text': '衡阳县',
            'level': 3,
            'pvalue': 430400000000
          },
          {
            'value': 430422000000,
            'text': '衡南县',
            'level': 3,
            'pvalue': 430400000000
          },
          {
            'value': 430423000000,
            'text': '衡山县',
            'level': 3,
            'pvalue': 430400000000
          },
          {
            'value': 430424000000,
            'text': '衡东县',
            'level': 3,
            'pvalue': 430400000000
          },
          {
            'value': 430426000000,
            'text': '祁东县',
            'level': 3,
            'pvalue': 430400000000
          },
          {
            'value': 430471000000,
            'text': '衡阳综合保税区',
            'level': 3,
            'pvalue': 430400000000
          },
          {
            'value': 430472000000,
            'text': '湖南衡阳高新技术产业园区',
            'level': 3,
            'pvalue': 430400000000
          },
          {
            'value': 430473000000,
            'text': '湖南衡阳松木经济开发区',
            'level': 3,
            'pvalue': 430400000000
          },
          {
            'value': 430481000000,
            'text': '耒阳市',
            'level': 3,
            'pvalue': 430400000000
          },
          {
            'value': 430482000000,
            'text': '常宁市',
            'level': 3,
            'pvalue': 430400000000
          }
        ]
      },
      {
        'value': 430500000000,
        'text': '邵阳市',
        'level': 2,
        'pvalue': 430000000000,
        'children': [
          {
            'value': 430501000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 430500000000
          },
          {
            'value': 430502000000,
            'text': '双清区',
            'level': 3,
            'pvalue': 430500000000
          },
          {
            'value': 430503000000,
            'text': '大祥区',
            'level': 3,
            'pvalue': 430500000000
          },
          {
            'value': 430511000000,
            'text': '北塔区',
            'level': 3,
            'pvalue': 430500000000
          },
          {
            'value': 430522000000,
            'text': '新邵县',
            'level': 3,
            'pvalue': 430500000000
          },
          {
            'value': 430523000000,
            'text': '邵阳县',
            'level': 3,
            'pvalue': 430500000000
          },
          {
            'value': 430524000000,
            'text': '隆回县',
            'level': 3,
            'pvalue': 430500000000
          },
          {
            'value': 430525000000,
            'text': '洞口县',
            'level': 3,
            'pvalue': 430500000000
          },
          {
            'value': 430527000000,
            'text': '绥宁县',
            'level': 3,
            'pvalue': 430500000000
          },
          {
            'value': 430528000000,
            'text': '新宁县',
            'level': 3,
            'pvalue': 430500000000
          },
          {
            'value': 430529000000,
            'text': '城步苗族自治县',
            'level': 3,
            'pvalue': 430500000000
          },
          {
            'value': 430581000000,
            'text': '武冈市',
            'level': 3,
            'pvalue': 430500000000
          },
          {
            'value': 430582000000,
            'text': '邵东市',
            'level': 3,
            'pvalue': 430500000000
          }
        ]
      },
      {
        'value': 430600000000,
        'text': '岳阳市',
        'level': 2,
        'pvalue': 430000000000,
        'children': [
          {
            'value': 430601000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 430600000000
          },
          {
            'value': 430602000000,
            'text': '岳阳楼区',
            'level': 3,
            'pvalue': 430600000000
          },
          {
            'value': 430603000000,
            'text': '云溪区',
            'level': 3,
            'pvalue': 430600000000
          },
          {
            'value': 430611000000,
            'text': '君山区',
            'level': 3,
            'pvalue': 430600000000
          },
          {
            'value': 430621000000,
            'text': '岳阳县',
            'level': 3,
            'pvalue': 430600000000
          },
          {
            'value': 430623000000,
            'text': '华容县',
            'level': 3,
            'pvalue': 430600000000
          },
          {
            'value': 430624000000,
            'text': '湘阴县',
            'level': 3,
            'pvalue': 430600000000
          },
          {
            'value': 430626000000,
            'text': '平江县',
            'level': 3,
            'pvalue': 430600000000
          },
          {
            'value': 430671000000,
            'text': '岳阳市屈原管理区',
            'level': 3,
            'pvalue': 430600000000
          },
          {
            'value': 430681000000,
            'text': '汨罗市',
            'level': 3,
            'pvalue': 430600000000
          },
          {
            'value': 430682000000,
            'text': '临湘市',
            'level': 3,
            'pvalue': 430600000000
          }
        ]
      },
      {
        'value': 430700000000,
        'text': '常德市',
        'level': 2,
        'pvalue': 430000000000,
        'children': [
          {
            'value': 430701000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 430700000000
          },
          {
            'value': 430702000000,
            'text': '武陵区',
            'level': 3,
            'pvalue': 430700000000
          },
          {
            'value': 430703000000,
            'text': '鼎城区',
            'level': 3,
            'pvalue': 430700000000
          },
          {
            'value': 430721000000,
            'text': '安乡县',
            'level': 3,
            'pvalue': 430700000000
          },
          {
            'value': 430722000000,
            'text': '汉寿县',
            'level': 3,
            'pvalue': 430700000000
          },
          {
            'value': 430723000000,
            'text': '澧县',
            'level': 3,
            'pvalue': 430700000000
          },
          {
            'value': 430724000000,
            'text': '临澧县',
            'level': 3,
            'pvalue': 430700000000
          },
          {
            'value': 430725000000,
            'text': '桃源县',
            'level': 3,
            'pvalue': 430700000000
          },
          {
            'value': 430726000000,
            'text': '石门县',
            'level': 3,
            'pvalue': 430700000000
          },
          {
            'value': 430771000000,
            'text': '常德市西洞庭管理区',
            'level': 3,
            'pvalue': 430700000000
          },
          {
            'value': 430781000000,
            'text': '津市市',
            'level': 3,
            'pvalue': 430700000000
          }
        ]
      },
      {
        'value': 430800000000,
        'text': '张家界市',
        'level': 2,
        'pvalue': 430000000000,
        'children': [
          {
            'value': 430801000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 430800000000
          },
          {
            'value': 430802000000,
            'text': '永定区',
            'level': 3,
            'pvalue': 430800000000
          },
          {
            'value': 430811000000,
            'text': '武陵源区',
            'level': 3,
            'pvalue': 430800000000
          },
          {
            'value': 430821000000,
            'text': '慈利县',
            'level': 3,
            'pvalue': 430800000000
          },
          {
            'value': 430822000000,
            'text': '桑植县',
            'level': 3,
            'pvalue': 430800000000
          }
        ]
      },
      {
        'value': 430900000000,
        'text': '益阳市',
        'level': 2,
        'pvalue': 430000000000,
        'children': [
          {
            'value': 430901000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 430900000000
          },
          {
            'value': 430902000000,
            'text': '资阳区',
            'level': 3,
            'pvalue': 430900000000
          },
          {
            'value': 430903000000,
            'text': '赫山区',
            'level': 3,
            'pvalue': 430900000000
          },
          {
            'value': 430921000000,
            'text': '南县',
            'level': 3,
            'pvalue': 430900000000
          },
          {
            'value': 430922000000,
            'text': '桃江县',
            'level': 3,
            'pvalue': 430900000000
          },
          {
            'value': 430923000000,
            'text': '安化县',
            'level': 3,
            'pvalue': 430900000000
          },
          {
            'value': 430971000000,
            'text': '益阳市大通湖管理区',
            'level': 3,
            'pvalue': 430900000000
          },
          {
            'value': 430972000000,
            'text': '湖南益阳高新技术产业园区',
            'level': 3,
            'pvalue': 430900000000
          },
          {
            'value': 430981000000,
            'text': '沅江市',
            'level': 3,
            'pvalue': 430900000000
          }
        ]
      },
      {
        'value': 431000000000,
        'text': '郴州市',
        'level': 2,
        'pvalue': 430000000000,
        'children': [
          {
            'value': 431001000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 431000000000
          },
          {
            'value': 431002000000,
            'text': '北湖区',
            'level': 3,
            'pvalue': 431000000000
          },
          {
            'value': 431003000000,
            'text': '苏仙区',
            'level': 3,
            'pvalue': 431000000000
          },
          {
            'value': 431021000000,
            'text': '桂阳县',
            'level': 3,
            'pvalue': 431000000000
          },
          {
            'value': 431022000000,
            'text': '宜章县',
            'level': 3,
            'pvalue': 431000000000
          },
          {
            'value': 431023000000,
            'text': '永兴县',
            'level': 3,
            'pvalue': 431000000000
          },
          {
            'value': 431024000000,
            'text': '嘉禾县',
            'level': 3,
            'pvalue': 431000000000
          },
          {
            'value': 431025000000,
            'text': '临武县',
            'level': 3,
            'pvalue': 431000000000
          },
          {
            'value': 431026000000,
            'text': '汝城县',
            'level': 3,
            'pvalue': 431000000000
          },
          {
            'value': 431027000000,
            'text': '桂东县',
            'level': 3,
            'pvalue': 431000000000
          },
          {
            'value': 431028000000,
            'text': '安仁县',
            'level': 3,
            'pvalue': 431000000000
          },
          {
            'value': 431081000000,
            'text': '资兴市',
            'level': 3,
            'pvalue': 431000000000
          }
        ]
      },
      {
        'value': 431100000000,
        'text': '永州市',
        'level': 2,
        'pvalue': 430000000000,
        'children': [
          {
            'value': 431101000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 431100000000
          },
          {
            'value': 431102000000,
            'text': '零陵区',
            'level': 3,
            'pvalue': 431100000000
          },
          {
            'value': 431103000000,
            'text': '冷水滩区',
            'level': 3,
            'pvalue': 431100000000
          },
          {
            'value': 431122000000,
            'text': '东安县',
            'level': 3,
            'pvalue': 431100000000
          },
          {
            'value': 431123000000,
            'text': '双牌县',
            'level': 3,
            'pvalue': 431100000000
          },
          {
            'value': 431124000000,
            'text': '道县',
            'level': 3,
            'pvalue': 431100000000
          },
          {
            'value': 431125000000,
            'text': '江永县',
            'level': 3,
            'pvalue': 431100000000
          },
          {
            'value': 431126000000,
            'text': '宁远县',
            'level': 3,
            'pvalue': 431100000000
          },
          {
            'value': 431127000000,
            'text': '蓝山县',
            'level': 3,
            'pvalue': 431100000000
          },
          {
            'value': 431128000000,
            'text': '新田县',
            'level': 3,
            'pvalue': 431100000000
          },
          {
            'value': 431129000000,
            'text': '江华瑶族自治县',
            'level': 3,
            'pvalue': 431100000000
          },
          {
            'value': 431171000000,
            'text': '永州经济技术开发区',
            'level': 3,
            'pvalue': 431100000000
          },
          {
            'value': 431173000000,
            'text': '永州市回龙圩管理区',
            'level': 3,
            'pvalue': 431100000000
          },
          {
            'value': 431181000000,
            'text': '祁阳市',
            'level': 3,
            'pvalue': 431100000000
          }
        ]
      },
      {
        'value': 431200000000,
        'text': '怀化市',
        'level': 2,
        'pvalue': 430000000000,
        'children': [
          {
            'value': 431201000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 431200000000
          },
          {
            'value': 431202000000,
            'text': '鹤城区',
            'level': 3,
            'pvalue': 431200000000
          },
          {
            'value': 431221000000,
            'text': '中方县',
            'level': 3,
            'pvalue': 431200000000
          },
          {
            'value': 431222000000,
            'text': '沅陵县',
            'level': 3,
            'pvalue': 431200000000
          },
          {
            'value': 431223000000,
            'text': '辰溪县',
            'level': 3,
            'pvalue': 431200000000
          },
          {
            'value': 431224000000,
            'text': '溆浦县',
            'level': 3,
            'pvalue': 431200000000
          },
          {
            'value': 431225000000,
            'text': '会同县',
            'level': 3,
            'pvalue': 431200000000
          },
          {
            'value': 431226000000,
            'text': '麻阳苗族自治县',
            'level': 3,
            'pvalue': 431200000000
          },
          {
            'value': 431227000000,
            'text': '新晃侗族自治县',
            'level': 3,
            'pvalue': 431200000000
          },
          {
            'value': 431228000000,
            'text': '芷江侗族自治县',
            'level': 3,
            'pvalue': 431200000000
          },
          {
            'value': 431229000000,
            'text': '靖州苗族侗族自治县',
            'level': 3,
            'pvalue': 431200000000
          },
          {
            'value': 431230000000,
            'text': '通道侗族自治县',
            'level': 3,
            'pvalue': 431200000000
          },
          {
            'value': 431271000000,
            'text': '怀化市洪江管理区',
            'level': 3,
            'pvalue': 431200000000
          },
          {
            'value': 431281000000,
            'text': '洪江市',
            'level': 3,
            'pvalue': 431200000000
          }
        ]
      },
      {
        'value': 431300000000,
        'text': '娄底市',
        'level': 2,
        'pvalue': 430000000000,
        'children': [
          {
            'value': 431301000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 431300000000
          },
          {
            'value': 431302000000,
            'text': '娄星区',
            'level': 3,
            'pvalue': 431300000000
          },
          {
            'value': 431321000000,
            'text': '双峰县',
            'level': 3,
            'pvalue': 431300000000
          },
          {
            'value': 431322000000,
            'text': '新化县',
            'level': 3,
            'pvalue': 431300000000
          },
          {
            'value': 431381000000,
            'text': '冷水江市',
            'level': 3,
            'pvalue': 431300000000
          },
          {
            'value': 431382000000,
            'text': '涟源市',
            'level': 3,
            'pvalue': 431300000000
          }
        ]
      },
      {
        'value': 433100000000,
        'text': '湘西土家族苗族自治州',
        'level': 2,
        'pvalue': 430000000000,
        'children': [
          {
            'value': 433101000000,
            'text': '吉首市',
            'level': 3,
            'pvalue': 433100000000
          },
          {
            'value': 433122000000,
            'text': '泸溪县',
            'level': 3,
            'pvalue': 433100000000
          },
          {
            'value': 433123000000,
            'text': '凤凰县',
            'level': 3,
            'pvalue': 433100000000
          },
          {
            'value': 433124000000,
            'text': '花垣县',
            'level': 3,
            'pvalue': 433100000000
          },
          {
            'value': 433125000000,
            'text': '保靖县',
            'level': 3,
            'pvalue': 433100000000
          },
          {
            'value': 433126000000,
            'text': '古丈县',
            'level': 3,
            'pvalue': 433100000000
          },
          {
            'value': 433127000000,
            'text': '永顺县',
            'level': 3,
            'pvalue': 433100000000
          },
          {
            'value': 433130000000,
            'text': '龙山县',
            'level': 3,
            'pvalue': 433100000000
          }
        ]
      }
    ]
  },
  {
    'value': 440000000000,
    'text': '广东省',
    'level': 1,
    'pvalue': 0,
    'children': [
      {
        'value': 440100000000,
        'text': '广州市',
        'level': 2,
        'pvalue': 440000000000,
        'children': [
          {
            'value': 440101000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 440100000000
          },
          {
            'value': 440103000000,
            'text': '荔湾区',
            'level': 3,
            'pvalue': 440100000000
          },
          {
            'value': 440104000000,
            'text': '越秀区',
            'level': 3,
            'pvalue': 440100000000
          },
          {
            'value': 440105000000,
            'text': '海珠区',
            'level': 3,
            'pvalue': 440100000000
          },
          {
            'value': 440106000000,
            'text': '天河区',
            'level': 3,
            'pvalue': 440100000000
          },
          {
            'value': 440111000000,
            'text': '白云区',
            'level': 3,
            'pvalue': 440100000000
          },
          {
            'value': 440112000000,
            'text': '黄埔区',
            'level': 3,
            'pvalue': 440100000000
          },
          {
            'value': 440113000000,
            'text': '番禺区',
            'level': 3,
            'pvalue': 440100000000
          },
          {
            'value': 440114000000,
            'text': '花都区',
            'level': 3,
            'pvalue': 440100000000
          },
          {
            'value': 440115000000,
            'text': '南沙区',
            'level': 3,
            'pvalue': 440100000000
          },
          {
            'value': 440117000000,
            'text': '从化区',
            'level': 3,
            'pvalue': 440100000000
          },
          {
            'value': 440118000000,
            'text': '增城区',
            'level': 3,
            'pvalue': 440100000000
          }
        ]
      },
      {
        'value': 440200000000,
        'text': '韶关市',
        'level': 2,
        'pvalue': 440000000000,
        'children': [
          {
            'value': 440201000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 440200000000
          },
          {
            'value': 440203000000,
            'text': '武江区',
            'level': 3,
            'pvalue': 440200000000
          },
          {
            'value': 440204000000,
            'text': '浈江区',
            'level': 3,
            'pvalue': 440200000000
          },
          {
            'value': 440205000000,
            'text': '曲江区',
            'level': 3,
            'pvalue': 440200000000
          },
          {
            'value': 440222000000,
            'text': '始兴县',
            'level': 3,
            'pvalue': 440200000000
          },
          {
            'value': 440224000000,
            'text': '仁化县',
            'level': 3,
            'pvalue': 440200000000
          },
          {
            'value': 440229000000,
            'text': '翁源县',
            'level': 3,
            'pvalue': 440200000000
          },
          {
            'value': 440232000000,
            'text': '乳源瑶族自治县',
            'level': 3,
            'pvalue': 440200000000
          },
          {
            'value': 440233000000,
            'text': '新丰县',
            'level': 3,
            'pvalue': 440200000000
          },
          {
            'value': 440281000000,
            'text': '乐昌市',
            'level': 3,
            'pvalue': 440200000000
          },
          {
            'value': 440282000000,
            'text': '南雄市',
            'level': 3,
            'pvalue': 440200000000
          }
        ]
      },
      {
        'value': 440300000000,
        'text': '深圳市',
        'level': 2,
        'pvalue': 440000000000,
        'children': [
          {
            'value': 440301000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 440300000000
          },
          {
            'value': 440303000000,
            'text': '罗湖区',
            'level': 3,
            'pvalue': 440300000000
          },
          {
            'value': 440304000000,
            'text': '福田区',
            'level': 3,
            'pvalue': 440300000000
          },
          {
            'value': 440305000000,
            'text': '南山区',
            'level': 3,
            'pvalue': 440300000000
          },
          {
            'value': 440306000000,
            'text': '宝安区',
            'level': 3,
            'pvalue': 440300000000
          },
          {
            'value': 440307000000,
            'text': '龙岗区',
            'level': 3,
            'pvalue': 440300000000
          },
          {
            'value': 440308000000,
            'text': '盐田区',
            'level': 3,
            'pvalue': 440300000000
          },
          {
            'value': 440309000000,
            'text': '龙华区',
            'level': 3,
            'pvalue': 440300000000
          },
          {
            'value': 440310000000,
            'text': '坪山区',
            'level': 3,
            'pvalue': 440300000000
          },
          {
            'value': 440311000000,
            'text': '光明区',
            'level': 3,
            'pvalue': 440300000000
          }
        ]
      },
      {
        'value': 440400000000,
        'text': '珠海市',
        'level': 2,
        'pvalue': 440000000000,
        'children': [
          {
            'value': 440401000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 440400000000
          },
          {
            'value': 440402000000,
            'text': '香洲区',
            'level': 3,
            'pvalue': 440400000000
          },
          {
            'value': 440403000000,
            'text': '斗门区',
            'level': 3,
            'pvalue': 440400000000
          },
          {
            'value': 440404000000,
            'text': '金湾区',
            'level': 3,
            'pvalue': 440400000000
          }
        ]
      },
      {
        'value': 440500000000,
        'text': '汕头市',
        'level': 2,
        'pvalue': 440000000000,
        'children': [
          {
            'value': 440501000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 440500000000
          },
          {
            'value': 440507000000,
            'text': '龙湖区',
            'level': 3,
            'pvalue': 440500000000
          },
          {
            'value': 440511000000,
            'text': '金平区',
            'level': 3,
            'pvalue': 440500000000
          },
          {
            'value': 440512000000,
            'text': '濠江区',
            'level': 3,
            'pvalue': 440500000000
          },
          {
            'value': 440513000000,
            'text': '潮阳区',
            'level': 3,
            'pvalue': 440500000000
          },
          {
            'value': 440514000000,
            'text': '潮南区',
            'level': 3,
            'pvalue': 440500000000
          },
          {
            'value': 440515000000,
            'text': '澄海区',
            'level': 3,
            'pvalue': 440500000000
          },
          {
            'value': 440523000000,
            'text': '南澳县',
            'level': 3,
            'pvalue': 440500000000
          }
        ]
      },
      {
        'value': 440600000000,
        'text': '佛山市',
        'level': 2,
        'pvalue': 440000000000,
        'children': [
          {
            'value': 440601000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 440600000000
          },
          {
            'value': 440604000000,
            'text': '禅城区',
            'level': 3,
            'pvalue': 440600000000
          },
          {
            'value': 440605000000,
            'text': '南海区',
            'level': 3,
            'pvalue': 440600000000
          },
          {
            'value': 440606000000,
            'text': '顺德区',
            'level': 3,
            'pvalue': 440600000000
          },
          {
            'value': 440607000000,
            'text': '三水区',
            'level': 3,
            'pvalue': 440600000000
          },
          {
            'value': 440608000000,
            'text': '高明区',
            'level': 3,
            'pvalue': 440600000000
          }
        ]
      },
      {
        'value': 440700000000,
        'text': '江门市',
        'level': 2,
        'pvalue': 440000000000,
        'children': [
          {
            'value': 440701000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 440700000000
          },
          {
            'value': 440703000000,
            'text': '蓬江区',
            'level': 3,
            'pvalue': 440700000000
          },
          {
            'value': 440704000000,
            'text': '江海区',
            'level': 3,
            'pvalue': 440700000000
          },
          {
            'value': 440705000000,
            'text': '新会区',
            'level': 3,
            'pvalue': 440700000000
          },
          {
            'value': 440781000000,
            'text': '台山市',
            'level': 3,
            'pvalue': 440700000000
          },
          {
            'value': 440783000000,
            'text': '开平市',
            'level': 3,
            'pvalue': 440700000000
          },
          {
            'value': 440784000000,
            'text': '鹤山市',
            'level': 3,
            'pvalue': 440700000000
          },
          {
            'value': 440785000000,
            'text': '恩平市',
            'level': 3,
            'pvalue': 440700000000
          }
        ]
      },
      {
        'value': 440800000000,
        'text': '湛江市',
        'level': 2,
        'pvalue': 440000000000,
        'children': [
          {
            'value': 440801000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 440800000000
          },
          {
            'value': 440802000000,
            'text': '赤坎区',
            'level': 3,
            'pvalue': 440800000000
          },
          {
            'value': 440803000000,
            'text': '霞山区',
            'level': 3,
            'pvalue': 440800000000
          },
          {
            'value': 440804000000,
            'text': '坡头区',
            'level': 3,
            'pvalue': 440800000000
          },
          {
            'value': 440811000000,
            'text': '麻章区',
            'level': 3,
            'pvalue': 440800000000
          },
          {
            'value': 440823000000,
            'text': '遂溪县',
            'level': 3,
            'pvalue': 440800000000
          },
          {
            'value': 440825000000,
            'text': '徐闻县',
            'level': 3,
            'pvalue': 440800000000
          },
          {
            'value': 440881000000,
            'text': '廉江市',
            'level': 3,
            'pvalue': 440800000000
          },
          {
            'value': 440882000000,
            'text': '雷州市',
            'level': 3,
            'pvalue': 440800000000
          },
          {
            'value': 440883000000,
            'text': '吴川市',
            'level': 3,
            'pvalue': 440800000000
          }
        ]
      },
      {
        'value': 440900000000,
        'text': '茂名市',
        'level': 2,
        'pvalue': 440000000000,
        'children': [
          {
            'value': 440901000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 440900000000
          },
          {
            'value': 440902000000,
            'text': '茂南区',
            'level': 3,
            'pvalue': 440900000000
          },
          {
            'value': 440904000000,
            'text': '电白区',
            'level': 3,
            'pvalue': 440900000000
          },
          {
            'value': 440981000000,
            'text': '高州市',
            'level': 3,
            'pvalue': 440900000000
          },
          {
            'value': 440982000000,
            'text': '化州市',
            'level': 3,
            'pvalue': 440900000000
          },
          {
            'value': 440983000000,
            'text': '信宜市',
            'level': 3,
            'pvalue': 440900000000
          }
        ]
      },
      {
        'value': 441200000000,
        'text': '肇庆市',
        'level': 2,
        'pvalue': 440000000000,
        'children': [
          {
            'value': 441201000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 441200000000
          },
          {
            'value': 441202000000,
            'text': '端州区',
            'level': 3,
            'pvalue': 441200000000
          },
          {
            'value': 441203000000,
            'text': '鼎湖区',
            'level': 3,
            'pvalue': 441200000000
          },
          {
            'value': 441204000000,
            'text': '高要区',
            'level': 3,
            'pvalue': 441200000000
          },
          {
            'value': 441223000000,
            'text': '广宁县',
            'level': 3,
            'pvalue': 441200000000
          },
          {
            'value': 441224000000,
            'text': '怀集县',
            'level': 3,
            'pvalue': 441200000000
          },
          {
            'value': 441225000000,
            'text': '封开县',
            'level': 3,
            'pvalue': 441200000000
          },
          {
            'value': 441226000000,
            'text': '德庆县',
            'level': 3,
            'pvalue': 441200000000
          },
          {
            'value': 441284000000,
            'text': '四会市',
            'level': 3,
            'pvalue': 441200000000
          }
        ]
      },
      {
        'value': 441300000000,
        'text': '惠州市',
        'level': 2,
        'pvalue': 440000000000,
        'children': [
          {
            'value': 441301000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 441300000000
          },
          {
            'value': 441302000000,
            'text': '惠城区',
            'level': 3,
            'pvalue': 441300000000
          },
          {
            'value': 441303000000,
            'text': '惠阳区',
            'level': 3,
            'pvalue': 441300000000
          },
          {
            'value': 441322000000,
            'text': '博罗县',
            'level': 3,
            'pvalue': 441300000000
          },
          {
            'value': 441323000000,
            'text': '惠东县',
            'level': 3,
            'pvalue': 441300000000
          },
          {
            'value': 441324000000,
            'text': '龙门县',
            'level': 3,
            'pvalue': 441300000000
          }
        ]
      },
      {
        'value': 441400000000,
        'text': '梅州市',
        'level': 2,
        'pvalue': 440000000000,
        'children': [
          {
            'value': 441401000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 441400000000
          },
          {
            'value': 441402000000,
            'text': '梅江区',
            'level': 3,
            'pvalue': 441400000000
          },
          {
            'value': 441403000000,
            'text': '梅县区',
            'level': 3,
            'pvalue': 441400000000
          },
          {
            'value': 441422000000,
            'text': '大埔县',
            'level': 3,
            'pvalue': 441400000000
          },
          {
            'value': 441423000000,
            'text': '丰顺县',
            'level': 3,
            'pvalue': 441400000000
          },
          {
            'value': 441424000000,
            'text': '五华县',
            'level': 3,
            'pvalue': 441400000000
          },
          {
            'value': 441426000000,
            'text': '平远县',
            'level': 3,
            'pvalue': 441400000000
          },
          {
            'value': 441427000000,
            'text': '蕉岭县',
            'level': 3,
            'pvalue': 441400000000
          },
          {
            'value': 441481000000,
            'text': '兴宁市',
            'level': 3,
            'pvalue': 441400000000
          }
        ]
      },
      {
        'value': 441500000000,
        'text': '汕尾市',
        'level': 2,
        'pvalue': 440000000000,
        'children': [
          {
            'value': 441501000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 441500000000
          },
          {
            'value': 441502000000,
            'text': '城区',
            'level': 3,
            'pvalue': 441500000000
          },
          {
            'value': 441521000000,
            'text': '海丰县',
            'level': 3,
            'pvalue': 441500000000
          },
          {
            'value': 441523000000,
            'text': '陆河县',
            'level': 3,
            'pvalue': 441500000000
          },
          {
            'value': 441581000000,
            'text': '陆丰市',
            'level': 3,
            'pvalue': 441500000000
          }
        ]
      },
      {
        'value': 441600000000,
        'text': '河源市',
        'level': 2,
        'pvalue': 440000000000,
        'children': [
          {
            'value': 441601000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 441600000000
          },
          {
            'value': 441602000000,
            'text': '源城区',
            'level': 3,
            'pvalue': 441600000000
          },
          {
            'value': 441621000000,
            'text': '紫金县',
            'level': 3,
            'pvalue': 441600000000
          },
          {
            'value': 441622000000,
            'text': '龙川县',
            'level': 3,
            'pvalue': 441600000000
          },
          {
            'value': 441623000000,
            'text': '连平县',
            'level': 3,
            'pvalue': 441600000000
          },
          {
            'value': 441624000000,
            'text': '和平县',
            'level': 3,
            'pvalue': 441600000000
          },
          {
            'value': 441625000000,
            'text': '东源县',
            'level': 3,
            'pvalue': 441600000000
          }
        ]
      },
      {
        'value': 441700000000,
        'text': '阳江市',
        'level': 2,
        'pvalue': 440000000000,
        'children': [
          {
            'value': 441701000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 441700000000
          },
          {
            'value': 441702000000,
            'text': '江城区',
            'level': 3,
            'pvalue': 441700000000
          },
          {
            'value': 441704000000,
            'text': '阳东区',
            'level': 3,
            'pvalue': 441700000000
          },
          {
            'value': 441721000000,
            'text': '阳西县',
            'level': 3,
            'pvalue': 441700000000
          },
          {
            'value': 441781000000,
            'text': '阳春市',
            'level': 3,
            'pvalue': 441700000000
          }
        ]
      },
      {
        'value': 441800000000,
        'text': '清远市',
        'level': 2,
        'pvalue': 440000000000,
        'children': [
          {
            'value': 441801000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 441800000000
          },
          {
            'value': 441802000000,
            'text': '清城区',
            'level': 3,
            'pvalue': 441800000000
          },
          {
            'value': 441803000000,
            'text': '清新区',
            'level': 3,
            'pvalue': 441800000000
          },
          {
            'value': 441821000000,
            'text': '佛冈县',
            'level': 3,
            'pvalue': 441800000000
          },
          {
            'value': 441823000000,
            'text': '阳山县',
            'level': 3,
            'pvalue': 441800000000
          },
          {
            'value': 441825000000,
            'text': '连山壮族瑶族自治县',
            'level': 3,
            'pvalue': 441800000000
          },
          {
            'value': 441826000000,
            'text': '连南瑶族自治县',
            'level': 3,
            'pvalue': 441800000000
          },
          {
            'value': 441881000000,
            'text': '英德市',
            'level': 3,
            'pvalue': 441800000000
          },
          {
            'value': 441882000000,
            'text': '连州市',
            'level': 3,
            'pvalue': 441800000000
          }
        ]
      },
      {
        'value': 441900000000,
        'text': '东莞市',
        'level': 2,
        'pvalue': 440000000000,
        'children': [
          {
            'value': 441900003000,
            'text': '东城街道',
            'level': 4,
            'pvalue': 441900000000
          },
          {
            'value': 441900004000,
            'text': '南城街道',
            'level': 4,
            'pvalue': 441900000000
          },
          {
            'value': 441900005000,
            'text': '万江街道',
            'level': 4,
            'pvalue': 441900000000
          },
          {
            'value': 441900006000,
            'text': '莞城街道',
            'level': 4,
            'pvalue': 441900000000
          },
          {
            'value': 441900101000,
            'text': '石碣镇',
            'level': 4,
            'pvalue': 441900000000
          },
          {
            'value': 441900102000,
            'text': '石龙镇',
            'level': 4,
            'pvalue': 441900000000
          },
          {
            'value': 441900103000,
            'text': '茶山镇',
            'level': 4,
            'pvalue': 441900000000
          },
          {
            'value': 441900104000,
            'text': '石排镇',
            'level': 4,
            'pvalue': 441900000000
          },
          {
            'value': 441900105000,
            'text': '企石镇',
            'level': 4,
            'pvalue': 441900000000
          },
          {
            'value': 441900106000,
            'text': '横沥镇',
            'level': 4,
            'pvalue': 441900000000
          },
          {
            'value': 441900107000,
            'text': '桥头镇',
            'level': 4,
            'pvalue': 441900000000
          },
          {
            'value': 441900108000,
            'text': '谢岗镇',
            'level': 4,
            'pvalue': 441900000000
          },
          {
            'value': 441900109000,
            'text': '东坑镇',
            'level': 4,
            'pvalue': 441900000000
          },
          {
            'value': 441900110000,
            'text': '常平镇',
            'level': 4,
            'pvalue': 441900000000
          },
          {
            'value': 441900111000,
            'text': '寮步镇',
            'level': 4,
            'pvalue': 441900000000
          },
          {
            'value': 441900112000,
            'text': '樟木头镇',
            'level': 4,
            'pvalue': 441900000000
          },
          {
            'value': 441900113000,
            'text': '大朗镇',
            'level': 4,
            'pvalue': 441900000000
          },
          {
            'value': 441900114000,
            'text': '黄江镇',
            'level': 4,
            'pvalue': 441900000000
          },
          {
            'value': 441900115000,
            'text': '清溪镇',
            'level': 4,
            'pvalue': 441900000000
          },
          {
            'value': 441900116000,
            'text': '塘厦镇',
            'level': 4,
            'pvalue': 441900000000
          },
          {
            'value': 441900117000,
            'text': '凤岗镇',
            'level': 4,
            'pvalue': 441900000000
          },
          {
            'value': 441900118000,
            'text': '大岭山镇',
            'level': 4,
            'pvalue': 441900000000
          },
          {
            'value': 441900119000,
            'text': '长安镇',
            'level': 4,
            'pvalue': 441900000000
          },
          {
            'value': 441900121000,
            'text': '虎门镇',
            'level': 4,
            'pvalue': 441900000000
          },
          {
            'value': 441900122000,
            'text': '厚街镇',
            'level': 4,
            'pvalue': 441900000000
          },
          {
            'value': 441900123000,
            'text': '沙田镇',
            'level': 4,
            'pvalue': 441900000000
          },
          {
            'value': 441900124000,
            'text': '道滘镇',
            'level': 4,
            'pvalue': 441900000000
          },
          {
            'value': 441900125000,
            'text': '洪梅镇',
            'level': 4,
            'pvalue': 441900000000
          },
          {
            'value': 441900126000,
            'text': '麻涌镇',
            'level': 4,
            'pvalue': 441900000000
          },
          {
            'value': 441900127000,
            'text': '望牛墩镇',
            'level': 4,
            'pvalue': 441900000000
          },
          {
            'value': 441900128000,
            'text': '中堂镇',
            'level': 4,
            'pvalue': 441900000000
          },
          {
            'value': 441900129000,
            'text': '高埗镇',
            'level': 4,
            'pvalue': 441900000000
          },
          {
            'value': 441900401000,
            'text': '松山湖',
            'level': 4,
            'pvalue': 441900000000
          },
          {
            'value': 441900402000,
            'text': '东莞港',
            'level': 4,
            'pvalue': 441900000000
          },
          {
            'value': 441900403000,
            'text': '东莞生态园',
            'level': 4,
            'pvalue': 441900000000
          },
          {
            'value': 441900404000,
            'text': '东莞滨海湾新区',
            'level': 4,
            'pvalue': 441900000000
          }
        ]
      },
      {
        'value': 442000000000,
        'text': '中山市',
        'level': 2,
        'pvalue': 440000000000,
        'children': [
          {
            'value': 442000001000,
            'text': '石岐街道',
            'level': 4,
            'pvalue': 442000000000
          },
          {
            'value': 442000002000,
            'text': '东区街道',
            'level': 4,
            'pvalue': 442000000000
          },
          {
            'value': 442000003000,
            'text': '中山港街道',
            'level': 4,
            'pvalue': 442000000000
          },
          {
            'value': 442000004000,
            'text': '西区街道',
            'level': 4,
            'pvalue': 442000000000
          },
          {
            'value': 442000005000,
            'text': '南区街道',
            'level': 4,
            'pvalue': 442000000000
          },
          {
            'value': 442000006000,
            'text': '五桂山街道',
            'level': 4,
            'pvalue': 442000000000
          },
          {
            'value': 442000007000,
            'text': '民众街道',
            'level': 4,
            'pvalue': 442000000000
          },
          {
            'value': 442000008000,
            'text': '南朗街道',
            'level': 4,
            'pvalue': 442000000000
          },
          {
            'value': 442000101000,
            'text': '黄圃镇',
            'level': 4,
            'pvalue': 442000000000
          },
          {
            'value': 442000103000,
            'text': '东凤镇',
            'level': 4,
            'pvalue': 442000000000
          },
          {
            'value': 442000105000,
            'text': '古镇镇',
            'level': 4,
            'pvalue': 442000000000
          },
          {
            'value': 442000106000,
            'text': '沙溪镇',
            'level': 4,
            'pvalue': 442000000000
          },
          {
            'value': 442000107000,
            'text': '坦洲镇',
            'level': 4,
            'pvalue': 442000000000
          },
          {
            'value': 442000108000,
            'text': '港口镇',
            'level': 4,
            'pvalue': 442000000000
          },
          {
            'value': 442000109000,
            'text': '三角镇',
            'level': 4,
            'pvalue': 442000000000
          },
          {
            'value': 442000110000,
            'text': '横栏镇',
            'level': 4,
            'pvalue': 442000000000
          },
          {
            'value': 442000111000,
            'text': '南头镇',
            'level': 4,
            'pvalue': 442000000000
          },
          {
            'value': 442000112000,
            'text': '阜沙镇',
            'level': 4,
            'pvalue': 442000000000
          },
          {
            'value': 442000114000,
            'text': '三乡镇',
            'level': 4,
            'pvalue': 442000000000
          },
          {
            'value': 442000115000,
            'text': '板芙镇',
            'level': 4,
            'pvalue': 442000000000
          },
          {
            'value': 442000116000,
            'text': '大涌镇',
            'level': 4,
            'pvalue': 442000000000
          },
          {
            'value': 442000117000,
            'text': '神湾镇',
            'level': 4,
            'pvalue': 442000000000
          },
          {
            'value': 442000118000,
            'text': '小榄镇',
            'level': 4,
            'pvalue': 442000000000
          }
        ]
      },
      {
        'value': 445100000000,
        'text': '潮州市',
        'level': 2,
        'pvalue': 440000000000,
        'children': [
          {
            'value': 445101000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 445100000000
          },
          {
            'value': 445102000000,
            'text': '湘桥区',
            'level': 3,
            'pvalue': 445100000000
          },
          {
            'value': 445103000000,
            'text': '潮安区',
            'level': 3,
            'pvalue': 445100000000
          },
          {
            'value': 445122000000,
            'text': '饶平县',
            'level': 3,
            'pvalue': 445100000000
          }
        ]
      },
      {
        'value': 445200000000,
        'text': '揭阳市',
        'level': 2,
        'pvalue': 440000000000,
        'children': [
          {
            'value': 445201000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 445200000000
          },
          {
            'value': 445202000000,
            'text': '榕城区',
            'level': 3,
            'pvalue': 445200000000
          },
          {
            'value': 445203000000,
            'text': '揭东区',
            'level': 3,
            'pvalue': 445200000000
          },
          {
            'value': 445222000000,
            'text': '揭西县',
            'level': 3,
            'pvalue': 445200000000
          },
          {
            'value': 445224000000,
            'text': '惠来县',
            'level': 3,
            'pvalue': 445200000000
          },
          {
            'value': 445281000000,
            'text': '普宁市',
            'level': 3,
            'pvalue': 445200000000
          }
        ]
      },
      {
        'value': 445300000000,
        'text': '云浮市',
        'level': 2,
        'pvalue': 440000000000,
        'children': [
          {
            'value': 445301000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 445300000000
          },
          {
            'value': 445302000000,
            'text': '云城区',
            'level': 3,
            'pvalue': 445300000000
          },
          {
            'value': 445303000000,
            'text': '云安区',
            'level': 3,
            'pvalue': 445300000000
          },
          {
            'value': 445321000000,
            'text': '新兴县',
            'level': 3,
            'pvalue': 445300000000
          },
          {
            'value': 445322000000,
            'text': '郁南县',
            'level': 3,
            'pvalue': 445300000000
          },
          {
            'value': 445381000000,
            'text': '罗定市',
            'level': 3,
            'pvalue': 445300000000
          }
        ]
      }
    ]
  },
  {
    'value': 450000000000,
    'text': '广西壮族自治区',
    'level': 1,
    'pvalue': 0,
    'children': [
      {
        'value': 450100000000,
        'text': '南宁市',
        'level': 2,
        'pvalue': 450000000000,
        'children': [
          {
            'value': 450101000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 450100000000
          },
          {
            'value': 450102000000,
            'text': '兴宁区',
            'level': 3,
            'pvalue': 450100000000
          },
          {
            'value': 450103000000,
            'text': '青秀区',
            'level': 3,
            'pvalue': 450100000000
          },
          {
            'value': 450105000000,
            'text': '江南区',
            'level': 3,
            'pvalue': 450100000000
          },
          {
            'value': 450107000000,
            'text': '西乡塘区',
            'level': 3,
            'pvalue': 450100000000
          },
          {
            'value': 450108000000,
            'text': '良庆区',
            'level': 3,
            'pvalue': 450100000000
          },
          {
            'value': 450109000000,
            'text': '邕宁区',
            'level': 3,
            'pvalue': 450100000000
          },
          {
            'value': 450110000000,
            'text': '武鸣区',
            'level': 3,
            'pvalue': 450100000000
          },
          {
            'value': 450123000000,
            'text': '隆安县',
            'level': 3,
            'pvalue': 450100000000
          },
          {
            'value': 450124000000,
            'text': '马山县',
            'level': 3,
            'pvalue': 450100000000
          },
          {
            'value': 450125000000,
            'text': '上林县',
            'level': 3,
            'pvalue': 450100000000
          },
          {
            'value': 450126000000,
            'text': '宾阳县',
            'level': 3,
            'pvalue': 450100000000
          },
          {
            'value': 450181000000,
            'text': '横州市',
            'level': 3,
            'pvalue': 450100000000
          }
        ]
      },
      {
        'value': 450200000000,
        'text': '柳州市',
        'level': 2,
        'pvalue': 450000000000,
        'children': [
          {
            'value': 450201000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 450200000000
          },
          {
            'value': 450202000000,
            'text': '城中区',
            'level': 3,
            'pvalue': 450200000000
          },
          {
            'value': 450203000000,
            'text': '鱼峰区',
            'level': 3,
            'pvalue': 450200000000
          },
          {
            'value': 450204000000,
            'text': '柳南区',
            'level': 3,
            'pvalue': 450200000000
          },
          {
            'value': 450205000000,
            'text': '柳北区',
            'level': 3,
            'pvalue': 450200000000
          },
          {
            'value': 450206000000,
            'text': '柳江区',
            'level': 3,
            'pvalue': 450200000000
          },
          {
            'value': 450222000000,
            'text': '柳城县',
            'level': 3,
            'pvalue': 450200000000
          },
          {
            'value': 450223000000,
            'text': '鹿寨县',
            'level': 3,
            'pvalue': 450200000000
          },
          {
            'value': 450224000000,
            'text': '融安县',
            'level': 3,
            'pvalue': 450200000000
          },
          {
            'value': 450225000000,
            'text': '融水苗族自治县',
            'level': 3,
            'pvalue': 450200000000
          },
          {
            'value': 450226000000,
            'text': '三江侗族自治县',
            'level': 3,
            'pvalue': 450200000000
          }
        ]
      },
      {
        'value': 450300000000,
        'text': '桂林市',
        'level': 2,
        'pvalue': 450000000000,
        'children': [
          {
            'value': 450301000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 450300000000
          },
          {
            'value': 450302000000,
            'text': '秀峰区',
            'level': 3,
            'pvalue': 450300000000
          },
          {
            'value': 450303000000,
            'text': '叠彩区',
            'level': 3,
            'pvalue': 450300000000
          },
          {
            'value': 450304000000,
            'text': '象山区',
            'level': 3,
            'pvalue': 450300000000
          },
          {
            'value': 450305000000,
            'text': '七星区',
            'level': 3,
            'pvalue': 450300000000
          },
          {
            'value': 450311000000,
            'text': '雁山区',
            'level': 3,
            'pvalue': 450300000000
          },
          {
            'value': 450312000000,
            'text': '临桂区',
            'level': 3,
            'pvalue': 450300000000
          },
          {
            'value': 450321000000,
            'text': '阳朔县',
            'level': 3,
            'pvalue': 450300000000
          },
          {
            'value': 450323000000,
            'text': '灵川县',
            'level': 3,
            'pvalue': 450300000000
          },
          {
            'value': 450324000000,
            'text': '全州县',
            'level': 3,
            'pvalue': 450300000000
          },
          {
            'value': 450325000000,
            'text': '兴安县',
            'level': 3,
            'pvalue': 450300000000
          },
          {
            'value': 450326000000,
            'text': '永福县',
            'level': 3,
            'pvalue': 450300000000
          },
          {
            'value': 450327000000,
            'text': '灌阳县',
            'level': 3,
            'pvalue': 450300000000
          },
          {
            'value': 450328000000,
            'text': '龙胜各族自治县',
            'level': 3,
            'pvalue': 450300000000
          },
          {
            'value': 450329000000,
            'text': '资源县',
            'level': 3,
            'pvalue': 450300000000
          },
          {
            'value': 450330000000,
            'text': '平乐县',
            'level': 3,
            'pvalue': 450300000000
          },
          {
            'value': 450332000000,
            'text': '恭城瑶族自治县',
            'level': 3,
            'pvalue': 450300000000
          },
          {
            'value': 450381000000,
            'text': '荔浦市',
            'level': 3,
            'pvalue': 450300000000
          }
        ]
      },
      {
        'value': 450400000000,
        'text': '梧州市',
        'level': 2,
        'pvalue': 450000000000,
        'children': [
          {
            'value': 450401000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 450400000000
          },
          {
            'value': 450403000000,
            'text': '万秀区',
            'level': 3,
            'pvalue': 450400000000
          },
          {
            'value': 450405000000,
            'text': '长洲区',
            'level': 3,
            'pvalue': 450400000000
          },
          {
            'value': 450406000000,
            'text': '龙圩区',
            'level': 3,
            'pvalue': 450400000000
          },
          {
            'value': 450421000000,
            'text': '苍梧县',
            'level': 3,
            'pvalue': 450400000000
          },
          {
            'value': 450422000000,
            'text': '藤县',
            'level': 3,
            'pvalue': 450400000000
          },
          {
            'value': 450423000000,
            'text': '蒙山县',
            'level': 3,
            'pvalue': 450400000000
          },
          {
            'value': 450481000000,
            'text': '岑溪市',
            'level': 3,
            'pvalue': 450400000000
          }
        ]
      },
      {
        'value': 450500000000,
        'text': '北海市',
        'level': 2,
        'pvalue': 450000000000,
        'children': [
          {
            'value': 450501000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 450500000000
          },
          {
            'value': 450502000000,
            'text': '海城区',
            'level': 3,
            'pvalue': 450500000000
          },
          {
            'value': 450503000000,
            'text': '银海区',
            'level': 3,
            'pvalue': 450500000000
          },
          {
            'value': 450512000000,
            'text': '铁山港区',
            'level': 3,
            'pvalue': 450500000000
          },
          {
            'value': 450521000000,
            'text': '合浦县',
            'level': 3,
            'pvalue': 450500000000
          }
        ]
      },
      {
        'value': 450600000000,
        'text': '防城港市',
        'level': 2,
        'pvalue': 450000000000,
        'children': [
          {
            'value': 450601000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 450600000000
          },
          {
            'value': 450602000000,
            'text': '港口区',
            'level': 3,
            'pvalue': 450600000000
          },
          {
            'value': 450603000000,
            'text': '防城区',
            'level': 3,
            'pvalue': 450600000000
          },
          {
            'value': 450621000000,
            'text': '上思县',
            'level': 3,
            'pvalue': 450600000000
          },
          {
            'value': 450681000000,
            'text': '东兴市',
            'level': 3,
            'pvalue': 450600000000
          }
        ]
      },
      {
        'value': 450700000000,
        'text': '钦州市',
        'level': 2,
        'pvalue': 450000000000,
        'children': [
          {
            'value': 450701000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 450700000000
          },
          {
            'value': 450702000000,
            'text': '钦南区',
            'level': 3,
            'pvalue': 450700000000
          },
          {
            'value': 450703000000,
            'text': '钦北区',
            'level': 3,
            'pvalue': 450700000000
          },
          {
            'value': 450721000000,
            'text': '灵山县',
            'level': 3,
            'pvalue': 450700000000
          },
          {
            'value': 450722000000,
            'text': '浦北县',
            'level': 3,
            'pvalue': 450700000000
          }
        ]
      },
      {
        'value': 450800000000,
        'text': '贵港市',
        'level': 2,
        'pvalue': 450000000000,
        'children': [
          {
            'value': 450801000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 450800000000
          },
          {
            'value': 450802000000,
            'text': '港北区',
            'level': 3,
            'pvalue': 450800000000
          },
          {
            'value': 450803000000,
            'text': '港南区',
            'level': 3,
            'pvalue': 450800000000
          },
          {
            'value': 450804000000,
            'text': '覃塘区',
            'level': 3,
            'pvalue': 450800000000
          },
          {
            'value': 450821000000,
            'text': '平南县',
            'level': 3,
            'pvalue': 450800000000
          },
          {
            'value': 450881000000,
            'text': '桂平市',
            'level': 3,
            'pvalue': 450800000000
          }
        ]
      },
      {
        'value': 450900000000,
        'text': '玉林市',
        'level': 2,
        'pvalue': 450000000000,
        'children': [
          {
            'value': 450901000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 450900000000
          },
          {
            'value': 450902000000,
            'text': '玉州区',
            'level': 3,
            'pvalue': 450900000000
          },
          {
            'value': 450903000000,
            'text': '福绵区',
            'level': 3,
            'pvalue': 450900000000
          },
          {
            'value': 450921000000,
            'text': '容县',
            'level': 3,
            'pvalue': 450900000000
          },
          {
            'value': 450922000000,
            'text': '陆川县',
            'level': 3,
            'pvalue': 450900000000
          },
          {
            'value': 450923000000,
            'text': '博白县',
            'level': 3,
            'pvalue': 450900000000
          },
          {
            'value': 450924000000,
            'text': '兴业县',
            'level': 3,
            'pvalue': 450900000000
          },
          {
            'value': 450981000000,
            'text': '北流市',
            'level': 3,
            'pvalue': 450900000000
          }
        ]
      },
      {
        'value': 451000000000,
        'text': '百色市',
        'level': 2,
        'pvalue': 450000000000,
        'children': [
          {
            'value': 451001000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 451000000000
          },
          {
            'value': 451002000000,
            'text': '右江区',
            'level': 3,
            'pvalue': 451000000000
          },
          {
            'value': 451003000000,
            'text': '田阳区',
            'level': 3,
            'pvalue': 451000000000
          },
          {
            'value': 451022000000,
            'text': '田东县',
            'level': 3,
            'pvalue': 451000000000
          },
          {
            'value': 451024000000,
            'text': '德保县',
            'level': 3,
            'pvalue': 451000000000
          },
          {
            'value': 451026000000,
            'text': '那坡县',
            'level': 3,
            'pvalue': 451000000000
          },
          {
            'value': 451027000000,
            'text': '凌云县',
            'level': 3,
            'pvalue': 451000000000
          },
          {
            'value': 451028000000,
            'text': '乐业县',
            'level': 3,
            'pvalue': 451000000000
          },
          {
            'value': 451029000000,
            'text': '田林县',
            'level': 3,
            'pvalue': 451000000000
          },
          {
            'value': 451030000000,
            'text': '西林县',
            'level': 3,
            'pvalue': 451000000000
          },
          {
            'value': 451031000000,
            'text': '隆林各族自治县',
            'level': 3,
            'pvalue': 451000000000
          },
          {
            'value': 451081000000,
            'text': '靖西市',
            'level': 3,
            'pvalue': 451000000000
          },
          {
            'value': 451082000000,
            'text': '平果市',
            'level': 3,
            'pvalue': 451000000000
          }
        ]
      },
      {
        'value': 451100000000,
        'text': '贺州市',
        'level': 2,
        'pvalue': 450000000000,
        'children': [
          {
            'value': 451101000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 451100000000
          },
          {
            'value': 451102000000,
            'text': '八步区',
            'level': 3,
            'pvalue': 451100000000
          },
          {
            'value': 451103000000,
            'text': '平桂区',
            'level': 3,
            'pvalue': 451100000000
          },
          {
            'value': 451121000000,
            'text': '昭平县',
            'level': 3,
            'pvalue': 451100000000
          },
          {
            'value': 451122000000,
            'text': '钟山县',
            'level': 3,
            'pvalue': 451100000000
          },
          {
            'value': 451123000000,
            'text': '富川瑶族自治县',
            'level': 3,
            'pvalue': 451100000000
          }
        ]
      },
      {
        'value': 451200000000,
        'text': '河池市',
        'level': 2,
        'pvalue': 450000000000,
        'children': [
          {
            'value': 451201000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 451200000000
          },
          {
            'value': 451202000000,
            'text': '金城江区',
            'level': 3,
            'pvalue': 451200000000
          },
          {
            'value': 451203000000,
            'text': '宜州区',
            'level': 3,
            'pvalue': 451200000000
          },
          {
            'value': 451221000000,
            'text': '南丹县',
            'level': 3,
            'pvalue': 451200000000
          },
          {
            'value': 451222000000,
            'text': '天峨县',
            'level': 3,
            'pvalue': 451200000000
          },
          {
            'value': 451223000000,
            'text': '凤山县',
            'level': 3,
            'pvalue': 451200000000
          },
          {
            'value': 451224000000,
            'text': '东兰县',
            'level': 3,
            'pvalue': 451200000000
          },
          {
            'value': 451225000000,
            'text': '罗城仫佬族自治县',
            'level': 3,
            'pvalue': 451200000000
          },
          {
            'value': 451226000000,
            'text': '环江毛南族自治县',
            'level': 3,
            'pvalue': 451200000000
          },
          {
            'value': 451227000000,
            'text': '巴马瑶族自治县',
            'level': 3,
            'pvalue': 451200000000
          },
          {
            'value': 451228000000,
            'text': '都安瑶族自治县',
            'level': 3,
            'pvalue': 451200000000
          },
          {
            'value': 451229000000,
            'text': '大化瑶族自治县',
            'level': 3,
            'pvalue': 451200000000
          }
        ]
      },
      {
        'value': 451300000000,
        'text': '来宾市',
        'level': 2,
        'pvalue': 450000000000,
        'children': [
          {
            'value': 451301000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 451300000000
          },
          {
            'value': 451302000000,
            'text': '兴宾区',
            'level': 3,
            'pvalue': 451300000000
          },
          {
            'value': 451321000000,
            'text': '忻城县',
            'level': 3,
            'pvalue': 451300000000
          },
          {
            'value': 451322000000,
            'text': '象州县',
            'level': 3,
            'pvalue': 451300000000
          },
          {
            'value': 451323000000,
            'text': '武宣县',
            'level': 3,
            'pvalue': 451300000000
          },
          {
            'value': 451324000000,
            'text': '金秀瑶族自治县',
            'level': 3,
            'pvalue': 451300000000
          },
          {
            'value': 451381000000,
            'text': '合山市',
            'level': 3,
            'pvalue': 451300000000
          }
        ]
      },
      {
        'value': 451400000000,
        'text': '崇左市',
        'level': 2,
        'pvalue': 450000000000,
        'children': [
          {
            'value': 451401000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 451400000000
          },
          {
            'value': 451402000000,
            'text': '江州区',
            'level': 3,
            'pvalue': 451400000000
          },
          {
            'value': 451421000000,
            'text': '扶绥县',
            'level': 3,
            'pvalue': 451400000000
          },
          {
            'value': 451422000000,
            'text': '宁明县',
            'level': 3,
            'pvalue': 451400000000
          },
          {
            'value': 451423000000,
            'text': '龙州县',
            'level': 3,
            'pvalue': 451400000000
          },
          {
            'value': 451424000000,
            'text': '大新县',
            'level': 3,
            'pvalue': 451400000000
          },
          {
            'value': 451425000000,
            'text': '天等县',
            'level': 3,
            'pvalue': 451400000000
          },
          {
            'value': 451481000000,
            'text': '凭祥市',
            'level': 3,
            'pvalue': 451400000000
          }
        ]
      }
    ]
  },
  {
    'value': 460000000000,
    'text': '海南省',
    'level': 1,
    'pvalue': 0,
    'children': [
      {
        'value': 460100000000,
        'text': '海口市',
        'level': 2,
        'pvalue': 460000000000,
        'children': [
          {
            'value': 460101000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 460100000000
          },
          {
            'value': 460105000000,
            'text': '秀英区',
            'level': 3,
            'pvalue': 460100000000
          },
          {
            'value': 460106000000,
            'text': '龙华区',
            'level': 3,
            'pvalue': 460100000000
          },
          {
            'value': 460107000000,
            'text': '琼山区',
            'level': 3,
            'pvalue': 460100000000
          },
          {
            'value': 460108000000,
            'text': '美兰区',
            'level': 3,
            'pvalue': 460100000000
          }
        ]
      },
      {
        'value': 460200000000,
        'text': '三亚市',
        'level': 2,
        'pvalue': 460000000000,
        'children': [
          {
            'value': 460201000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 460200000000
          },
          {
            'value': 460202000000,
            'text': '海棠区',
            'level': 3,
            'pvalue': 460200000000
          },
          {
            'value': 460203000000,
            'text': '吉阳区',
            'level': 3,
            'pvalue': 460200000000
          },
          {
            'value': 460204000000,
            'text': '天涯区',
            'level': 3,
            'pvalue': 460200000000
          },
          {
            'value': 460205000000,
            'text': '崖州区',
            'level': 3,
            'pvalue': 460200000000
          }
        ]
      },
      {
        'value': 460300000000,
        'text': '三沙市',
        'level': 2,
        'pvalue': 460000000000,
        'children': [
          {
            'value': 460321000000,
            'text': '西沙群岛',
            'level': 3,
            'pvalue': 460300000000
          },
          {
            'value': 460322000000,
            'text': '南沙群岛',
            'level': 3,
            'pvalue': 460300000000
          },
          {
            'value': 460323000000,
            'text': '中沙群岛的岛礁及其海域',
            'level': 3,
            'pvalue': 460300000000
          }
        ]
      },
      {
        'value': 460400000000,
        'text': '儋州市',
        'level': 2,
        'pvalue': 460000000000,
        'children': [
          {
            'value': 460400100000,
            'text': '那大镇',
            'level': 4,
            'pvalue': 460400000000
          },
          {
            'value': 460400101000,
            'text': '和庆镇',
            'level': 4,
            'pvalue': 460400000000
          },
          {
            'value': 460400102000,
            'text': '南丰镇',
            'level': 4,
            'pvalue': 460400000000
          },
          {
            'value': 460400103000,
            'text': '大成镇',
            'level': 4,
            'pvalue': 460400000000
          },
          {
            'value': 460400104000,
            'text': '雅星镇',
            'level': 4,
            'pvalue': 460400000000
          },
          {
            'value': 460400105000,
            'text': '兰洋镇',
            'level': 4,
            'pvalue': 460400000000
          },
          {
            'value': 460400106000,
            'text': '光村镇',
            'level': 4,
            'pvalue': 460400000000
          },
          {
            'value': 460400107000,
            'text': '木棠镇',
            'level': 4,
            'pvalue': 460400000000
          },
          {
            'value': 460400108000,
            'text': '海头镇',
            'level': 4,
            'pvalue': 460400000000
          },
          {
            'value': 460400109000,
            'text': '峨蔓镇',
            'level': 4,
            'pvalue': 460400000000
          },
          {
            'value': 460400111000,
            'text': '王五镇',
            'level': 4,
            'pvalue': 460400000000
          },
          {
            'value': 460400112000,
            'text': '白马井镇',
            'level': 4,
            'pvalue': 460400000000
          },
          {
            'value': 460400113000,
            'text': '中和镇',
            'level': 4,
            'pvalue': 460400000000
          },
          {
            'value': 460400114000,
            'text': '排浦镇',
            'level': 4,
            'pvalue': 460400000000
          },
          {
            'value': 460400115000,
            'text': '东成镇',
            'level': 4,
            'pvalue': 460400000000
          },
          {
            'value': 460400116000,
            'text': '新州镇',
            'level': 4,
            'pvalue': 460400000000
          },
          {
            'value': 460400499000,
            'text': '洋浦经济开发区',
            'level': 4,
            'pvalue': 460400000000
          },
          {
            'value': 460400500000,
            'text': '华南热作学院',
            'level': 4,
            'pvalue': 460400000000
          }
        ]
      },
      {
        'value': 469000000000,
        'text': '省直辖县级行政区划',
        'level': 2,
        'pvalue': 460000000000,
        'children': [
          {
            'value': 469001000000,
            'text': '五指山市',
            'level': 3,
            'pvalue': 469000000000
          },
          {
            'value': 469002000000,
            'text': '琼海市',
            'level': 3,
            'pvalue': 469000000000
          },
          {
            'value': 469005000000,
            'text': '文昌市',
            'level': 3,
            'pvalue': 469000000000
          },
          {
            'value': 469006000000,
            'text': '万宁市',
            'level': 3,
            'pvalue': 469000000000
          },
          {
            'value': 469007000000,
            'text': '东方市',
            'level': 3,
            'pvalue': 469000000000
          },
          {
            'value': 469021000000,
            'text': '定安县',
            'level': 3,
            'pvalue': 469000000000
          },
          {
            'value': 469022000000,
            'text': '屯昌县',
            'level': 3,
            'pvalue': 469000000000
          },
          {
            'value': 469023000000,
            'text': '澄迈县',
            'level': 3,
            'pvalue': 469000000000
          },
          {
            'value': 469024000000,
            'text': '临高县',
            'level': 3,
            'pvalue': 469000000000
          },
          {
            'value': 469025000000,
            'text': '白沙黎族自治县',
            'level': 3,
            'pvalue': 469000000000
          },
          {
            'value': 469026000000,
            'text': '昌江黎族自治县',
            'level': 3,
            'pvalue': 469000000000
          },
          {
            'value': 469027000000,
            'text': '乐东黎族自治县',
            'level': 3,
            'pvalue': 469000000000
          },
          {
            'value': 469028000000,
            'text': '陵水黎族自治县',
            'level': 3,
            'pvalue': 469000000000
          },
          {
            'value': 469029000000,
            'text': '保亭黎族苗族自治县',
            'level': 3,
            'pvalue': 469000000000
          },
          {
            'value': 469030000000,
            'text': '琼中黎族苗族自治县',
            'level': 3,
            'pvalue': 469000000000
          }
        ]
      }
    ]
  },
  {
    'value': 500000000000,
    'text': '重庆市',
    'level': 1,
    'pvalue': 0,
    'children': [
      {
        'value': 500100000000,
        'text': '市辖区',
        'level': 2,
        'pvalue': 500000000000,
        'children': [
          {
            'value': 500101000000,
            'text': '万州区',
            'level': 3,
            'pvalue': 500100000000
          },
          {
            'value': 500102000000,
            'text': '涪陵区',
            'level': 3,
            'pvalue': 500100000000
          },
          {
            'value': 500103000000,
            'text': '渝中区',
            'level': 3,
            'pvalue': 500100000000
          },
          {
            'value': 500104000000,
            'text': '大渡口区',
            'level': 3,
            'pvalue': 500100000000
          },
          {
            'value': 500105000000,
            'text': '江北区',
            'level': 3,
            'pvalue': 500100000000
          },
          {
            'value': 500106000000,
            'text': '沙坪坝区',
            'level': 3,
            'pvalue': 500100000000
          },
          {
            'value': 500107000000,
            'text': '九龙坡区',
            'level': 3,
            'pvalue': 500100000000
          },
          {
            'value': 500108000000,
            'text': '南岸区',
            'level': 3,
            'pvalue': 500100000000
          },
          {
            'value': 500109000000,
            'text': '北碚区',
            'level': 3,
            'pvalue': 500100000000
          },
          {
            'value': 500110000000,
            'text': '綦江区',
            'level': 3,
            'pvalue': 500100000000
          },
          {
            'value': 500111000000,
            'text': '大足区',
            'level': 3,
            'pvalue': 500100000000
          },
          {
            'value': 500112000000,
            'text': '渝北区',
            'level': 3,
            'pvalue': 500100000000
          },
          {
            'value': 500113000000,
            'text': '巴南区',
            'level': 3,
            'pvalue': 500100000000
          },
          {
            'value': 500114000000,
            'text': '黔江区',
            'level': 3,
            'pvalue': 500100000000
          },
          {
            'value': 500115000000,
            'text': '长寿区',
            'level': 3,
            'pvalue': 500100000000
          },
          {
            'value': 500116000000,
            'text': '江津区',
            'level': 3,
            'pvalue': 500100000000
          },
          {
            'value': 500117000000,
            'text': '合川区',
            'level': 3,
            'pvalue': 500100000000
          },
          {
            'value': 500118000000,
            'text': '永川区',
            'level': 3,
            'pvalue': 500100000000
          },
          {
            'value': 500119000000,
            'text': '南川区',
            'level': 3,
            'pvalue': 500100000000
          },
          {
            'value': 500120000000,
            'text': '璧山区',
            'level': 3,
            'pvalue': 500100000000
          },
          {
            'value': 500151000000,
            'text': '铜梁区',
            'level': 3,
            'pvalue': 500100000000
          },
          {
            'value': 500152000000,
            'text': '潼南区',
            'level': 3,
            'pvalue': 500100000000
          },
          {
            'value': 500153000000,
            'text': '荣昌区',
            'level': 3,
            'pvalue': 500100000000
          },
          {
            'value': 500154000000,
            'text': '开州区',
            'level': 3,
            'pvalue': 500100000000
          },
          {
            'value': 500155000000,
            'text': '梁平区',
            'level': 3,
            'pvalue': 500100000000
          },
          {
            'value': 500156000000,
            'text': '武隆区',
            'level': 3,
            'pvalue': 500100000000
          }
        ]
      },
      {
        'value': 500200000000,
        'text': '县',
        'level': 2,
        'pvalue': 500000000000,
        'children': [
          {
            'value': 500229000000,
            'text': '城口县',
            'level': 3,
            'pvalue': 500200000000
          },
          {
            'value': 500230000000,
            'text': '丰都县',
            'level': 3,
            'pvalue': 500200000000
          },
          {
            'value': 500231000000,
            'text': '垫江县',
            'level': 3,
            'pvalue': 500200000000
          },
          {
            'value': 500233000000,
            'text': '忠县',
            'level': 3,
            'pvalue': 500200000000
          },
          {
            'value': 500235000000,
            'text': '云阳县',
            'level': 3,
            'pvalue': 500200000000
          },
          {
            'value': 500236000000,
            'text': '奉节县',
            'level': 3,
            'pvalue': 500200000000
          },
          {
            'value': 500237000000,
            'text': '巫山县',
            'level': 3,
            'pvalue': 500200000000
          },
          {
            'value': 500238000000,
            'text': '巫溪县',
            'level': 3,
            'pvalue': 500200000000
          },
          {
            'value': 500240000000,
            'text': '石柱土家族自治县',
            'level': 3,
            'pvalue': 500200000000
          },
          {
            'value': 500241000000,
            'text': '秀山土家族苗族自治县',
            'level': 3,
            'pvalue': 500200000000
          },
          {
            'value': 500242000000,
            'text': '酉阳土家族苗族自治县',
            'level': 3,
            'pvalue': 500200000000
          },
          {
            'value': 500243000000,
            'text': '彭水苗族土家族自治县',
            'level': 3,
            'pvalue': 500200000000
          }
        ]
      }
    ]
  },
  {
    'value': 510000000000,
    'text': '四川省',
    'level': 1,
    'pvalue': 0,
    'children': [
      {
        'value': 510100000000,
        'text': '成都市',
        'level': 2,
        'pvalue': 510000000000,
        'children': [
          {
            'value': 510101000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 510100000000
          },
          {
            'value': 510104000000,
            'text': '锦江区',
            'level': 3,
            'pvalue': 510100000000
          },
          {
            'value': 510105000000,
            'text': '青羊区',
            'level': 3,
            'pvalue': 510100000000
          },
          {
            'value': 510106000000,
            'text': '金牛区',
            'level': 3,
            'pvalue': 510100000000
          },
          {
            'value': 510107000000,
            'text': '武侯区',
            'level': 3,
            'pvalue': 510100000000
          },
          {
            'value': 510108000000,
            'text': '成华区',
            'level': 3,
            'pvalue': 510100000000
          },
          {
            'value': 510112000000,
            'text': '龙泉驿区',
            'level': 3,
            'pvalue': 510100000000
          },
          {
            'value': 510113000000,
            'text': '青白江区',
            'level': 3,
            'pvalue': 510100000000
          },
          {
            'value': 510114000000,
            'text': '新都区',
            'level': 3,
            'pvalue': 510100000000
          },
          {
            'value': 510115000000,
            'text': '温江区',
            'level': 3,
            'pvalue': 510100000000
          },
          {
            'value': 510116000000,
            'text': '双流区',
            'level': 3,
            'pvalue': 510100000000
          },
          {
            'value': 510117000000,
            'text': '郫都区',
            'level': 3,
            'pvalue': 510100000000
          },
          {
            'value': 510118000000,
            'text': '新津区',
            'level': 3,
            'pvalue': 510100000000
          },
          {
            'value': 510121000000,
            'text': '金堂县',
            'level': 3,
            'pvalue': 510100000000
          },
          {
            'value': 510129000000,
            'text': '大邑县',
            'level': 3,
            'pvalue': 510100000000
          },
          {
            'value': 510131000000,
            'text': '蒲江县',
            'level': 3,
            'pvalue': 510100000000
          },
          {
            'value': 510181000000,
            'text': '都江堰市',
            'level': 3,
            'pvalue': 510100000000
          },
          {
            'value': 510182000000,
            'text': '彭州市',
            'level': 3,
            'pvalue': 510100000000
          },
          {
            'value': 510183000000,
            'text': '邛崃市',
            'level': 3,
            'pvalue': 510100000000
          },
          {
            'value': 510184000000,
            'text': '崇州市',
            'level': 3,
            'pvalue': 510100000000
          },
          {
            'value': 510185000000,
            'text': '简阳市',
            'level': 3,
            'pvalue': 510100000000
          }
        ]
      },
      {
        'value': 510300000000,
        'text': '自贡市',
        'level': 2,
        'pvalue': 510000000000,
        'children': [
          {
            'value': 510301000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 510300000000
          },
          {
            'value': 510302000000,
            'text': '自流井区',
            'level': 3,
            'pvalue': 510300000000
          },
          {
            'value': 510303000000,
            'text': '贡井区',
            'level': 3,
            'pvalue': 510300000000
          },
          {
            'value': 510304000000,
            'text': '大安区',
            'level': 3,
            'pvalue': 510300000000
          },
          {
            'value': 510311000000,
            'text': '沿滩区',
            'level': 3,
            'pvalue': 510300000000
          },
          {
            'value': 510321000000,
            'text': '荣县',
            'level': 3,
            'pvalue': 510300000000
          },
          {
            'value': 510322000000,
            'text': '富顺县',
            'level': 3,
            'pvalue': 510300000000
          }
        ]
      },
      {
        'value': 510400000000,
        'text': '攀枝花市',
        'level': 2,
        'pvalue': 510000000000,
        'children': [
          {
            'value': 510401000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 510400000000
          },
          {
            'value': 510402000000,
            'text': '东区',
            'level': 3,
            'pvalue': 510400000000
          },
          {
            'value': 510403000000,
            'text': '西区',
            'level': 3,
            'pvalue': 510400000000
          },
          {
            'value': 510411000000,
            'text': '仁和区',
            'level': 3,
            'pvalue': 510400000000
          },
          {
            'value': 510421000000,
            'text': '米易县',
            'level': 3,
            'pvalue': 510400000000
          },
          {
            'value': 510422000000,
            'text': '盐边县',
            'level': 3,
            'pvalue': 510400000000
          }
        ]
      },
      {
        'value': 510500000000,
        'text': '泸州市',
        'level': 2,
        'pvalue': 510000000000,
        'children': [
          {
            'value': 510501000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 510500000000
          },
          {
            'value': 510502000000,
            'text': '江阳区',
            'level': 3,
            'pvalue': 510500000000
          },
          {
            'value': 510503000000,
            'text': '纳溪区',
            'level': 3,
            'pvalue': 510500000000
          },
          {
            'value': 510504000000,
            'text': '龙马潭区',
            'level': 3,
            'pvalue': 510500000000
          },
          {
            'value': 510521000000,
            'text': '泸县',
            'level': 3,
            'pvalue': 510500000000
          },
          {
            'value': 510522000000,
            'text': '合江县',
            'level': 3,
            'pvalue': 510500000000
          },
          {
            'value': 510524000000,
            'text': '叙永县',
            'level': 3,
            'pvalue': 510500000000
          },
          {
            'value': 510525000000,
            'text': '古蔺县',
            'level': 3,
            'pvalue': 510500000000
          }
        ]
      },
      {
        'value': 510600000000,
        'text': '德阳市',
        'level': 2,
        'pvalue': 510000000000,
        'children': [
          {
            'value': 510601000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 510600000000
          },
          {
            'value': 510603000000,
            'text': '旌阳区',
            'level': 3,
            'pvalue': 510600000000
          },
          {
            'value': 510604000000,
            'text': '罗江区',
            'level': 3,
            'pvalue': 510600000000
          },
          {
            'value': 510623000000,
            'text': '中江县',
            'level': 3,
            'pvalue': 510600000000
          },
          {
            'value': 510681000000,
            'text': '广汉市',
            'level': 3,
            'pvalue': 510600000000
          },
          {
            'value': 510682000000,
            'text': '什邡市',
            'level': 3,
            'pvalue': 510600000000
          },
          {
            'value': 510683000000,
            'text': '绵竹市',
            'level': 3,
            'pvalue': 510600000000
          }
        ]
      },
      {
        'value': 510700000000,
        'text': '绵阳市',
        'level': 2,
        'pvalue': 510000000000,
        'children': [
          {
            'value': 510701000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 510700000000
          },
          {
            'value': 510703000000,
            'text': '涪城区',
            'level': 3,
            'pvalue': 510700000000
          },
          {
            'value': 510704000000,
            'text': '游仙区',
            'level': 3,
            'pvalue': 510700000000
          },
          {
            'value': 510705000000,
            'text': '安州区',
            'level': 3,
            'pvalue': 510700000000
          },
          {
            'value': 510722000000,
            'text': '三台县',
            'level': 3,
            'pvalue': 510700000000
          },
          {
            'value': 510723000000,
            'text': '盐亭县',
            'level': 3,
            'pvalue': 510700000000
          },
          {
            'value': 510725000000,
            'text': '梓潼县',
            'level': 3,
            'pvalue': 510700000000
          },
          {
            'value': 510726000000,
            'text': '北川羌族自治县',
            'level': 3,
            'pvalue': 510700000000
          },
          {
            'value': 510727000000,
            'text': '平武县',
            'level': 3,
            'pvalue': 510700000000
          },
          {
            'value': 510781000000,
            'text': '江油市',
            'level': 3,
            'pvalue': 510700000000
          }
        ]
      },
      {
        'value': 510800000000,
        'text': '广元市',
        'level': 2,
        'pvalue': 510000000000,
        'children': [
          {
            'value': 510801000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 510800000000
          },
          {
            'value': 510802000000,
            'text': '利州区',
            'level': 3,
            'pvalue': 510800000000
          },
          {
            'value': 510811000000,
            'text': '昭化区',
            'level': 3,
            'pvalue': 510800000000
          },
          {
            'value': 510812000000,
            'text': '朝天区',
            'level': 3,
            'pvalue': 510800000000
          },
          {
            'value': 510821000000,
            'text': '旺苍县',
            'level': 3,
            'pvalue': 510800000000
          },
          {
            'value': 510822000000,
            'text': '青川县',
            'level': 3,
            'pvalue': 510800000000
          },
          {
            'value': 510823000000,
            'text': '剑阁县',
            'level': 3,
            'pvalue': 510800000000
          },
          {
            'value': 510824000000,
            'text': '苍溪县',
            'level': 3,
            'pvalue': 510800000000
          }
        ]
      },
      {
        'value': 510900000000,
        'text': '遂宁市',
        'level': 2,
        'pvalue': 510000000000,
        'children': [
          {
            'value': 510901000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 510900000000
          },
          {
            'value': 510903000000,
            'text': '船山区',
            'level': 3,
            'pvalue': 510900000000
          },
          {
            'value': 510904000000,
            'text': '安居区',
            'level': 3,
            'pvalue': 510900000000
          },
          {
            'value': 510921000000,
            'text': '蓬溪县',
            'level': 3,
            'pvalue': 510900000000
          },
          {
            'value': 510923000000,
            'text': '大英县',
            'level': 3,
            'pvalue': 510900000000
          },
          {
            'value': 510981000000,
            'text': '射洪市',
            'level': 3,
            'pvalue': 510900000000
          }
        ]
      },
      {
        'value': 511000000000,
        'text': '内江市',
        'level': 2,
        'pvalue': 510000000000,
        'children': [
          {
            'value': 511001000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 511000000000
          },
          {
            'value': 511002000000,
            'text': '市中区',
            'level': 3,
            'pvalue': 511000000000
          },
          {
            'value': 511011000000,
            'text': '东兴区',
            'level': 3,
            'pvalue': 511000000000
          },
          {
            'value': 511024000000,
            'text': '威远县',
            'level': 3,
            'pvalue': 511000000000
          },
          {
            'value': 511025000000,
            'text': '资中县',
            'level': 3,
            'pvalue': 511000000000
          },
          {
            'value': 511071000000,
            'text': '内江经济开发区',
            'level': 3,
            'pvalue': 511000000000
          },
          {
            'value': 511083000000,
            'text': '隆昌市',
            'level': 3,
            'pvalue': 511000000000
          }
        ]
      },
      {
        'value': 511100000000,
        'text': '乐山市',
        'level': 2,
        'pvalue': 510000000000,
        'children': [
          {
            'value': 511101000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 511100000000
          },
          {
            'value': 511102000000,
            'text': '市中区',
            'level': 3,
            'pvalue': 511100000000
          },
          {
            'value': 511111000000,
            'text': '沙湾区',
            'level': 3,
            'pvalue': 511100000000
          },
          {
            'value': 511112000000,
            'text': '五通桥区',
            'level': 3,
            'pvalue': 511100000000
          },
          {
            'value': 511113000000,
            'text': '金口河区',
            'level': 3,
            'pvalue': 511100000000
          },
          {
            'value': 511123000000,
            'text': '犍为县',
            'level': 3,
            'pvalue': 511100000000
          },
          {
            'value': 511124000000,
            'text': '井研县',
            'level': 3,
            'pvalue': 511100000000
          },
          {
            'value': 511126000000,
            'text': '夹江县',
            'level': 3,
            'pvalue': 511100000000
          },
          {
            'value': 511129000000,
            'text': '沐川县',
            'level': 3,
            'pvalue': 511100000000
          },
          {
            'value': 511132000000,
            'text': '峨边彝族自治县',
            'level': 3,
            'pvalue': 511100000000
          },
          {
            'value': 511133000000,
            'text': '马边彝族自治县',
            'level': 3,
            'pvalue': 511100000000
          },
          {
            'value': 511181000000,
            'text': '峨眉山市',
            'level': 3,
            'pvalue': 511100000000
          }
        ]
      },
      {
        'value': 511300000000,
        'text': '南充市',
        'level': 2,
        'pvalue': 510000000000,
        'children': [
          {
            'value': 511301000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 511300000000
          },
          {
            'value': 511302000000,
            'text': '顺庆区',
            'level': 3,
            'pvalue': 511300000000
          },
          {
            'value': 511303000000,
            'text': '高坪区',
            'level': 3,
            'pvalue': 511300000000
          },
          {
            'value': 511304000000,
            'text': '嘉陵区',
            'level': 3,
            'pvalue': 511300000000
          },
          {
            'value': 511321000000,
            'text': '南部县',
            'level': 3,
            'pvalue': 511300000000
          },
          {
            'value': 511322000000,
            'text': '营山县',
            'level': 3,
            'pvalue': 511300000000
          },
          {
            'value': 511323000000,
            'text': '蓬安县',
            'level': 3,
            'pvalue': 511300000000
          },
          {
            'value': 511324000000,
            'text': '仪陇县',
            'level': 3,
            'pvalue': 511300000000
          },
          {
            'value': 511325000000,
            'text': '西充县',
            'level': 3,
            'pvalue': 511300000000
          },
          {
            'value': 511381000000,
            'text': '阆中市',
            'level': 3,
            'pvalue': 511300000000
          }
        ]
      },
      {
        'value': 511400000000,
        'text': '眉山市',
        'level': 2,
        'pvalue': 510000000000,
        'children': [
          {
            'value': 511401000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 511400000000
          },
          {
            'value': 511402000000,
            'text': '东坡区',
            'level': 3,
            'pvalue': 511400000000
          },
          {
            'value': 511403000000,
            'text': '彭山区',
            'level': 3,
            'pvalue': 511400000000
          },
          {
            'value': 511421000000,
            'text': '仁寿县',
            'level': 3,
            'pvalue': 511400000000
          },
          {
            'value': 511423000000,
            'text': '洪雅县',
            'level': 3,
            'pvalue': 511400000000
          },
          {
            'value': 511424000000,
            'text': '丹棱县',
            'level': 3,
            'pvalue': 511400000000
          },
          {
            'value': 511425000000,
            'text': '青神县',
            'level': 3,
            'pvalue': 511400000000
          }
        ]
      },
      {
        'value': 511500000000,
        'text': '宜宾市',
        'level': 2,
        'pvalue': 510000000000,
        'children': [
          {
            'value': 511501000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 511500000000
          },
          {
            'value': 511502000000,
            'text': '翠屏区',
            'level': 3,
            'pvalue': 511500000000
          },
          {
            'value': 511503000000,
            'text': '南溪区',
            'level': 3,
            'pvalue': 511500000000
          },
          {
            'value': 511504000000,
            'text': '叙州区',
            'level': 3,
            'pvalue': 511500000000
          },
          {
            'value': 511523000000,
            'text': '江安县',
            'level': 3,
            'pvalue': 511500000000
          },
          {
            'value': 511524000000,
            'text': '长宁县',
            'level': 3,
            'pvalue': 511500000000
          },
          {
            'value': 511525000000,
            'text': '高县',
            'level': 3,
            'pvalue': 511500000000
          },
          {
            'value': 511526000000,
            'text': '珙县',
            'level': 3,
            'pvalue': 511500000000
          },
          {
            'value': 511527000000,
            'text': '筠连县',
            'level': 3,
            'pvalue': 511500000000
          },
          {
            'value': 511528000000,
            'text': '兴文县',
            'level': 3,
            'pvalue': 511500000000
          },
          {
            'value': 511529000000,
            'text': '屏山县',
            'level': 3,
            'pvalue': 511500000000
          }
        ]
      },
      {
        'value': 511600000000,
        'text': '广安市',
        'level': 2,
        'pvalue': 510000000000,
        'children': [
          {
            'value': 511601000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 511600000000
          },
          {
            'value': 511602000000,
            'text': '广安区',
            'level': 3,
            'pvalue': 511600000000
          },
          {
            'value': 511603000000,
            'text': '前锋区',
            'level': 3,
            'pvalue': 511600000000
          },
          {
            'value': 511621000000,
            'text': '岳池县',
            'level': 3,
            'pvalue': 511600000000
          },
          {
            'value': 511622000000,
            'text': '武胜县',
            'level': 3,
            'pvalue': 511600000000
          },
          {
            'value': 511623000000,
            'text': '邻水县',
            'level': 3,
            'pvalue': 511600000000
          },
          {
            'value': 511681000000,
            'text': '华蓥市',
            'level': 3,
            'pvalue': 511600000000
          }
        ]
      },
      {
        'value': 511700000000,
        'text': '达州市',
        'level': 2,
        'pvalue': 510000000000,
        'children': [
          {
            'value': 511701000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 511700000000
          },
          {
            'value': 511702000000,
            'text': '通川区',
            'level': 3,
            'pvalue': 511700000000
          },
          {
            'value': 511703000000,
            'text': '达川区',
            'level': 3,
            'pvalue': 511700000000
          },
          {
            'value': 511722000000,
            'text': '宣汉县',
            'level': 3,
            'pvalue': 511700000000
          },
          {
            'value': 511723000000,
            'text': '开江县',
            'level': 3,
            'pvalue': 511700000000
          },
          {
            'value': 511724000000,
            'text': '大竹县',
            'level': 3,
            'pvalue': 511700000000
          },
          {
            'value': 511725000000,
            'text': '渠县',
            'level': 3,
            'pvalue': 511700000000
          },
          {
            'value': 511771000000,
            'text': '达州经济开发区',
            'level': 3,
            'pvalue': 511700000000
          },
          {
            'value': 511781000000,
            'text': '万源市',
            'level': 3,
            'pvalue': 511700000000
          }
        ]
      },
      {
        'value': 511800000000,
        'text': '雅安市',
        'level': 2,
        'pvalue': 510000000000,
        'children': [
          {
            'value': 511801000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 511800000000
          },
          {
            'value': 511802000000,
            'text': '雨城区',
            'level': 3,
            'pvalue': 511800000000
          },
          {
            'value': 511803000000,
            'text': '名山区',
            'level': 3,
            'pvalue': 511800000000
          },
          {
            'value': 511822000000,
            'text': '荥经县',
            'level': 3,
            'pvalue': 511800000000
          },
          {
            'value': 511823000000,
            'text': '汉源县',
            'level': 3,
            'pvalue': 511800000000
          },
          {
            'value': 511824000000,
            'text': '石棉县',
            'level': 3,
            'pvalue': 511800000000
          },
          {
            'value': 511825000000,
            'text': '天全县',
            'level': 3,
            'pvalue': 511800000000
          },
          {
            'value': 511826000000,
            'text': '芦山县',
            'level': 3,
            'pvalue': 511800000000
          },
          {
            'value': 511827000000,
            'text': '宝兴县',
            'level': 3,
            'pvalue': 511800000000
          }
        ]
      },
      {
        'value': 511900000000,
        'text': '巴中市',
        'level': 2,
        'pvalue': 510000000000,
        'children': [
          {
            'value': 511901000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 511900000000
          },
          {
            'value': 511902000000,
            'text': '巴州区',
            'level': 3,
            'pvalue': 511900000000
          },
          {
            'value': 511903000000,
            'text': '恩阳区',
            'level': 3,
            'pvalue': 511900000000
          },
          {
            'value': 511921000000,
            'text': '通江县',
            'level': 3,
            'pvalue': 511900000000
          },
          {
            'value': 511922000000,
            'text': '南江县',
            'level': 3,
            'pvalue': 511900000000
          },
          {
            'value': 511923000000,
            'text': '平昌县',
            'level': 3,
            'pvalue': 511900000000
          },
          {
            'value': 511971000000,
            'text': '巴中经济开发区',
            'level': 3,
            'pvalue': 511900000000
          }
        ]
      },
      {
        'value': 512000000000,
        'text': '资阳市',
        'level': 2,
        'pvalue': 510000000000,
        'children': [
          {
            'value': 512001000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 512000000000
          },
          {
            'value': 512002000000,
            'text': '雁江区',
            'level': 3,
            'pvalue': 512000000000
          },
          {
            'value': 512021000000,
            'text': '安岳县',
            'level': 3,
            'pvalue': 512000000000
          },
          {
            'value': 512022000000,
            'text': '乐至县',
            'level': 3,
            'pvalue': 512000000000
          }
        ]
      },
      {
        'value': 513200000000,
        'text': '阿坝藏族羌族自治州',
        'level': 2,
        'pvalue': 510000000000,
        'children': [
          {
            'value': 513201000000,
            'text': '马尔康市',
            'level': 3,
            'pvalue': 513200000000
          },
          {
            'value': 513221000000,
            'text': '汶川县',
            'level': 3,
            'pvalue': 513200000000
          },
          {
            'value': 513222000000,
            'text': '理县',
            'level': 3,
            'pvalue': 513200000000
          },
          {
            'value': 513223000000,
            'text': '茂县',
            'level': 3,
            'pvalue': 513200000000
          },
          {
            'value': 513224000000,
            'text': '松潘县',
            'level': 3,
            'pvalue': 513200000000
          },
          {
            'value': 513225000000,
            'text': '九寨沟县',
            'level': 3,
            'pvalue': 513200000000
          },
          {
            'value': 513226000000,
            'text': '金川县',
            'level': 3,
            'pvalue': 513200000000
          },
          {
            'value': 513227000000,
            'text': '小金县',
            'level': 3,
            'pvalue': 513200000000
          },
          {
            'value': 513228000000,
            'text': '黑水县',
            'level': 3,
            'pvalue': 513200000000
          },
          {
            'value': 513230000000,
            'text': '壤塘县',
            'level': 3,
            'pvalue': 513200000000
          },
          {
            'value': 513231000000,
            'text': '阿坝县',
            'level': 3,
            'pvalue': 513200000000
          },
          {
            'value': 513232000000,
            'text': '若尔盖县',
            'level': 3,
            'pvalue': 513200000000
          },
          {
            'value': 513233000000,
            'text': '红原县',
            'level': 3,
            'pvalue': 513200000000
          }
        ]
      },
      {
        'value': 513300000000,
        'text': '甘孜藏族自治州',
        'level': 2,
        'pvalue': 510000000000,
        'children': [
          {
            'value': 513301000000,
            'text': '康定市',
            'level': 3,
            'pvalue': 513300000000
          },
          {
            'value': 513322000000,
            'text': '泸定县',
            'level': 3,
            'pvalue': 513300000000
          },
          {
            'value': 513323000000,
            'text': '丹巴县',
            'level': 3,
            'pvalue': 513300000000
          },
          {
            'value': 513324000000,
            'text': '九龙县',
            'level': 3,
            'pvalue': 513300000000
          },
          {
            'value': 513325000000,
            'text': '雅江县',
            'level': 3,
            'pvalue': 513300000000
          },
          {
            'value': 513326000000,
            'text': '道孚县',
            'level': 3,
            'pvalue': 513300000000
          },
          {
            'value': 513327000000,
            'text': '炉霍县',
            'level': 3,
            'pvalue': 513300000000
          },
          {
            'value': 513328000000,
            'text': '甘孜县',
            'level': 3,
            'pvalue': 513300000000
          },
          {
            'value': 513329000000,
            'text': '新龙县',
            'level': 3,
            'pvalue': 513300000000
          },
          {
            'value': 513330000000,
            'text': '德格县',
            'level': 3,
            'pvalue': 513300000000
          },
          {
            'value': 513331000000,
            'text': '白玉县',
            'level': 3,
            'pvalue': 513300000000
          },
          {
            'value': 513332000000,
            'text': '石渠县',
            'level': 3,
            'pvalue': 513300000000
          },
          {
            'value': 513333000000,
            'text': '色达县',
            'level': 3,
            'pvalue': 513300000000
          },
          {
            'value': 513334000000,
            'text': '理塘县',
            'level': 3,
            'pvalue': 513300000000
          },
          {
            'value': 513335000000,
            'text': '巴塘县',
            'level': 3,
            'pvalue': 513300000000
          },
          {
            'value': 513336000000,
            'text': '乡城县',
            'level': 3,
            'pvalue': 513300000000
          },
          {
            'value': 513337000000,
            'text': '稻城县',
            'level': 3,
            'pvalue': 513300000000
          },
          {
            'value': 513338000000,
            'text': '得荣县',
            'level': 3,
            'pvalue': 513300000000
          }
        ]
      },
      {
        'value': 513400000000,
        'text': '凉山彝族自治州',
        'level': 2,
        'pvalue': 510000000000,
        'children': [
          {
            'value': 513401000000,
            'text': '西昌市',
            'level': 3,
            'pvalue': 513400000000
          },
          {
            'value': 513402000000,
            'text': '会理市',
            'level': 3,
            'pvalue': 513400000000
          },
          {
            'value': 513422000000,
            'text': '木里藏族自治县',
            'level': 3,
            'pvalue': 513400000000
          },
          {
            'value': 513423000000,
            'text': '盐源县',
            'level': 3,
            'pvalue': 513400000000
          },
          {
            'value': 513424000000,
            'text': '德昌县',
            'level': 3,
            'pvalue': 513400000000
          },
          {
            'value': 513426000000,
            'text': '会东县',
            'level': 3,
            'pvalue': 513400000000
          },
          {
            'value': 513427000000,
            'text': '宁南县',
            'level': 3,
            'pvalue': 513400000000
          },
          {
            'value': 513428000000,
            'text': '普格县',
            'level': 3,
            'pvalue': 513400000000
          },
          {
            'value': 513429000000,
            'text': '布拖县',
            'level': 3,
            'pvalue': 513400000000
          },
          {
            'value': 513430000000,
            'text': '金阳县',
            'level': 3,
            'pvalue': 513400000000
          },
          {
            'value': 513431000000,
            'text': '昭觉县',
            'level': 3,
            'pvalue': 513400000000
          },
          {
            'value': 513432000000,
            'text': '喜德县',
            'level': 3,
            'pvalue': 513400000000
          },
          {
            'value': 513433000000,
            'text': '冕宁县',
            'level': 3,
            'pvalue': 513400000000
          },
          {
            'value': 513434000000,
            'text': '越西县',
            'level': 3,
            'pvalue': 513400000000
          },
          {
            'value': 513435000000,
            'text': '甘洛县',
            'level': 3,
            'pvalue': 513400000000
          },
          {
            'value': 513436000000,
            'text': '美姑县',
            'level': 3,
            'pvalue': 513400000000
          },
          {
            'value': 513437000000,
            'text': '雷波县',
            'level': 3,
            'pvalue': 513400000000
          }
        ]
      }
    ]
  },
  {
    'value': 520000000000,
    'text': '贵州省',
    'level': 1,
    'pvalue': 0,
    'children': [
      {
        'value': 520100000000,
        'text': '贵阳市',
        'level': 2,
        'pvalue': 520000000000,
        'children': [
          {
            'value': 520101000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 520100000000
          },
          {
            'value': 520102000000,
            'text': '南明区',
            'level': 3,
            'pvalue': 520100000000
          },
          {
            'value': 520103000000,
            'text': '云岩区',
            'level': 3,
            'pvalue': 520100000000
          },
          {
            'value': 520111000000,
            'text': '花溪区',
            'level': 3,
            'pvalue': 520100000000
          },
          {
            'value': 520112000000,
            'text': '乌当区',
            'level': 3,
            'pvalue': 520100000000
          },
          {
            'value': 520113000000,
            'text': '白云区',
            'level': 3,
            'pvalue': 520100000000
          },
          {
            'value': 520115000000,
            'text': '观山湖区',
            'level': 3,
            'pvalue': 520100000000
          },
          {
            'value': 520121000000,
            'text': '开阳县',
            'level': 3,
            'pvalue': 520100000000
          },
          {
            'value': 520122000000,
            'text': '息烽县',
            'level': 3,
            'pvalue': 520100000000
          },
          {
            'value': 520123000000,
            'text': '修文县',
            'level': 3,
            'pvalue': 520100000000
          },
          {
            'value': 520181000000,
            'text': '清镇市',
            'level': 3,
            'pvalue': 520100000000
          }
        ]
      },
      {
        'value': 520200000000,
        'text': '六盘水市',
        'level': 2,
        'pvalue': 520000000000,
        'children': [
          {
            'value': 520201000000,
            'text': '钟山区',
            'level': 3,
            'pvalue': 520200000000
          },
          {
            'value': 520203000000,
            'text': '六枝特区',
            'level': 3,
            'pvalue': 520200000000
          },
          {
            'value': 520204000000,
            'text': '水城区',
            'level': 3,
            'pvalue': 520200000000
          },
          {
            'value': 520281000000,
            'text': '盘州市',
            'level': 3,
            'pvalue': 520200000000
          }
        ]
      },
      {
        'value': 520300000000,
        'text': '遵义市',
        'level': 2,
        'pvalue': 520000000000,
        'children': [
          {
            'value': 520301000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 520300000000
          },
          {
            'value': 520302000000,
            'text': '红花岗区',
            'level': 3,
            'pvalue': 520300000000
          },
          {
            'value': 520303000000,
            'text': '汇川区',
            'level': 3,
            'pvalue': 520300000000
          },
          {
            'value': 520304000000,
            'text': '播州区',
            'level': 3,
            'pvalue': 520300000000
          },
          {
            'value': 520322000000,
            'text': '桐梓县',
            'level': 3,
            'pvalue': 520300000000
          },
          {
            'value': 520323000000,
            'text': '绥阳县',
            'level': 3,
            'pvalue': 520300000000
          },
          {
            'value': 520324000000,
            'text': '正安县',
            'level': 3,
            'pvalue': 520300000000
          },
          {
            'value': 520325000000,
            'text': '道真仡佬族苗族自治县',
            'level': 3,
            'pvalue': 520300000000
          },
          {
            'value': 520326000000,
            'text': '务川仡佬族苗族自治县',
            'level': 3,
            'pvalue': 520300000000
          },
          {
            'value': 520327000000,
            'text': '凤冈县',
            'level': 3,
            'pvalue': 520300000000
          },
          {
            'value': 520328000000,
            'text': '湄潭县',
            'level': 3,
            'pvalue': 520300000000
          },
          {
            'value': 520329000000,
            'text': '余庆县',
            'level': 3,
            'pvalue': 520300000000
          },
          {
            'value': 520330000000,
            'text': '习水县',
            'level': 3,
            'pvalue': 520300000000
          },
          {
            'value': 520381000000,
            'text': '赤水市',
            'level': 3,
            'pvalue': 520300000000
          },
          {
            'value': 520382000000,
            'text': '仁怀市',
            'level': 3,
            'pvalue': 520300000000
          }
        ]
      },
      {
        'value': 520400000000,
        'text': '安顺市',
        'level': 2,
        'pvalue': 520000000000,
        'children': [
          {
            'value': 520401000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 520400000000
          },
          {
            'value': 520402000000,
            'text': '西秀区',
            'level': 3,
            'pvalue': 520400000000
          },
          {
            'value': 520403000000,
            'text': '平坝区',
            'level': 3,
            'pvalue': 520400000000
          },
          {
            'value': 520422000000,
            'text': '普定县',
            'level': 3,
            'pvalue': 520400000000
          },
          {
            'value': 520423000000,
            'text': '镇宁布依族苗族自治县',
            'level': 3,
            'pvalue': 520400000000
          },
          {
            'value': 520424000000,
            'text': '关岭布依族苗族自治县',
            'level': 3,
            'pvalue': 520400000000
          },
          {
            'value': 520425000000,
            'text': '紫云苗族布依族自治县',
            'level': 3,
            'pvalue': 520400000000
          }
        ]
      },
      {
        'value': 520500000000,
        'text': '毕节市',
        'level': 2,
        'pvalue': 520000000000,
        'children': [
          {
            'value': 520501000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 520500000000
          },
          {
            'value': 520502000000,
            'text': '七星关区',
            'level': 3,
            'pvalue': 520500000000
          },
          {
            'value': 520521000000,
            'text': '大方县',
            'level': 3,
            'pvalue': 520500000000
          },
          {
            'value': 520523000000,
            'text': '金沙县',
            'level': 3,
            'pvalue': 520500000000
          },
          {
            'value': 520524000000,
            'text': '织金县',
            'level': 3,
            'pvalue': 520500000000
          },
          {
            'value': 520525000000,
            'text': '纳雍县',
            'level': 3,
            'pvalue': 520500000000
          },
          {
            'value': 520526000000,
            'text': '威宁彝族回族苗族自治县',
            'level': 3,
            'pvalue': 520500000000
          },
          {
            'value': 520527000000,
            'text': '赫章县',
            'level': 3,
            'pvalue': 520500000000
          },
          {
            'value': 520581000000,
            'text': '黔西市',
            'level': 3,
            'pvalue': 520500000000
          }
        ]
      },
      {
        'value': 520600000000,
        'text': '铜仁市',
        'level': 2,
        'pvalue': 520000000000,
        'children': [
          {
            'value': 520601000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 520600000000
          },
          {
            'value': 520602000000,
            'text': '碧江区',
            'level': 3,
            'pvalue': 520600000000
          },
          {
            'value': 520603000000,
            'text': '万山区',
            'level': 3,
            'pvalue': 520600000000
          },
          {
            'value': 520621000000,
            'text': '江口县',
            'level': 3,
            'pvalue': 520600000000
          },
          {
            'value': 520622000000,
            'text': '玉屏侗族自治县',
            'level': 3,
            'pvalue': 520600000000
          },
          {
            'value': 520623000000,
            'text': '石阡县',
            'level': 3,
            'pvalue': 520600000000
          },
          {
            'value': 520624000000,
            'text': '思南县',
            'level': 3,
            'pvalue': 520600000000
          },
          {
            'value': 520625000000,
            'text': '印江土家族苗族自治县',
            'level': 3,
            'pvalue': 520600000000
          },
          {
            'value': 520626000000,
            'text': '德江县',
            'level': 3,
            'pvalue': 520600000000
          },
          {
            'value': 520627000000,
            'text': '沿河土家族自治县',
            'level': 3,
            'pvalue': 520600000000
          },
          {
            'value': 520628000000,
            'text': '松桃苗族自治县',
            'level': 3,
            'pvalue': 520600000000
          }
        ]
      },
      {
        'value': 522300000000,
        'text': '黔西南布依族苗族自治州',
        'level': 2,
        'pvalue': 520000000000,
        'children': [
          {
            'value': 522301000000,
            'text': '兴义市',
            'level': 3,
            'pvalue': 522300000000
          },
          {
            'value': 522302000000,
            'text': '兴仁市',
            'level': 3,
            'pvalue': 522300000000
          },
          {
            'value': 522323000000,
            'text': '普安县',
            'level': 3,
            'pvalue': 522300000000
          },
          {
            'value': 522324000000,
            'text': '晴隆县',
            'level': 3,
            'pvalue': 522300000000
          },
          {
            'value': 522325000000,
            'text': '贞丰县',
            'level': 3,
            'pvalue': 522300000000
          },
          {
            'value': 522326000000,
            'text': '望谟县',
            'level': 3,
            'pvalue': 522300000000
          },
          {
            'value': 522327000000,
            'text': '册亨县',
            'level': 3,
            'pvalue': 522300000000
          },
          {
            'value': 522328000000,
            'text': '安龙县',
            'level': 3,
            'pvalue': 522300000000
          }
        ]
      },
      {
        'value': 522600000000,
        'text': '黔东南苗族侗族自治州',
        'level': 2,
        'pvalue': 520000000000,
        'children': [
          {
            'value': 522601000000,
            'text': '凯里市',
            'level': 3,
            'pvalue': 522600000000
          },
          {
            'value': 522622000000,
            'text': '黄平县',
            'level': 3,
            'pvalue': 522600000000
          },
          {
            'value': 522623000000,
            'text': '施秉县',
            'level': 3,
            'pvalue': 522600000000
          },
          {
            'value': 522624000000,
            'text': '三穗县',
            'level': 3,
            'pvalue': 522600000000
          },
          {
            'value': 522625000000,
            'text': '镇远县',
            'level': 3,
            'pvalue': 522600000000
          },
          {
            'value': 522626000000,
            'text': '岑巩县',
            'level': 3,
            'pvalue': 522600000000
          },
          {
            'value': 522627000000,
            'text': '天柱县',
            'level': 3,
            'pvalue': 522600000000
          },
          {
            'value': 522628000000,
            'text': '锦屏县',
            'level': 3,
            'pvalue': 522600000000
          },
          {
            'value': 522629000000,
            'text': '剑河县',
            'level': 3,
            'pvalue': 522600000000
          },
          {
            'value': 522630000000,
            'text': '台江县',
            'level': 3,
            'pvalue': 522600000000
          },
          {
            'value': 522631000000,
            'text': '黎平县',
            'level': 3,
            'pvalue': 522600000000
          },
          {
            'value': 522632000000,
            'text': '榕江县',
            'level': 3,
            'pvalue': 522600000000
          },
          {
            'value': 522633000000,
            'text': '从江县',
            'level': 3,
            'pvalue': 522600000000
          },
          {
            'value': 522634000000,
            'text': '雷山县',
            'level': 3,
            'pvalue': 522600000000
          },
          {
            'value': 522635000000,
            'text': '麻江县',
            'level': 3,
            'pvalue': 522600000000
          },
          {
            'value': 522636000000,
            'text': '丹寨县',
            'level': 3,
            'pvalue': 522600000000
          }
        ]
      },
      {
        'value': 522700000000,
        'text': '黔南布依族苗族自治州',
        'level': 2,
        'pvalue': 520000000000,
        'children': [
          {
            'value': 522701000000,
            'text': '都匀市',
            'level': 3,
            'pvalue': 522700000000
          },
          {
            'value': 522702000000,
            'text': '福泉市',
            'level': 3,
            'pvalue': 522700000000
          },
          {
            'value': 522722000000,
            'text': '荔波县',
            'level': 3,
            'pvalue': 522700000000
          },
          {
            'value': 522723000000,
            'text': '贵定县',
            'level': 3,
            'pvalue': 522700000000
          },
          {
            'value': 522725000000,
            'text': '瓮安县',
            'level': 3,
            'pvalue': 522700000000
          },
          {
            'value': 522726000000,
            'text': '独山县',
            'level': 3,
            'pvalue': 522700000000
          },
          {
            'value': 522727000000,
            'text': '平塘县',
            'level': 3,
            'pvalue': 522700000000
          },
          {
            'value': 522728000000,
            'text': '罗甸县',
            'level': 3,
            'pvalue': 522700000000
          },
          {
            'value': 522729000000,
            'text': '长顺县',
            'level': 3,
            'pvalue': 522700000000
          },
          {
            'value': 522730000000,
            'text': '龙里县',
            'level': 3,
            'pvalue': 522700000000
          },
          {
            'value': 522731000000,
            'text': '惠水县',
            'level': 3,
            'pvalue': 522700000000
          },
          {
            'value': 522732000000,
            'text': '三都水族自治县',
            'level': 3,
            'pvalue': 522700000000
          }
        ]
      }
    ]
  },
  {
    'value': 530000000000,
    'text': '云南省',
    'level': 1,
    'pvalue': 0,
    'children': [
      {
        'value': 530100000000,
        'text': '昆明市',
        'level': 2,
        'pvalue': 530000000000,
        'children': [
          {
            'value': 530101000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 530100000000
          },
          {
            'value': 530102000000,
            'text': '五华区',
            'level': 3,
            'pvalue': 530100000000
          },
          {
            'value': 530103000000,
            'text': '盘龙区',
            'level': 3,
            'pvalue': 530100000000
          },
          {
            'value': 530111000000,
            'text': '官渡区',
            'level': 3,
            'pvalue': 530100000000
          },
          {
            'value': 530112000000,
            'text': '西山区',
            'level': 3,
            'pvalue': 530100000000
          },
          {
            'value': 530113000000,
            'text': '东川区',
            'level': 3,
            'pvalue': 530100000000
          },
          {
            'value': 530114000000,
            'text': '呈贡区',
            'level': 3,
            'pvalue': 530100000000
          },
          {
            'value': 530115000000,
            'text': '晋宁区',
            'level': 3,
            'pvalue': 530100000000
          },
          {
            'value': 530124000000,
            'text': '富民县',
            'level': 3,
            'pvalue': 530100000000
          },
          {
            'value': 530125000000,
            'text': '宜良县',
            'level': 3,
            'pvalue': 530100000000
          },
          {
            'value': 530126000000,
            'text': '石林彝族自治县',
            'level': 3,
            'pvalue': 530100000000
          },
          {
            'value': 530127000000,
            'text': '嵩明县',
            'level': 3,
            'pvalue': 530100000000
          },
          {
            'value': 530128000000,
            'text': '禄劝彝族苗族自治县',
            'level': 3,
            'pvalue': 530100000000
          },
          {
            'value': 530129000000,
            'text': '寻甸回族彝族自治县',
            'level': 3,
            'pvalue': 530100000000
          },
          {
            'value': 530181000000,
            'text': '安宁市',
            'level': 3,
            'pvalue': 530100000000
          }
        ]
      },
      {
        'value': 530300000000,
        'text': '曲靖市',
        'level': 2,
        'pvalue': 530000000000,
        'children': [
          {
            'value': 530301000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 530300000000
          },
          {
            'value': 530302000000,
            'text': '麒麟区',
            'level': 3,
            'pvalue': 530300000000
          },
          {
            'value': 530303000000,
            'text': '沾益区',
            'level': 3,
            'pvalue': 530300000000
          },
          {
            'value': 530304000000,
            'text': '马龙区',
            'level': 3,
            'pvalue': 530300000000
          },
          {
            'value': 530322000000,
            'text': '陆良县',
            'level': 3,
            'pvalue': 530300000000
          },
          {
            'value': 530323000000,
            'text': '师宗县',
            'level': 3,
            'pvalue': 530300000000
          },
          {
            'value': 530324000000,
            'text': '罗平县',
            'level': 3,
            'pvalue': 530300000000
          },
          {
            'value': 530325000000,
            'text': '富源县',
            'level': 3,
            'pvalue': 530300000000
          },
          {
            'value': 530326000000,
            'text': '会泽县',
            'level': 3,
            'pvalue': 530300000000
          },
          {
            'value': 530381000000,
            'text': '宣威市',
            'level': 3,
            'pvalue': 530300000000
          }
        ]
      },
      {
        'value': 530400000000,
        'text': '玉溪市',
        'level': 2,
        'pvalue': 530000000000,
        'children': [
          {
            'value': 530401000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 530400000000
          },
          {
            'value': 530402000000,
            'text': '红塔区',
            'level': 3,
            'pvalue': 530400000000
          },
          {
            'value': 530403000000,
            'text': '江川区',
            'level': 3,
            'pvalue': 530400000000
          },
          {
            'value': 530423000000,
            'text': '通海县',
            'level': 3,
            'pvalue': 530400000000
          },
          {
            'value': 530424000000,
            'text': '华宁县',
            'level': 3,
            'pvalue': 530400000000
          },
          {
            'value': 530425000000,
            'text': '易门县',
            'level': 3,
            'pvalue': 530400000000
          },
          {
            'value': 530426000000,
            'text': '峨山彝族自治县',
            'level': 3,
            'pvalue': 530400000000
          },
          {
            'value': 530427000000,
            'text': '新平彝族傣族自治县',
            'level': 3,
            'pvalue': 530400000000
          },
          {
            'value': 530428000000,
            'text': '元江哈尼族彝族傣族自治县',
            'level': 3,
            'pvalue': 530400000000
          },
          {
            'value': 530481000000,
            'text': '澄江市',
            'level': 3,
            'pvalue': 530400000000
          }
        ]
      },
      {
        'value': 530500000000,
        'text': '保山市',
        'level': 2,
        'pvalue': 530000000000,
        'children': [
          {
            'value': 530501000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 530500000000
          },
          {
            'value': 530502000000,
            'text': '隆阳区',
            'level': 3,
            'pvalue': 530500000000
          },
          {
            'value': 530521000000,
            'text': '施甸县',
            'level': 3,
            'pvalue': 530500000000
          },
          {
            'value': 530523000000,
            'text': '龙陵县',
            'level': 3,
            'pvalue': 530500000000
          },
          {
            'value': 530524000000,
            'text': '昌宁县',
            'level': 3,
            'pvalue': 530500000000
          },
          {
            'value': 530581000000,
            'text': '腾冲市',
            'level': 3,
            'pvalue': 530500000000
          }
        ]
      },
      {
        'value': 530600000000,
        'text': '昭通市',
        'level': 2,
        'pvalue': 530000000000,
        'children': [
          {
            'value': 530601000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 530600000000
          },
          {
            'value': 530602000000,
            'text': '昭阳区',
            'level': 3,
            'pvalue': 530600000000
          },
          {
            'value': 530621000000,
            'text': '鲁甸县',
            'level': 3,
            'pvalue': 530600000000
          },
          {
            'value': 530622000000,
            'text': '巧家县',
            'level': 3,
            'pvalue': 530600000000
          },
          {
            'value': 530623000000,
            'text': '盐津县',
            'level': 3,
            'pvalue': 530600000000
          },
          {
            'value': 530624000000,
            'text': '大关县',
            'level': 3,
            'pvalue': 530600000000
          },
          {
            'value': 530625000000,
            'text': '永善县',
            'level': 3,
            'pvalue': 530600000000
          },
          {
            'value': 530626000000,
            'text': '绥江县',
            'level': 3,
            'pvalue': 530600000000
          },
          {
            'value': 530627000000,
            'text': '镇雄县',
            'level': 3,
            'pvalue': 530600000000
          },
          {
            'value': 530628000000,
            'text': '彝良县',
            'level': 3,
            'pvalue': 530600000000
          },
          {
            'value': 530629000000,
            'text': '威信县',
            'level': 3,
            'pvalue': 530600000000
          },
          {
            'value': 530681000000,
            'text': '水富市',
            'level': 3,
            'pvalue': 530600000000
          }
        ]
      },
      {
        'value': 530700000000,
        'text': '丽江市',
        'level': 2,
        'pvalue': 530000000000,
        'children': [
          {
            'value': 530701000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 530700000000
          },
          {
            'value': 530702000000,
            'text': '古城区',
            'level': 3,
            'pvalue': 530700000000
          },
          {
            'value': 530721000000,
            'text': '玉龙纳西族自治县',
            'level': 3,
            'pvalue': 530700000000
          },
          {
            'value': 530722000000,
            'text': '永胜县',
            'level': 3,
            'pvalue': 530700000000
          },
          {
            'value': 530723000000,
            'text': '华坪县',
            'level': 3,
            'pvalue': 530700000000
          },
          {
            'value': 530724000000,
            'text': '宁蒗彝族自治县',
            'level': 3,
            'pvalue': 530700000000
          }
        ]
      },
      {
        'value': 530800000000,
        'text': '普洱市',
        'level': 2,
        'pvalue': 530000000000,
        'children': [
          {
            'value': 530801000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 530800000000
          },
          {
            'value': 530802000000,
            'text': '思茅区',
            'level': 3,
            'pvalue': 530800000000
          },
          {
            'value': 530821000000,
            'text': '宁洱哈尼族彝族自治县',
            'level': 3,
            'pvalue': 530800000000
          },
          {
            'value': 530822000000,
            'text': '墨江哈尼族自治县',
            'level': 3,
            'pvalue': 530800000000
          },
          {
            'value': 530823000000,
            'text': '景东彝族自治县',
            'level': 3,
            'pvalue': 530800000000
          },
          {
            'value': 530824000000,
            'text': '景谷傣族彝族自治县',
            'level': 3,
            'pvalue': 530800000000
          },
          {
            'value': 530825000000,
            'text': '镇沅彝族哈尼族拉祜族自治县',
            'level': 3,
            'pvalue': 530800000000
          },
          {
            'value': 530826000000,
            'text': '江城哈尼族彝族自治县',
            'level': 3,
            'pvalue': 530800000000
          },
          {
            'value': 530827000000,
            'text': '孟连傣族拉祜族佤族自治县',
            'level': 3,
            'pvalue': 530800000000
          },
          {
            'value': 530828000000,
            'text': '澜沧拉祜族自治县',
            'level': 3,
            'pvalue': 530800000000
          },
          {
            'value': 530829000000,
            'text': '西盟佤族自治县',
            'level': 3,
            'pvalue': 530800000000
          }
        ]
      },
      {
        'value': 530900000000,
        'text': '临沧市',
        'level': 2,
        'pvalue': 530000000000,
        'children': [
          {
            'value': 530901000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 530900000000
          },
          {
            'value': 530902000000,
            'text': '临翔区',
            'level': 3,
            'pvalue': 530900000000
          },
          {
            'value': 530921000000,
            'text': '凤庆县',
            'level': 3,
            'pvalue': 530900000000
          },
          {
            'value': 530922000000,
            'text': '云县',
            'level': 3,
            'pvalue': 530900000000
          },
          {
            'value': 530923000000,
            'text': '永德县',
            'level': 3,
            'pvalue': 530900000000
          },
          {
            'value': 530924000000,
            'text': '镇康县',
            'level': 3,
            'pvalue': 530900000000
          },
          {
            'value': 530925000000,
            'text': '双江拉祜族佤族布朗族傣族自治县',
            'level': 3,
            'pvalue': 530900000000
          },
          {
            'value': 530926000000,
            'text': '耿马傣族佤族自治县',
            'level': 3,
            'pvalue': 530900000000
          },
          {
            'value': 530927000000,
            'text': '沧源佤族自治县',
            'level': 3,
            'pvalue': 530900000000
          }
        ]
      },
      {
        'value': 532300000000,
        'text': '楚雄彝族自治州',
        'level': 2,
        'pvalue': 530000000000,
        'children': [
          {
            'value': 532301000000,
            'text': '楚雄市',
            'level': 3,
            'pvalue': 532300000000
          },
          {
            'value': 532302000000,
            'text': '禄丰市',
            'level': 3,
            'pvalue': 532300000000
          },
          {
            'value': 532322000000,
            'text': '双柏县',
            'level': 3,
            'pvalue': 532300000000
          },
          {
            'value': 532323000000,
            'text': '牟定县',
            'level': 3,
            'pvalue': 532300000000
          },
          {
            'value': 532324000000,
            'text': '南华县',
            'level': 3,
            'pvalue': 532300000000
          },
          {
            'value': 532325000000,
            'text': '姚安县',
            'level': 3,
            'pvalue': 532300000000
          },
          {
            'value': 532326000000,
            'text': '大姚县',
            'level': 3,
            'pvalue': 532300000000
          },
          {
            'value': 532327000000,
            'text': '永仁县',
            'level': 3,
            'pvalue': 532300000000
          },
          {
            'value': 532328000000,
            'text': '元谋县',
            'level': 3,
            'pvalue': 532300000000
          },
          {
            'value': 532329000000,
            'text': '武定县',
            'level': 3,
            'pvalue': 532300000000
          }
        ]
      },
      {
        'value': 532500000000,
        'text': '红河哈尼族彝族自治州',
        'level': 2,
        'pvalue': 530000000000,
        'children': [
          {
            'value': 532501000000,
            'text': '个旧市',
            'level': 3,
            'pvalue': 532500000000
          },
          {
            'value': 532502000000,
            'text': '开远市',
            'level': 3,
            'pvalue': 532500000000
          },
          {
            'value': 532503000000,
            'text': '蒙自市',
            'level': 3,
            'pvalue': 532500000000
          },
          {
            'value': 532504000000,
            'text': '弥勒市',
            'level': 3,
            'pvalue': 532500000000
          },
          {
            'value': 532523000000,
            'text': '屏边苗族自治县',
            'level': 3,
            'pvalue': 532500000000
          },
          {
            'value': 532524000000,
            'text': '建水县',
            'level': 3,
            'pvalue': 532500000000
          },
          {
            'value': 532525000000,
            'text': '石屏县',
            'level': 3,
            'pvalue': 532500000000
          },
          {
            'value': 532527000000,
            'text': '泸西县',
            'level': 3,
            'pvalue': 532500000000
          },
          {
            'value': 532528000000,
            'text': '元阳县',
            'level': 3,
            'pvalue': 532500000000
          },
          {
            'value': 532529000000,
            'text': '红河县',
            'level': 3,
            'pvalue': 532500000000
          },
          {
            'value': 532530000000,
            'text': '金平苗族瑶族傣族自治县',
            'level': 3,
            'pvalue': 532500000000
          },
          {
            'value': 532531000000,
            'text': '绿春县',
            'level': 3,
            'pvalue': 532500000000
          },
          {
            'value': 532532000000,
            'text': '河口瑶族自治县',
            'level': 3,
            'pvalue': 532500000000
          }
        ]
      },
      {
        'value': 532600000000,
        'text': '文山壮族苗族自治州',
        'level': 2,
        'pvalue': 530000000000,
        'children': [
          {
            'value': 532601000000,
            'text': '文山市',
            'level': 3,
            'pvalue': 532600000000
          },
          {
            'value': 532622000000,
            'text': '砚山县',
            'level': 3,
            'pvalue': 532600000000
          },
          {
            'value': 532623000000,
            'text': '西畴县',
            'level': 3,
            'pvalue': 532600000000
          },
          {
            'value': 532624000000,
            'text': '麻栗坡县',
            'level': 3,
            'pvalue': 532600000000
          },
          {
            'value': 532625000000,
            'text': '马关县',
            'level': 3,
            'pvalue': 532600000000
          },
          {
            'value': 532626000000,
            'text': '丘北县',
            'level': 3,
            'pvalue': 532600000000
          },
          {
            'value': 532627000000,
            'text': '广南县',
            'level': 3,
            'pvalue': 532600000000
          },
          {
            'value': 532628000000,
            'text': '富宁县',
            'level': 3,
            'pvalue': 532600000000
          }
        ]
      },
      {
        'value': 532800000000,
        'text': '西双版纳傣族自治州',
        'level': 2,
        'pvalue': 530000000000,
        'children': [
          {
            'value': 532801000000,
            'text': '景洪市',
            'level': 3,
            'pvalue': 532800000000
          },
          {
            'value': 532822000000,
            'text': '勐海县',
            'level': 3,
            'pvalue': 532800000000
          },
          {
            'value': 532823000000,
            'text': '勐腊县',
            'level': 3,
            'pvalue': 532800000000
          }
        ]
      },
      {
        'value': 532900000000,
        'text': '大理白族自治州',
        'level': 2,
        'pvalue': 530000000000,
        'children': [
          {
            'value': 532901000000,
            'text': '大理市',
            'level': 3,
            'pvalue': 532900000000
          },
          {
            'value': 532922000000,
            'text': '漾濞彝族自治县',
            'level': 3,
            'pvalue': 532900000000
          },
          {
            'value': 532923000000,
            'text': '祥云县',
            'level': 3,
            'pvalue': 532900000000
          },
          {
            'value': 532924000000,
            'text': '宾川县',
            'level': 3,
            'pvalue': 532900000000
          },
          {
            'value': 532925000000,
            'text': '弥渡县',
            'level': 3,
            'pvalue': 532900000000
          },
          {
            'value': 532926000000,
            'text': '南涧彝族自治县',
            'level': 3,
            'pvalue': 532900000000
          },
          {
            'value': 532927000000,
            'text': '巍山彝族回族自治县',
            'level': 3,
            'pvalue': 532900000000
          },
          {
            'value': 532928000000,
            'text': '永平县',
            'level': 3,
            'pvalue': 532900000000
          },
          {
            'value': 532929000000,
            'text': '云龙县',
            'level': 3,
            'pvalue': 532900000000
          },
          {
            'value': 532930000000,
            'text': '洱源县',
            'level': 3,
            'pvalue': 532900000000
          },
          {
            'value': 532931000000,
            'text': '剑川县',
            'level': 3,
            'pvalue': 532900000000
          },
          {
            'value': 532932000000,
            'text': '鹤庆县',
            'level': 3,
            'pvalue': 532900000000
          }
        ]
      },
      {
        'value': 533100000000,
        'text': '德宏傣族景颇族自治州',
        'level': 2,
        'pvalue': 530000000000,
        'children': [
          {
            'value': 533102000000,
            'text': '瑞丽市',
            'level': 3,
            'pvalue': 533100000000
          },
          {
            'value': 533103000000,
            'text': '芒市',
            'level': 3,
            'pvalue': 533100000000
          },
          {
            'value': 533122000000,
            'text': '梁河县',
            'level': 3,
            'pvalue': 533100000000
          },
          {
            'value': 533123000000,
            'text': '盈江县',
            'level': 3,
            'pvalue': 533100000000
          },
          {
            'value': 533124000000,
            'text': '陇川县',
            'level': 3,
            'pvalue': 533100000000
          }
        ]
      },
      {
        'value': 533300000000,
        'text': '怒江傈僳族自治州',
        'level': 2,
        'pvalue': 530000000000,
        'children': [
          {
            'value': 533301000000,
            'text': '泸水市',
            'level': 3,
            'pvalue': 533300000000
          },
          {
            'value': 533323000000,
            'text': '福贡县',
            'level': 3,
            'pvalue': 533300000000
          },
          {
            'value': 533324000000,
            'text': '贡山独龙族怒族自治县',
            'level': 3,
            'pvalue': 533300000000
          },
          {
            'value': 533325000000,
            'text': '兰坪白族普米族自治县',
            'level': 3,
            'pvalue': 533300000000
          }
        ]
      },
      {
        'value': 533400000000,
        'text': '迪庆藏族自治州',
        'level': 2,
        'pvalue': 530000000000,
        'children': [
          {
            'value': 533401000000,
            'text': '香格里拉市',
            'level': 3,
            'pvalue': 533400000000
          },
          {
            'value': 533422000000,
            'text': '德钦县',
            'level': 3,
            'pvalue': 533400000000
          },
          {
            'value': 533423000000,
            'text': '维西傈僳族自治县',
            'level': 3,
            'pvalue': 533400000000
          }
        ]
      }
    ]
  },
  {
    'value': 540000000000,
    'text': '西藏自治区',
    'level': 1,
    'pvalue': 0,
    'children': [
      {
        'value': 540100000000,
        'text': '拉萨市',
        'level': 2,
        'pvalue': 540000000000,
        'children': [
          {
            'value': 540101000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 540100000000
          },
          {
            'value': 540102000000,
            'text': '城关区',
            'level': 3,
            'pvalue': 540100000000
          },
          {
            'value': 540103000000,
            'text': '堆龙德庆区',
            'level': 3,
            'pvalue': 540100000000
          },
          {
            'value': 540104000000,
            'text': '达孜区',
            'level': 3,
            'pvalue': 540100000000
          },
          {
            'value': 540121000000,
            'text': '林周县',
            'level': 3,
            'pvalue': 540100000000
          },
          {
            'value': 540122000000,
            'text': '当雄县',
            'level': 3,
            'pvalue': 540100000000
          },
          {
            'value': 540123000000,
            'text': '尼木县',
            'level': 3,
            'pvalue': 540100000000
          },
          {
            'value': 540124000000,
            'text': '曲水县',
            'level': 3,
            'pvalue': 540100000000
          },
          {
            'value': 540127000000,
            'text': '墨竹工卡县',
            'level': 3,
            'pvalue': 540100000000
          },
          {
            'value': 540171000000,
            'text': '格尔木藏青工业园区',
            'level': 3,
            'pvalue': 540100000000
          },
          {
            'value': 540172000000,
            'text': '拉萨经济技术开发区',
            'level': 3,
            'pvalue': 540100000000
          },
          {
            'value': 540173000000,
            'text': '西藏文化旅游创意园区',
            'level': 3,
            'pvalue': 540100000000
          },
          {
            'value': 540174000000,
            'text': '达孜工业园区',
            'level': 3,
            'pvalue': 540100000000
          }
        ]
      },
      {
        'value': 540200000000,
        'text': '日喀则市',
        'level': 2,
        'pvalue': 540000000000,
        'children': [
          {
            'value': 540202000000,
            'text': '桑珠孜区',
            'level': 3,
            'pvalue': 540200000000
          },
          {
            'value': 540221000000,
            'text': '南木林县',
            'level': 3,
            'pvalue': 540200000000
          },
          {
            'value': 540222000000,
            'text': '江孜县',
            'level': 3,
            'pvalue': 540200000000
          },
          {
            'value': 540223000000,
            'text': '定日县',
            'level': 3,
            'pvalue': 540200000000
          },
          {
            'value': 540224000000,
            'text': '萨迦县',
            'level': 3,
            'pvalue': 540200000000
          },
          {
            'value': 540225000000,
            'text': '拉孜县',
            'level': 3,
            'pvalue': 540200000000
          },
          {
            'value': 540226000000,
            'text': '昂仁县',
            'level': 3,
            'pvalue': 540200000000
          },
          {
            'value': 540227000000,
            'text': '谢通门县',
            'level': 3,
            'pvalue': 540200000000
          },
          {
            'value': 540228000000,
            'text': '白朗县',
            'level': 3,
            'pvalue': 540200000000
          },
          {
            'value': 540229000000,
            'text': '仁布县',
            'level': 3,
            'pvalue': 540200000000
          },
          {
            'value': 540230000000,
            'text': '康马县',
            'level': 3,
            'pvalue': 540200000000
          },
          {
            'value': 540231000000,
            'text': '定结县',
            'level': 3,
            'pvalue': 540200000000
          },
          {
            'value': 540232000000,
            'text': '仲巴县',
            'level': 3,
            'pvalue': 540200000000
          },
          {
            'value': 540233000000,
            'text': '亚东县',
            'level': 3,
            'pvalue': 540200000000
          },
          {
            'value': 540234000000,
            'text': '吉隆县',
            'level': 3,
            'pvalue': 540200000000
          },
          {
            'value': 540235000000,
            'text': '聂拉木县',
            'level': 3,
            'pvalue': 540200000000
          },
          {
            'value': 540236000000,
            'text': '萨嘎县',
            'level': 3,
            'pvalue': 540200000000
          },
          {
            'value': 540237000000,
            'text': '岗巴县',
            'level': 3,
            'pvalue': 540200000000
          }
        ]
      },
      {
        'value': 540300000000,
        'text': '昌都市',
        'level': 2,
        'pvalue': 540000000000,
        'children': [
          {
            'value': 540302000000,
            'text': '卡若区',
            'level': 3,
            'pvalue': 540300000000
          },
          {
            'value': 540321000000,
            'text': '江达县',
            'level': 3,
            'pvalue': 540300000000
          },
          {
            'value': 540322000000,
            'text': '贡觉县',
            'level': 3,
            'pvalue': 540300000000
          },
          {
            'value': 540323000000,
            'text': '类乌齐县',
            'level': 3,
            'pvalue': 540300000000
          },
          {
            'value': 540324000000,
            'text': '丁青县',
            'level': 3,
            'pvalue': 540300000000
          },
          {
            'value': 540325000000,
            'text': '察雅县',
            'level': 3,
            'pvalue': 540300000000
          },
          {
            'value': 540326000000,
            'text': '八宿县',
            'level': 3,
            'pvalue': 540300000000
          },
          {
            'value': 540327000000,
            'text': '左贡县',
            'level': 3,
            'pvalue': 540300000000
          },
          {
            'value': 540328000000,
            'text': '芒康县',
            'level': 3,
            'pvalue': 540300000000
          },
          {
            'value': 540329000000,
            'text': '洛隆县',
            'level': 3,
            'pvalue': 540300000000
          },
          {
            'value': 540330000000,
            'text': '边坝县',
            'level': 3,
            'pvalue': 540300000000
          }
        ]
      },
      {
        'value': 540400000000,
        'text': '林芝市',
        'level': 2,
        'pvalue': 540000000000,
        'children': [
          {
            'value': 540402000000,
            'text': '巴宜区',
            'level': 3,
            'pvalue': 540400000000
          },
          {
            'value': 540421000000,
            'text': '工布江达县',
            'level': 3,
            'pvalue': 540400000000
          },
          {
            'value': 540422000000,
            'text': '米林县',
            'level': 3,
            'pvalue': 540400000000
          },
          {
            'value': 540423000000,
            'text': '墨脱县',
            'level': 3,
            'pvalue': 540400000000
          },
          {
            'value': 540424000000,
            'text': '波密县',
            'level': 3,
            'pvalue': 540400000000
          },
          {
            'value': 540425000000,
            'text': '察隅县',
            'level': 3,
            'pvalue': 540400000000
          },
          {
            'value': 540426000000,
            'text': '朗县',
            'level': 3,
            'pvalue': 540400000000
          }
        ]
      },
      {
        'value': 540500000000,
        'text': '山南市',
        'level': 2,
        'pvalue': 540000000000,
        'children': [
          {
            'value': 540501000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 540500000000
          },
          {
            'value': 540502000000,
            'text': '乃东区',
            'level': 3,
            'pvalue': 540500000000
          },
          {
            'value': 540521000000,
            'text': '扎囊县',
            'level': 3,
            'pvalue': 540500000000
          },
          {
            'value': 540522000000,
            'text': '贡嘎县',
            'level': 3,
            'pvalue': 540500000000
          },
          {
            'value': 540523000000,
            'text': '桑日县',
            'level': 3,
            'pvalue': 540500000000
          },
          {
            'value': 540524000000,
            'text': '琼结县',
            'level': 3,
            'pvalue': 540500000000
          },
          {
            'value': 540525000000,
            'text': '曲松县',
            'level': 3,
            'pvalue': 540500000000
          },
          {
            'value': 540526000000,
            'text': '措美县',
            'level': 3,
            'pvalue': 540500000000
          },
          {
            'value': 540527000000,
            'text': '洛扎县',
            'level': 3,
            'pvalue': 540500000000
          },
          {
            'value': 540528000000,
            'text': '加查县',
            'level': 3,
            'pvalue': 540500000000
          },
          {
            'value': 540529000000,
            'text': '隆子县',
            'level': 3,
            'pvalue': 540500000000
          },
          {
            'value': 540530000000,
            'text': '错那县',
            'level': 3,
            'pvalue': 540500000000
          },
          {
            'value': 540531000000,
            'text': '浪卡子县',
            'level': 3,
            'pvalue': 540500000000
          }
        ]
      },
      {
        'value': 540600000000,
        'text': '那曲市',
        'level': 2,
        'pvalue': 540000000000,
        'children': [
          {
            'value': 540602000000,
            'text': '色尼区',
            'level': 3,
            'pvalue': 540600000000
          },
          {
            'value': 540621000000,
            'text': '嘉黎县',
            'level': 3,
            'pvalue': 540600000000
          },
          {
            'value': 540622000000,
            'text': '比如县',
            'level': 3,
            'pvalue': 540600000000
          },
          {
            'value': 540623000000,
            'text': '聂荣县',
            'level': 3,
            'pvalue': 540600000000
          },
          {
            'value': 540624000000,
            'text': '安多县',
            'level': 3,
            'pvalue': 540600000000
          },
          {
            'value': 540625000000,
            'text': '申扎县',
            'level': 3,
            'pvalue': 540600000000
          },
          {
            'value': 540626000000,
            'text': '索县',
            'level': 3,
            'pvalue': 540600000000
          },
          {
            'value': 540627000000,
            'text': '班戈县',
            'level': 3,
            'pvalue': 540600000000
          },
          {
            'value': 540628000000,
            'text': '巴青县',
            'level': 3,
            'pvalue': 540600000000
          },
          {
            'value': 540629000000,
            'text': '尼玛县',
            'level': 3,
            'pvalue': 540600000000
          },
          {
            'value': 540630000000,
            'text': '双湖县',
            'level': 3,
            'pvalue': 540600000000
          }
        ]
      },
      {
        'value': 542500000000,
        'text': '阿里地区',
        'level': 2,
        'pvalue': 540000000000,
        'children': [
          {
            'value': 542521000000,
            'text': '普兰县',
            'level': 3,
            'pvalue': 542500000000
          },
          {
            'value': 542522000000,
            'text': '札达县',
            'level': 3,
            'pvalue': 542500000000
          },
          {
            'value': 542523000000,
            'text': '噶尔县',
            'level': 3,
            'pvalue': 542500000000
          },
          {
            'value': 542524000000,
            'text': '日土县',
            'level': 3,
            'pvalue': 542500000000
          },
          {
            'value': 542525000000,
            'text': '革吉县',
            'level': 3,
            'pvalue': 542500000000
          },
          {
            'value': 542526000000,
            'text': '改则县',
            'level': 3,
            'pvalue': 542500000000
          },
          {
            'value': 542527000000,
            'text': '措勤县',
            'level': 3,
            'pvalue': 542500000000
          }
        ]
      }
    ]
  },
  {
    'value': 610000000000,
    'text': '陕西省',
    'level': 1,
    'pvalue': 0,
    'children': [
      {
        'value': 610100000000,
        'text': '西安市',
        'level': 2,
        'pvalue': 610000000000,
        'children': [
          {
            'value': 610101000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 610100000000
          },
          {
            'value': 610102000000,
            'text': '新城区',
            'level': 3,
            'pvalue': 610100000000
          },
          {
            'value': 610103000000,
            'text': '碑林区',
            'level': 3,
            'pvalue': 610100000000
          },
          {
            'value': 610104000000,
            'text': '莲湖区',
            'level': 3,
            'pvalue': 610100000000
          },
          {
            'value': 610111000000,
            'text': '灞桥区',
            'level': 3,
            'pvalue': 610100000000
          },
          {
            'value': 610112000000,
            'text': '未央区',
            'level': 3,
            'pvalue': 610100000000
          },
          {
            'value': 610113000000,
            'text': '雁塔区',
            'level': 3,
            'pvalue': 610100000000
          },
          {
            'value': 610114000000,
            'text': '阎良区',
            'level': 3,
            'pvalue': 610100000000
          },
          {
            'value': 610115000000,
            'text': '临潼区',
            'level': 3,
            'pvalue': 610100000000
          },
          {
            'value': 610116000000,
            'text': '长安区',
            'level': 3,
            'pvalue': 610100000000
          },
          {
            'value': 610117000000,
            'text': '高陵区',
            'level': 3,
            'pvalue': 610100000000
          },
          {
            'value': 610118000000,
            'text': '鄠邑区',
            'level': 3,
            'pvalue': 610100000000
          },
          {
            'value': 610122000000,
            'text': '蓝田县',
            'level': 3,
            'pvalue': 610100000000
          },
          {
            'value': 610124000000,
            'text': '周至县',
            'level': 3,
            'pvalue': 610100000000
          }
        ]
      },
      {
        'value': 610200000000,
        'text': '铜川市',
        'level': 2,
        'pvalue': 610000000000,
        'children': [
          {
            'value': 610201000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 610200000000
          },
          {
            'value': 610202000000,
            'text': '王益区',
            'level': 3,
            'pvalue': 610200000000
          },
          {
            'value': 610203000000,
            'text': '印台区',
            'level': 3,
            'pvalue': 610200000000
          },
          {
            'value': 610204000000,
            'text': '耀州区',
            'level': 3,
            'pvalue': 610200000000
          },
          {
            'value': 610222000000,
            'text': '宜君县',
            'level': 3,
            'pvalue': 610200000000
          }
        ]
      },
      {
        'value': 610300000000,
        'text': '宝鸡市',
        'level': 2,
        'pvalue': 610000000000,
        'children': [
          {
            'value': 610301000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 610300000000
          },
          {
            'value': 610302000000,
            'text': '渭滨区',
            'level': 3,
            'pvalue': 610300000000
          },
          {
            'value': 610303000000,
            'text': '金台区',
            'level': 3,
            'pvalue': 610300000000
          },
          {
            'value': 610304000000,
            'text': '陈仓区',
            'level': 3,
            'pvalue': 610300000000
          },
          {
            'value': 610305000000,
            'text': '凤翔区',
            'level': 3,
            'pvalue': 610300000000
          },
          {
            'value': 610323000000,
            'text': '岐山县',
            'level': 3,
            'pvalue': 610300000000
          },
          {
            'value': 610324000000,
            'text': '扶风县',
            'level': 3,
            'pvalue': 610300000000
          },
          {
            'value': 610326000000,
            'text': '眉县',
            'level': 3,
            'pvalue': 610300000000
          },
          {
            'value': 610327000000,
            'text': '陇县',
            'level': 3,
            'pvalue': 610300000000
          },
          {
            'value': 610328000000,
            'text': '千阳县',
            'level': 3,
            'pvalue': 610300000000
          },
          {
            'value': 610329000000,
            'text': '麟游县',
            'level': 3,
            'pvalue': 610300000000
          },
          {
            'value': 610330000000,
            'text': '凤县',
            'level': 3,
            'pvalue': 610300000000
          },
          {
            'value': 610331000000,
            'text': '太白县',
            'level': 3,
            'pvalue': 610300000000
          }
        ]
      },
      {
        'value': 610400000000,
        'text': '咸阳市',
        'level': 2,
        'pvalue': 610000000000,
        'children': [
          {
            'value': 610401000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 610400000000
          },
          {
            'value': 610402000000,
            'text': '秦都区',
            'level': 3,
            'pvalue': 610400000000
          },
          {
            'value': 610403000000,
            'text': '杨陵区',
            'level': 3,
            'pvalue': 610400000000
          },
          {
            'value': 610404000000,
            'text': '渭城区',
            'level': 3,
            'pvalue': 610400000000
          },
          {
            'value': 610422000000,
            'text': '三原县',
            'level': 3,
            'pvalue': 610400000000
          },
          {
            'value': 610423000000,
            'text': '泾阳县',
            'level': 3,
            'pvalue': 610400000000
          },
          {
            'value': 610424000000,
            'text': '乾县',
            'level': 3,
            'pvalue': 610400000000
          },
          {
            'value': 610425000000,
            'text': '礼泉县',
            'level': 3,
            'pvalue': 610400000000
          },
          {
            'value': 610426000000,
            'text': '永寿县',
            'level': 3,
            'pvalue': 610400000000
          },
          {
            'value': 610428000000,
            'text': '长武县',
            'level': 3,
            'pvalue': 610400000000
          },
          {
            'value': 610429000000,
            'text': '旬邑县',
            'level': 3,
            'pvalue': 610400000000
          },
          {
            'value': 610430000000,
            'text': '淳化县',
            'level': 3,
            'pvalue': 610400000000
          },
          {
            'value': 610431000000,
            'text': '武功县',
            'level': 3,
            'pvalue': 610400000000
          },
          {
            'value': 610481000000,
            'text': '兴平市',
            'level': 3,
            'pvalue': 610400000000
          },
          {
            'value': 610482000000,
            'text': '彬州市',
            'level': 3,
            'pvalue': 610400000000
          }
        ]
      },
      {
        'value': 610500000000,
        'text': '渭南市',
        'level': 2,
        'pvalue': 610000000000,
        'children': [
          {
            'value': 610501000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 610500000000
          },
          {
            'value': 610502000000,
            'text': '临渭区',
            'level': 3,
            'pvalue': 610500000000
          },
          {
            'value': 610503000000,
            'text': '华州区',
            'level': 3,
            'pvalue': 610500000000
          },
          {
            'value': 610522000000,
            'text': '潼关县',
            'level': 3,
            'pvalue': 610500000000
          },
          {
            'value': 610523000000,
            'text': '大荔县',
            'level': 3,
            'pvalue': 610500000000
          },
          {
            'value': 610524000000,
            'text': '合阳县',
            'level': 3,
            'pvalue': 610500000000
          },
          {
            'value': 610525000000,
            'text': '澄城县',
            'level': 3,
            'pvalue': 610500000000
          },
          {
            'value': 610526000000,
            'text': '蒲城县',
            'level': 3,
            'pvalue': 610500000000
          },
          {
            'value': 610527000000,
            'text': '白水县',
            'level': 3,
            'pvalue': 610500000000
          },
          {
            'value': 610528000000,
            'text': '富平县',
            'level': 3,
            'pvalue': 610500000000
          },
          {
            'value': 610581000000,
            'text': '韩城市',
            'level': 3,
            'pvalue': 610500000000
          },
          {
            'value': 610582000000,
            'text': '华阴市',
            'level': 3,
            'pvalue': 610500000000
          }
        ]
      },
      {
        'value': 610600000000,
        'text': '延安市',
        'level': 2,
        'pvalue': 610000000000,
        'children': [
          {
            'value': 610601000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 610600000000
          },
          {
            'value': 610602000000,
            'text': '宝塔区',
            'level': 3,
            'pvalue': 610600000000
          },
          {
            'value': 610603000000,
            'text': '安塞区',
            'level': 3,
            'pvalue': 610600000000
          },
          {
            'value': 610621000000,
            'text': '延长县',
            'level': 3,
            'pvalue': 610600000000
          },
          {
            'value': 610622000000,
            'text': '延川县',
            'level': 3,
            'pvalue': 610600000000
          },
          {
            'value': 610625000000,
            'text': '志丹县',
            'level': 3,
            'pvalue': 610600000000
          },
          {
            'value': 610626000000,
            'text': '吴起县',
            'level': 3,
            'pvalue': 610600000000
          },
          {
            'value': 610627000000,
            'text': '甘泉县',
            'level': 3,
            'pvalue': 610600000000
          },
          {
            'value': 610628000000,
            'text': '富县',
            'level': 3,
            'pvalue': 610600000000
          },
          {
            'value': 610629000000,
            'text': '洛川县',
            'level': 3,
            'pvalue': 610600000000
          },
          {
            'value': 610630000000,
            'text': '宜川县',
            'level': 3,
            'pvalue': 610600000000
          },
          {
            'value': 610631000000,
            'text': '黄龙县',
            'level': 3,
            'pvalue': 610600000000
          },
          {
            'value': 610632000000,
            'text': '黄陵县',
            'level': 3,
            'pvalue': 610600000000
          },
          {
            'value': 610681000000,
            'text': '子长市',
            'level': 3,
            'pvalue': 610600000000
          }
        ]
      },
      {
        'value': 610700000000,
        'text': '汉中市',
        'level': 2,
        'pvalue': 610000000000,
        'children': [
          {
            'value': 610701000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 610700000000
          },
          {
            'value': 610702000000,
            'text': '汉台区',
            'level': 3,
            'pvalue': 610700000000
          },
          {
            'value': 610703000000,
            'text': '南郑区',
            'level': 3,
            'pvalue': 610700000000
          },
          {
            'value': 610722000000,
            'text': '城固县',
            'level': 3,
            'pvalue': 610700000000
          },
          {
            'value': 610723000000,
            'text': '洋县',
            'level': 3,
            'pvalue': 610700000000
          },
          {
            'value': 610724000000,
            'text': '西乡县',
            'level': 3,
            'pvalue': 610700000000
          },
          {
            'value': 610725000000,
            'text': '勉县',
            'level': 3,
            'pvalue': 610700000000
          },
          {
            'value': 610726000000,
            'text': '宁强县',
            'level': 3,
            'pvalue': 610700000000
          },
          {
            'value': 610727000000,
            'text': '略阳县',
            'level': 3,
            'pvalue': 610700000000
          },
          {
            'value': 610728000000,
            'text': '镇巴县',
            'level': 3,
            'pvalue': 610700000000
          },
          {
            'value': 610729000000,
            'text': '留坝县',
            'level': 3,
            'pvalue': 610700000000
          },
          {
            'value': 610730000000,
            'text': '佛坪县',
            'level': 3,
            'pvalue': 610700000000
          }
        ]
      },
      {
        'value': 610800000000,
        'text': '榆林市',
        'level': 2,
        'pvalue': 610000000000,
        'children': [
          {
            'value': 610801000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 610800000000
          },
          {
            'value': 610802000000,
            'text': '榆阳区',
            'level': 3,
            'pvalue': 610800000000
          },
          {
            'value': 610803000000,
            'text': '横山区',
            'level': 3,
            'pvalue': 610800000000
          },
          {
            'value': 610822000000,
            'text': '府谷县',
            'level': 3,
            'pvalue': 610800000000
          },
          {
            'value': 610824000000,
            'text': '靖边县',
            'level': 3,
            'pvalue': 610800000000
          },
          {
            'value': 610825000000,
            'text': '定边县',
            'level': 3,
            'pvalue': 610800000000
          },
          {
            'value': 610826000000,
            'text': '绥德县',
            'level': 3,
            'pvalue': 610800000000
          },
          {
            'value': 610827000000,
            'text': '米脂县',
            'level': 3,
            'pvalue': 610800000000
          },
          {
            'value': 610828000000,
            'text': '佳县',
            'level': 3,
            'pvalue': 610800000000
          },
          {
            'value': 610829000000,
            'text': '吴堡县',
            'level': 3,
            'pvalue': 610800000000
          },
          {
            'value': 610830000000,
            'text': '清涧县',
            'level': 3,
            'pvalue': 610800000000
          },
          {
            'value': 610831000000,
            'text': '子洲县',
            'level': 3,
            'pvalue': 610800000000
          },
          {
            'value': 610881000000,
            'text': '神木市',
            'level': 3,
            'pvalue': 610800000000
          }
        ]
      },
      {
        'value': 610900000000,
        'text': '安康市',
        'level': 2,
        'pvalue': 610000000000,
        'children': [
          {
            'value': 610901000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 610900000000
          },
          {
            'value': 610902000000,
            'text': '汉滨区',
            'level': 3,
            'pvalue': 610900000000
          },
          {
            'value': 610921000000,
            'text': '汉阴县',
            'level': 3,
            'pvalue': 610900000000
          },
          {
            'value': 610922000000,
            'text': '石泉县',
            'level': 3,
            'pvalue': 610900000000
          },
          {
            'value': 610923000000,
            'text': '宁陕县',
            'level': 3,
            'pvalue': 610900000000
          },
          {
            'value': 610924000000,
            'text': '紫阳县',
            'level': 3,
            'pvalue': 610900000000
          },
          {
            'value': 610925000000,
            'text': '岚皋县',
            'level': 3,
            'pvalue': 610900000000
          },
          {
            'value': 610926000000,
            'text': '平利县',
            'level': 3,
            'pvalue': 610900000000
          },
          {
            'value': 610927000000,
            'text': '镇坪县',
            'level': 3,
            'pvalue': 610900000000
          },
          {
            'value': 610929000000,
            'text': '白河县',
            'level': 3,
            'pvalue': 610900000000
          },
          {
            'value': 610981000000,
            'text': '旬阳市',
            'level': 3,
            'pvalue': 610900000000
          }
        ]
      },
      {
        'value': 611000000000,
        'text': '商洛市',
        'level': 2,
        'pvalue': 610000000000,
        'children': [
          {
            'value': 611001000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 611000000000
          },
          {
            'value': 611002000000,
            'text': '商州区',
            'level': 3,
            'pvalue': 611000000000
          },
          {
            'value': 611021000000,
            'text': '洛南县',
            'level': 3,
            'pvalue': 611000000000
          },
          {
            'value': 611022000000,
            'text': '丹凤县',
            'level': 3,
            'pvalue': 611000000000
          },
          {
            'value': 611023000000,
            'text': '商南县',
            'level': 3,
            'pvalue': 611000000000
          },
          {
            'value': 611024000000,
            'text': '山阳县',
            'level': 3,
            'pvalue': 611000000000
          },
          {
            'value': 611025000000,
            'text': '镇安县',
            'level': 3,
            'pvalue': 611000000000
          },
          {
            'value': 611026000000,
            'text': '柞水县',
            'level': 3,
            'pvalue': 611000000000
          }
        ]
      }
    ]
  },
  {
    'value': 620000000000,
    'text': '甘肃省',
    'level': 1,
    'pvalue': 0,
    'children': [
      {
        'value': 620100000000,
        'text': '兰州市',
        'level': 2,
        'pvalue': 620000000000,
        'children': [
          {
            'value': 620101000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 620100000000
          },
          {
            'value': 620102000000,
            'text': '城关区',
            'level': 3,
            'pvalue': 620100000000
          },
          {
            'value': 620103000000,
            'text': '七里河区',
            'level': 3,
            'pvalue': 620100000000
          },
          {
            'value': 620104000000,
            'text': '西固区',
            'level': 3,
            'pvalue': 620100000000
          },
          {
            'value': 620105000000,
            'text': '安宁区',
            'level': 3,
            'pvalue': 620100000000
          },
          {
            'value': 620111000000,
            'text': '红古区',
            'level': 3,
            'pvalue': 620100000000
          },
          {
            'value': 620121000000,
            'text': '永登县',
            'level': 3,
            'pvalue': 620100000000
          },
          {
            'value': 620122000000,
            'text': '皋兰县',
            'level': 3,
            'pvalue': 620100000000
          },
          {
            'value': 620123000000,
            'text': '榆中县',
            'level': 3,
            'pvalue': 620100000000
          },
          {
            'value': 620171000000,
            'text': '兰州新区',
            'level': 3,
            'pvalue': 620100000000
          }
        ]
      },
      {
        'value': 620200000000,
        'text': '嘉峪关市',
        'level': 2,
        'pvalue': 620000000000,
        'children': [
          {
            'value': 620201000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 620200000000
          }
        ]
      },
      {
        'value': 620300000000,
        'text': '金昌市',
        'level': 2,
        'pvalue': 620000000000,
        'children': [
          {
            'value': 620301000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 620300000000
          },
          {
            'value': 620302000000,
            'text': '金川区',
            'level': 3,
            'pvalue': 620300000000
          },
          {
            'value': 620321000000,
            'text': '永昌县',
            'level': 3,
            'pvalue': 620300000000
          }
        ]
      },
      {
        'value': 620400000000,
        'text': '白银市',
        'level': 2,
        'pvalue': 620000000000,
        'children': [
          {
            'value': 620401000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 620400000000
          },
          {
            'value': 620402000000,
            'text': '白银区',
            'level': 3,
            'pvalue': 620400000000
          },
          {
            'value': 620403000000,
            'text': '平川区',
            'level': 3,
            'pvalue': 620400000000
          },
          {
            'value': 620421000000,
            'text': '靖远县',
            'level': 3,
            'pvalue': 620400000000
          },
          {
            'value': 620422000000,
            'text': '会宁县',
            'level': 3,
            'pvalue': 620400000000
          },
          {
            'value': 620423000000,
            'text': '景泰县',
            'level': 3,
            'pvalue': 620400000000
          }
        ]
      },
      {
        'value': 620500000000,
        'text': '天水市',
        'level': 2,
        'pvalue': 620000000000,
        'children': [
          {
            'value': 620501000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 620500000000
          },
          {
            'value': 620502000000,
            'text': '秦州区',
            'level': 3,
            'pvalue': 620500000000
          },
          {
            'value': 620503000000,
            'text': '麦积区',
            'level': 3,
            'pvalue': 620500000000
          },
          {
            'value': 620521000000,
            'text': '清水县',
            'level': 3,
            'pvalue': 620500000000
          },
          {
            'value': 620522000000,
            'text': '秦安县',
            'level': 3,
            'pvalue': 620500000000
          },
          {
            'value': 620523000000,
            'text': '甘谷县',
            'level': 3,
            'pvalue': 620500000000
          },
          {
            'value': 620524000000,
            'text': '武山县',
            'level': 3,
            'pvalue': 620500000000
          },
          {
            'value': 620525000000,
            'text': '张家川回族自治县',
            'level': 3,
            'pvalue': 620500000000
          }
        ]
      },
      {
        'value': 620600000000,
        'text': '武威市',
        'level': 2,
        'pvalue': 620000000000,
        'children': [
          {
            'value': 620601000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 620600000000
          },
          {
            'value': 620602000000,
            'text': '凉州区',
            'level': 3,
            'pvalue': 620600000000
          },
          {
            'value': 620621000000,
            'text': '民勤县',
            'level': 3,
            'pvalue': 620600000000
          },
          {
            'value': 620622000000,
            'text': '古浪县',
            'level': 3,
            'pvalue': 620600000000
          },
          {
            'value': 620623000000,
            'text': '天祝藏族自治县',
            'level': 3,
            'pvalue': 620600000000
          }
        ]
      },
      {
        'value': 620700000000,
        'text': '张掖市',
        'level': 2,
        'pvalue': 620000000000,
        'children': [
          {
            'value': 620701000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 620700000000
          },
          {
            'value': 620702000000,
            'text': '甘州区',
            'level': 3,
            'pvalue': 620700000000
          },
          {
            'value': 620721000000,
            'text': '肃南裕固族自治县',
            'level': 3,
            'pvalue': 620700000000
          },
          {
            'value': 620722000000,
            'text': '民乐县',
            'level': 3,
            'pvalue': 620700000000
          },
          {
            'value': 620723000000,
            'text': '临泽县',
            'level': 3,
            'pvalue': 620700000000
          },
          {
            'value': 620724000000,
            'text': '高台县',
            'level': 3,
            'pvalue': 620700000000
          },
          {
            'value': 620725000000,
            'text': '山丹县',
            'level': 3,
            'pvalue': 620700000000
          }
        ]
      },
      {
        'value': 620800000000,
        'text': '平凉市',
        'level': 2,
        'pvalue': 620000000000,
        'children': [
          {
            'value': 620801000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 620800000000
          },
          {
            'value': 620802000000,
            'text': '崆峒区',
            'level': 3,
            'pvalue': 620800000000
          },
          {
            'value': 620821000000,
            'text': '泾川县',
            'level': 3,
            'pvalue': 620800000000
          },
          {
            'value': 620822000000,
            'text': '灵台县',
            'level': 3,
            'pvalue': 620800000000
          },
          {
            'value': 620823000000,
            'text': '崇信县',
            'level': 3,
            'pvalue': 620800000000
          },
          {
            'value': 620825000000,
            'text': '庄浪县',
            'level': 3,
            'pvalue': 620800000000
          },
          {
            'value': 620826000000,
            'text': '静宁县',
            'level': 3,
            'pvalue': 620800000000
          },
          {
            'value': 620881000000,
            'text': '华亭市',
            'level': 3,
            'pvalue': 620800000000
          }
        ]
      },
      {
        'value': 620900000000,
        'text': '酒泉市',
        'level': 2,
        'pvalue': 620000000000,
        'children': [
          {
            'value': 620901000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 620900000000
          },
          {
            'value': 620902000000,
            'text': '肃州区',
            'level': 3,
            'pvalue': 620900000000
          },
          {
            'value': 620921000000,
            'text': '金塔县',
            'level': 3,
            'pvalue': 620900000000
          },
          {
            'value': 620922000000,
            'text': '瓜州县',
            'level': 3,
            'pvalue': 620900000000
          },
          {
            'value': 620923000000,
            'text': '肃北蒙古族自治县',
            'level': 3,
            'pvalue': 620900000000
          },
          {
            'value': 620924000000,
            'text': '阿克塞哈萨克族自治县',
            'level': 3,
            'pvalue': 620900000000
          },
          {
            'value': 620981000000,
            'text': '玉门市',
            'level': 3,
            'pvalue': 620900000000
          },
          {
            'value': 620982000000,
            'text': '敦煌市',
            'level': 3,
            'pvalue': 620900000000
          }
        ]
      },
      {
        'value': 621000000000,
        'text': '庆阳市',
        'level': 2,
        'pvalue': 620000000000,
        'children': [
          {
            'value': 621001000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 621000000000
          },
          {
            'value': 621002000000,
            'text': '西峰区',
            'level': 3,
            'pvalue': 621000000000
          },
          {
            'value': 621021000000,
            'text': '庆城县',
            'level': 3,
            'pvalue': 621000000000
          },
          {
            'value': 621022000000,
            'text': '环县',
            'level': 3,
            'pvalue': 621000000000
          },
          {
            'value': 621023000000,
            'text': '华池县',
            'level': 3,
            'pvalue': 621000000000
          },
          {
            'value': 621024000000,
            'text': '合水县',
            'level': 3,
            'pvalue': 621000000000
          },
          {
            'value': 621025000000,
            'text': '正宁县',
            'level': 3,
            'pvalue': 621000000000
          },
          {
            'value': 621026000000,
            'text': '宁县',
            'level': 3,
            'pvalue': 621000000000
          },
          {
            'value': 621027000000,
            'text': '镇原县',
            'level': 3,
            'pvalue': 621000000000
          }
        ]
      },
      {
        'value': 621100000000,
        'text': '定西市',
        'level': 2,
        'pvalue': 620000000000,
        'children': [
          {
            'value': 621101000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 621100000000
          },
          {
            'value': 621102000000,
            'text': '安定区',
            'level': 3,
            'pvalue': 621100000000
          },
          {
            'value': 621121000000,
            'text': '通渭县',
            'level': 3,
            'pvalue': 621100000000
          },
          {
            'value': 621122000000,
            'text': '陇西县',
            'level': 3,
            'pvalue': 621100000000
          },
          {
            'value': 621123000000,
            'text': '渭源县',
            'level': 3,
            'pvalue': 621100000000
          },
          {
            'value': 621124000000,
            'text': '临洮县',
            'level': 3,
            'pvalue': 621100000000
          },
          {
            'value': 621125000000,
            'text': '漳县',
            'level': 3,
            'pvalue': 621100000000
          },
          {
            'value': 621126000000,
            'text': '岷县',
            'level': 3,
            'pvalue': 621100000000
          }
        ]
      },
      {
        'value': 621200000000,
        'text': '陇南市',
        'level': 2,
        'pvalue': 620000000000,
        'children': [
          {
            'value': 621201000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 621200000000
          },
          {
            'value': 621202000000,
            'text': '武都区',
            'level': 3,
            'pvalue': 621200000000
          },
          {
            'value': 621221000000,
            'text': '成县',
            'level': 3,
            'pvalue': 621200000000
          },
          {
            'value': 621222000000,
            'text': '文县',
            'level': 3,
            'pvalue': 621200000000
          },
          {
            'value': 621223000000,
            'text': '宕昌县',
            'level': 3,
            'pvalue': 621200000000
          },
          {
            'value': 621224000000,
            'text': '康县',
            'level': 3,
            'pvalue': 621200000000
          },
          {
            'value': 621225000000,
            'text': '西和县',
            'level': 3,
            'pvalue': 621200000000
          },
          {
            'value': 621226000000,
            'text': '礼县',
            'level': 3,
            'pvalue': 621200000000
          },
          {
            'value': 621227000000,
            'text': '徽县',
            'level': 3,
            'pvalue': 621200000000
          },
          {
            'value': 621228000000,
            'text': '两当县',
            'level': 3,
            'pvalue': 621200000000
          }
        ]
      },
      {
        'value': 622900000000,
        'text': '临夏回族自治州',
        'level': 2,
        'pvalue': 620000000000,
        'children': [
          {
            'value': 622901000000,
            'text': '临夏市',
            'level': 3,
            'pvalue': 622900000000
          },
          {
            'value': 622921000000,
            'text': '临夏县',
            'level': 3,
            'pvalue': 622900000000
          },
          {
            'value': 622922000000,
            'text': '康乐县',
            'level': 3,
            'pvalue': 622900000000
          },
          {
            'value': 622923000000,
            'text': '永靖县',
            'level': 3,
            'pvalue': 622900000000
          },
          {
            'value': 622924000000,
            'text': '广河县',
            'level': 3,
            'pvalue': 622900000000
          },
          {
            'value': 622925000000,
            'text': '和政县',
            'level': 3,
            'pvalue': 622900000000
          },
          {
            'value': 622926000000,
            'text': '东乡族自治县',
            'level': 3,
            'pvalue': 622900000000
          },
          {
            'value': 622927000000,
            'text': '积石山保安族东乡族撒拉族自治县',
            'level': 3,
            'pvalue': 622900000000
          }
        ]
      },
      {
        'value': 623000000000,
        'text': '甘南藏族自治州',
        'level': 2,
        'pvalue': 620000000000,
        'children': [
          {
            'value': 623001000000,
            'text': '合作市',
            'level': 3,
            'pvalue': 623000000000
          },
          {
            'value': 623021000000,
            'text': '临潭县',
            'level': 3,
            'pvalue': 623000000000
          },
          {
            'value': 623022000000,
            'text': '卓尼县',
            'level': 3,
            'pvalue': 623000000000
          },
          {
            'value': 623023000000,
            'text': '舟曲县',
            'level': 3,
            'pvalue': 623000000000
          },
          {
            'value': 623024000000,
            'text': '迭部县',
            'level': 3,
            'pvalue': 623000000000
          },
          {
            'value': 623025000000,
            'text': '玛曲县',
            'level': 3,
            'pvalue': 623000000000
          },
          {
            'value': 623026000000,
            'text': '碌曲县',
            'level': 3,
            'pvalue': 623000000000
          },
          {
            'value': 623027000000,
            'text': '夏河县',
            'level': 3,
            'pvalue': 623000000000
          }
        ]
      }
    ]
  },
  {
    'value': 630000000000,
    'text': '青海省',
    'level': 1,
    'pvalue': 0,
    'children': [
      {
        'value': 630100000000,
        'text': '西宁市',
        'level': 2,
        'pvalue': 630000000000,
        'children': [
          {
            'value': 630101000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 630100000000
          },
          {
            'value': 630102000000,
            'text': '城东区',
            'level': 3,
            'pvalue': 630100000000
          },
          {
            'value': 630103000000,
            'text': '城中区',
            'level': 3,
            'pvalue': 630100000000
          },
          {
            'value': 630104000000,
            'text': '城西区',
            'level': 3,
            'pvalue': 630100000000
          },
          {
            'value': 630105000000,
            'text': '城北区',
            'level': 3,
            'pvalue': 630100000000
          },
          {
            'value': 630106000000,
            'text': '湟中区',
            'level': 3,
            'pvalue': 630100000000
          },
          {
            'value': 630121000000,
            'text': '大通回族土族自治县',
            'level': 3,
            'pvalue': 630100000000
          },
          {
            'value': 630123000000,
            'text': '湟源县',
            'level': 3,
            'pvalue': 630100000000
          }
        ]
      },
      {
        'value': 630200000000,
        'text': '海东市',
        'level': 2,
        'pvalue': 630000000000,
        'children': [
          {
            'value': 630202000000,
            'text': '乐都区',
            'level': 3,
            'pvalue': 630200000000
          },
          {
            'value': 630203000000,
            'text': '平安区',
            'level': 3,
            'pvalue': 630200000000
          },
          {
            'value': 630222000000,
            'text': '民和回族土族自治县',
            'level': 3,
            'pvalue': 630200000000
          },
          {
            'value': 630223000000,
            'text': '互助土族自治县',
            'level': 3,
            'pvalue': 630200000000
          },
          {
            'value': 630224000000,
            'text': '化隆回族自治县',
            'level': 3,
            'pvalue': 630200000000
          },
          {
            'value': 630225000000,
            'text': '循化撒拉族自治县',
            'level': 3,
            'pvalue': 630200000000
          }
        ]
      },
      {
        'value': 632200000000,
        'text': '海北藏族自治州',
        'level': 2,
        'pvalue': 630000000000,
        'children': [
          {
            'value': 632221000000,
            'text': '门源回族自治县',
            'level': 3,
            'pvalue': 632200000000
          },
          {
            'value': 632222000000,
            'text': '祁连县',
            'level': 3,
            'pvalue': 632200000000
          },
          {
            'value': 632223000000,
            'text': '海晏县',
            'level': 3,
            'pvalue': 632200000000
          },
          {
            'value': 632224000000,
            'text': '刚察县',
            'level': 3,
            'pvalue': 632200000000
          }
        ]
      },
      {
        'value': 632300000000,
        'text': '黄南藏族自治州',
        'level': 2,
        'pvalue': 630000000000,
        'children': [
          {
            'value': 632301000000,
            'text': '同仁市',
            'level': 3,
            'pvalue': 632300000000
          },
          {
            'value': 632322000000,
            'text': '尖扎县',
            'level': 3,
            'pvalue': 632300000000
          },
          {
            'value': 632323000000,
            'text': '泽库县',
            'level': 3,
            'pvalue': 632300000000
          },
          {
            'value': 632324000000,
            'text': '河南蒙古族自治县',
            'level': 3,
            'pvalue': 632300000000
          }
        ]
      },
      {
        'value': 632500000000,
        'text': '海南藏族自治州',
        'level': 2,
        'pvalue': 630000000000,
        'children': [
          {
            'value': 632521000000,
            'text': '共和县',
            'level': 3,
            'pvalue': 632500000000
          },
          {
            'value': 632522000000,
            'text': '同德县',
            'level': 3,
            'pvalue': 632500000000
          },
          {
            'value': 632523000000,
            'text': '贵德县',
            'level': 3,
            'pvalue': 632500000000
          },
          {
            'value': 632524000000,
            'text': '兴海县',
            'level': 3,
            'pvalue': 632500000000
          },
          {
            'value': 632525000000,
            'text': '贵南县',
            'level': 3,
            'pvalue': 632500000000
          }
        ]
      },
      {
        'value': 632600000000,
        'text': '果洛藏族自治州',
        'level': 2,
        'pvalue': 630000000000,
        'children': [
          {
            'value': 632621000000,
            'text': '玛沁县',
            'level': 3,
            'pvalue': 632600000000
          },
          {
            'value': 632622000000,
            'text': '班玛县',
            'level': 3,
            'pvalue': 632600000000
          },
          {
            'value': 632623000000,
            'text': '甘德县',
            'level': 3,
            'pvalue': 632600000000
          },
          {
            'value': 632624000000,
            'text': '达日县',
            'level': 3,
            'pvalue': 632600000000
          },
          {
            'value': 632625000000,
            'text': '久治县',
            'level': 3,
            'pvalue': 632600000000
          },
          {
            'value': 632626000000,
            'text': '玛多县',
            'level': 3,
            'pvalue': 632600000000
          }
        ]
      },
      {
        'value': 632700000000,
        'text': '玉树藏族自治州',
        'level': 2,
        'pvalue': 630000000000,
        'children': [
          {
            'value': 632701000000,
            'text': '玉树市',
            'level': 3,
            'pvalue': 632700000000
          },
          {
            'value': 632722000000,
            'text': '杂多县',
            'level': 3,
            'pvalue': 632700000000
          },
          {
            'value': 632723000000,
            'text': '称多县',
            'level': 3,
            'pvalue': 632700000000
          },
          {
            'value': 632724000000,
            'text': '治多县',
            'level': 3,
            'pvalue': 632700000000
          },
          {
            'value': 632725000000,
            'text': '囊谦县',
            'level': 3,
            'pvalue': 632700000000
          },
          {
            'value': 632726000000,
            'text': '曲麻莱县',
            'level': 3,
            'pvalue': 632700000000
          }
        ]
      },
      {
        'value': 632800000000,
        'text': '海西蒙古族藏族自治州',
        'level': 2,
        'pvalue': 630000000000,
        'children': [
          {
            'value': 632801000000,
            'text': '格尔木市',
            'level': 3,
            'pvalue': 632800000000
          },
          {
            'value': 632802000000,
            'text': '德令哈市',
            'level': 3,
            'pvalue': 632800000000
          },
          {
            'value': 632803000000,
            'text': '茫崖市',
            'level': 3,
            'pvalue': 632800000000
          },
          {
            'value': 632821000000,
            'text': '乌兰县',
            'level': 3,
            'pvalue': 632800000000
          },
          {
            'value': 632822000000,
            'text': '都兰县',
            'level': 3,
            'pvalue': 632800000000
          },
          {
            'value': 632823000000,
            'text': '天峻县',
            'level': 3,
            'pvalue': 632800000000
          },
          {
            'value': 632857000000,
            'text': '大柴旦行政委员会',
            'level': 3,
            'pvalue': 632800000000
          }
        ]
      }
    ]
  },
  {
    'value': 640000000000,
    'text': '宁夏回族自治区',
    'level': 1,
    'pvalue': 0,
    'children': [
      {
        'value': 640100000000,
        'text': '银川市',
        'level': 2,
        'pvalue': 640000000000,
        'children': [
          {
            'value': 640101000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 640100000000
          },
          {
            'value': 640104000000,
            'text': '兴庆区',
            'level': 3,
            'pvalue': 640100000000
          },
          {
            'value': 640105000000,
            'text': '西夏区',
            'level': 3,
            'pvalue': 640100000000
          },
          {
            'value': 640106000000,
            'text': '金凤区',
            'level': 3,
            'pvalue': 640100000000
          },
          {
            'value': 640121000000,
            'text': '永宁县',
            'level': 3,
            'pvalue': 640100000000
          },
          {
            'value': 640122000000,
            'text': '贺兰县',
            'level': 3,
            'pvalue': 640100000000
          },
          {
            'value': 640181000000,
            'text': '灵武市',
            'level': 3,
            'pvalue': 640100000000
          }
        ]
      },
      {
        'value': 640200000000,
        'text': '石嘴山市',
        'level': 2,
        'pvalue': 640000000000,
        'children': [
          {
            'value': 640201000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 640200000000
          },
          {
            'value': 640202000000,
            'text': '大武口区',
            'level': 3,
            'pvalue': 640200000000
          },
          {
            'value': 640205000000,
            'text': '惠农区',
            'level': 3,
            'pvalue': 640200000000
          },
          {
            'value': 640221000000,
            'text': '平罗县',
            'level': 3,
            'pvalue': 640200000000
          }
        ]
      },
      {
        'value': 640300000000,
        'text': '吴忠市',
        'level': 2,
        'pvalue': 640000000000,
        'children': [
          {
            'value': 640301000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 640300000000
          },
          {
            'value': 640302000000,
            'text': '利通区',
            'level': 3,
            'pvalue': 640300000000
          },
          {
            'value': 640303000000,
            'text': '红寺堡区',
            'level': 3,
            'pvalue': 640300000000
          },
          {
            'value': 640323000000,
            'text': '盐池县',
            'level': 3,
            'pvalue': 640300000000
          },
          {
            'value': 640324000000,
            'text': '同心县',
            'level': 3,
            'pvalue': 640300000000
          },
          {
            'value': 640381000000,
            'text': '青铜峡市',
            'level': 3,
            'pvalue': 640300000000
          }
        ]
      },
      {
        'value': 640400000000,
        'text': '固原市',
        'level': 2,
        'pvalue': 640000000000,
        'children': [
          {
            'value': 640401000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 640400000000
          },
          {
            'value': 640402000000,
            'text': '原州区',
            'level': 3,
            'pvalue': 640400000000
          },
          {
            'value': 640422000000,
            'text': '西吉县',
            'level': 3,
            'pvalue': 640400000000
          },
          {
            'value': 640423000000,
            'text': '隆德县',
            'level': 3,
            'pvalue': 640400000000
          },
          {
            'value': 640424000000,
            'text': '泾源县',
            'level': 3,
            'pvalue': 640400000000
          },
          {
            'value': 640425000000,
            'text': '彭阳县',
            'level': 3,
            'pvalue': 640400000000
          }
        ]
      },
      {
        'value': 640500000000,
        'text': '中卫市',
        'level': 2,
        'pvalue': 640000000000,
        'children': [
          {
            'value': 640501000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 640500000000
          },
          {
            'value': 640502000000,
            'text': '沙坡头区',
            'level': 3,
            'pvalue': 640500000000
          },
          {
            'value': 640521000000,
            'text': '中宁县',
            'level': 3,
            'pvalue': 640500000000
          },
          {
            'value': 640522000000,
            'text': '海原县',
            'level': 3,
            'pvalue': 640500000000
          }
        ]
      }
    ]
  },
  {
    'value': 650000000000,
    'text': '新疆维吾尔自治区',
    'level': 1,
    'pvalue': 0,
    'children': [
      {
        'value': 650100000000,
        'text': '乌鲁木齐市',
        'level': 2,
        'pvalue': 650000000000,
        'children': [
          {
            'value': 650101000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 650100000000
          },
          {
            'value': 650102000000,
            'text': '天山区',
            'level': 3,
            'pvalue': 650100000000
          },
          {
            'value': 650103000000,
            'text': '沙依巴克区',
            'level': 3,
            'pvalue': 650100000000
          },
          {
            'value': 650104000000,
            'text': '新市区',
            'level': 3,
            'pvalue': 650100000000
          },
          {
            'value': 650105000000,
            'text': '水磨沟区',
            'level': 3,
            'pvalue': 650100000000
          },
          {
            'value': 650106000000,
            'text': '头屯河区',
            'level': 3,
            'pvalue': 650100000000
          },
          {
            'value': 650107000000,
            'text': '达坂城区',
            'level': 3,
            'pvalue': 650100000000
          },
          {
            'value': 650109000000,
            'text': '米东区',
            'level': 3,
            'pvalue': 650100000000
          },
          {
            'value': 650121000000,
            'text': '乌鲁木齐县',
            'level': 3,
            'pvalue': 650100000000
          }
        ]
      },
      {
        'value': 650200000000,
        'text': '克拉玛依市',
        'level': 2,
        'pvalue': 650000000000,
        'children': [
          {
            'value': 650201000000,
            'text': '市辖区',
            'level': 3,
            'pvalue': 650200000000
          },
          {
            'value': 650202000000,
            'text': '独山子区',
            'level': 3,
            'pvalue': 650200000000
          },
          {
            'value': 650203000000,
            'text': '克拉玛依区',
            'level': 3,
            'pvalue': 650200000000
          },
          {
            'value': 650204000000,
            'text': '白碱滩区',
            'level': 3,
            'pvalue': 650200000000
          },
          {
            'value': 650205000000,
            'text': '乌尔禾区',
            'level': 3,
            'pvalue': 650200000000
          }
        ]
      },
      {
        'value': 650400000000,
        'text': '吐鲁番市',
        'level': 2,
        'pvalue': 650000000000,
        'children': [
          {
            'value': 650402000000,
            'text': '高昌区',
            'level': 3,
            'pvalue': 650400000000
          },
          {
            'value': 650421000000,
            'text': '鄯善县',
            'level': 3,
            'pvalue': 650400000000
          },
          {
            'value': 650422000000,
            'text': '托克逊县',
            'level': 3,
            'pvalue': 650400000000
          }
        ]
      },
      {
        'value': 650500000000,
        'text': '哈密市',
        'level': 2,
        'pvalue': 650000000000,
        'children': [
          {
            'value': 650502000000,
            'text': '伊州区',
            'level': 3,
            'pvalue': 650500000000
          },
          {
            'value': 650521000000,
            'text': '巴里坤哈萨克自治县',
            'level': 3,
            'pvalue': 650500000000
          },
          {
            'value': 650522000000,
            'text': '伊吾县',
            'level': 3,
            'pvalue': 650500000000
          }
        ]
      },
      {
        'value': 652300000000,
        'text': '昌吉回族自治州',
        'level': 2,
        'pvalue': 650000000000,
        'children': [
          {
            'value': 652301000000,
            'text': '昌吉市',
            'level': 3,
            'pvalue': 652300000000
          },
          {
            'value': 652302000000,
            'text': '阜康市',
            'level': 3,
            'pvalue': 652300000000
          },
          {
            'value': 652323000000,
            'text': '呼图壁县',
            'level': 3,
            'pvalue': 652300000000
          },
          {
            'value': 652324000000,
            'text': '玛纳斯县',
            'level': 3,
            'pvalue': 652300000000
          },
          {
            'value': 652325000000,
            'text': '奇台县',
            'level': 3,
            'pvalue': 652300000000
          },
          {
            'value': 652327000000,
            'text': '吉木萨尔县',
            'level': 3,
            'pvalue': 652300000000
          },
          {
            'value': 652328000000,
            'text': '木垒哈萨克自治县',
            'level': 3,
            'pvalue': 652300000000
          }
        ]
      },
      {
        'value': 652700000000,
        'text': '博尔塔拉蒙古自治州',
        'level': 2,
        'pvalue': 650000000000,
        'children': [
          {
            'value': 652701000000,
            'text': '博乐市',
            'level': 3,
            'pvalue': 652700000000
          },
          {
            'value': 652702000000,
            'text': '阿拉山口市',
            'level': 3,
            'pvalue': 652700000000
          },
          {
            'value': 652722000000,
            'text': '精河县',
            'level': 3,
            'pvalue': 652700000000
          },
          {
            'value': 652723000000,
            'text': '温泉县',
            'level': 3,
            'pvalue': 652700000000
          }
        ]
      },
      {
        'value': 652800000000,
        'text': '巴音郭楞蒙古自治州',
        'level': 2,
        'pvalue': 650000000000,
        'children': [
          {
            'value': 652801000000,
            'text': '库尔勒市',
            'level': 3,
            'pvalue': 652800000000
          },
          {
            'value': 652822000000,
            'text': '轮台县',
            'level': 3,
            'pvalue': 652800000000
          },
          {
            'value': 652823000000,
            'text': '尉犁县',
            'level': 3,
            'pvalue': 652800000000
          },
          {
            'value': 652824000000,
            'text': '若羌县',
            'level': 3,
            'pvalue': 652800000000
          },
          {
            'value': 652825000000,
            'text': '且末县',
            'level': 3,
            'pvalue': 652800000000
          },
          {
            'value': 652826000000,
            'text': '焉耆回族自治县',
            'level': 3,
            'pvalue': 652800000000
          },
          {
            'value': 652827000000,
            'text': '和静县',
            'level': 3,
            'pvalue': 652800000000
          },
          {
            'value': 652828000000,
            'text': '和硕县',
            'level': 3,
            'pvalue': 652800000000
          },
          {
            'value': 652829000000,
            'text': '博湖县',
            'level': 3,
            'pvalue': 652800000000
          },
          {
            'value': 652871000000,
            'text': '库尔勒经济技术开发区',
            'level': 3,
            'pvalue': 652800000000
          }
        ]
      },
      {
        'value': 652900000000,
        'text': '阿克苏地区',
        'level': 2,
        'pvalue': 650000000000,
        'children': [
          {
            'value': 652901000000,
            'text': '阿克苏市',
            'level': 3,
            'pvalue': 652900000000
          },
          {
            'value': 652902000000,
            'text': '库车市',
            'level': 3,
            'pvalue': 652900000000
          },
          {
            'value': 652922000000,
            'text': '温宿县',
            'level': 3,
            'pvalue': 652900000000
          },
          {
            'value': 652924000000,
            'text': '沙雅县',
            'level': 3,
            'pvalue': 652900000000
          },
          {
            'value': 652925000000,
            'text': '新和县',
            'level': 3,
            'pvalue': 652900000000
          },
          {
            'value': 652926000000,
            'text': '拜城县',
            'level': 3,
            'pvalue': 652900000000
          },
          {
            'value': 652927000000,
            'text': '乌什县',
            'level': 3,
            'pvalue': 652900000000
          },
          {
            'value': 652928000000,
            'text': '阿瓦提县',
            'level': 3,
            'pvalue': 652900000000
          },
          {
            'value': 652929000000,
            'text': '柯坪县',
            'level': 3,
            'pvalue': 652900000000
          }
        ]
      },
      {
        'value': 653000000000,
        'text': '克孜勒苏柯尔克孜自治州',
        'level': 2,
        'pvalue': 650000000000,
        'children': [
          {
            'value': 653001000000,
            'text': '阿图什市',
            'level': 3,
            'pvalue': 653000000000
          },
          {
            'value': 653022000000,
            'text': '阿克陶县',
            'level': 3,
            'pvalue': 653000000000
          },
          {
            'value': 653023000000,
            'text': '阿合奇县',
            'level': 3,
            'pvalue': 653000000000
          },
          {
            'value': 653024000000,
            'text': '乌恰县',
            'level': 3,
            'pvalue': 653000000000
          }
        ]
      },
      {
        'value': 653100000000,
        'text': '喀什地区',
        'level': 2,
        'pvalue': 650000000000,
        'children': [
          {
            'value': 653101000000,
            'text': '喀什市',
            'level': 3,
            'pvalue': 653100000000
          },
          {
            'value': 653121000000,
            'text': '疏附县',
            'level': 3,
            'pvalue': 653100000000
          },
          {
            'value': 653122000000,
            'text': '疏勒县',
            'level': 3,
            'pvalue': 653100000000
          },
          {
            'value': 653123000000,
            'text': '英吉沙县',
            'level': 3,
            'pvalue': 653100000000
          },
          {
            'value': 653124000000,
            'text': '泽普县',
            'level': 3,
            'pvalue': 653100000000
          },
          {
            'value': 653125000000,
            'text': '莎车县',
            'level': 3,
            'pvalue': 653100000000
          },
          {
            'value': 653126000000,
            'text': '叶城县',
            'level': 3,
            'pvalue': 653100000000
          },
          {
            'value': 653127000000,
            'text': '麦盖提县',
            'level': 3,
            'pvalue': 653100000000
          },
          {
            'value': 653128000000,
            'text': '岳普湖县',
            'level': 3,
            'pvalue': 653100000000
          },
          {
            'value': 653129000000,
            'text': '伽师县',
            'level': 3,
            'pvalue': 653100000000
          },
          {
            'value': 653130000000,
            'text': '巴楚县',
            'level': 3,
            'pvalue': 653100000000
          },
          {
            'value': 653131000000,
            'text': '塔什库尔干塔吉克自治县',
            'level': 3,
            'pvalue': 653100000000
          }
        ]
      },
      {
        'value': 653200000000,
        'text': '和田地区',
        'level': 2,
        'pvalue': 650000000000,
        'children': [
          {
            'value': 653201000000,
            'text': '和田市',
            'level': 3,
            'pvalue': 653200000000
          },
          {
            'value': 653221000000,
            'text': '和田县',
            'level': 3,
            'pvalue': 653200000000
          },
          {
            'value': 653222000000,
            'text': '墨玉县',
            'level': 3,
            'pvalue': 653200000000
          },
          {
            'value': 653223000000,
            'text': '皮山县',
            'level': 3,
            'pvalue': 653200000000
          },
          {
            'value': 653224000000,
            'text': '洛浦县',
            'level': 3,
            'pvalue': 653200000000
          },
          {
            'value': 653225000000,
            'text': '策勒县',
            'level': 3,
            'pvalue': 653200000000
          },
          {
            'value': 653226000000,
            'text': '于田县',
            'level': 3,
            'pvalue': 653200000000
          },
          {
            'value': 653227000000,
            'text': '民丰县',
            'level': 3,
            'pvalue': 653200000000
          }
        ]
      },
      {
        'value': 654000000000,
        'text': '伊犁哈萨克自治州',
        'level': 2,
        'pvalue': 650000000000,
        'children': [
          {
            'value': 654002000000,
            'text': '伊宁市',
            'level': 3,
            'pvalue': 654000000000
          },
          {
            'value': 654003000000,
            'text': '奎屯市',
            'level': 3,
            'pvalue': 654000000000
          },
          {
            'value': 654004000000,
            'text': '霍尔果斯市',
            'level': 3,
            'pvalue': 654000000000
          },
          {
            'value': 654021000000,
            'text': '伊宁县',
            'level': 3,
            'pvalue': 654000000000
          },
          {
            'value': 654022000000,
            'text': '察布查尔锡伯自治县',
            'level': 3,
            'pvalue': 654000000000
          },
          {
            'value': 654023000000,
            'text': '霍城县',
            'level': 3,
            'pvalue': 654000000000
          },
          {
            'value': 654024000000,
            'text': '巩留县',
            'level': 3,
            'pvalue': 654000000000
          },
          {
            'value': 654025000000,
            'text': '新源县',
            'level': 3,
            'pvalue': 654000000000
          },
          {
            'value': 654026000000,
            'text': '昭苏县',
            'level': 3,
            'pvalue': 654000000000
          },
          {
            'value': 654027000000,
            'text': '特克斯县',
            'level': 3,
            'pvalue': 654000000000
          },
          {
            'value': 654028000000,
            'text': '尼勒克县',
            'level': 3,
            'pvalue': 654000000000
          }
        ]
      },
      {
        'value': 654200000000,
        'text': '塔城地区',
        'level': 2,
        'pvalue': 650000000000,
        'children': [
          {
            'value': 654201000000,
            'text': '塔城市',
            'level': 3,
            'pvalue': 654200000000
          },
          {
            'value': 654202000000,
            'text': '乌苏市',
            'level': 3,
            'pvalue': 654200000000
          },
          {
            'value': 654203000000,
            'text': '沙湾市',
            'level': 3,
            'pvalue': 654200000000
          },
          {
            'value': 654221000000,
            'text': '额敏县',
            'level': 3,
            'pvalue': 654200000000
          },
          {
            'value': 654224000000,
            'text': '托里县',
            'level': 3,
            'pvalue': 654200000000
          },
          {
            'value': 654225000000,
            'text': '裕民县',
            'level': 3,
            'pvalue': 654200000000
          },
          {
            'value': 654226000000,
            'text': '和布克赛尔蒙古自治县',
            'level': 3,
            'pvalue': 654200000000
          }
        ]
      },
      {
        'value': 654300000000,
        'text': '阿勒泰地区',
        'level': 2,
        'pvalue': 650000000000,
        'children': [
          {
            'value': 654301000000,
            'text': '阿勒泰市',
            'level': 3,
            'pvalue': 654300000000
          },
          {
            'value': 654321000000,
            'text': '布尔津县',
            'level': 3,
            'pvalue': 654300000000
          },
          {
            'value': 654322000000,
            'text': '富蕴县',
            'level': 3,
            'pvalue': 654300000000
          },
          {
            'value': 654323000000,
            'text': '福海县',
            'level': 3,
            'pvalue': 654300000000
          },
          {
            'value': 654324000000,
            'text': '哈巴河县',
            'level': 3,
            'pvalue': 654300000000
          },
          {
            'value': 654325000000,
            'text': '青河县',
            'level': 3,
            'pvalue': 654300000000
          },
          {
            'value': 654326000000,
            'text': '吉木乃县',
            'level': 3,
            'pvalue': 654300000000
          }
        ]
      },
      {
        'value': 659000000000,
        'text': '自治区直辖县级行政区划',
        'level': 2,
        'pvalue': 650000000000,
        'children': [
          {
            'value': 659001000000,
            'text': '石河子市',
            'level': 3,
            'pvalue': 659000000000
          },
          {
            'value': 659002000000,
            'text': '阿拉尔市',
            'level': 3,
            'pvalue': 659000000000
          },
          {
            'value': 659003000000,
            'text': '图木舒克市',
            'level': 3,
            'pvalue': 659000000000
          },
          {
            'value': 659004000000,
            'text': '五家渠市',
            'level': 3,
            'pvalue': 659000000000
          },
          {
            'value': 659005000000,
            'text': '北屯市',
            'level': 3,
            'pvalue': 659000000000
          },
          {
            'value': 659006000000,
            'text': '铁门关市',
            'level': 3,
            'pvalue': 659000000000
          },
          {
            'value': 659007000000,
            'text': '双河市',
            'level': 3,
            'pvalue': 659000000000
          },
          {
            'value': 659008000000,
            'text': '可克达拉市',
            'level': 3,
            'pvalue': 659000000000
          },
          {
            'value': 659009000000,
            'text': '昆玉市',
            'level': 3,
            'pvalue': 659000000000
          },
          {
            'value': 659010000000,
            'text': '胡杨河市',
            'level': 3,
            'pvalue': 659000000000
          },
          {
            'value': 659011000000,
            'text': '新星市',
            'level': 3,
            'pvalue': 659000000000
          }
        ]
      }
    ]
  }
]
